export const storefrontSearchesData = [
  {
    original_query: "kuscheldecke",
    total_searches: 27535,
  },
  {
    original_query: "läufer",
    total_searches: 3519,
  },
  {
    original_query: "schmutzfangmatte",
    total_searches: 2764,
  },
  {
    original_query: "tischfolie",
    total_searches: 2013,
  },
  {
    original_query: "sisal",
    total_searches: 1919,
  },
  {
    original_query: "rasenteppich",
    total_searches: 1901,
  },
  {
    original_query: "abdeckplane",
    total_searches: 1633,
  },
  {
    original_query: "teppich",
    total_searches: 1553,
  },
  {
    original_query: "filz",
    total_searches: 1380,
  },
  {
    original_query: "amazonas",
    total_searches: 1357,
  },
  {
    original_query: "schmutz",
    total_searches: 1222,
  },
  {
    original_query: "nadelfilz",
    total_searches: 1111,
  },
  {
    original_query: "sonnensegel",
    total_searches: 1077,
  },
  {
    original_query: "rhine",
    total_searches: 1033,
  },
  {
    original_query: "rasen",
    total_searches: 1008,
  },
  {
    original_query: "bodenschutzmatte",
    total_searches: 969,
  },
  {
    original_query: "schmutzfang",
    total_searches: 959,
  },
  {
    original_query: "kunstrasen",
    total_searches: 937,
  },
  {
    original_query: "schm",
    total_searches: 812,
  },
  {
    original_query: "sichtschutz",
    total_searches: 801,
  },
  {
    original_query: "stufenmatten",
    total_searches: 765,
  },
  {
    original_query: "rasente",
    total_searches: 733,
  },
  {
    original_query: "küchenläufer",
    total_searches: 726,
  },
  {
    original_query: "schmu",
    total_searches: 724,
  },
  {
    original_query: "london",
    total_searches: 719,
  },
  {
    original_query: "rase",
    total_searches: 715,
  },
  {
    original_query: "badematte",
    total_searches: 672,
  },
  {
    original_query: "teppichläufer",
    total_searches: 672,
  },
  {
    original_query: "kork",
    total_searches: 671,
  },
  {
    original_query: "bambus",
    total_searches: 660,
  },
  {
    original_query: "fußmatte",
    total_searches: 647,
  },
  {
    original_query: "plane",
    total_searches: 627,
  },
  {
    original_query: "Rasen",
    total_searches: 608,
  },
  {
    original_query: "gummi",
    total_searches: 597,
  },
  {
    original_query: "teppi",
    total_searches: 587,
  },
  {
    original_query: "schwerlastregal",
    total_searches: 584,
  },
  {
    original_query: "anti",
    total_searches: 583,
  },
  {
    original_query: "sonnen",
    total_searches: 563,
  },
  {
    original_query: "regal",
    total_searches: 545,
  },
  {
    original_query: "abdeck",
    total_searches: 544,
  },
  {
    original_query: "karat",
    total_searches: 543,
  },
  {
    original_query: "whiteboard",
    total_searches: 515,
  },
  {
    original_query: "hong",
    total_searches: 513,
  },
  {
    original_query: "Läufer",
    total_searches: 501,
  },
  {
    original_query: "fussmatte",
    total_searches: 500,
  },
  {
    original_query: "abde",
    total_searches: 497,
  },
  {
    original_query: "stufenkantenprofil",
    total_searches: 487,
  },
  {
    original_query: "sisa",
    total_searches: 487,
  },
  {
    original_query: "tepp",
    total_searches: 484,
  },
  {
    original_query: "stufenmatte",
    total_searches: 484,
  },
  {
    original_query: "Rase",
    total_searches: 482,
  },
  {
    original_query: "Rasenteppich",
    total_searches: 479,
  },
  {
    original_query: "schmutzf",
    total_searches: 477,
  },
  {
    original_query: "schmutzfan",
    total_searches: 474,
  },
  {
    original_query: "schmutzfa",
    total_searches: 463,
  },
  {
    original_query: "bodenschutz",
    total_searches: 462,
  },
  {
    original_query: "rasenteppi",
    total_searches: 461,
  },
  {
    original_query: "gummimatte",
    total_searches: 460,
  },
  {
    original_query: "treppen",
    total_searches: 458,
  },
  {
    original_query: "Rasente",
    total_searches: 452,
  },
  {
    original_query: "übergangsprofil",
    total_searches: 442,
  },
  {
    original_query: "stufen",
    total_searches: 441,
  },
  {
    original_query: "sauberlaufmatte",
    total_searches: 440,
  },
  {
    original_query: "Schmutz",
    total_searches: 434,
  },
  {
    original_query: "teppichfliesen",
    total_searches: 431,
  },
  {
    original_query: "rasent",
    total_searches: 428,
  },
  {
    original_query: "sockelleisten",
    total_searches: 423,
  },
  {
    original_query: "antirutsch",
    total_searches: 421,
  },
  {
    original_query: "sonn",
    total_searches: 420,
  },
  {
    original_query: "stallmatte",
    total_searches: 411,
  },
  {
    original_query: "Schm",
    total_searches: 404,
  },
  {
    original_query: "sabang",
    total_searches: 389,
  },
  {
    original_query: "Schmu",
    total_searches: 378,
  },
  {
    original_query: "schmutzfangma",
    total_searches: 377,
  },
  {
    original_query: "klickfliesen",
    total_searches: 376,
  },
  {
    original_query: "sonne",
    total_searches: 368,
  },
  {
    original_query: "schmutzfangm",
    total_searches: 365,
  },
  {
    original_query: "sonnense",
    total_searches: 364,
  },
  {
    original_query: "abdec",
    total_searches: 355,
  },
  {
    original_query: "rollenkork",
    total_searches: 355,
  },
  {
    original_query: "sisalteppich",
    total_searches: 355,
  },
  {
    original_query: "teppic",
    total_searches: 353,
  },
  {
    original_query: "rasentepp",
    total_searches: 351,
  },
  {
    original_query: "kleber",
    total_searches: 349,
  },
  {
    original_query: "nadel",
    total_searches: 348,
  },
  {
    original_query: "treppenkantenprofil",
    total_searches: 348,
  },
  {
    original_query: "Teppich",
    total_searches: 347,
  },
  {
    original_query: "sylt",
    total_searches: 347,
  },
  {
    original_query: "schmutzfangmatten",
    total_searches: 340,
  },
  {
    original_query: "stufe",
    total_searches: 339,
  },
  {
    original_query: "vinyl",
    total_searches: 337,
  },
  {
    original_query: "Teppi",
    total_searches: 324,
  },
  {
    original_query: "Schmutzfangmatte",
    total_searches: 321,
  },
  {
    original_query: "sicht",
    total_searches: 318,
  },
  {
    original_query: "Schmutzfang",
    total_searches: 317,
  },
  {
    original_query: "bade",
    total_searches: 316,
  },
  {
    original_query: "boden",
    total_searches: 312,
  },
  {
    original_query: "zaun",
    total_searches: 311,
  },
  {
    original_query: "sonnensege",
    total_searches: 307,
  },
  {
    original_query: "plissee",
    total_searches: 296,
  },
  {
    original_query: "zaunblende",
    total_searches: 294,
  },
  {
    original_query: "outdoor",
    total_searches: 290,
  },
  {
    original_query: "Rasenteppi",
    total_searches: 290,
  },
  {
    original_query: "sockelleiste",
    total_searches: 289,
  },
  {
    original_query: "kokos",
    total_searches: 288,
  },
  {
    original_query: "läuf",
    total_searches: 288,
  },
  {
    original_query: "schmut",
    total_searches: 287,
  },
  {
    original_query: "Tepp",
    total_searches: 286,
  },
  {
    original_query: "küchen",
    total_searches: 281,
  },
  {
    original_query: "bali",
    total_searches: 277,
  },
  {
    original_query: "sprühkleber",
    total_searches: 275,
  },
  {
    original_query: "kunst",
    total_searches: 272,
  },
  {
    original_query: "balkon",
    total_searches: 272,
  },
  {
    original_query: "dura",
    total_searches: 271,
  },
  {
    original_query: "abdeckpl",
    total_searches: 267,
  },
  {
    original_query: "Schmutzfa",
    total_searches: 266,
  },
  {
    original_query: "treppenteppich",
    total_searches: 264,
  },
  {
    original_query: "outdoorteppich",
    total_searches: 264,
  },
  {
    original_query: "marius",
    total_searches: 262,
  },
  {
    original_query: "Sisal",
    total_searches: 261,
  },
  {
    original_query: "Schmutzfan",
    total_searches: 261,
  },
  {
    original_query: "kuns",
    total_searches: 257,
  },
  {
    original_query: "klick",
    total_searches: 251,
  },
  {
    original_query: "küche",
    total_searches: 250,
  },
  {
    original_query: "trepp",
    total_searches: 249,
  },
  {
    original_query: "Rasent",
    total_searches: 249,
  },
  {
    original_query: "Schmutzf",
    total_searches: 248,
  },
  {
    original_query: "treppe",
    total_searches: 248,
  },
  {
    original_query: "mono",
    total_searches: 244,
  },
  {
    original_query: "badteppich",
    total_searches: 243,
  },
  {
    original_query: "stuf",
    total_searches: 243,
  },
  {
    original_query: "versandkosten",
    total_searches: 243,
  },
  {
    original_query: "stufenkanten",
    total_searches: 242,
  },
  {
    original_query: "Rasentepp",
    total_searches: 240,
  },
  {
    original_query: "rund",
    total_searches: 232,
  },
  {
    original_query: "bettumrandung",
    total_searches: 232,
  },
  {
    original_query: "Sonnen",
    total_searches: 231,
  },
  {
    original_query: "kalkutta",
    total_searches: 228,
  },
  {
    original_query: "Schmutzfangma",
    total_searches: 227,
  },
  {
    original_query: "alto",
    total_searches: 224,
  },
  {
    original_query: "bode",
    total_searches: 224,
  },
  {
    original_query: "stall",
    total_searches: 223,
  },
  {
    original_query: "antirutschmatte",
    total_searches: 222,
  },
  {
    original_query: "fuss",
    total_searches: 220,
  },
  {
    original_query: "gummiläufer",
    total_searches: 217,
  },
  {
    original_query: "sonnens",
    total_searches: 212,
  },
  {
    original_query: "kokosmatte",
    total_searches: 211,
  },
  {
    original_query: "Sicht",
    total_searches: 210,
  },
  {
    original_query: "kunstr",
    total_searches: 207,
  },
  {
    original_query: "kunstrase",
    total_searches: 205,
  },
  {
    original_query: "sich",
    total_searches: 204,
  },
  {
    original_query: "nadelfil",
    total_searches: 204,
  },
  {
    original_query: "bamb",
    total_searches: 203,
  },
  {
    original_query: "gumm",
    total_searches: 203,
  },
  {
    original_query: "Schmutzfangm",
    total_searches: 202,
  },
  {
    original_query: "planen",
    total_searches: 200,
  },
  {
    original_query: "nade",
    total_searches: 200,
  },
  {
    original_query: "Kunstrasen",
    total_searches: 200,
  },
  {
    original_query: "abdeckpla",
    total_searches: 199,
  },
  {
    original_query: "Sisa",
    total_searches: 197,
  },
  {
    original_query: "brasil",
    total_searches: 197,
  },
  {
    original_query: "Stufen",
    total_searches: 196,
  },
  {
    original_query: "küchenteppich",
    total_searches: 195,
  },
  {
    original_query: "rasenteppic",
    total_searches: 194,
  },
  {
    original_query: "über",
    total_searches: 194,
  },
  {
    original_query: "sichts",
    total_searches: 193,
  },
  {
    original_query: "Filz",
    total_searches: 193,
  },
  {
    original_query: "Sonn",
    total_searches: 193,
  },
  {
    original_query: "Sonnensegel",
    total_searches: 192,
  },
  {
    original_query: "sauberlauf",
    total_searches: 191,
  },
  {
    original_query: "übergangs",
    total_searches: 191,
  },
  {
    original_query: "Teppic",
    total_searches: 191,
  },
  {
    original_query: "küch",
    total_searches: 190,
  },
  {
    original_query: "schaukasten",
    total_searches: 190,
  },
  {
    original_query: "antir",
    total_searches: 190,
  },
  {
    original_query: "schmutzfangmatt",
    total_searches: 190,
  },
  {
    original_query: "sonnenseg",
    total_searches: 190,
  },
  {
    original_query: "bodensch",
    total_searches: 189,
  },
  {
    original_query: "Läuf",
    total_searches: 189,
  },
  {
    original_query: "grill",
    total_searches: 188,
  },
  {
    original_query: "stallmatten",
    total_searches: 186,
  },
  {
    original_query: "nadelf",
    total_searches: 185,
  },
  {
    original_query: "drahtgitter",
    total_searches: 184,
  },
  {
    original_query: "bodenschu",
    total_searches: 184,
  },
  {
    original_query: "mülleimer",
    total_searches: 184,
  },
  {
    original_query: "muster",
    total_searches: 183,
  },
  {
    original_query: "barcelona",
    total_searches: 181,
  },
  {
    original_query: "abdeckplan",
    total_searches: 181,
  },
  {
    original_query: "bodens",
    total_searches: 180,
  },
  {
    original_query: "stufenma",
    total_searches: 178,
  },
  {
    original_query: "jute",
    total_searches: 178,
  },
  {
    original_query: "antiru",
    total_searches: 176,
  },
  {
    original_query: "Sonne",
    total_searches: 175,
  },
  {
    original_query: "sichtschu",
    total_searches: 175,
  },
  {
    original_query: "Sichtschutz",
    total_searches: 174,
  },
  {
    original_query: "Stufe",
    total_searches: 172,
  },
  {
    original_query: "stufenm",
    total_searches: 170,
  },
  {
    original_query: "Kuns",
    total_searches: 170,
  },
  {
    original_query: "felix",
    total_searches: 169,
  },
  {
    original_query: "dynasty",
    total_searches: 169,
  },
  {
    original_query: "farbwunder",
    total_searches: 168,
  },
  {
    original_query: "Bambus",
    total_searches: 168,
  },
  {
    original_query: "profil",
    total_searches: 167,
  },
  {
    original_query: "bambu",
    total_searches: 167,
  },
  {
    original_query: "Sich",
    total_searches: 166,
  },
  {
    original_query: "Abde",
    total_searches: 166,
  },
  {
    original_query: "schmutzfangläufer",
    total_searches: 165,
  },
  {
    original_query: "antivibrationsmatte",
    total_searches: 165,
  },
  {
    original_query: "klebeband",
    total_searches: 164,
  },
  {
    original_query: "versand",
    total_searches: 164,
  },
  {
    original_query: "schwerlast",
    total_searches: 163,
  },
  {
    original_query: "sichtsch",
    total_searches: 162,
  },
  {
    original_query: "Abdeck",
    total_searches: 161,
  },
  {
    original_query: "teppiche",
    total_searches: 161,
  },
  {
    original_query: "flur",
    total_searches: 161,
  },
  {
    original_query: "Kunstr",
    total_searches: 161,
  },
  {
    original_query: "doppelrollo",
    total_searches: 159,
  },
  {
    original_query: "sauber",
    total_searches: 159,
  },
  {
    original_query: "bautenschutzmatte",
    total_searches: 157,
  },
  {
    original_query: "plan",
    total_searches: 156,
  },
  {
    original_query: "treppenkanten",
    total_searches: 155,
  },
  {
    original_query: "Nadelfilz",
    total_searches: 155,
  },
  {
    original_query: "rollo",
    total_searches: 155,
  },
  {
    original_query: "moscow",
    total_searches: 154,
  },
  {
    original_query: "heizmatte",
    total_searches: 154,
  },
  {
    original_query: "auto",
    total_searches: 153,
  },
  {
    original_query: "bodensc",
    total_searches: 152,
  },
  {
    original_query: "Kunst",
    total_searches: 152,
  },
  {
    original_query: "monochrom",
    total_searches: 151,
  },
  {
    original_query: "läufe",
    total_searches: 150,
  },
  {
    original_query: "flurläufer",
    total_searches: 150,
  },
  {
    original_query: "performa",
    total_searches: 149,
  },
  {
    original_query: "abdeckp",
    total_searches: 149,
  },
  {
    original_query: "magic",
    total_searches: 149,
  },
  {
    original_query: "Sonnense",
    total_searches: 149,
  },
  {
    original_query: "rücksendung",
    total_searches: 148,
  },
  {
    original_query: "folie",
    total_searches: 148,
  },
  {
    original_query: "rhin",
    total_searches: 148,
  },
  {
    original_query: "Kunstrase",
    total_searches: 148,
  },
  {
    original_query: "Sichts",
    total_searches: 146,
  },
  {
    original_query: "outd",
    total_searches: 146,
  },
  {
    original_query: "gummimatten",
    total_searches: 145,
  },
  {
    original_query: "Treppen",
    total_searches: 144,
  },
  {
    original_query: "antirut",
    total_searches: 144,
  },
  {
    original_query: "doppel",
    total_searches: 143,
  },
  {
    original_query: "bodenschutzm",
    total_searches: 143,
  },
  {
    original_query: "badematten",
    total_searches: 143,
  },
  {
    original_query: "kunstra",
    total_searches: 143,
  },
  {
    original_query: "klickfliese",
    total_searches: 143,
  },
  {
    original_query: "grandeur",
    total_searches: 143,
  },
  {
    original_query: "kunstras",
    total_searches: 142,
  },
  {
    original_query: "matte",
    total_searches: 142,
  },
  {
    original_query: "Abdec",
    total_searches: 141,
  },
  {
    original_query: "white",
    total_searches: 141,
  },
  {
    original_query: "bodenschutzma",
    total_searches: 140,
  },
  {
    original_query: "Nadel",
    total_searches: 139,
  },
  {
    original_query: "Gummi",
    total_searches: 139,
  },
  {
    original_query: "carlton",
    total_searches: 138,
  },
  {
    original_query: "teppichfliese",
    total_searches: 137,
  },
  {
    original_query: "Boden",
    total_searches: 136,
  },
  {
    original_query: "küchenl",
    total_searches: 135,
  },
  {
    original_query: "diamond",
    total_searches: 134,
  },
  {
    original_query: "oslo",
    total_searches: 134,
  },
  {
    original_query: "antivi",
    total_searches: 133,
  },
  {
    original_query: "shaggy",
    total_searches: 133,
  },
  {
    original_query: "draht",
    total_searches: 133,
  },
  {
    original_query: "gewebeplane",
    total_searches: 133,
  },
  {
    original_query: "Stuf",
    total_searches: 132,
  },
  {
    original_query: "Schmut",
    total_searches: 132,
  },
  {
    original_query: "badema",
    total_searches: 132,
  },
  {
    original_query: "regale",
    total_searches: 132,
  },
  {
    original_query: "bodenschutzmatten",
    total_searches: 131,
  },
  {
    original_query: "abdeckplanen",
    total_searches: 131,
  },
  {
    original_query: "schlingenmatte",
    total_searches: 131,
  },
  {
    original_query: "schmutzmatte",
    total_searches: 130,
  },
  {
    original_query: "adria",
    total_searches: 130,
  },
  {
    original_query: "balko",
    total_searches: 128,
  },
  {
    original_query: "sichtsc",
    total_searches: 128,
  },
  {
    original_query: "stufenkan",
    total_searches: 127,
  },
  {
    original_query: "Sonnensege",
    total_searches: 127,
  },
  {
    original_query: "küchenlä",
    total_searches: 127,
  },
  {
    original_query: "balkonteppich",
    total_searches: 127,
  },
  {
    original_query: "sundae",
    total_searches: 126,
  },
  {
    original_query: "badem",
    total_searches: 126,
  },
  {
    original_query: "Schmutzfangmatt",
    total_searches: 126,
  },
  {
    original_query: "heiz",
    total_searches: 125,
  },
  {
    original_query: "nadelfi",
    total_searches: 125,
  },
  {
    original_query: "sockel",
    total_searches: 125,
  },
  {
    original_query: "royal",
    total_searches: 125,
  },
  {
    original_query: "Sichtschu",
    total_searches: 125,
  },
  {
    original_query: "gummima",
    total_searches: 125,
  },
  {
    original_query: "treppenläufer",
    total_searches: 124,
  },
  {
    original_query: "hongkong",
    total_searches: 124,
  },
  {
    original_query: "Sichtsch",
    total_searches: 123,
  },
  {
    original_query: "teppichboden",
    total_searches: 123,
  },
  {
    original_query: "tisch",
    total_searches: 123,
  },
  {
    original_query: "messeteppich",
    total_searches: 122,
  },
  {
    original_query: "fussma",
    total_searches: 122,
  },
  {
    original_query: "outdoo",
    total_searches: 121,
  },
  {
    original_query: "Sonnens",
    total_searches: 121,
  },
  {
    original_query: "Treppe",
    total_searches: 121,
  },
  {
    original_query: "gitter",
    total_searches: 120,
  },
  {
    original_query: "Fuss",
    total_searches: 120,
  },
  {
    original_query: "lakota",
    total_searches: 120,
  },
  {
    original_query: "klebe",
    total_searches: 120,
  },
  {
    original_query: "Fussmatte",
    total_searches: 120,
  },
  {
    original_query: "Balkon",
    total_searches: 119,
  },
  {
    original_query: "gummim",
    total_searches: 119,
  },
  {
    original_query: "stufenk",
    total_searches: 119,
  },
  {
    original_query: "fußmatten",
    total_searches: 118,
  },
  {
    original_query: "Anti",
    total_searches: 118,
  },
  {
    original_query: "Abdeckplane",
    total_searches: 118,
  },
  {
    original_query: "rutsch",
    total_searches: 117,
  },
  {
    original_query: "fussmatten",
    total_searches: 116,
  },
  {
    original_query: "Rasenteppic",
    total_searches: 116,
  },
  {
    original_query: "Bambu",
    total_searches: 115,
  },
  {
    original_query: "Trepp",
    total_searches: 114,
  },
  {
    original_query: "Bode",
    total_searches: 114,
  },
  {
    original_query: "fliesen",
    total_searches: 114,
  },
  {
    original_query: "fahrradständer",
    total_searches: 114,
  },
  {
    original_query: "akustik",
    total_searches: 114,
  },
  {
    original_query: "Bamb",
    total_searches: 114,
  },
  {
    original_query: "Sichtsc",
    total_searches: 113,
  },
  {
    original_query: "fussm",
    total_searches: 113,
  },
  {
    original_query: "dopp",
    total_searches: 113,
  },
  {
    original_query: "küchenläu",
    total_searches: 112,
  },
  {
    original_query: "schwer",
    total_searches: 111,
  },
  {
    original_query: "treppenstufen",
    total_searches: 111,
  },
  {
    original_query: "magnet",
    total_searches: 110,
  },
  {
    original_query: "überga",
    total_searches: 109,
  },
  {
    original_query: "Bade",
    total_searches: 109,
  },
  {
    original_query: "Plane",
    total_searches: 108,
  },
  {
    original_query: "stufenka",
    total_searches: 108,
  },
  {
    original_query: "laminat",
    total_searches: 108,
  },
  {
    original_query: "kratz",
    total_searches: 108,
  },
  {
    original_query: "roll",
    total_searches: 107,
  },
  {
    original_query: "fell",
    total_searches: 106,
  },
  {
    original_query: "seil",
    total_searches: 106,
  },
  {
    original_query: "glas",
    total_searches: 106,
  },
  {
    original_query: "teppichl",
    total_searches: 106,
  },
  {
    original_query: "antiv",
    total_searches: 105,
  },
  {
    original_query: "weidenzaun",
    total_searches: 104,
  },
  {
    original_query: "Outdoor",
    total_searches: 104,
  },
  {
    original_query: "doppe",
    total_searches: 104,
  },
  {
    original_query: "lond",
    total_searches: 103,
  },
  {
    original_query: "rutschfest",
    total_searches: 102,
  },
  {
    original_query: "doppelsteg",
    total_searches: 102,
  },
  {
    original_query: "überg",
    total_searches: 102,
  },
  {
    original_query: "teppichlä",
    total_searches: 101,
  },
  {
    original_query: "übergang",
    total_searches: 101,
  },
  {
    original_query: "Kunstra",
    total_searches: 101,
  },
  {
    original_query: "elite",
    total_searches: 101,
  },
  {
    original_query: "leiste",
    total_searches: 100,
  },
  {
    original_query: "geneva",
    total_searches: 100,
  },
  {
    original_query: "turbo",
    total_searches: 100,
  },
  {
    original_query: "koko",
    total_searches: 100,
  },
  {
    original_query: "Outd",
    total_searches: 99,
  },
  {
    original_query: "meterware",
    total_searches: 99,
  },
  {
    original_query: "carousel",
    total_searches: 99,
  },
  {
    original_query: "weitspannregal",
    total_searches: 99,
  },
  {
    original_query: "bodenschut",
    total_searches: 99,
  },
  {
    original_query: "fußma",
    total_searches: 98,
  },
  {
    original_query: "stufenkante",
    total_searches: 98,
  },
  {
    original_query: "akustikpaneele",
    total_searches: 98,
  },
  {
    original_query: "saub",
    total_searches: 97,
  },
  {
    original_query: "antiruts",
    total_searches: 97,
  },
  {
    original_query: "vienna",
    total_searches: 97,
  },
  {
    original_query: "schmutzfangteppich",
    total_searches: 97,
  },
  {
    original_query: "dusch",
    total_searches: 97,
  },
  {
    original_query: "flies",
    total_searches: 97,
  },
  {
    original_query: "Stufenma",
    total_searches: 97,
  },
  {
    original_query: "flokati",
    total_searches: 96,
  },
  {
    original_query: "sprüh",
    total_searches: 96,
  },
  {
    original_query: "kabelbinder",
    total_searches: 96,
  },
  {
    original_query: "Abdeckpl",
    total_searches: 96,
  },
  {
    original_query: "klic",
    total_searches: 96,
  },
  {
    original_query: "Nade",
    total_searches: 95,
  },
  {
    original_query: "pool",
    total_searches: 95,
  },
  {
    original_query: "kinder",
    total_searches: 95,
  },
  {
    original_query: "sisalläufer",
    total_searches: 95,
  },
  {
    original_query: "vlies",
    total_searches: 94,
  },
  {
    original_query: "Bodenschutz",
    total_searches: 94,
  },
  {
    original_query: "katze",
    total_searches: 94,
  },
  {
    original_query: "Stufenmatte",
    total_searches: 94,
  },
  {
    original_query: "fußm",
    total_searches: 93,
  },
  {
    original_query: "vinylboden",
    total_searches: 93,
  },
  {
    original_query: "schutz",
    total_searches: 93,
  },
  {
    original_query: "flurteppich",
    total_searches: 93,
  },
  {
    original_query: "leisten",
    total_searches: 92,
  },
  {
    original_query: "sisalte",
    total_searches: 92,
  },
  {
    original_query: "schmutzfangmat",
    total_searches: 92,
  },
  {
    original_query: "Zaun",
    total_searches: 92,
  },
  {
    original_query: "linoleum",
    total_searches: 91,
  },
  {
    original_query: "bodenbelag",
    total_searches: 91,
  },
  {
    original_query: "kabelmatte",
    total_searches: 91,
  },
  {
    original_query: "bambusteppich",
    total_searches: 91,
  },
  {
    original_query: "stallm",
    total_searches: 90,
  },
  {
    original_query: "stallma",
    total_searches: 89,
  },
  {
    original_query: "messe",
    total_searches: 89,
  },
  {
    original_query: "Fussma",
    total_searches: 89,
  },
  {
    original_query: "superflex",
    total_searches: 89,
  },
  {
    original_query: "schreibtischunterlage",
    total_searches: 89,
  },
  {
    original_query: "duschhocker",
    total_searches: 89,
  },
  {
    original_query: "Nadelfil",
    total_searches: 89,
  },
  {
    original_query: "balkonsichtschutz",
    total_searches: 88,
  },
  {
    original_query: "waschbar",
    total_searches: 88,
  },
  {
    original_query: "bauten",
    total_searches: 88,
  },
  {
    original_query: "Fussm",
    total_searches: 88,
  },
  {
    original_query: "Stufenmatten",
    total_searches: 87,
  },
  {
    original_query: "badezimmer",
    total_searches: 87,
  },
  {
    original_query: "lyon",
    total_searches: 87,
  },
  {
    original_query: "kratzteppich",
    total_searches: 87,
  },
  {
    original_query: "Sonnenseg",
    total_searches: 87,
  },
  {
    original_query: "teppichläu",
    total_searches: 87,
  },
  {
    original_query: "katzen",
    total_searches: 86,
  },
  {
    original_query: "weiden",
    total_searches: 86,
  },
  {
    original_query: "Bodens",
    total_searches: 86,
  },
  {
    original_query: "kleb",
    total_searches: 86,
  },
  {
    original_query: "spann",
    total_searches: 86,
  },
  {
    original_query: "decke",
    total_searches: 86,
  },
  {
    original_query: "Abdeckpla",
    total_searches: 86,
  },
  {
    original_query: "rasentep",
    total_searches: 85,
  },
  {
    original_query: "laufer",
    total_searches: 85,
  },
  {
    original_query: "Kork",
    total_searches: 85,
  },
  {
    original_query: "Stufenm",
    total_searches: 85,
  },
  {
    original_query: "Küchen",
    total_searches: 85,
  },
  {
    original_query: "sauberl",
    total_searches: 84,
  },
  {
    original_query: "Grill",
    total_searches: 84,
  },
  {
    original_query: "viny",
    total_searches: 84,
  },
  {
    original_query: "schu",
    total_searches: 83,
  },
  {
    original_query: "zaunbl",
    total_searches: 83,
  },
  {
    original_query: "antirutsc",
    total_searches: 83,
  },
  {
    original_query: "magnete",
    total_searches: 83,
  },
  {
    original_query: "schau",
    total_searches: 82,
  },
  {
    original_query: "bautenschutz",
    total_searches: 82,
  },
  {
    original_query: "kantenprofil",
    total_searches: 82,
  },
  {
    original_query: "grillschutzmatte",
    total_searches: 82,
  },
  {
    original_query: "Abdeckplan",
    total_searches: 82,
  },
  {
    original_query: "flie",
    total_searches: 82,
  },
  {
    original_query: "noppen",
    total_searches: 82,
  },
  {
    original_query: "hochflor",
    total_searches: 82,
  },
  {
    original_query: "Balko",
    total_searches: 82,
  },
  {
    original_query: "Doppel",
    total_searches: 82,
  },
  {
    original_query: "stufenmatt",
    total_searches: 81,
  },
  {
    original_query: "terrassen",
    total_searches: 81,
  },
  {
    original_query: "zaunb",
    total_searches: 81,
  },
  {
    original_query: "weide",
    total_searches: 81,
  },
  {
    original_query: "rügen",
    total_searches: 80,
  },
  {
    original_query: "schutzmatte",
    total_searches: 80,
  },
  {
    original_query: "doppelstegplatte",
    total_searches: 80,
  },
  {
    original_query: "übergan",
    total_searches: 80,
  },
  {
    original_query: "erdanker",
    total_searches: 80,
  },
  {
    original_query: "Läufe",
    total_searches: 79,
  },
  {
    original_query: "wand",
    total_searches: 79,
  },
  {
    original_query: "teppichf",
    total_searches: 79,
  },
  {
    original_query: "bett",
    total_searches: 79,
  },
  {
    original_query: "Doppe",
    total_searches: 78,
  },
  {
    original_query: "sprü",
    total_searches: 78,
  },
  {
    original_query: "balk",
    total_searches: 78,
  },
  {
    original_query: "leno",
    total_searches: 77,
  },
  {
    original_query: "sicherheitsmatte",
    total_searches: 77,
  },
  {
    original_query: "dustin",
    total_searches: 77,
  },
  {
    original_query: "integral",
    total_searches: 77,
  },
  {
    original_query: "farb",
    total_searches: 77,
  },
  {
    original_query: "spanngummi",
    total_searches: 77,
  },
  {
    original_query: "Plan",
    total_searches: 77,
  },
  {
    original_query: "nadelholz",
    total_searches: 77,
  },
  {
    original_query: "rapido",
    total_searches: 77,
  },
  {
    original_query: "türmatte",
    total_searches: 76,
  },
  {
    original_query: "Kunstras",
    total_searches: 76,
  },
  {
    original_query: "antivib",
    total_searches: 76,
  },
  {
    original_query: "ponto",
    total_searches: 76,
  },
  {
    original_query: "grün",
    total_searches: 76,
  },
  {
    original_query: "badte",
    total_searches: 75,
  },
  {
    original_query: "claire",
    total_searches: 75,
  },
  {
    original_query: "Bodenschu",
    total_searches: 75,
  },
  {
    original_query: "stufenkantenpro",
    total_searches: 75,
  },
  {
    original_query: "kara",
    total_searches: 75,
  },
  {
    original_query: "Gumm",
    total_searches: 75,
  },
  {
    original_query: "prestige",
    total_searches: 75,
  },
  {
    original_query: "Dopp",
    total_searches: 75,
  },
  {
    original_query: "rechnung",
    total_searches: 75,
  },
  {
    original_query: "trapezblech",
    total_searches: 75,
  },
  {
    original_query: "sock",
    total_searches: 75,
  },
  {
    original_query: "schlingen",
    total_searches: 75,
  },
  {
    original_query: "Nadelf",
    total_searches: 75,
  },
  {
    original_query: "Bodensch",
    total_searches: 74,
  },
  {
    original_query: "sichtschut",
    total_searches: 74,
  },
  {
    original_query: "terassenfliesen",
    total_searches: 74,
  },
  {
    original_query: "Küche",
    total_searches: 74,
  },
  {
    original_query: "Outdoo",
    total_searches: 74,
  },
  {
    original_query: "flaschenkastenständer",
    total_searches: 74,
  },
  {
    original_query: "befestigungsschienen",
    total_searches: 74,
  },
  {
    original_query: "Doppelsteg",
    total_searches: 73,
  },
  {
    original_query: "Bodenschutzmatte",
    total_searches: 73,
  },
  {
    original_query: "unkraut",
    total_searches: 73,
  },
  {
    original_query: "Küch",
    total_searches: 73,
  },
  {
    original_query: "befestigung",
    total_searches: 73,
  },
  {
    original_query: "Abdeckp",
    total_searches: 73,
  },
  {
    original_query: "everest",
    total_searches: 73,
  },
  {
    original_query: "trennwand",
    total_searches: 72,
  },
  {
    original_query: "rollhocker",
    total_searches: 72,
  },
  {
    original_query: "akus",
    total_searches: 72,
  },
  {
    original_query: "Fußmatte",
    total_searches: 72,
  },
  {
    original_query: "trap",
    total_searches: 72,
  },
  {
    original_query: "sichtschutzzaun",
    total_searches: 72,
  },
  {
    original_query: "stellwand",
    total_searches: 72,
  },
  {
    original_query: "melange",
    total_searches: 72,
  },
  {
    original_query: "badematt",
    total_searches: 72,
  },
  {
    original_query: "Klick",
    total_searches: 72,
  },
  {
    original_query: "klickf",
    total_searches: 72,
  },
  {
    original_query: "küchenläuf",
    total_searches: 72,
  },
  {
    original_query: "rollen",
    total_searches: 72,
  },
  {
    original_query: "stufenkant",
    total_searches: 72,
  },
  {
    original_query: "terra",
    total_searches: 71,
  },
  {
    original_query: "karo",
    total_searches: 71,
  },
  {
    original_query: "tischdecke",
    total_searches: 71,
  },
  {
    original_query: "gummimatt",
    total_searches: 71,
  },
  {
    original_query: "mari",
    total_searches: 71,
  },
  {
    original_query: "Doppels",
    total_searches: 70,
  },
  {
    original_query: "Teppichläufer",
    total_searches: 70,
  },
  {
    original_query: "wühlmausgitter",
    total_searches: 70,
  },
  {
    original_query: "londo",
    total_searches: 70,
  },
  {
    original_query: "Bodensc",
    total_searches: 70,
  },
  {
    original_query: "versan",
    total_searches: 70,
  },
  {
    original_query: "befestigungsschiene",
    total_searches: 70,
  },
  {
    original_query: "holz",
    total_searches: 70,
  },
  {
    original_query: "hoch",
    total_searches: 69,
  },
  {
    original_query: "rocky",
    total_searches: 69,
  },
  {
    original_query: "flipchart",
    total_searches: 69,
  },
  {
    original_query: "scha",
    total_searches: 69,
  },
  {
    original_query: "magi",
    total_searches: 69,
  },
  {
    original_query: "treppente",
    total_searches: 69,
  },
  {
    original_query: "versa",
    total_searches: 69,
  },
  {
    original_query: "terrasse",
    total_searches: 69,
  },
  {
    original_query: "sauberlaufmatten",
    total_searches: 69,
  },
  {
    original_query: "kinderteppich",
    total_searches: 69,
  },
  {
    original_query: "arnold",
    total_searches: 69,
  },
  {
    original_query: "socke",
    total_searches: 68,
  },
  {
    original_query: "whiteb",
    total_searches: 68,
  },
  {
    original_query: "duschmatte",
    total_searches: 68,
  },
  {
    original_query: "sonnenschutz",
    total_searches: 68,
  },
  {
    original_query: "schwerl",
    total_searches: 68,
  },
  {
    original_query: "rega",
    total_searches: 68,
  },
  {
    original_query: "sauberla",
    total_searches: 67,
  },
  {
    original_query: "übergangspro",
    total_searches: 67,
  },
  {
    original_query: "sauberlau",
    total_searches: 67,
  },
  {
    original_query: "bodenschutzmatt",
    total_searches: 67,
  },
  {
    original_query: "fussmatt",
    total_searches: 67,
  },
  {
    original_query: "London",
    total_searches: 67,
  },
  {
    original_query: "malta",
    total_searches: 66,
  },
  {
    original_query: "abschluss",
    total_searches: 66,
  },
  {
    original_query: "fahrrad",
    total_searches: 66,
  },
  {
    original_query: "velour",
    total_searches: 66,
  },
  {
    original_query: "Antir",
    total_searches: 66,
  },
  {
    original_query: "terrassenfliesen",
    total_searches: 66,
  },
  {
    original_query: "rollkork",
    total_searches: 65,
  },
  {
    original_query: "gummil",
    total_searches: 65,
  },
  {
    original_query: "trapez",
    total_searches: 65,
  },
  {
    original_query: "sisaloptik",
    total_searches: 65,
  },
  {
    original_query: "autoteppich",
    total_searches: 65,
  },
  {
    original_query: "matten",
    total_searches: 65,
  },
  {
    original_query: "hochfloor",
    total_searches: 65,
  },
  {
    original_query: "stufenkantenp",
    total_searches: 64,
  },
  {
    original_query: "basel",
    total_searches: 64,
  },
  {
    original_query: "jazz",
    total_searches: 64,
  },
  {
    original_query: "coin",
    total_searches: 64,
  },
  {
    original_query: "Nadelfi",
    total_searches: 64,
  },
  {
    original_query: "terr",
    total_searches: 64,
  },
  {
    original_query: "antirutschmatten",
    total_searches: 64,
  },
  {
    original_query: "doppels",
    total_searches: 63,
  },
  {
    original_query: "zaunble",
    total_searches: 63,
  },
  {
    original_query: "terrassenfliese",
    total_searches: 63,
  },
  {
    original_query: "profile",
    total_searches: 63,
  },
  {
    original_query: "faltrollo",
    total_searches: 63,
  },
  {
    original_query: "trep",
    total_searches: 63,
  },
  {
    original_query: "schw",
    total_searches: 62,
  },
  {
    original_query: "seitenmarkise",
    total_searches: 62,
  },
  {
    original_query: "stufenkantenpr",
    total_searches: 62,
  },
  {
    original_query: "akzent",
    total_searches: 62,
  },
  {
    original_query: "doppelstegplatten",
    total_searches: 62,
  },
  {
    original_query: "Stufenkanten",
    total_searches: 62,
  },
  {
    original_query: "teppichunterlage",
    total_searches: 62,
  },
  {
    original_query: "sicherheits",
    total_searches: 61,
  },
  {
    original_query: "daylight",
    total_searches: 61,
  },
  {
    original_query: "übergangspr",
    total_searches: 61,
  },
  {
    original_query: "doppelr",
    total_searches: 61,
  },
  {
    original_query: "profi",
    total_searches: 61,
  },
  {
    original_query: "gitterregal",
    total_searches: 61,
  },
  {
    original_query: "Gummimatte",
    total_searches: 61,
  },
  {
    original_query: "thermo",
    total_searches: 61,
  },
  {
    original_query: "eingangsmatte",
    total_searches: 61,
  },
  {
    original_query: "Doppelst",
    total_searches: 60,
  },
  {
    original_query: "teppichfli",
    total_searches: 60,
  },
  {
    original_query: "fliegengitter",
    total_searches: 60,
  },
  {
    original_query: "dyna",
    total_searches: 60,
  },
  {
    original_query: "kontakt",
    total_searches: 60,
  },
  {
    original_query: "garten",
    total_searches: 60,
  },
  {
    original_query: "Teppichlä",
    total_searches: 60,
  },
  {
    original_query: "Antiru",
    total_searches: 60,
  },
  {
    original_query: "kalku",
    total_searches: 59,
  },
  {
    original_query: "Antirutsch",
    total_searches: 59,
  },
  {
    original_query: "baute",
    total_searches: 59,
  },
  {
    original_query: "outdoorte",
    total_searches: 59,
  },
  {
    original_query: "mariu",
    total_searches: 59,
  },
  {
    original_query: "badeteppich",
    total_searches: 59,
  },
  {
    original_query: "rainbow",
    total_searches: 59,
  },
  {
    original_query: "akust",
    total_searches: 59,
  },
  {
    original_query: "Doppelste",
    total_searches: 59,
  },
  {
    original_query: "Hong",
    total_searches: 58,
  },
  {
    original_query: "spring",
    total_searches: 58,
  },
  {
    original_query: "versandko",
    total_searches: 58,
  },
  {
    original_query: "teppichfl",
    total_searches: 58,
  },
  {
    original_query: "schwerlas",
    total_searches: 58,
  },
  {
    original_query: "kabel",
    total_searches: 58,
  },
  {
    original_query: "velours",
    total_searches: 57,
  },
  {
    original_query: "auslegware",
    total_searches: 57,
  },
  {
    original_query: "sintra",
    total_searches: 57,
  },
  {
    original_query: "bambuszaun",
    total_searches: 57,
  },
  {
    original_query: "müll",
    total_searches: 57,
  },
  {
    original_query: "sauberlaufma",
    total_searches: 57,
  },
  {
    original_query: "klickfli",
    total_searches: 57,
  },
  {
    original_query: "glory",
    total_searches: 57,
  },
  {
    original_query: "Stufenmatt",
    total_searches: 56,
  },
  {
    original_query: "flachnoppen",
    total_searches: 56,
  },
  {
    original_query: "netz",
    total_searches: 56,
  },
  {
    original_query: "Teppichl",
    total_searches: 56,
  },
  {
    original_query: "gewebe",
    total_searches: 56,
  },
  {
    original_query: "Über",
    total_searches: 56,
  },
  {
    original_query: "Karat",
    total_searches: 56,
  },
  {
    original_query: "sprühkl",
    total_searches: 56,
  },
  {
    original_query: "Stufenkan",
    total_searches: 56,
  },
  {
    original_query: "übergangsp",
    total_searches: 56,
  },
  {
    original_query: "mira",
    total_searches: 56,
  },
  {
    original_query: "doppelste",
    total_searches: 56,
  },
  {
    original_query: "whit",
    total_searches: 56,
  },
  {
    original_query: "acryl",
    total_searches: 56,
  },
  {
    original_query: "Badematte",
    total_searches: 55,
  },
  {
    original_query: "Badem",
    total_searches: 55,
  },
  {
    original_query: "Stufenkantenprofil",
    total_searches: 55,
  },
  {
    original_query: "trape",
    total_searches: 55,
  },
  {
    original_query: "leipzig",
    total_searches: 55,
  },
  {
    original_query: "Rhine",
    total_searches: 55,
  },
  {
    original_query: "winkelprofil",
    total_searches: 55,
  },
  {
    original_query: "sockell",
    total_searches: 55,
  },
  {
    original_query: "Badema",
    total_searches: 55,
  },
  {
    original_query: "Stufenk",
    total_searches: 54,
  },
  {
    original_query: "Rasentep",
    total_searches: 54,
  },
  {
    original_query: "sisaltepp",
    total_searches: 54,
  },
  {
    original_query: "steckregal",
    total_searches: 54,
  },
  {
    original_query: "treppenkante",
    total_searches: 54,
  },
  {
    original_query: "Stufenka",
    total_searches: 54,
  },
  {
    original_query: "tera",
    total_searches: 54,
  },
  {
    original_query: "Teppichläu",
    total_searches: 54,
  },
  {
    original_query: "Bodenschutzma",
    total_searches: 54,
  },
  {
    original_query: "büro",
    total_searches: 54,
  },
  {
    original_query: "gummilä",
    total_searches: 54,
  },
  {
    original_query: "sisalteppi",
    total_searches: 53,
  },
  {
    original_query: "fußabtreter",
    total_searches: 53,
  },
  {
    original_query: "heizteppich",
    total_searches: 53,
  },
  {
    original_query: "Sauber",
    total_searches: 53,
  },
  {
    original_query: "Outdoorteppich",
    total_searches: 53,
  },
  {
    original_query: "schmi",
    total_searches: 53,
  },
  {
    original_query: "safety",
    total_searches: 53,
  },
  {
    original_query: "übergangsprofi",
    total_searches: 53,
  },
  {
    original_query: "selbstklebend",
    total_searches: 53,
  },
  {
    original_query: "glasboard",
    total_searches: 53,
  },
  {
    original_query: "Sauberlaufmatte",
    total_searches: 53,
  },
  {
    original_query: "spanngummis",
    total_searches: 53,
  },
  {
    original_query: "noppenfolie",
    total_searches: 52,
  },
  {
    original_query: "drah",
    total_searches: 52,
  },
  {
    original_query: "Fussmatt",
    total_searches: 52,
  },
  {
    original_query: "hochf",
    total_searches: 52,
  },
  {
    original_query: "farbw",
    total_searches: 52,
  },
  {
    original_query: "badt",
    total_searches: 52,
  },
  {
    original_query: "pliss",
    total_searches: 52,
  },
  {
    original_query: "sicher",
    total_searches: 52,
  },
  {
    original_query: "veneto",
    total_searches: 52,
  },
  {
    original_query: "doppelro",
    total_searches: 52,
  },
  {
    original_query: "Bodenschutzm",
    total_searches: 52,
  },
  {
    original_query: "outdoort",
    total_searches: 52,
  },
  {
    original_query: "saban",
    total_searches: 52,
  },
  {
    original_query: "brandon",
    total_searches: 51,
  },
  {
    original_query: "power",
    total_searches: 51,
  },
  {
    original_query: "stufenkantenprof",
    total_searches: 51,
  },
  {
    original_query: "kenji",
    total_searches: 51,
  },
  {
    original_query: "lieferzeit",
    total_searches: 51,
  },
  {
    original_query: "rabatt",
    total_searches: 51,
  },
  {
    original_query: "markise",
    total_searches: 51,
  },
  {
    original_query: "ringgummimatte",
    total_searches: 51,
  },
  {
    original_query: "Antirut",
    total_searches: 51,
  },
  {
    original_query: "moderationstafel",
    total_searches: 51,
  },
  {
    original_query: "bambusmatte",
    total_searches: 51,
  },
  {
    original_query: "verbinder",
    total_searches: 51,
  },
  {
    original_query: "weichsockelleiste",
    total_searches: 50,
  },
  {
    original_query: "palermo",
    total_searches: 50,
  },
  {
    original_query: "grillschutz",
    total_searches: 50,
  },
  {
    original_query: "whitebo",
    total_searches: 50,
  },
  {
    original_query: "amour",
    total_searches: 50,
  },
  {
    original_query: "terassen",
    total_searches: 50,
  },
  {
    original_query: "plissees",
    total_searches: 50,
  },
  {
    original_query: "Fußma",
    total_searches: 50,
  },
  {
    original_query: "wühlmaus",
    total_searches: 50,
  },
  {
    original_query: "rückgabe",
    total_searches: 50,
  },
  {
    original_query: "sonnenschirm",
    total_searches: 50,
  },
  {
    original_query: "seiten",
    total_searches: 50,
  },
  {
    original_query: "atlantis",
    total_searches: 49,
  },
  {
    original_query: "sauberlaufm",
    total_searches: 49,
  },
  {
    original_query: "zaunblen",
    total_searches: 49,
  },
  {
    original_query: "blumen",
    total_searches: 49,
  },
  {
    original_query: "heide",
    total_searches: 49,
  },
  {
    original_query: "plisse",
    total_searches: 49,
  },
  {
    original_query: "treppenkan",
    total_searches: 49,
  },
  {
    original_query: "Sichtschut",
    total_searches: 49,
  },
  {
    original_query: "badtepp",
    total_searches: 49,
  },
  {
    original_query: "schuh",
    total_searches: 48,
  },
  {
    original_query: "octo",
    total_searches: 48,
  },
  {
    original_query: "filzteppich",
    total_searches: 48,
  },
  {
    original_query: "balkonte",
    total_searches: 48,
  },
  {
    original_query: "abschlussleiste",
    total_searches: 48,
  },
  {
    original_query: "gran",
    total_searches: 48,
  },
  {
    original_query: "schmitz",
    total_searches: 48,
  },
  {
    original_query: "fliegen",
    total_searches: 48,
  },
  {
    original_query: "magnettafel",
    total_searches: 48,
  },
  {
    original_query: "treppenk",
    total_searches: 48,
  },
  {
    original_query: "linz",
    total_searches: 48,
  },
  {
    original_query: "befest",
    total_searches: 48,
  },
  {
    original_query: "vintage",
    total_searches: 48,
  },
  {
    original_query: "Sock",
    total_searches: 47,
  },
  {
    original_query: "unkrautvlies",
    total_searches: 47,
  },
  {
    original_query: "verona",
    total_searches: 47,
  },
  {
    original_query: "schmutzmatten",
    total_searches: 47,
  },
  {
    original_query: "odin",
    total_searches: 47,
  },
  {
    original_query: "viking",
    total_searches: 47,
  },
  {
    original_query: "tiger",
    total_searches: 47,
  },
  {
    original_query: "transparent",
    total_searches: 47,
  },
  {
    original_query: "klickfl",
    total_searches: 47,
  },
  {
    original_query: "ruts",
    total_searches: 47,
  },
  {
    original_query: "schreibtisch",
    total_searches: 47,
  },
  {
    original_query: "Vinyl",
    total_searches: 47,
  },
  {
    original_query: "Outdoorte",
    total_searches: 46,
  },
  {
    original_query: "teppichläuf",
    total_searches: 46,
  },
  {
    original_query: "Übergangs",
    total_searches: 46,
  },
  {
    original_query: "tresor",
    total_searches: 46,
  },
  {
    original_query: "event",
    total_searches: 46,
  },
  {
    original_query: "Gummima",
    total_searches: 46,
  },
  {
    original_query: "teppichflie",
    total_searches: 46,
  },
  {
    original_query: "übergangsprof",
    total_searches: 46,
  },
  {
    original_query: "farbwun",
    total_searches: 46,
  },
  {
    original_query: "Küchenläufer",
    total_searches: 46,
  },
  {
    original_query: "Stufenkante",
    total_searches: 46,
  },
  {
    original_query: "antivibr",
    total_searches: 46,
  },
  {
    original_query: "drahtzaun",
    total_searches: 46,
  },
  {
    original_query: "lucano",
    total_searches: 46,
  },
  {
    original_query: "antirutschm",
    total_searches: 46,
  },
  {
    original_query: "sisalt",
    total_searches: 45,
  },
  {
    original_query: "Flur",
    total_searches: 45,
  },
  {
    original_query: "dynast",
    total_searches: 45,
  },
  {
    original_query: "Sauberlauf",
    total_searches: 45,
  },
  {
    original_query: "abschlussprofil",
    total_searches: 45,
  },
  {
    original_query: "Lond",
    total_searches: 45,
  },
  {
    original_query: "malaga",
    total_searches: 45,
  },
  {
    original_query: "duschrollo",
    total_searches: 45,
  },
  {
    original_query: "fussabtreter",
    total_searches: 45,
  },
  {
    original_query: "velo",
    total_searches: 45,
  },
  {
    original_query: "kratzmatte",
    total_searches: 45,
  },
  {
    original_query: "befesti",
    total_searches: 45,
  },
  {
    original_query: "eckregal",
    total_searches: 45,
  },
  {
    original_query: "dirk",
    total_searches: 45,
  },
  {
    original_query: "Zaunb",
    total_searches: 45,
  },
  {
    original_query: "whiteboa",
    total_searches: 45,
  },
  {
    original_query: "schl",
    total_searches: 44,
  },
  {
    original_query: "grillmatte",
    total_searches: 44,
  },
  {
    original_query: "Outdoorteppi",
    total_searches: 44,
  },
  {
    original_query: "korkkleber",
    total_searches: 44,
  },
  {
    original_query: "Fußm",
    total_searches: 44,
  },
  {
    original_query: "kaminholzregal",
    total_searches: 44,
  },
  {
    original_query: "outdoortepp",
    total_searches: 44,
  },
  {
    original_query: "linus",
    total_searches: 44,
  },
  {
    original_query: "Stall",
    total_searches: 44,
  },
  {
    original_query: "doppelst",
    total_searches: 44,
  },
  {
    original_query: "Zaunblende",
    total_searches: 44,
  },
  {
    original_query: "antirutschma",
    total_searches: 44,
  },
  {
    original_query: "coral",
    total_searches: 44,
  },
  {
    original_query: "antivibra",
    total_searches: 44,
  },
  {
    original_query: "treppenkantenpro",
    total_searches: 43,
  },
  {
    original_query: "sprühkle",
    total_searches: 43,
  },
  {
    original_query: "venyl",
    total_searches: 43,
  },
  {
    original_query: "rollos",
    total_searches: 43,
  },
  {
    original_query: "balkonsicht",
    total_searches: 43,
  },
  {
    original_query: "schli",
    total_searches: 43,
  },
  {
    original_query: "versandkos",
    total_searches: 43,
  },
  {
    original_query: "gewe",
    total_searches: 43,
  },
  {
    original_query: "kokosm",
    total_searches: 43,
  },
  {
    original_query: "seite",
    total_searches: 43,
  },
  {
    original_query: "kokosma",
    total_searches: 43,
  },
  {
    original_query: "befes",
    total_searches: 43,
  },
  {
    original_query: "Saub",
    total_searches: 43,
  },
  {
    original_query: "schwerlastre",
    total_searches: 43,
  },
  {
    original_query: "Regal",
    total_searches: 43,
  },
  {
    original_query: "küchente",
    total_searches: 43,
  },
  {
    original_query: "farbwu",
    total_searches: 43,
  },
  {
    original_query: "Kleber",
    total_searches: 43,
  },
  {
    original_query: "expotop",
    total_searches: 42,
  },
  {
    original_query: "rocket",
    total_searches: 42,
  },
  {
    original_query: "kundenstopper",
    total_searches: 42,
  },
  {
    original_query: "granada",
    total_searches: 42,
  },
  {
    original_query: "wohnzimmer",
    total_searches: 42,
  },
  {
    original_query: "kante",
    total_searches: 42,
  },
  {
    original_query: "schlin",
    total_searches: 42,
  },
  {
    original_query: "calama",
    total_searches: 42,
  },
  {
    original_query: "korkrolle",
    total_searches: 42,
  },
  {
    original_query: "sonnensch",
    total_searches: 42,
  },
  {
    original_query: "badteppi",
    total_searches: 42,
  },
  {
    original_query: "rabattcode",
    total_searches: 42,
  },
  {
    original_query: "tepich",
    total_searches: 42,
  },
  {
    original_query: "prof",
    total_searches: 42,
  },
  {
    original_query: "übergangsprofile",
    total_searches: 42,
  },
  {
    original_query: "Klic",
    total_searches: 42,
  },
  {
    original_query: "teppichflies",
    total_searches: 42,
  },
  {
    original_query: "Sauberl",
    total_searches: 42,
  },
  {
    original_query: "noah",
    total_searches: 42,
  },
  {
    original_query: "cosenza",
    total_searches: 41,
  },
  {
    original_query: "vers",
    total_searches: 41,
  },
  {
    original_query: "Antiruts",
    total_searches: 41,
  },
  {
    original_query: "schiene",
    total_searches: 41,
  },
  {
    original_query: "lucca",
    total_searches: 41,
  },
  {
    original_query: "outdoorteppi",
    total_searches: 41,
  },
  {
    original_query: "outdo",
    total_searches: 41,
  },
  {
    original_query: "ring",
    total_searches: 41,
  },
  {
    original_query: "Socke",
    total_searches: 41,
  },
  {
    original_query: "madras",
    total_searches: 41,
  },
  {
    original_query: "velou",
    total_searches: 41,
  },
  {
    original_query: "genua",
    total_searches: 41,
  },
  {
    original_query: "gewächshaus",
    total_searches: 41,
  },
  {
    original_query: "türvorleger",
    total_searches: 41,
  },
  {
    original_query: "rolle",
    total_searches: 41,
  },
  {
    original_query: "hochflo",
    total_searches: 41,
  },
  {
    original_query: "Küchenlä",
    total_searches: 41,
  },
  {
    original_query: "stallmatt",
    total_searches: 41,
  },
  {
    original_query: "fußmatt",
    total_searches: 41,
  },
  {
    original_query: "tafelfolie",
    total_searches: 41,
  },
  {
    original_query: "Versand",
    total_searches: 41,
  },
  {
    original_query: "whiteboar",
    total_searches: 41,
  },
  {
    original_query: "kokosmatten",
    total_searches: 40,
  },
  {
    original_query: "kurzflor",
    total_searches: 40,
  },
  {
    original_query: "Roll",
    total_searches: 40,
  },
  {
    original_query: "winkel",
    total_searches: 40,
  },
  {
    original_query: "pflanzenwand",
    total_searches: 40,
  },
  {
    original_query: "rollenkor",
    total_searches: 40,
  },
  {
    original_query: "antivibration",
    total_searches: 40,
  },
  {
    original_query: "heringe",
    total_searches: 40,
  },
  {
    original_query: "Balk",
    total_searches: 40,
  },
  {
    original_query: "schlinge",
    total_searches: 40,
  },
  {
    original_query: "schutzfangmatte",
    total_searches: 40,
  },
  {
    original_query: "anpassungsprofil",
    total_searches: 40,
  },
  {
    original_query: "kanten",
    total_searches: 40,
  },
  {
    original_query: "terasse",
    total_searches: 40,
  },
  {
    original_query: "wollteppich",
    total_searches: 40,
  },
  {
    original_query: "kunstfell",
    total_searches: 40,
  },
  {
    original_query: "verd",
    total_searches: 40,
  },
  {
    original_query: "baut",
    total_searches: 40,
  },
  {
    original_query: "mosc",
    total_searches: 40,
  },
  {
    original_query: "rück",
    total_searches: 40,
  },
  {
    original_query: "treppent",
    total_searches: 40,
  },
  {
    original_query: "wühl",
    total_searches: 40,
  },
  {
    original_query: "schwarz",
    total_searches: 39,
  },
  {
    original_query: "hochfl",
    total_searches: 39,
  },
  {
    original_query: "Sauberla",
    total_searches: 39,
  },
  {
    original_query: "gummiläu",
    total_searches: 39,
  },
  {
    original_query: "granulat",
    total_searches: 39,
  },
  {
    original_query: "weichschaummatte",
    total_searches: 39,
  },
  {
    original_query: "flash",
    total_searches: 39,
  },
  {
    original_query: "Klebe",
    total_searches: 39,
  },
  {
    original_query: "fallschutz",
    total_searches: 39,
  },
  {
    original_query: "rollenko",
    total_searches: 39,
  },
  {
    original_query: "Gummim",
    total_searches: 39,
  },
  {
    original_query: "klickflie",
    total_searches: 39,
  },
  {
    original_query: "versandkoste",
    total_searches: 39,
  },
  {
    original_query: "Versa",
    total_searches: 39,
  },
  {
    original_query: "Sisalteppich",
    total_searches: 39,
  },
  {
    original_query: "Küchenl",
    total_searches: 39,
  },
  {
    original_query: "safe",
    total_searches: 39,
  },
  {
    original_query: "badvorleger",
    total_searches: 39,
  },
  {
    original_query: "Kleb",
    total_searches: 39,
  },
  {
    original_query: "schauk",
    total_searches: 39,
  },
  {
    original_query: "barce",
    total_searches: 39,
  },
  {
    original_query: "Zaunbl",
    total_searches: 39,
  },
  {
    original_query: "scene",
    total_searches: 38,
  },
  {
    original_query: "treppenka",
    total_searches: 38,
  },
  {
    original_query: "zack",
    total_searches: 38,
  },
  {
    original_query: "astra",
    total_searches: 38,
  },
  {
    original_query: "bettum",
    total_searches: 38,
  },
  {
    original_query: "Draht",
    total_searches: 38,
  },
  {
    original_query: "poolrunner",
    total_searches: 38,
  },
  {
    original_query: "treppentepp",
    total_searches: 38,
  },
  {
    original_query: "akusti",
    total_searches: 38,
  },
  {
    original_query: "Doppelstegplatte",
    total_searches: 38,
  },
  {
    original_query: "bubble",
    total_searches: 38,
  },
  {
    original_query: "stufenkantenprofi",
    total_searches: 38,
  },
  {
    original_query: "fahrra",
    total_searches: 37,
  },
  {
    original_query: "saba",
    total_searches: 37,
  },
  {
    original_query: "Rhin",
    total_searches: 37,
  },
  {
    original_query: "fitness",
    total_searches: 37,
  },
  {
    original_query: "Stufenkantenpro",
    total_searches: 37,
  },
  {
    original_query: "Sauberlau",
    total_searches: 37,
  },
  {
    original_query: "tomaten",
    total_searches: 37,
  },
  {
    original_query: "badezimmerteppich",
    total_searches: 37,
  },
  {
    original_query: "Sockel",
    total_searches: 37,
  },
  {
    original_query: "himalaya",
    total_searches: 37,
  },
  {
    original_query: "schwe",
    total_searches: 37,
  },
  {
    original_query: "Sisalte",
    total_searches: 37,
  },
  {
    original_query: "verdu",
    total_searches: 37,
  },
  {
    original_query: "stufenprofil",
    total_searches: 37,
  },
  {
    original_query: "Zaunble",
    total_searches: 37,
  },
  {
    original_query: "retour",
    total_searches: 37,
  },
  {
    original_query: "treppenkant",
    total_searches: 37,
  },
  {
    original_query: "salvador",
    total_searches: 37,
  },
  {
    original_query: "dusc",
    total_searches: 37,
  },
  {
    original_query: "santiago",
    total_searches: 37,
  },
  {
    original_query: "ther",
    total_searches: 37,
  },
  {
    original_query: "haken",
    total_searches: 36,
  },
  {
    original_query: "schwerlastreg",
    total_searches: 36,
  },
  {
    original_query: "Stufenkantenpr",
    total_searches: 36,
  },
  {
    original_query: "badmatte",
    total_searches: 36,
  },
  {
    original_query: "befe",
    total_searches: 36,
  },
  {
    original_query: "stuffenmatten",
    total_searches: 36,
  },
  {
    original_query: "schwerla",
    total_searches: 36,
  },
  {
    original_query: "Matte",
    total_searches: 36,
  },
  {
    original_query: "übergangsleiste",
    total_searches: 36,
  },
  {
    original_query: "stanford",
    total_searches: 36,
  },
  {
    original_query: "Schutz",
    total_searches: 36,
  },
  {
    original_query: "Terr",
    total_searches: 36,
  },
  {
    original_query: "premium",
    total_searches: 36,
  },
  {
    original_query: "Teppiche",
    total_searches: 36,
  },
  {
    original_query: "eingang",
    total_searches: 36,
  },
  {
    original_query: "fliese",
    total_searches: 36,
  },
  {
    original_query: "Outdoort",
    total_searches: 36,
  },
  {
    original_query: "super",
    total_searches: 35,
  },
  {
    original_query: "windschutz",
    total_searches: 35,
  },
  {
    original_query: "fußleisten",
    total_searches: 35,
  },
  {
    original_query: "pfosten",
    total_searches: 35,
  },
  {
    original_query: "Weiden",
    total_searches: 35,
  },
  {
    original_query: "Stufenkantenp",
    total_searches: 35,
  },
  {
    original_query: "weid",
    total_searches: 35,
  },
  {
    original_query: "tibet",
    total_searches: 35,
  },
  {
    original_query: "Hoch",
    total_searches: 35,
  },
  {
    original_query: "wohn",
    total_searches: 35,
  },
  {
    original_query: "bodenschutzmat",
    total_searches: 35,
  },
  {
    original_query: "poly",
    total_searches: 35,
  },
  {
    original_query: "dynas",
    total_searches: 35,
  },
  {
    original_query: "stufenteppich",
    total_searches: 35,
  },
  {
    original_query: "kalk",
    total_searches: 35,
  },
  {
    original_query: "treppenst",
    total_searches: 35,
  },
  {
    original_query: "spanngu",
    total_searches: 35,
  },
  {
    original_query: "pinnwand",
    total_searches: 35,
  },
  {
    original_query: "Stallma",
    total_searches: 35,
  },
  {
    original_query: "Übergan",
    total_searches: 35,
  },
  {
    original_query: "grizzly",
    total_searches: 35,
  },
  {
    original_query: "vorhang",
    total_searches: 35,
  },
  {
    original_query: "antivibrations",
    total_searches: 35,
  },
  {
    original_query: "Küchenläu",
    total_searches: 35,
  },
  {
    original_query: "sichtschutzrollo",
    total_searches: 35,
  },
  {
    original_query: "acrylglas",
    total_searches: 35,
  },
  {
    original_query: "schall",
    total_searches: 35,
  },
  {
    original_query: "fahrr",
    total_searches: 35,
  },
  {
    original_query: "fallschutzmatte",
    total_searches: 35,
  },
  {
    original_query: "Weide",
    total_searches: 35,
  },
  {
    original_query: "bonita",
    total_searches: 34,
  },
  {
    original_query: "fahrradst",
    total_searches: 34,
  },
  {
    original_query: "Doppelstegpla",
    total_searches: 34,
  },
  {
    original_query: "Terrassen",
    total_searches: 34,
  },
  {
    original_query: "akkustik",
    total_searches: 34,
  },
  {
    original_query: "teppichläufe",
    total_searches: 34,
  },
  {
    original_query: "ösen",
    total_searches: 34,
  },
  {
    original_query: "katz",
    total_searches: 34,
  },
  {
    original_query: "Stallmatte",
    total_searches: 34,
  },
  {
    original_query: "Versan",
    total_searches: 34,
  },
  {
    original_query: "Sabang",
    total_searches: 34,
  },
  {
    original_query: "schuhregal",
    total_searches: 34,
  },
  {
    original_query: "Teppichläuf",
    total_searches: 34,
  },
  {
    original_query: "decken",
    total_searches: 34,
  },
  {
    original_query: "küchenläufe",
    total_searches: 34,
  },
  {
    original_query: "Sprühkleber",
    total_searches: 34,
  },
  {
    original_query: "schwerlastrega",
    total_searches: 34,
  },
  {
    original_query: "Schu",
    total_searches: 34,
  },
  {
    original_query: "feli",
    total_searches: 34,
  },
  {
    original_query: "Badte",
    total_searches: 34,
  },
  {
    original_query: "seitenm",
    total_searches: 34,
  },
  {
    original_query: "balkonteppi",
    total_searches: 34,
  },
  {
    original_query: "treppenteppi",
    total_searches: 34,
  },
  {
    original_query: "santo",
    total_searches: 34,
  },
  {
    original_query: "sale",
    total_searches: 34,
  },
  {
    original_query: "Londo",
    total_searches: 34,
  },
  {
    original_query: "Übergang",
    total_searches: 34,
  },
  {
    original_query: "seit",
    total_searches: 34,
  },
  {
    original_query: "schwerlastr",
    total_searches: 33,
  },
  {
    original_query: "hochfloorteppich",
    total_searches: 33,
  },
  {
    original_query: "wandregal",
    total_searches: 33,
  },
  {
    original_query: "papierspender",
    total_searches: 33,
  },
  {
    original_query: "stufenmat",
    total_searches: 33,
  },
  {
    original_query: "tepi",
    total_searches: 33,
  },
  {
    original_query: "bastel",
    total_searches: 33,
  },
  {
    original_query: "schlafzimmer",
    total_searches: 33,
  },
  {
    original_query: "Schwer",
    total_searches: 33,
  },
  {
    original_query: "schi",
    total_searches: 33,
  },
  {
    original_query: "polycarbonat",
    total_searches: 33,
  },
  {
    original_query: "spiegel",
    total_searches: 33,
  },
  {
    original_query: "perfor",
    total_searches: 33,
  },
  {
    original_query: "geweb",
    total_searches: 33,
  },
  {
    original_query: "Treppenstufen",
    total_searches: 33,
  },
  {
    original_query: "schling",
    total_searches: 33,
  },
  {
    original_query: "gril",
    total_searches: 33,
  },
  {
    original_query: "maschendraht",
    total_searches: 33,
  },
  {
    original_query: "Übergangsprofil",
    total_searches: 33,
  },
  {
    original_query: "Treppens",
    total_searches: 33,
  },
  {
    original_query: "nadelvlies",
    total_searches: 33,
  },
  {
    original_query: "kissen",
    total_searches: 33,
  },
  {
    original_query: "jamie",
    total_searches: 33,
  },
  {
    original_query: "schienen",
    total_searches: 33,
  },
  {
    original_query: "mustang",
    total_searches: 33,
  },
  {
    original_query: "Rund",
    total_searches: 32,
  },
  {
    original_query: "antivibrat",
    total_searches: 32,
  },
  {
    original_query: "sisalteppic",
    total_searches: 32,
  },
  {
    original_query: "puzzle",
    total_searches: 32,
  },
  {
    original_query: "stan",
    total_searches: 32,
  },
  {
    original_query: "aussen",
    total_searches: 32,
  },
  {
    original_query: "arte",
    total_searches: 32,
  },
  {
    original_query: "versandk",
    total_searches: 32,
  },
  {
    original_query: "balkons",
    total_searches: 32,
  },
  {
    original_query: "matt",
    total_searches: 32,
  },
  {
    original_query: "casa",
    total_searches: 32,
  },
  {
    original_query: "hochflorteppich",
    total_searches: 32,
  },
  {
    original_query: "Viny",
    total_searches: 32,
  },
  {
    original_query: "sichtschutzmatte",
    total_searches: 32,
  },
  {
    original_query: "Badematt",
    total_searches: 32,
  },
  {
    original_query: "octagon",
    total_searches: 32,
  },
  {
    original_query: "Stufenkant",
    total_searches: 32,
  },
  {
    original_query: "tafel",
    total_searches: 32,
  },
  {
    original_query: "kamin",
    total_searches: 32,
  },
  {
    original_query: "kalkutt",
    total_searches: 32,
  },
  {
    original_query: "rank",
    total_searches: 32,
  },
  {
    original_query: "Badteppich",
    total_searches: 32,
  },
  {
    original_query: "magn",
    total_searches: 32,
  },
  {
    original_query: "sockelle",
    total_searches: 32,
  },
  {
    original_query: "versandkost",
    total_searches: 32,
  },
  {
    original_query: "verdunklungsrollo",
    total_searches: 32,
  },
  {
    original_query: "peter",
    total_searches: 32,
  },
  {
    original_query: "fahr",
    total_searches: 31,
  },
  {
    original_query: "befestigun",
    total_searches: 31,
  },
  {
    original_query: "weidezaun",
    total_searches: 31,
  },
  {
    original_query: "sauna",
    total_searches: 31,
  },
  {
    original_query: "schwerlastregale",
    total_searches: 31,
  },
  {
    original_query: "spielteppich",
    total_searches: 31,
  },
  {
    original_query: "Bodenschut",
    total_searches: 31,
  },
  {
    original_query: "Garten",
    total_searches: 31,
  },
  {
    original_query: "Badt",
    total_searches: 31,
  },
  {
    original_query: "Flie",
    total_searches: 31,
  },
  {
    original_query: "beige",
    total_searches: 31,
  },
  {
    original_query: "autote",
    total_searches: 31,
  },
  {
    original_query: "arnol",
    total_searches: 31,
  },
  {
    original_query: "Überga",
    total_searches: 31,
  },
  {
    original_query: "kratzbrett",
    total_searches: 31,
  },
  {
    original_query: "Tisch",
    total_searches: 31,
  },
  {
    original_query: "magnetleisten",
    total_searches: 31,
  },
  {
    original_query: "carl",
    total_searches: 31,
  },
  {
    original_query: "Scha",
    total_searches: 31,
  },
  {
    original_query: "mülle",
    total_searches: 31,
  },
  {
    original_query: "kabe",
    total_searches: 31,
  },
  {
    original_query: "unterlage",
    total_searches: 31,
  },
  {
    original_query: "vinylteppich",
    total_searches: 31,
  },
  {
    original_query: "riviera",
    total_searches: 31,
  },
  {
    original_query: "wildzaun",
    total_searches: 31,
  },
  {
    original_query: "tisc",
    total_searches: 31,
  },
  {
    original_query: "rutsc",
    total_searches: 31,
  },
  {
    original_query: "clyde",
    total_searches: 31,
  },
  {
    original_query: "terassenfliese",
    total_searches: 31,
  },
  {
    original_query: "atlanta",
    total_searches: 31,
  },
  {
    original_query: "drahtg",
    total_searches: 31,
  },
  {
    original_query: "Kabelbinder",
    total_searches: 31,
  },
  {
    original_query: "maris",
    total_searches: 31,
  },
  {
    original_query: "sonnensc",
    total_searches: 31,
  },
  {
    original_query: "treppenprofil",
    total_searches: 31,
  },
  {
    original_query: "bras",
    total_searches: 31,
  },
  {
    original_query: "mosco",
    total_searches: 31,
  },
  {
    original_query: "Sisalteppi",
    total_searches: 31,
  },
  {
    original_query: "balkonsi",
    total_searches: 30,
  },
  {
    original_query: "Tera",
    total_searches: 30,
  },
  {
    original_query: "treppens",
    total_searches: 30,
  },
  {
    original_query: "Stufenkantenprof",
    total_searches: 30,
  },
  {
    original_query: "antirutschmatt",
    total_searches: 30,
  },
  {
    original_query: "grandeu",
    total_searches: 30,
  },
  {
    original_query: "grau",
    total_searches: 30,
  },
  {
    original_query: "bodenmatte",
    total_searches: 30,
  },
  {
    original_query: "Doppelstegpl",
    total_searches: 30,
  },
  {
    original_query: "befestig",
    total_searches: 30,
  },
  {
    original_query: "inte",
    total_searches: 30,
  },
  {
    original_query: "york",
    total_searches: 30,
  },
  {
    original_query: "weits",
    total_searches: 30,
  },
  {
    original_query: "runde",
    total_searches: 30,
  },
  {
    original_query: "flaschen",
    total_searches: 30,
  },
  {
    original_query: "zuschnitt",
    total_searches: 30,
  },
  {
    original_query: "Sisaltepp",
    total_searches: 30,
  },
  {
    original_query: "maschendrahtzaun",
    total_searches: 30,
  },
  {
    original_query: "amalfi",
    total_searches: 30,
  },
  {
    original_query: "perf",
    total_searches: 30,
  },
  {
    original_query: "expo",
    total_searches: 30,
  },
  {
    original_query: "woche",
    total_searches: 30,
  },
  {
    original_query: "sisall",
    total_searches: 30,
  },
  {
    original_query: "Klebeband",
    total_searches: 30,
  },
  {
    original_query: "schallschutz",
    total_searches: 30,
  },
  {
    original_query: "terrass",
    total_searches: 30,
  },
  {
    original_query: "sicherheit",
    total_searches: 30,
  },
  {
    original_query: "leah",
    total_searches: 30,
  },
  {
    original_query: "Sisalt",
    total_searches: 30,
  },
  {
    original_query: "sockellei",
    total_searches: 30,
  },
  {
    original_query: "murcia",
    total_searches: 30,
  },
  {
    original_query: "stange",
    total_searches: 30,
  },
  {
    original_query: "befestigungs",
    total_searches: 30,
  },
  {
    original_query: "Sauberlaufma",
    total_searches: 30,
  },
  {
    original_query: "grande",
    total_searches: 30,
  },
  {
    original_query: "abtreter",
    total_searches: 30,
  },
  {
    original_query: "schutzhülle",
    total_searches: 29,
  },
  {
    original_query: "padua",
    total_searches: 29,
  },
  {
    original_query: "lauf",
    total_searches: 29,
  },
  {
    original_query: "Treppenkanten",
    total_searches: 29,
  },
  {
    original_query: "fliesenprofil",
    total_searches: 29,
  },
  {
    original_query: "bettvorleger",
    total_searches: 29,
  },
  {
    original_query: "Antirutsc",
    total_searches: 29,
  },
  {
    original_query: "klebeb",
    total_searches: 29,
  },
  {
    original_query: "treppenkantenp",
    total_searches: 29,
  },
  {
    original_query: "sand",
    total_searches: 29,
  },
  {
    original_query: "balkontepp",
    total_searches: 29,
  },
  {
    original_query: "messete",
    total_searches: 29,
  },
  {
    original_query: "Sockelleiste",
    total_searches: 29,
  },
  {
    original_query: "Outdoortepp",
    total_searches: 29,
  },
  {
    original_query: "bindedraht",
    total_searches: 29,
  },
  {
    original_query: "Überg",
    total_searches: 29,
  },
  {
    original_query: "Kabel",
    total_searches: 29,
  },
  {
    original_query: "drahtgi",
    total_searches: 29,
  },
  {
    original_query: "magne",
    total_searches: 29,
  },
  {
    original_query: "selbst",
    total_searches: 29,
  },
  {
    original_query: "korkboden",
    total_searches: 29,
  },
  {
    original_query: "plis",
    total_searches: 29,
  },
  {
    original_query: "Auto",
    total_searches: 29,
  },
  {
    original_query: "noppe",
    total_searches: 29,
  },
  {
    original_query: "Terra",
    total_searches: 29,
  },
  {
    original_query: "wasch",
    total_searches: 29,
  },
  {
    original_query: "kreta",
    total_searches: 29,
  },
  {
    original_query: "abdeckfolie",
    total_searches: 29,
  },
  {
    original_query: "absch",
    total_searches: 29,
  },
  {
    original_query: "Terasse",
    total_searches: 29,
  },
  {
    original_query: "seitenma",
    total_searches: 29,
  },
  {
    original_query: "blau",
    total_searches: 29,
  },
  {
    original_query: "outdoorteppic",
    total_searches: 29,
  },
  {
    original_query: "shark",
    total_searches: 29,
  },
  {
    original_query: "sprühkleb",
    total_searches: 29,
  },
  {
    original_query: "Zaunblen",
    total_searches: 29,
  },
  {
    original_query: "bürostuhl",
    total_searches: 29,
  },
  {
    original_query: "befestigu",
    total_searches: 29,
  },
  {
    original_query: "dusche",
    total_searches: 29,
  },
  {
    original_query: "shine",
    total_searches: 29,
  },
  {
    original_query: "Sprüh",
    total_searches: 29,
  },
  {
    original_query: "soft",
    total_searches: 29,
  },
  {
    original_query: "innenraumverkleidung",
    total_searches: 28,
  },
  {
    original_query: "noppenmatte",
    total_searches: 28,
  },
  {
    original_query: "schut",
    total_searches: 28,
  },
  {
    original_query: "rindenmatte",
    total_searches: 28,
  },
  {
    original_query: "schlingenflor",
    total_searches: 28,
  },
  {
    original_query: "treppenmatten",
    total_searches: 28,
  },
  {
    original_query: "perfo",
    total_searches: 28,
  },
  {
    original_query: "unter",
    total_searches: 28,
  },
  {
    original_query: "schlingenm",
    total_searches: 28,
  },
  {
    original_query: "ringgummi",
    total_searches: 28,
  },
  {
    original_query: "firm",
    total_searches: 28,
  },
  {
    original_query: "Treppenst",
    total_searches: 28,
  },
  {
    original_query: "kurz",
    total_searches: 28,
  },
  {
    original_query: "superf",
    total_searches: 28,
  },
  {
    original_query: "bürostuhlunterlage",
    total_searches: 28,
  },
  {
    original_query: "spaghetti",
    total_searches: 28,
  },
  {
    original_query: "rollh",
    total_searches: 28,
  },
  {
    original_query: "Saba",
    total_searches: 28,
  },
  {
    original_query: "heidekraut",
    total_searches: 28,
  },
  {
    original_query: "volierendraht",
    total_searches: 28,
  },
  {
    original_query: "Treppenkantenprofil",
    total_searches: 28,
  },
  {
    original_query: "badmatten",
    total_searches: 28,
  },
  {
    original_query: "lemon",
    total_searches: 28,
  },
  {
    original_query: "plexiglas",
    total_searches: 28,
  },
  {
    original_query: "rollenk",
    total_searches: 28,
  },
  {
    original_query: "eingangs",
    total_searches: 28,
  },
  {
    original_query: "bautens",
    total_searches: 28,
  },
  {
    original_query: "Sprü",
    total_searches: 28,
  },
  {
    original_query: "gummigranulat",
    total_searches: 28,
  },
  {
    original_query: "baleno",
    total_searches: 28,
  },
  {
    original_query: "schmutzfänger",
    total_searches: 28,
  },
  {
    original_query: "integr",
    total_searches: 27,
  },
  {
    original_query: "valencia",
    total_searches: 27,
  },
  {
    original_query: "spanng",
    total_searches: 27,
  },
  {
    original_query: "bettu",
    total_searches: 27,
  },
  {
    original_query: "kunden",
    total_searches: 27,
  },
  {
    original_query: "Sauberlaufm",
    total_searches: 27,
  },
  {
    original_query: "nantes",
    total_searches: 27,
  },
  {
    original_query: "küchentepp",
    total_searches: 27,
  },
  {
    original_query: "antiermüdungsmatte",
    total_searches: 27,
  },
  {
    original_query: "sicherhei",
    total_searches: 27,
  },
  {
    original_query: "Bett",
    total_searches: 27,
  },
  {
    original_query: "treppenkantenpr",
    total_searches: 27,
  },
  {
    original_query: "Seite",
    total_searches: 27,
  },
  {
    original_query: "Übergangspr",
    total_searches: 27,
  },
  {
    original_query: "stuhl",
    total_searches: 27,
  },
  {
    original_query: "Whiteboard",
    total_searches: 27,
  },
  {
    original_query: "sauberlaufteppich",
    total_searches: 27,
  },
  {
    original_query: "Kara",
    total_searches: 27,
  },
  {
    original_query: "modena",
    total_searches: 27,
  },
  {
    original_query: "baumrindenmatte",
    total_searches: 27,
  },
  {
    original_query: "nadelfilzteppich",
    total_searches: 27,
  },
  {
    original_query: "grillschu",
    total_searches: 27,
  },
  {
    original_query: "promenade",
    total_searches: 27,
  },
  {
    original_query: "Saban",
    total_searches: 27,
  },
  {
    original_query: "natura",
    total_searches: 27,
  },
  {
    original_query: "rutschmatte",
    total_searches: 27,
  },
  {
    original_query: "diam",
    total_searches: 27,
  },
  {
    original_query: "Stallm",
    total_searches: 27,
  },
  {
    original_query: "Balkonsichtschutz",
    total_searches: 27,
  },
  {
    original_query: "paradies",
    total_searches: 27,
  },
  {
    original_query: "balkont",
    total_searches: 27,
  },
  {
    original_query: "Treppenstufe",
    total_searches: 27,
  },
  {
    original_query: "küchenteppi",
    total_searches: 27,
  },
  {
    original_query: "Bodenschutzmatt",
    total_searches: 27,
  },
  {
    original_query: "marki",
    total_searches: 27,
  },
  {
    original_query: "colombo",
    total_searches: 27,
  },
  {
    original_query: "Gummimatt",
    total_searches: 27,
  },
  {
    original_query: "toma",
    total_searches: 27,
  },
  {
    original_query: "Bauten",
    total_searches: 27,
  },
  {
    original_query: "Farb",
    total_searches: 27,
  },
  {
    original_query: "White",
    total_searches: 27,
  },
  {
    original_query: "warsaw",
    total_searches: 27,
  },
  {
    original_query: "amaz",
    total_searches: 27,
  },
  {
    original_query: "cancun",
    total_searches: 27,
  },
  {
    original_query: "Holz",
    total_searches: 27,
  },
  {
    original_query: "Sockelle",
    total_searches: 27,
  },
  {
    original_query: "pontiac",
    total_searches: 27,
  },
  {
    original_query: "schlüsseltresor",
    total_searches: 27,
  },
  {
    original_query: "Teppichfliese",
    total_searches: 26,
  },
  {
    original_query: "treppenstufe",
    total_searches: 26,
  },
  {
    original_query: "Treppenstu",
    total_searches: 26,
  },
  {
    original_query: "Terrasse",
    total_searches: 26,
  },
  {
    original_query: "duschvorhang",
    total_searches: 26,
  },
  {
    original_query: "schn",
    total_searches: 26,
  },
  {
    original_query: "juteseil",
    total_searches: 26,
  },
  {
    original_query: "kurzfloor",
    total_searches: 26,
  },
  {
    original_query: "Outdoorteppic",
    total_searches: 26,
  },
  {
    original_query: "korkplatte",
    total_searches: 26,
  },
  {
    original_query: "zelt",
    total_searches: 26,
  },
  {
    original_query: "gummimat",
    total_searches: 26,
  },
  {
    original_query: "flach",
    total_searches: 26,
  },
  {
    original_query: "sockelleis",
    total_searches: 26,
  },
  {
    original_query: "maulwurfgitter",
    total_searches: 26,
  },
  {
    original_query: "piranha",
    total_searches: 26,
  },
  {
    original_query: "Matt",
    total_searches: 26,
  },
  {
    original_query: "abschl",
    total_searches: 26,
  },
  {
    original_query: "foli",
    total_searches: 26,
  },
  {
    original_query: "Sockell",
    total_searches: 26,
  },
  {
    original_query: "Sonnensch",
    total_searches: 26,
  },
  {
    original_query: "Schwerlastregal",
    total_searches: 26,
  },
  {
    original_query: "sauberlaufmatt",
    total_searches: 26,
  },
  {
    original_query: "Gran",
    total_searches: 26,
  },
  {
    original_query: "teppichkleber",
    total_searches: 26,
  },
  {
    original_query: "weit",
    total_searches: 26,
  },
  {
    original_query: "gras",
    total_searches: 26,
  },
  {
    original_query: "treppenkantenprofi",
    total_searches: 26,
  },
  {
    original_query: "treppenkantenprofile",
    total_searches: 26,
  },
  {
    original_query: "monsano",
    total_searches: 26,
  },
  {
    original_query: "handtuch",
    total_searches: 26,
  },
  {
    original_query: "kantenschutz",
    total_searches: 26,
  },
  {
    original_query: "Seiten",
    total_searches: 26,
  },
  {
    original_query: "blum",
    total_searches: 26,
  },
  {
    original_query: "flas",
    total_searches: 26,
  },
  {
    original_query: "Schli",
    total_searches: 26,
  },
  {
    original_query: "schmutzm",
    total_searches: 26,
  },
  {
    original_query: "Teppichfl",
    total_searches: 25,
  },
  {
    original_query: "getränke",
    total_searches: 25,
  },
  {
    original_query: "atlas",
    total_searches: 25,
  },
  {
    original_query: "Stufenkantenprofi",
    total_searches: 25,
  },
  {
    original_query: "unterlegmatte",
    total_searches: 25,
  },
  {
    original_query: "adri",
    total_searches: 25,
  },
  {
    original_query: "flurte",
    total_searches: 25,
  },
  {
    original_query: "Drah",
    total_searches: 25,
  },
  {
    original_query: "Gummiläufer",
    total_searches: 25,
  },
  {
    original_query: "seitenmar",
    total_searches: 25,
  },
  {
    original_query: "stein",
    total_searches: 25,
  },
  {
    original_query: "wasser",
    total_searches: 25,
  },
  {
    original_query: "tritt",
    total_searches: 25,
  },
  {
    original_query: "schmutzma",
    total_searches: 25,
  },
  {
    original_query: "Gummil",
    total_searches: 25,
  },
  {
    original_query: "teppisch",
    total_searches: 25,
  },
  {
    original_query: "Seitenmarkise",
    total_searches: 25,
  },
  {
    original_query: "küchent",
    total_searches: 25,
  },
  {
    original_query: "carou",
    total_searches: 25,
  },
  {
    original_query: "Schl",
    total_searches: 25,
  },
  {
    original_query: "tanaga",
    total_searches: 25,
  },
  {
    original_query: "Teppichfliesen",
    total_searches: 25,
  },
  {
    original_query: "akustikpaneel",
    total_searches: 25,
  },
  {
    original_query: "Übergangspro",
    total_searches: 25,
  },
  {
    original_query: "perform",
    total_searches: 25,
  },
  {
    original_query: "silikon",
    total_searches: 25,
  },
  {
    original_query: "Hochflor",
    total_searches: 25,
  },
  {
    original_query: "Schn",
    total_searches: 25,
  },
  {
    original_query: "Spann",
    total_searches: 25,
  },
  {
    original_query: "stangen",
    total_searches: 25,
  },
  {
    original_query: "wohnzimmerteppich",
    total_searches: 25,
  },
  {
    original_query: "Rutsch",
    total_searches: 25,
  },
  {
    original_query: "telefon",
    total_searches: 25,
  },
  {
    original_query: "abdeckung",
    total_searches: 25,
  },
  {
    original_query: "amazon",
    total_searches: 25,
  },
  {
    original_query: "Terassen",
    total_searches: 25,
  },
  {
    original_query: "Teppichf",
    total_searches: 25,
  },
  {
    original_query: "java",
    total_searches: 25,
  },
  {
    original_query: "schaukas",
    total_searches: 25,
  },
  {
    original_query: "gitt",
    total_searches: 25,
  },
  {
    original_query: "Sockelleis",
    total_searches: 25,
  },
  {
    original_query: "navona",
    total_searches: 25,
  },
  {
    original_query: "grills",
    total_searches: 25,
  },
  {
    original_query: "dach",
    total_searches: 25,
  },
  {
    original_query: "Befest",
    total_searches: 25,
  },
  {
    original_query: "schmutzläufer",
    total_searches: 25,
  },
  {
    original_query: "linol",
    total_searches: 25,
  },
  {
    original_query: "Gummilä",
    total_searches: 24,
  },
  {
    original_query: "Doppelstegplatten",
    total_searches: 24,
  },
  {
    original_query: "teak",
    total_searches: 24,
  },
  {
    original_query: "blumenregal",
    total_searches: 24,
  },
  {
    original_query: "balkonfliesen",
    total_searches: 24,
  },
  {
    original_query: "lagama",
    total_searches: 24,
  },
  {
    original_query: "doppelstegpl",
    total_searches: 24,
  },
  {
    original_query: "tränen",
    total_searches: 24,
  },
  {
    original_query: "stuffen",
    total_searches: 24,
  },
  {
    original_query: "badez",
    total_searches: 24,
  },
  {
    original_query: "sicherh",
    total_searches: 24,
  },
  {
    original_query: "Farbwunder",
    total_searches: 24,
  },
  {
    original_query: "schreib",
    total_searches: 24,
  },
  {
    original_query: "sisallä",
    total_searches: 24,
  },
  {
    original_query: "must",
    total_searches: 24,
  },
  {
    original_query: "rock",
    total_searches: 24,
  },
  {
    original_query: "Rega",
    total_searches: 24,
  },
  {
    original_query: "brilliant",
    total_searches: 24,
  },
  {
    original_query: "terrassenf",
    total_searches: 24,
  },
  {
    original_query: "bademat",
    total_searches: 24,
  },
  {
    original_query: "roya",
    total_searches: 24,
  },
  {
    original_query: "mess",
    total_searches: 24,
  },
  {
    original_query: "schnur",
    total_searches: 24,
  },
  {
    original_query: "gewebepl",
    total_searches: 24,
  },
  {
    original_query: "wühlm",
    total_searches: 24,
  },
  {
    original_query: "ermüdungsmatte",
    total_searches: 24,
  },
  {
    original_query: "Alto",
    total_searches: 24,
  },
  {
    original_query: "garderobenständer",
    total_searches: 24,
  },
  {
    original_query: "stell",
    total_searches: 24,
  },
  {
    original_query: "monoch",
    total_searches: 24,
  },
  {
    original_query: "klickflies",
    total_searches: 24,
  },
  {
    original_query: "Noppen",
    total_searches: 24,
  },
  {
    original_query: "raden",
    total_searches: 24,
  },
  {
    original_query: "badteppic",
    total_searches: 24,
  },
  {
    original_query: "Sonnensc",
    total_searches: 24,
  },
  {
    original_query: "Dusch",
    total_searches: 23,
  },
  {
    original_query: "Klickfliesen",
    total_searches: 23,
  },
  {
    original_query: "hochfloo",
    total_searches: 23,
  },
  {
    original_query: "carlto",
    total_searches: 23,
  },
  {
    original_query: "rutschfes",
    total_searches: 23,
  },
  {
    original_query: "Baute",
    total_searches: 23,
  },
  {
    original_query: "bettumrand",
    total_searches: 23,
  },
  {
    original_query: "reto",
    total_searches: 23,
  },
  {
    original_query: "gummiplatte",
    total_searches: 23,
  },
  {
    original_query: "paddock",
    total_searches: 23,
  },
  {
    original_query: "marble",
    total_searches: 23,
  },
  {
    original_query: "mammut",
    total_searches: 23,
  },
  {
    original_query: "gewebeplan",
    total_searches: 23,
  },
  {
    original_query: "Übergangsp",
    total_searches: 23,
  },
  {
    original_query: "Seit",
    total_searches: 23,
  },
  {
    original_query: "weidenmatte",
    total_searches: 23,
  },
  {
    original_query: "Hochf",
    total_searches: 23,
  },
  {
    original_query: "schutzma",
    total_searches: 23,
  },
  {
    original_query: "müllei",
    total_searches: 23,
  },
  {
    original_query: "bautenschu",
    total_searches: 23,
  },
  {
    original_query: "schmutzfangte",
    total_searches: 23,
  },
  {
    original_query: "klebeban",
    total_searches: 23,
  },
  {
    original_query: "Bali",
    total_searches: 23,
  },
  {
    original_query: "vynil",
    total_searches: 23,
  },
  {
    original_query: "sonja",
    total_searches: 23,
  },
  {
    original_query: "rade",
    total_searches: 23,
  },
  {
    original_query: "Treppenk",
    total_searches: 23,
  },
  {
    original_query: "pavillon",
    total_searches: 23,
  },
  {
    original_query: "vogel",
    total_searches: 23,
  },
  {
    original_query: "treppenmatte",
    total_searches: 23,
  },
  {
    original_query: "Badteppi",
    total_searches: 23,
  },
  {
    original_query: "ella",
    total_searches: 23,
  },
  {
    original_query: "fussmat",
    total_searches: 23,
  },
  {
    original_query: "schaukaste",
    total_searches: 23,
  },
  {
    original_query: "bettumr",
    total_searches: 23,
  },
  {
    original_query: "nopp",
    total_searches: 23,
  },
  {
    original_query: "treppenl",
    total_searches: 23,
  },
  {
    original_query: "stuffenmatte",
    total_searches: 23,
  },
  {
    original_query: "dust",
    total_searches: 23,
  },
  {
    original_query: "sonnenschi",
    total_searches: 23,
  },
  {
    original_query: "Rollenkork",
    total_searches: 23,
  },
  {
    original_query: "baum",
    total_searches: 23,
  },
  {
    original_query: "sisalläu",
    total_searches: 23,
  },
  {
    original_query: "weidenz",
    total_searches: 23,
  },
  {
    original_query: "farbwund",
    total_searches: 23,
  },
  {
    original_query: "metallregal",
    total_searches: 23,
  },
  {
    original_query: "rollho",
    total_searches: 23,
  },
  {
    original_query: "Fußmatt",
    total_searches: 23,
  },
  {
    original_query: "hängematte",
    total_searches: 23,
  },
  {
    original_query: "kalkuta",
    total_searches: 23,
  },
  {
    original_query: "messet",
    total_searches: 23,
  },
  {
    original_query: "Befes",
    total_searches: 23,
  },
  {
    original_query: "teppichfließen",
    total_searches: 23,
  },
  {
    original_query: "bautensc",
    total_searches: 23,
  },
  {
    original_query: "venice",
    total_searches: 23,
  },
  {
    original_query: "bautensch",
    total_searches: 23,
  },
  {
    original_query: "blumenre",
    total_searches: 23,
  },
  {
    original_query: "ausgleichsprofil",
    total_searches: 22,
  },
  {
    original_query: "saube",
    total_searches: 22,
  },
  {
    original_query: "Gitter",
    total_searches: 22,
  },
  {
    original_query: "Versandkosten",
    total_searches: 22,
  },
  {
    original_query: "maschen",
    total_searches: 22,
  },
  {
    original_query: "Gummiläu",
    total_searches: 22,
  },
  {
    original_query: "holzfliesen",
    total_searches: 22,
  },
  {
    original_query: "safet",
    total_searches: 22,
  },
  {
    original_query: "kiel",
    total_searches: 22,
  },
  {
    original_query: "feuer",
    total_searches: 22,
  },
  {
    original_query: "aqua",
    total_searches: 22,
  },
  {
    original_query: "schlingenma",
    total_searches: 22,
  },
  {
    original_query: "sicherhe",
    total_searches: 22,
  },
  {
    original_query: "arbeitsplatzmatte",
    total_searches: 22,
  },
  {
    original_query: "antier",
    total_searches: 22,
  },
  {
    original_query: "fußabstreifer",
    total_searches: 22,
  },
  {
    original_query: "flurl",
    total_searches: 22,
  },
  {
    original_query: "garte",
    total_searches: 22,
  },
  {
    original_query: "schnutz",
    total_searches: 22,
  },
  {
    original_query: "floka",
    total_searches: 22,
  },
  {
    original_query: "Fliesen",
    total_searches: 22,
  },
  {
    original_query: "garage",
    total_searches: 22,
  },
  {
    original_query: "Balkons",
    total_searches: 22,
  },
  {
    original_query: "martin",
    total_searches: 22,
  },
  {
    original_query: "terass",
    total_searches: 22,
  },
  {
    original_query: "teppichs",
    total_searches: 22,
  },
  {
    original_query: "balkonsich",
    total_searches: 22,
  },
  {
    original_query: "erda",
    total_searches: 22,
  },
  {
    original_query: "kunstrasenteppich",
    total_searches: 22,
  },
  {
    original_query: "übergangsleisten",
    total_searches: 22,
  },
  {
    original_query: "fahrradstä",
    total_searches: 22,
  },
  {
    original_query: "küchenregal",
    total_searches: 22,
  },
  {
    original_query: "parkett",
    total_searches: 22,
  },
  {
    original_query: "floordirekt",
    total_searches: 22,
  },
  {
    original_query: "hund",
    total_searches: 22,
  },
  {
    original_query: "flip",
    total_searches: 22,
  },
  {
    original_query: "Kabe",
    total_searches: 22,
  },
  {
    original_query: "balkonbelag",
    total_searches: 22,
  },
  {
    original_query: "floo",
    total_searches: 22,
  },
  {
    original_query: "grand",
    total_searches: 22,
  },
  {
    original_query: "brasi",
    total_searches: 22,
  },
  {
    original_query: "Badtepp",
    total_searches: 22,
  },
  {
    original_query: "akku",
    total_searches: 22,
  },
  {
    original_query: "petrol",
    total_searches: 22,
  },
  {
    original_query: "Profi",
    total_searches: 22,
  },
  {
    original_query: "ikaria",
    total_searches: 22,
  },
  {
    original_query: "schaffell",
    total_searches: 22,
  },
  {
    original_query: "Schlin",
    total_searches: 22,
  },
  {
    original_query: "gewebepla",
    total_searches: 22,
  },
  {
    original_query: "doppelstegpla",
    total_searches: 22,
  },
  {
    original_query: "korkmatte",
    total_searches: 22,
  },
  {
    original_query: "steck",
    total_searches: 22,
  },
  {
    original_query: "Klickfliese",
    total_searches: 22,
  },
  {
    original_query: "Balkonteppich",
    total_searches: 22,
  },
  {
    original_query: "fusmatte",
    total_searches: 22,
  },
  {
    original_query: "kunde",
    total_searches: 22,
  },
  {
    original_query: "floor",
    total_searches: 22,
  },
  {
    original_query: "plisee",
    total_searches: 22,
  },
  {
    original_query: "eingangsmatten",
    total_searches: 22,
  },
  {
    original_query: "bettumra",
    total_searches: 22,
  },
  {
    original_query: "balkonsichtschu",
    total_searches: 22,
  },
  {
    original_query: "teppichstufen",
    total_searches: 21,
  },
  {
    original_query: "laeufer",
    total_searches: 21,
  },
  {
    original_query: "treppenstufenmatten",
    total_searches: 21,
  },
  {
    original_query: "Planen",
    total_searches: 21,
  },
  {
    original_query: "Schwerl",
    total_searches: 21,
  },
  {
    original_query: "Küchenläuf",
    total_searches: 21,
  },
  {
    original_query: "klapptritt",
    total_searches: 21,
  },
  {
    original_query: "treppenstu",
    total_searches: 21,
  },
  {
    original_query: "Befestigu",
    total_searches: 21,
  },
  {
    original_query: "sonnenschir",
    total_searches: 21,
  },
  {
    original_query: "treppenkantenprof",
    total_searches: 21,
  },
  {
    original_query: "turb",
    total_searches: 21,
  },
  {
    original_query: "Wühl",
    total_searches: 21,
  },
  {
    original_query: "paul",
    total_searches: 21,
  },
  {
    original_query: "verdun",
    total_searches: 21,
  },
  {
    original_query: "hering",
    total_searches: 21,
  },
  {
    original_query: "vita",
    total_searches: 21,
  },
  {
    original_query: "teppichdielen",
    total_searches: 21,
  },
  {
    original_query: "farbwunde",
    total_searches: 21,
  },
  {
    original_query: "optimum",
    total_searches: 21,
  },
  {
    original_query: "schlingenteppich",
    total_searches: 21,
  },
  {
    original_query: "chester",
    total_searches: 21,
  },
  {
    original_query: "braun",
    total_searches: 21,
  },
  {
    original_query: "fliege",
    total_searches: 21,
  },
  {
    original_query: "grace",
    total_searches: 21,
  },
  {
    original_query: "terras",
    total_searches: 21,
  },
  {
    original_query: "fussabstreifer",
    total_searches: 21,
  },
  {
    original_query: "Tisc",
    total_searches: 21,
  },
  {
    original_query: "Kokos",
    total_searches: 21,
  },
  {
    original_query: "flieg",
    total_searches: 21,
  },
  {
    original_query: "Drahtgitter",
    total_searches: 21,
  },
  {
    original_query: "turin",
    total_searches: 21,
  },
  {
    original_query: "Ruts",
    total_searches: 21,
  },
  {
    original_query: "spectral",
    total_searches: 21,
  },
  {
    original_query: "Sockellei",
    total_searches: 21,
  },
  {
    original_query: "übergangsschiene",
    total_searches: 21,
  },
  {
    original_query: "trittschalldämmung",
    total_searches: 21,
  },
  {
    original_query: "Schmutzfangmatten",
    total_searches: 21,
  },
  {
    original_query: "charly",
    total_searches: 21,
  },
  {
    original_query: "teras",
    total_searches: 21,
  },
  {
    original_query: "teichfolie",
    total_searches: 21,
  },
  {
    original_query: "Unkraut",
    total_searches: 21,
  },
  {
    original_query: "Koko",
    total_searches: 21,
  },
  {
    original_query: "schmutzfanglä",
    total_searches: 21,
  },
  {
    original_query: "teppichstangen",
    total_searches: 21,
  },
  {
    original_query: "küchenteppic",
    total_searches: 21,
  },
  {
    original_query: "sisalmatte",
    total_searches: 21,
  },
  {
    original_query: "kund",
    total_searches: 21,
  },
  {
    original_query: "pflan",
    total_searches: 21,
  },
  {
    original_query: "gene",
    total_searches: 21,
  },
  {
    original_query: "Kabelbin",
    total_searches: 21,
  },
  {
    original_query: "Grills",
    total_searches: 21,
  },
  {
    original_query: "anthrazit",
    total_searches: 21,
  },
  {
    original_query: "moderations",
    total_searches: 21,
  },
  {
    original_query: "stuffe",
    total_searches: 21,
  },
  {
    original_query: "unkr",
    total_searches: 21,
  },
  {
    original_query: "wohnteppich",
    total_searches: 21,
  },
  {
    original_query: "atlan",
    total_searches: 21,
  },
  {
    original_query: "expander",
    total_searches: 21,
  },
  {
    original_query: "türkis",
    total_searches: 21,
  },
  {
    original_query: "bettumran",
    total_searches: 21,
  },
  {
    original_query: "monoc",
    total_searches: 20,
  },
  {
    original_query: "badteppiche",
    total_searches: 20,
  },
  {
    original_query: "schmutzfsng",
    total_searches: 20,
  },
  {
    original_query: "Prof",
    total_searches: 20,
  },
  {
    original_query: "Garte",
    total_searches: 20,
  },
  {
    original_query: "Befesti",
    total_searches: 20,
  },
  {
    original_query: "sprühk",
    total_searches: 20,
  },
  {
    original_query: "Sprühkl",
    total_searches: 20,
  },
  {
    original_query: "drahtgitt",
    total_searches: 20,
  },
  {
    original_query: "berlin",
    total_searches: 20,
  },
  {
    original_query: "kratzte",
    total_searches: 20,
  },
  {
    original_query: "nelly",
    total_searches: 20,
  },
  {
    original_query: "abschlu",
    total_searches: 20,
  },
  {
    original_query: "schrauben",
    total_searches: 20,
  },
  {
    original_query: "Antiv",
    total_searches: 20,
  },
  {
    original_query: "gummiläuf",
    total_searches: 20,
  },
  {
    original_query: "bettumrandun",
    total_searches: 20,
  },
  {
    original_query: "Antivi",
    total_searches: 20,
  },
  {
    original_query: "Schau",
    total_searches: 20,
  },
  {
    original_query: "tretford",
    total_searches: 20,
  },
  {
    original_query: "badete",
    total_searches: 20,
  },
  {
    original_query: "magnetwand",
    total_searches: 20,
  },
  {
    original_query: "rhone",
    total_searches: 20,
  },
  {
    original_query: "retou",
    total_searches: 20,
  },
  {
    original_query: "rutschfeste",
    total_searches: 20,
  },
  {
    original_query: "getränkekistenregal",
    total_searches: 20,
  },
  {
    original_query: "Schmitz",
    total_searches: 20,
  },
  {
    original_query: "bodenleiste",
    total_searches: 20,
  },
  {
    original_query: "gummigra",
    total_searches: 20,
  },
  {
    original_query: "atlant",
    total_searches: 20,
  },
  {
    original_query: "Rollen",
    total_searches: 20,
  },
  {
    original_query: "rinden",
    total_searches: 20,
  },
  {
    original_query: "moderat",
    total_searches: 20,
  },
  {
    original_query: "modera",
    total_searches: 20,
  },
  {
    original_query: "falt",
    total_searches: 20,
  },
  {
    original_query: "archway",
    total_searches: 20,
  },
  {
    original_query: "pisa",
    total_searches: 20,
  },
  {
    original_query: "sund",
    total_searches: 20,
  },
  {
    original_query: "rassenteppich",
    total_searches: 20,
  },
  {
    original_query: "heidekrautmatte",
    total_searches: 20,
  },
  {
    original_query: "Badematten",
    total_searches: 20,
  },
  {
    original_query: "Sisalteppic",
    total_searches: 20,
  },
  {
    original_query: "Schmutzfangmat",
    total_searches: 20,
  },
  {
    original_query: "berber",
    total_searches: 20,
  },
  {
    original_query: "Küchente",
    total_searches: 20,
  },
  {
    original_query: "stal",
    total_searches: 20,
  },
  {
    original_query: "integra",
    total_searches: 20,
  },
  {
    original_query: "Farbw",
    total_searches: 20,
  },
  {
    original_query: "clai",
    total_searches: 20,
  },
  {
    original_query: "Schwerlas",
    total_searches: 20,
  },
  {
    original_query: "Balkonte",
    total_searches: 20,
  },
  {
    original_query: "markisen",
    total_searches: 20,
  },
  {
    original_query: "matera",
    total_searches: 20,
  },
  {
    original_query: "kleur",
    total_searches: 20,
  },
  {
    original_query: "acry",
    total_searches: 20,
  },
  {
    original_query: "terassenf",
    total_searches: 20,
  },
  {
    original_query: "orange",
    total_searches: 20,
  },
  {
    original_query: "blume",
    total_searches: 20,
  },
  {
    original_query: "pferde",
    total_searches: 20,
  },
  {
    original_query: "trenn",
    total_searches: 20,
  },
  {
    original_query: "büroteppich",
    total_searches: 20,
  },
  {
    original_query: "rutschfe",
    total_searches: 20,
  },
  {
    original_query: "unkrau",
    total_searches: 20,
  },
  {
    original_query: "boston",
    total_searches: 20,
  },
  {
    original_query: "Teppichfli",
    total_searches: 19,
  },
  {
    original_query: "Whiteb",
    total_searches: 19,
  },
  {
    original_query: "Doppelstegp",
    total_searches: 19,
  },
  {
    original_query: "breite",
    total_searches: 19,
  },
  {
    original_query: "Versandko",
    total_searches: 19,
  },
  {
    original_query: "Muster",
    total_searches: 19,
  },
  {
    original_query: "fußleiste",
    total_searches: 19,
  },
  {
    original_query: "segel",
    total_searches: 19,
  },
  {
    original_query: "feuerschale",
    total_searches: 19,
  },
  {
    original_query: "Treppenkante",
    total_searches: 19,
  },
  {
    original_query: "navelli",
    total_searches: 19,
  },
  {
    original_query: "verb",
    total_searches: 19,
  },
  {
    original_query: "superfle",
    total_searches: 19,
  },
  {
    original_query: "Antirutschmatte",
    total_searches: 19,
  },
  {
    original_query: "badläufer",
    total_searches: 19,
  },
  {
    original_query: "Schmi",
    total_searches: 19,
  },
  {
    original_query: "asti",
    total_searches: 19,
  },
  {
    original_query: "sichtschutzz",
    total_searches: 19,
  },
  {
    original_query: "trier",
    total_searches: 19,
  },
  {
    original_query: "pflanzen",
    total_searches: 19,
  },
  {
    original_query: "cheron",
    total_searches: 19,
  },
  {
    original_query: "flokat",
    total_searches: 19,
  },
  {
    original_query: "abdeckleiste",
    total_searches: 19,
  },
  {
    original_query: "biden",
    total_searches: 19,
  },
  {
    original_query: "rise",
    total_searches: 19,
  },
  {
    original_query: "Treppenkan",
    total_searches: 19,
  },
  {
    original_query: "reklamation",
    total_searches: 19,
  },
  {
    original_query: "Grandeur",
    total_searches: 19,
  },
  {
    original_query: "katzenschutznetz",
    total_searches: 19,
  },
  {
    original_query: "heizmatten",
    total_searches: 19,
  },
  {
    original_query: "moskau",
    total_searches: 19,
  },
  {
    original_query: "korkplatten",
    total_searches: 19,
  },
  {
    original_query: "halbrund",
    total_searches: 19,
  },
  {
    original_query: "befestigungsschi",
    total_searches: 19,
  },
  {
    original_query: "marigold",
    total_searches: 19,
  },
  {
    original_query: "Hochfl",
    total_searches: 19,
  },
  {
    original_query: "plaza",
    total_searches: 19,
  },
  {
    original_query: "Schwerlast",
    total_searches: 19,
  },
  {
    original_query: "cubo",
    total_searches: 19,
  },
  {
    original_query: "krat",
    total_searches: 19,
  },
  {
    original_query: "superfl",
    total_searches: 19,
  },
  {
    original_query: "terassenfl",
    total_searches: 19,
  },
  {
    original_query: "antierm",
    total_searches: 19,
  },
  {
    original_query: "stallboden",
    total_searches: 19,
  },
  {
    original_query: "Sonnenschutz",
    total_searches: 19,
  },
  {
    original_query: "sparrow",
    total_searches: 19,
  },
  {
    original_query: "teppichunter",
    total_searches: 19,
  },
  {
    original_query: "balkonsichts",
    total_searches: 19,
  },
  {
    original_query: "Schw",
    total_searches: 19,
  },
  {
    original_query: "Trep",
    total_searches: 19,
  },
  {
    original_query: "dallas",
    total_searches: 19,
  },
  {
    original_query: "wild",
    total_searches: 19,
  },
  {
    original_query: "glor",
    total_searches: 19,
  },
  {
    original_query: "monochr",
    total_searches: 19,
  },
  {
    original_query: "fließ",
    total_searches: 19,
  },
  {
    original_query: "flurtepp",
    total_searches: 19,
  },
  {
    original_query: "filzmatte",
    total_searches: 19,
  },
  {
    original_query: "dots",
    total_searches: 19,
  },
  {
    original_query: "flurlä",
    total_searches: 19,
  },
  {
    original_query: "katzennetz",
    total_searches: 19,
  },
  {
    original_query: "bautenschut",
    total_searches: 19,
  },
  {
    original_query: "unkra",
    total_searches: 19,
  },
  {
    original_query: "pflanz",
    total_searches: 19,
  },
  {
    original_query: "telefonnummer",
    total_searches: 19,
  },
  {
    original_query: "Befestigung",
    total_searches: 19,
  },
  {
    original_query: "vibration",
    total_searches: 18,
  },
  {
    original_query: "Dura",
    total_searches: 18,
  },
  {
    original_query: "schauka",
    total_searches: 18,
  },
  {
    original_query: "Whit",
    total_searches: 18,
  },
  {
    original_query: "lakot",
    total_searches: 18,
  },
  {
    original_query: "shagg",
    total_searches: 18,
  },
  {
    original_query: "audrey",
    total_searches: 18,
  },
  {
    original_query: "tischschutz",
    total_searches: 18,
  },
  {
    original_query: "Hochflo",
    total_searches: 18,
  },
  {
    original_query: "therm",
    total_searches: 18,
  },
  {
    original_query: "Sundae",
    total_searches: 18,
  },
  {
    original_query: "schmutzfangläu",
    total_searches: 18,
  },
  {
    original_query: "camper",
    total_searches: 18,
  },
  {
    original_query: "Maschendraht",
    total_searches: 18,
  },
  {
    original_query: "akkust",
    total_searches: 18,
  },
  {
    original_query: "oval",
    total_searches: 18,
  },
  {
    original_query: "kant",
    total_searches: 18,
  },
  {
    original_query: "magnus",
    total_searches: 18,
  },
  {
    original_query: "geona",
    total_searches: 18,
  },
  {
    original_query: "treppenm",
    total_searches: 18,
  },
  {
    original_query: "treppenlä",
    total_searches: 18,
  },
  {
    original_query: "Treppenka",
    total_searches: 18,
  },
  {
    original_query: "spanngurt",
    total_searches: 18,
  },
  {
    original_query: "Kabelb",
    total_searches: 18,
  },
  {
    original_query: "Doppelstegplatt",
    total_searches: 18,
  },
  {
    original_query: "lagos",
    total_searches: 18,
  },
  {
    original_query: "teppichb",
    total_searches: 18,
  },
  {
    original_query: "Bodenbelag",
    total_searches: 18,
  },
  {
    original_query: "schmutzfangl",
    total_searches: 18,
  },
  {
    original_query: "tralee",
    total_searches: 18,
  },
  {
    original_query: "Balkont",
    total_searches: 18,
  },
  {
    original_query: "sockelleist",
    total_searches: 18,
  },
  {
    original_query: "leis",
    total_searches: 18,
  },
  {
    original_query: "edelstahl",
    total_searches: 18,
  },
  {
    original_query: "maul",
    total_searches: 18,
  },
  {
    original_query: "außen",
    total_searches: 18,
  },
  {
    original_query: "bauschutzmatte",
    total_searches: 18,
  },
  {
    original_query: "filzt",
    total_searches: 18,
  },
  {
    original_query: "Schwe",
    total_searches: 18,
  },
  {
    original_query: "naturstein",
    total_searches: 18,
  },
  {
    original_query: "antirutschmat",
    total_searches: 18,
  },
  {
    original_query: "wasc",
    total_searches: 18,
  },
  {
    original_query: "passage",
    total_searches: 18,
  },
  {
    original_query: "james",
    total_searches: 18,
  },
  {
    original_query: "antiermü",
    total_searches: 18,
  },
  {
    original_query: "befestigungss",
    total_searches: 18,
  },
  {
    original_query: "terrassenfli",
    total_searches: 18,
  },
  {
    original_query: "türmatten",
    total_searches: 18,
  },
  {
    original_query: "Sylt",
    total_searches: 18,
  },
  {
    original_query: "schutzmatten",
    total_searches: 18,
  },
  {
    original_query: "atlanti",
    total_searches: 18,
  },
  {
    original_query: "kratzt",
    total_searches: 18,
  },
  {
    original_query: "masche",
    total_searches: 18,
  },
  {
    original_query: "laüfer",
    total_searches: 18,
  },
  {
    original_query: "arno",
    total_searches: 18,
  },
  {
    original_query: "Outdo",
    total_searches: 18,
  },
  {
    original_query: "tomat",
    total_searches: 18,
  },
  {
    original_query: "klebeba",
    total_searches: 18,
  },
  {
    original_query: "Profil",
    total_searches: 18,
  },
  {
    original_query: "ennis",
    total_searches: 18,
  },
  {
    original_query: "navan",
    total_searches: 18,
  },
  {
    original_query: "hygiene",
    total_searches: 18,
  },
  {
    original_query: "Impre",
    total_searches: 18,
  },
  {
    original_query: "Antivibrationsmatte",
    total_searches: 18,
  },
  {
    original_query: "kalkut",
    total_searches: 18,
  },
  {
    original_query: "badma",
    total_searches: 18,
  },
  {
    original_query: "sunda",
    total_searches: 18,
  },
  {
    original_query: "honk",
    total_searches: 18,
  },
  {
    original_query: "carouse",
    total_searches: 18,
  },
  {
    original_query: "thomas",
    total_searches: 18,
  },
  {
    original_query: "schmitzfang",
    total_searches: 18,
  },
  {
    original_query: "treppenschoner",
    total_searches: 18,
  },
  {
    original_query: "Übergangsprofi",
    total_searches: 18,
  },
  {
    original_query: "schmitzfangmatte",
    total_searches: 18,
  },
  {
    original_query: "zaunblend",
    total_searches: 18,
  },
  {
    original_query: "baumwolle",
    total_searches: 18,
  },
  {
    original_query: "sisalop",
    total_searches: 18,
  },
  {
    original_query: "fussa",
    total_searches: 18,
  },
  {
    original_query: "mark",
    total_searches: 18,
  },
  {
    original_query: "fahrrads",
    total_searches: 18,
  },
  {
    original_query: "akkus",
    total_searches: 18,
  },
  {
    original_query: "gelb",
    total_searches: 18,
  },
  {
    original_query: "treppenteppic",
    total_searches: 18,
  },
  {
    original_query: "aztec",
    total_searches: 18,
  },
  {
    original_query: "rankgitter",
    total_searches: 18,
  },
  {
    original_query: "sisalläuf",
    total_searches: 17,
  },
  {
    original_query: "luft",
    total_searches: 17,
  },
  {
    original_query: "duschma",
    total_searches: 17,
  },
  {
    original_query: "stanf",
    total_searches: 17,
  },
  {
    original_query: "schmutzfangtepp",
    total_searches: 17,
  },
  {
    original_query: "doppelstegp",
    total_searches: 17,
  },
  {
    original_query: "nass",
    total_searches: 17,
  },
  {
    original_query: "nadelflies",
    total_searches: 17,
  },
  {
    original_query: "gummiband",
    total_searches: 17,
  },
  {
    original_query: "Kabelbi",
    total_searches: 17,
  },
  {
    original_query: "Küchent",
    total_searches: 17,
  },
  {
    original_query: "Raden",
    total_searches: 17,
  },
  {
    original_query: "fußmat",
    total_searches: 17,
  },
  {
    original_query: "Noppe",
    total_searches: 17,
  },
  {
    original_query: "Befe",
    total_searches: 17,
  },
  {
    original_query: "badezi",
    total_searches: 17,
  },
  {
    original_query: "reifenregal",
    total_searches: 17,
  },
  {
    original_query: "Treppenstuf",
    total_searches: 17,
  },
  {
    original_query: "Selbst",
    total_searches: 17,
  },
  {
    original_query: "gitte",
    total_searches: 17,
  },
  {
    original_query: "Unkra",
    total_searches: 17,
  },
  {
    original_query: "Seitenma",
    total_searches: 17,
  },
  {
    original_query: "lieferung",
    total_searches: 17,
  },
  {
    original_query: "fenster",
    total_searches: 17,
  },
  {
    original_query: "Sauberlaufmatt",
    total_searches: 17,
  },
  {
    original_query: "wars",
    total_searches: 17,
  },
  {
    original_query: "Bettu",
    total_searches: 17,
  },
  {
    original_query: "magnetrahmen",
    total_searches: 17,
  },
  {
    original_query: "cotton",
    total_searches: 17,
  },
  {
    original_query: "sport",
    total_searches: 17,
  },
  {
    original_query: "grillsc",
    total_searches: 17,
  },
  {
    original_query: "folien",
    total_searches: 17,
  },
  {
    original_query: "raba",
    total_searches: 17,
  },
  {
    original_query: "werkbank",
    total_searches: 17,
  },
  {
    original_query: "badeteppi",
    total_searches: 17,
  },
  {
    original_query: "kurzflorteppich",
    total_searches: 17,
  },
  {
    original_query: "blackout",
    total_searches: 17,
  },
  {
    original_query: "schilf",
    total_searches: 17,
  },
  {
    original_query: "lyonn",
    total_searches: 17,
  },
  {
    original_query: "Drahtgi",
    total_searches: 17,
  },
  {
    original_query: "cudilero",
    total_searches: 17,
  },
  {
    original_query: "lino",
    total_searches: 17,
  },
  {
    original_query: "rückse",
    total_searches: 17,
  },
  {
    original_query: "flor",
    total_searches: 17,
  },
  {
    original_query: "whiteboardfolien",
    total_searches: 17,
  },
  {
    original_query: "whiteboardfolie",
    total_searches: 17,
  },
  {
    original_query: "sisalopt",
    total_searches: 17,
  },
  {
    original_query: "stacheldraht",
    total_searches: 17,
  },
  {
    original_query: "stegplatten",
    total_searches: 17,
  },
  {
    original_query: "Plissee",
    total_searches: 17,
  },
  {
    original_query: "spanndraht",
    total_searches: 17,
  },
  {
    original_query: "kundenst",
    total_searches: 17,
  },
  {
    original_query: "fussab",
    total_searches: 17,
  },
  {
    original_query: "antivibratio",
    total_searches: 17,
  },
  {
    original_query: "mobile",
    total_searches: 17,
  },
  {
    original_query: "leder",
    total_searches: 17,
  },
  {
    original_query: "gartenzaun",
    total_searches: 17,
  },
  {
    original_query: "bettumrandu",
    total_searches: 17,
  },
  {
    original_query: "Teppichflie",
    total_searches: 17,
  },
  {
    original_query: "schutzfolie",
    total_searches: 17,
  },
  {
    original_query: "genev",
    total_searches: 17,
  },
  {
    original_query: "neodym",
    total_searches: 17,
  },
  {
    original_query: "paris",
    total_searches: 17,
  },
  {
    original_query: "Wühlm",
    total_searches: 17,
  },
  {
    original_query: "camping",
    total_searches: 17,
  },
  {
    original_query: "tepiche",
    total_searches: 17,
  },
  {
    original_query: "balkonsichtsch",
    total_searches: 17,
  },
  {
    original_query: "carlt",
    total_searches: 17,
  },
  {
    original_query: "spanngurte",
    total_searches: 17,
  },
  {
    original_query: "Klickf",
    total_searches: 17,
  },
  {
    original_query: "weitsp",
    total_searches: 17,
  },
  {
    original_query: "Schling",
    total_searches: 17,
  },
  {
    original_query: "flurläu",
    total_searches: 17,
  },
  {
    original_query: "tirana",
    total_searches: 17,
  },
  {
    original_query: "boot",
    total_searches: 17,
  },
  {
    original_query: "grillsch",
    total_searches: 17,
  },
  {
    original_query: "kantenpro",
    total_searches: 17,
  },
  {
    original_query: "vlie",
    total_searches: 17,
  },
  {
    original_query: "Antirutschma",
    total_searches: 17,
  },
  {
    original_query: "Badteppic",
    total_searches: 17,
  },
  {
    original_query: "rosa",
    total_searches: 17,
  },
  {
    original_query: "spark",
    total_searches: 17,
  },
  {
    original_query: "flac",
    total_searches: 17,
  },
  {
    original_query: "Carlton",
    total_searches: 17,
  },
  {
    original_query: "autot",
    total_searches: 17,
  },
  {
    original_query: "blumenrega",
    total_searches: 17,
  },
  {
    original_query: "sonnenschein",
    total_searches: 17,
  },
  {
    original_query: "rapi",
    total_searches: 17,
  },
  {
    original_query: "fahrradstän",
    total_searches: 17,
  },
  {
    original_query: "nova",
    total_searches: 17,
  },
  {
    original_query: "doppelroll",
    total_searches: 17,
  },
  {
    original_query: "Seitenm",
    total_searches: 17,
  },
  {
    original_query: "Mono",
    total_searches: 17,
  },
  {
    original_query: "verdunk",
    total_searches: 16,
  },
  {
    original_query: "zubehör",
    total_searches: 16,
  },
  {
    original_query: "weichschaum",
    total_searches: 16,
  },
  {
    original_query: "wind",
    total_searches: 16,
  },
  {
    original_query: "terrassenfl",
    total_searches: 16,
  },
  {
    original_query: "heizte",
    total_searches: 16,
  },
  {
    original_query: "classic",
    total_searches: 16,
  },
  {
    original_query: "clair",
    total_searches: 16,
  },
  {
    original_query: "kong",
    total_searches: 16,
  },
  {
    original_query: "balkonsichtsc",
    total_searches: 16,
  },
  {
    original_query: "flok",
    total_searches: 16,
  },
  {
    original_query: "gordon",
    total_searches: 16,
  },
  {
    original_query: "verzinkt",
    total_searches: 16,
  },
  {
    original_query: "kundens",
    total_searches: 16,
  },
  {
    original_query: "apollo",
    total_searches: 16,
  },
  {
    original_query: "Sockelleist",
    total_searches: 16,
  },
  {
    original_query: "teppichlaufer",
    total_searches: 16,
  },
  {
    original_query: "heidek",
    total_searches: 16,
  },
  {
    original_query: "Bettum",
    total_searches: 16,
  },
  {
    original_query: "bodenanker",
    total_searches: 16,
  },
  {
    original_query: "Balkonteppi",
    total_searches: 16,
  },
  {
    original_query: "Balkonsi",
    total_searches: 16,
  },
  {
    original_query: "tränenblech",
    total_searches: 16,
  },
  {
    original_query: "titan",
    total_searches: 16,
  },
  {
    original_query: "rimu",
    total_searches: 16,
  },
  {
    original_query: "brillant",
    total_searches: 16,
  },
  {
    original_query: "Teppichläufe",
    total_searches: 16,
  },
  {
    original_query: "vena",
    total_searches: 16,
  },
  {
    original_query: "Trap",
    total_searches: 16,
  },
  {
    original_query: "balkonteppic",
    total_searches: 16,
  },
  {
    original_query: "Nopp",
    total_searches: 16,
  },
  {
    original_query: "schnu",
    total_searches: 16,
  },
  {
    original_query: "rutschf",
    total_searches: 16,
  },
  {
    original_query: "bambuste",
    total_searches: 16,
  },
  {
    original_query: "bodenfliesen",
    total_searches: 16,
  },
  {
    original_query: "dayli",
    total_searches: 16,
  },
  {
    original_query: "handtücher",
    total_searches: 16,
  },
  {
    original_query: "Pool",
    total_searches: 16,
  },
  {
    original_query: "Velo",
    total_searches: 16,
  },
  {
    original_query: "seitenmarki",
    total_searches: 16,
  },
  {
    original_query: "flurt",
    total_searches: 16,
  },
  {
    original_query: "stec",
    total_searches: 16,
  },
  {
    original_query: "Klickfli",
    total_searches: 16,
  },
  {
    original_query: "schmutzfs",
    total_searches: 16,
  },
  {
    original_query: "noppenbahn",
    total_searches: 16,
  },
  {
    original_query: "Calama",
    total_searches: 16,
  },
  {
    original_query: "Rück",
    total_searches: 16,
  },
  {
    original_query: "sprühklebe",
    total_searches: 16,
  },
  {
    original_query: "filztasche",
    total_searches: 16,
  },
  {
    original_query: "Fahrrad",
    total_searches: 16,
  },
  {
    original_query: "innenraum",
    total_searches: 16,
  },
  {
    original_query: "Poly",
    total_searches: 16,
  },
  {
    original_query: "Drahtg",
    total_searches: 16,
  },
  {
    original_query: "stufenkantenprofile",
    total_searches: 16,
  },
  {
    original_query: "sauberlaufmat",
    total_searches: 16,
  },
  {
    original_query: "Vers",
    total_searches: 16,
  },
  {
    original_query: "wohnmobil",
    total_searches: 16,
  },
  {
    original_query: "rasengitter",
    total_searches: 16,
  },
  {
    original_query: "gummigr",
    total_searches: 16,
  },
  {
    original_query: "Schlingen",
    total_searches: 16,
  },
  {
    original_query: "Sonnenschirm",
    total_searches: 16,
  },
  {
    original_query: "Wasch",
    total_searches: 16,
  },
  {
    original_query: "gardinen",
    total_searches: 16,
  },
  {
    original_query: "base",
    total_searches: 16,
  },
  {
    original_query: "tango",
    total_searches: 16,
  },
  {
    original_query: "barc",
    total_searches: 16,
  },
  {
    original_query: "marker",
    total_searches: 16,
  },
  {
    original_query: "metall",
    total_searches: 16,
  },
  {
    original_query: "kofferraum",
    total_searches: 16,
  },
  {
    original_query: "bodenbela",
    total_searches: 16,
  },
  {
    original_query: "fußboden",
    total_searches: 16,
  },
  {
    original_query: "ausgleichs",
    total_searches: 16,
  },
  {
    original_query: "schutzfang",
    total_searches: 16,
  },
  {
    original_query: "kordel",
    total_searches: 16,
  },
  {
    original_query: "weitspa",
    total_searches: 16,
  },
  {
    original_query: "umtausch",
    total_searches: 16,
  },
  {
    original_query: "Sprühkle",
    total_searches: 16,
  },
  {
    original_query: "rips",
    total_searches: 16,
  },
  {
    original_query: "dokumentenhalter",
    total_searches: 16,
  },
  {
    original_query: "Bettumrandung",
    total_searches: 16,
  },
  {
    original_query: "Küchenteppich",
    total_searches: 16,
  },
  {
    original_query: "hochbeet",
    total_searches: 16,
  },
  {
    original_query: "Wühlmaus",
    total_searches: 16,
  },
  {
    original_query: "palau",
    total_searches: 16,
  },
  {
    original_query: "tres",
    total_searches: 15,
  },
  {
    original_query: "Saube",
    total_searches: 15,
  },
  {
    original_query: "stellw",
    total_searches: 15,
  },
  {
    original_query: "luftentfeuchter",
    total_searches: 15,
  },
  {
    original_query: "trapezb",
    total_searches: 15,
  },
  {
    original_query: "brush",
    total_searches: 15,
  },
  {
    original_query: "polypropylen",
    total_searches: 15,
  },
  {
    original_query: "baste",
    total_searches: 15,
  },
  {
    original_query: "bambuss",
    total_searches: 15,
  },
  {
    original_query: "Rutsc",
    total_searches: 15,
  },
  {
    original_query: "kellerregal",
    total_searches: 15,
  },
  {
    original_query: "rankhilfe",
    total_searches: 15,
  },
  {
    original_query: "hocker",
    total_searches: 15,
  },
  {
    original_query: "fliegeng",
    total_searches: 15,
  },
  {
    original_query: "kratzpappe",
    total_searches: 15,
  },
  {
    original_query: "bodenbe",
    total_searches: 15,
  },
  {
    original_query: "Fussmatten",
    total_searches: 15,
  },
  {
    original_query: "Baut",
    total_searches: 15,
  },
  {
    original_query: "Schlinge",
    total_searches: 15,
  },
  {
    original_query: "Mariu",
    total_searches: 15,
  },
  {
    original_query: "dicht",
    total_searches: 15,
  },
  {
    original_query: "Küchenteppi",
    total_searches: 15,
  },
  {
    original_query: "Treppenteppich",
    total_searches: 15,
  },
  {
    original_query: "Maschen",
    total_searches: 15,
  },
  {
    original_query: "bambussichtschutz",
    total_searches: 15,
  },
  {
    original_query: "weitspann",
    total_searches: 15,
  },
  {
    original_query: "ringgu",
    total_searches: 15,
  },
  {
    original_query: "atla",
    total_searches: 15,
  },
  {
    original_query: "Befestig",
    total_searches: 15,
  },
  {
    original_query: "sichtschutzza",
    total_searches: 15,
  },
  {
    original_query: "Kalku",
    total_searches: 15,
  },
  {
    original_query: "monochro",
    total_searches: 15,
  },
  {
    original_query: "leip",
    total_searches: 15,
  },
  {
    original_query: "Grillschutz",
    total_searches: 15,
  },
  {
    original_query: "innen",
    total_searches: 15,
  },
  {
    original_query: "schuhablage",
    total_searches: 15,
  },
  {
    original_query: "schreibtischstuhlunterlage",
    total_searches: 15,
  },
  {
    original_query: "leist",
    total_searches: 15,
  },
  {
    original_query: "garderobe",
    total_searches: 15,
  },
  {
    original_query: "Rollo",
    total_searches: 15,
  },
  {
    original_query: "wash",
    total_searches: 15,
  },
  {
    original_query: "lila",
    total_searches: 15,
  },
  {
    original_query: "sicherheitsm",
    total_searches: 15,
  },
  {
    original_query: "juta",
    total_searches: 15,
  },
  {
    original_query: "eventteppich",
    total_searches: 15,
  },
  {
    original_query: "Baum",
    total_searches: 15,
  },
  {
    original_query: "Laufer",
    total_searches: 15,
  },
  {
    original_query: "kurzf",
    total_searches: 15,
  },
  {
    original_query: "verbin",
    total_searches: 15,
  },
  {
    original_query: "Antirutschm",
    total_searches: 15,
  },
  {
    original_query: "spiel",
    total_searches: 15,
  },
  {
    original_query: "siche",
    total_searches: 15,
  },
  {
    original_query: "Carl",
    total_searches: 15,
  },
  {
    original_query: "Farbwu",
    total_searches: 15,
  },
  {
    original_query: "Balkonsicht",
    total_searches: 15,
  },
  {
    original_query: "diamon",
    total_searches: 15,
  },
  {
    original_query: "Unkr",
    total_searches: 15,
  },
  {
    original_query: "wanneneinlage",
    total_searches: 15,
  },
  {
    original_query: "sichtschutzzau",
    total_searches: 15,
  },
  {
    original_query: "Rolle",
    total_searches: 15,
  },
  {
    original_query: "Velour",
    total_searches: 15,
  },
  {
    original_query: "tischdecken",
    total_searches: 15,
  },
  {
    original_query: "böschungsmatte",
    total_searches: 15,
  },
  {
    original_query: "türma",
    total_searches: 15,
  },
  {
    original_query: "pane",
    total_searches: 15,
  },
  {
    original_query: "bologna",
    total_searches: 15,
  },
  {
    original_query: "platten",
    total_searches: 15,
  },
  {
    original_query: "selb",
    total_searches: 15,
  },
  {
    original_query: "flasch",
    total_searches: 15,
  },
  {
    original_query: "gummiboden",
    total_searches: 15,
  },
  {
    original_query: "sidal",
    total_searches: 15,
  },
  {
    original_query: "bambustepp",
    total_searches: 15,
  },
  {
    original_query: "tischf",
    total_searches: 15,
  },
  {
    original_query: "schmutzfangläuf",
    total_searches: 15,
  },
  {
    original_query: "lako",
    total_searches: 15,
  },
  {
    original_query: "spag",
    total_searches: 15,
  },
  {
    original_query: "Bodenbe",
    total_searches: 15,
  },
  {
    original_query: "meter",
    total_searches: 15,
  },
  {
    original_query: "luca",
    total_searches: 15,
  },
  {
    original_query: "schutzm",
    total_searches: 15,
  },
  {
    original_query: "schnutzfangmatte",
    total_searches: 15,
  },
  {
    original_query: "akustikp",
    total_searches: 15,
  },
  {
    original_query: "aussenteppich",
    total_searches: 15,
  },
  {
    original_query: "Schmutzmatte",
    total_searches: 15,
  },
  {
    original_query: "flasche",
    total_searches: 15,
  },
  {
    original_query: "sichtschutzmatten",
    total_searches: 15,
  },
  {
    original_query: "widerruf",
    total_searches: 15,
  },
  {
    original_query: "Gewebe",
    total_searches: 15,
  },
  {
    original_query: "Befestigun",
    total_searches: 15,
  },
  {
    original_query: "schallschutzmatte",
    total_searches: 15,
  },
  {
    original_query: "aluminium",
    total_searches: 15,
  },
  {
    original_query: "selbstklebende",
    total_searches: 15,
  },
  {
    original_query: "verdunkl",
    total_searches: 15,
  },
  {
    original_query: "amor",
    total_searches: 15,
  },
  {
    original_query: "erdank",
    total_searches: 15,
  },
  {
    original_query: "band",
    total_searches: 15,
  },
  {
    original_query: "Seitenmar",
    total_searches: 15,
  },
  {
    original_query: "Vlies",
    total_searches: 15,
  },
  {
    original_query: "volieren",
    total_searches: 14,
  },
  {
    original_query: "bodenplane",
    total_searches: 14,
  },
  {
    original_query: "filt",
    total_searches: 14,
  },
  {
    original_query: "Treppenkantenpro",
    total_searches: 14,
  },
  {
    original_query: "winke",
    total_searches: 14,
  },
  {
    original_query: "galway",
    total_searches: 14,
  },
  {
    original_query: "rücksendun",
    total_searches: 14,
  },
  {
    original_query: "Schwerlastre",
    total_searches: 14,
  },
  {
    original_query: "pune",
    total_searches: 14,
  },
  {
    original_query: "vorwerk",
    total_searches: 14,
  },
  {
    original_query: "Versandkoste",
    total_searches: 14,
  },
  {
    original_query: "kabelb",
    total_searches: 14,
  },
  {
    original_query: "catania",
    total_searches: 14,
  },
  {
    original_query: "flasc",
    total_searches: 14,
  },
  {
    original_query: "schlingmatte",
    total_searches: 14,
  },
  {
    original_query: "Bettumr",
    total_searches: 14,
  },
  {
    original_query: "hongko",
    total_searches: 14,
  },
  {
    original_query: "sauberläufer",
    total_searches: 14,
  },
  {
    original_query: "wohndecke",
    total_searches: 14,
  },
  {
    original_query: "edin",
    total_searches: 14,
  },
  {
    original_query: "badezimm",
    total_searches: 14,
  },
  {
    original_query: "küchenlaufer",
    total_searches: 14,
  },
  {
    original_query: "hand",
    total_searches: 14,
  },
  {
    original_query: "schmutzfanf",
    total_searches: 14,
  },
  {
    original_query: "rassen",
    total_searches: 14,
  },
  {
    original_query: "Flurläufer",
    total_searches: 14,
  },
  {
    original_query: "diamo",
    total_searches: 14,
  },
  {
    original_query: "Treppenl",
    total_searches: 14,
  },
  {
    original_query: "Müll",
    total_searches: 14,
  },
  {
    original_query: "Antivibrat",
    total_searches: 14,
  },
  {
    original_query: "Treppenkant",
    total_searches: 14,
  },
  {
    original_query: "antirutschbelag",
    total_searches: 14,
  },
  {
    original_query: "natur",
    total_searches: 14,
  },
  {
    original_query: "gutschein",
    total_searches: 14,
  },
  {
    original_query: "Terrass",
    total_searches: 14,
  },
  {
    original_query: "ausse",
    total_searches: 14,
  },
  {
    original_query: "Bettumra",
    total_searches: 14,
  },
  {
    original_query: "badezimmermatte",
    total_searches: 14,
  },
  {
    original_query: "trans",
    total_searches: 14,
  },
  {
    original_query: "Küchenläufe",
    total_searches: 14,
  },
  {
    original_query: "schmutzfanmatte",
    total_searches: 14,
  },
  {
    original_query: "rahmen",
    total_searches: 14,
  },
  {
    original_query: "Fussmat",
    total_searches: 14,
  },
  {
    original_query: "Royal",
    total_searches: 14,
  },
  {
    original_query: "belag",
    total_searches: 14,
  },
  {
    original_query: "bodenmatten",
    total_searches: 14,
  },
  {
    original_query: "kurzflo",
    total_searches: 14,
  },
  {
    original_query: "rutschhemmend",
    total_searches: 14,
  },
  {
    original_query: "seile",
    total_searches: 14,
  },
  {
    original_query: "filzte",
    total_searches: 14,
  },
  {
    original_query: "ringg",
    total_searches: 14,
  },
  {
    original_query: "rasentr",
    total_searches: 14,
  },
  {
    original_query: "linole",
    total_searches: 14,
  },
  {
    original_query: "hunde",
    total_searches: 14,
  },
  {
    original_query: "sonnenschu",
    total_searches: 14,
  },
  {
    original_query: "schrank",
    total_searches: 14,
  },
  {
    original_query: "hing",
    total_searches: 14,
  },
  {
    original_query: "flaschenkasten",
    total_searches: 14,
  },
  {
    original_query: "Terass",
    total_searches: 14,
  },
  {
    original_query: "badetepp",
    total_searches: 14,
  },
  {
    original_query: "rapid",
    total_searches: 14,
  },
  {
    original_query: "jalousie",
    total_searches: 14,
  },
  {
    original_query: "stuff",
    total_searches: 14,
  },
  {
    original_query: "dayl",
    total_searches: 14,
  },
  {
    original_query: "kunstrasente",
    total_searches: 14,
  },
  {
    original_query: "wühlmau",
    total_searches: 14,
  },
  {
    original_query: "stegplatte",
    total_searches: 14,
  },
  {
    original_query: "bodenleisten",
    total_searches: 14,
  },
  {
    original_query: "dalton",
    total_searches: 14,
  },
  {
    original_query: "bodenb",
    total_searches: 14,
  },
  {
    original_query: "trittschall",
    total_searches: 14,
  },
  {
    original_query: "Gewebeplane",
    total_searches: 14,
  },
  {
    original_query: "nikosia",
    total_searches: 14,
  },
  {
    original_query: "Rutschfest",
    total_searches: 14,
  },
  {
    original_query: "duschm",
    total_searches: 14,
  },
  {
    original_query: "Sicher",
    total_searches: 14,
  },
  {
    original_query: "stuffenm",
    total_searches: 14,
  },
  {
    original_query: "bamboo",
    total_searches: 14,
  },
  {
    original_query: "treppenläu",
    total_searches: 14,
  },
  {
    original_query: "masch",
    total_searches: 14,
  },
  {
    original_query: "tomate",
    total_searches: 14,
  },
  {
    original_query: "paneele",
    total_searches: 14,
  },
  {
    original_query: "tesoro",
    total_searches: 14,
  },
  {
    original_query: "pinn",
    total_searches: 14,
  },
  {
    original_query: "sisaltep",
    total_searches: 14,
  },
  {
    original_query: "wollte",
    total_searches: 14,
  },
  {
    original_query: "Kalkutta",
    total_searches: 14,
  },
  {
    original_query: "trän",
    total_searches: 14,
  },
  {
    original_query: "kantenp",
    total_searches: 14,
  },
  {
    original_query: "maulwurf",
    total_searches: 14,
  },
  {
    original_query: "waschba",
    total_searches: 14,
  },
  {
    original_query: "Gril",
    total_searches: 14,
  },
  {
    original_query: "Schwerlastrega",
    total_searches: 14,
  },
  {
    original_query: "schuhmatte",
    total_searches: 14,
  },
  {
    original_query: "schlingenmatten",
    total_searches: 14,
  },
  {
    original_query: "wolle",
    total_searches: 14,
  },
  {
    original_query: "teppichsch",
    total_searches: 14,
  },
  {
    original_query: "cork",
    total_searches: 14,
  },
  {
    original_query: "Dynasty",
    total_searches: 14,
  },
  {
    original_query: "Garage",
    total_searches: 14,
  },
  {
    original_query: "grillschutzma",
    total_searches: 14,
  },
  {
    original_query: "baumwollteppich",
    total_searches: 14,
  },
  {
    original_query: "Erdanker",
    total_searches: 14,
  },
  {
    original_query: "wasserdicht",
    total_searches: 14,
  },
  {
    original_query: "kuchen",
    total_searches: 14,
  },
  {
    original_query: "eing",
    total_searches: 14,
  },
  {
    original_query: "oxford",
    total_searches: 14,
  },
  {
    original_query: "caro",
    total_searches: 14,
  },
  {
    original_query: "hohlkammer",
    total_searches: 14,
  },
  {
    original_query: "Farbwun",
    total_searches: 14,
  },
  {
    original_query: "balkonsic",
    total_searches: 14,
  },
  {
    original_query: "akkusti",
    total_searches: 14,
  },
  {
    original_query: "bambust",
    total_searches: 14,
  },
  {
    original_query: "gitterfolie",
    total_searches: 14,
  },
  {
    original_query: "gitterregale",
    total_searches: 14,
  },
  {
    original_query: "fitn",
    total_searches: 14,
  },
  {
    original_query: "Bodenb",
    total_searches: 14,
  },
  {
    original_query: "Seitenmarki",
    total_searches: 14,
  },
  {
    original_query: "wühlma",
    total_searches: 14,
  },
  {
    original_query: "breit",
    total_searches: 14,
  },
  {
    original_query: "Schnutz",
    total_searches: 14,
  },
  {
    original_query: "antistatik",
    total_searches: 14,
  },
  {
    original_query: "lombok",
    total_searches: 14,
  },
  {
    original_query: "fussleiste",
    total_searches: 14,
  },
  {
    original_query: "Rasentr",
    total_searches: 14,
  },
  {
    original_query: "marbella",
    total_searches: 14,
  },
  {
    original_query: "absperrzaun",
    total_searches: 14,
  },
  {
    original_query: "treppentep",
    total_searches: 14,
  },
  {
    original_query: "eden",
    total_searches: 14,
  },
  {
    original_query: "Treppenlä",
    total_searches: 14,
  },
  {
    original_query: "Klebeb",
    total_searches: 14,
  },
  {
    original_query: "drainage",
    total_searches: 14,
  },
  {
    original_query: "Whiteboa",
    total_searches: 14,
  },
  {
    original_query: "rücksen",
    total_searches: 14,
  },
  {
    original_query: "atlantic",
    total_searches: 14,
  },
  {
    original_query: "stallmat",
    total_searches: 14,
  },
  {
    original_query: "licht",
    total_searches: 14,
  },
  {
    original_query: "garagenboden",
    total_searches: 14,
  },
  {
    original_query: "korb",
    total_searches: 14,
  },
  {
    original_query: "blac",
    total_searches: 14,
  },
  {
    original_query: "flurläuf",
    total_searches: 14,
  },
  {
    original_query: "befestigungssch",
    total_searches: 14,
  },
  {
    original_query: "Katz",
    total_searches: 14,
  },
  {
    original_query: "impre",
    total_searches: 14,
  },
  {
    original_query: "einga",
    total_searches: 14,
  },
  {
    original_query: "kosmetikspiegel",
    total_searches: 14,
  },
  {
    original_query: "planenspanner",
    total_searches: 14,
  },
  {
    original_query: "Stufenmat",
    total_searches: 14,
  },
  {
    original_query: "span",
    total_searches: 14,
  },
  {
    original_query: "Grillschu",
    total_searches: 14,
  },
  {
    original_query: "Ring",
    total_searches: 14,
  },
  {
    original_query: "teppu",
    total_searches: 14,
  },
  {
    original_query: "holzabdeckplane",
    total_searches: 14,
  },
  {
    original_query: "Rutschfes",
    total_searches: 14,
  },
  {
    original_query: "Velou",
    total_searches: 14,
  },
  {
    original_query: "Fliese",
    total_searches: 14,
  },
  {
    original_query: "tosca",
    total_searches: 14,
  },
  {
    original_query: "beet",
    total_searches: 14,
  },
  {
    original_query: "erdan",
    total_searches: 13,
  },
  {
    original_query: "Must",
    total_searches: 13,
  },
  {
    original_query: "baumrinden",
    total_searches: 13,
  },
  {
    original_query: "kaminholz",
    total_searches: 13,
  },
  {
    original_query: "vorleger",
    total_searches: 13,
  },
  {
    original_query: "terraza",
    total_searches: 13,
  },
  {
    original_query: "akustikpanele",
    total_searches: 13,
  },
  {
    original_query: "mülleim",
    total_searches: 13,
  },
  {
    original_query: "masc",
    total_searches: 13,
  },
  {
    original_query: "feuerfest",
    total_searches: 13,
  },
  {
    original_query: "brücke",
    total_searches: 13,
  },
  {
    original_query: "rainb",
    total_searches: 13,
  },
  {
    original_query: "cher",
    total_searches: 13,
  },
  {
    original_query: "tepic",
    total_searches: 13,
  },
  {
    original_query: "schmutzfangt",
    total_searches: 13,
  },
  {
    original_query: "pietvoss",
    total_searches: 13,
  },
  {
    original_query: "maulw",
    total_searches: 13,
  },
  {
    original_query: "Grande",
    total_searches: 13,
  },
  {
    original_query: "sant",
    total_searches: 13,
  },
  {
    original_query: "wandp",
    total_searches: 13,
  },
  {
    original_query: "honkong",
    total_searches: 13,
  },
  {
    original_query: "terrassenflies",
    total_searches: 13,
  },
  {
    original_query: "antivibrationsmatten",
    total_searches: 13,
  },
  {
    original_query: "Flies",
    total_searches: 13,
  },
  {
    original_query: "fall",
    total_searches: 13,
  },
  {
    original_query: "bauschutzmatten",
    total_searches: 13,
  },
  {
    original_query: "gardenia",
    total_searches: 13,
  },
  {
    original_query: "gummigranu",
    total_searches: 13,
  },
  {
    original_query: "Selbs",
    total_searches: 13,
  },
  {
    original_query: "Wühlmausgitter",
    total_searches: 13,
  },
  {
    original_query: "Marius",
    total_searches: 13,
  },
  {
    original_query: "dundalk",
    total_searches: 13,
  },
  {
    original_query: "mobil",
    total_searches: 13,
  },
  {
    original_query: "Schut",
    total_searches: 13,
  },
  {
    original_query: "bodenprofil",
    total_searches: 13,
  },
  {
    original_query: "rampe",
    total_searches: 13,
  },
  {
    original_query: "Antivibrations",
    total_searches: 13,
  },
  {
    original_query: "Flurt",
    total_searches: 13,
  },
  {
    original_query: "boardmarker",
    total_searches: 13,
  },
  {
    original_query: "befestigungsschien",
    total_searches: 13,
  },
  {
    original_query: "Gewe",
    total_searches: 13,
  },
  {
    original_query: "ringgumm",
    total_searches: 13,
  },
  {
    original_query: "schreibti",
    total_searches: 13,
  },
  {
    original_query: "Autote",
    total_searches: 13,
  },
  {
    original_query: "Winke",
    total_searches: 13,
  },
  {
    original_query: "fein",
    total_searches: 13,
  },
  {
    original_query: "polystyrol",
    total_searches: 13,
  },
  {
    original_query: "sida",
    total_searches: 13,
  },
  {
    original_query: "board",
    total_searches: 13,
  },
  {
    original_query: "mäusegitter",
    total_searches: 13,
  },
  {
    original_query: "schwimmbad",
    total_searches: 13,
  },
  {
    original_query: "gummiseil",
    total_searches: 13,
  },
  {
    original_query: "fußbodenheizung",
    total_searches: 13,
  },
  {
    original_query: "Sonnenschi",
    total_searches: 13,
  },
  {
    original_query: "hohlkammerplatte",
    total_searches: 13,
  },
  {
    original_query: "Gitt",
    total_searches: 13,
  },
  {
    original_query: "evere",
    total_searches: 13,
  },
  {
    original_query: "befestigungsschie",
    total_searches: 13,
  },
  {
    original_query: "sichtschutzr",
    total_searches: 13,
  },
  {
    original_query: "bösch",
    total_searches: 13,
  },
  {
    original_query: "outdoorläufer",
    total_searches: 13,
  },
  {
    original_query: "fahrradständ",
    total_searches: 13,
  },
  {
    original_query: "absc",
    total_searches: 13,
  },
  {
    original_query: "taupe",
    total_searches: 13,
  },
  {
    original_query: "gewächs",
    total_searches: 13,
  },
  {
    original_query: "autoabdeckung",
    total_searches: 13,
  },
  {
    original_query: "zahlung",
    total_searches: 13,
  },
  {
    original_query: "Sonnenschu",
    total_searches: 13,
  },
  {
    original_query: "autofilz",
    total_searches: 13,
  },
  {
    original_query: "stockholm",
    total_searches: 13,
  },
  {
    original_query: "Flurteppich",
    total_searches: 13,
  },
  {
    original_query: "deck",
    total_searches: 13,
  },
  {
    original_query: "katzenschutz",
    total_searches: 13,
  },
  {
    original_query: "Rank",
    total_searches: 13,
  },
  {
    original_query: "Grillsch",
    total_searches: 13,
  },
  {
    original_query: "flacher",
    total_searches: 13,
  },
  {
    original_query: "sahara",
    total_searches: 13,
  },
  {
    original_query: "Rade",
    total_searches: 13,
  },
  {
    original_query: "klapp",
    total_searches: 13,
  },
  {
    original_query: "gina",
    total_searches: 13,
  },
  {
    original_query: "Tepi",
    total_searches: 13,
  },
  {
    original_query: "schreibt",
    total_searches: 13,
  },
  {
    original_query: "weich",
    total_searches: 13,
  },
  {
    original_query: "garde",
    total_searches: 13,
  },
  {
    original_query: "übergangsperiode",
    total_searches: 13,
  },
  {
    original_query: "amazo",
    total_searches: 13,
  },
  {
    original_query: "Weidenzaun",
    total_searches: 13,
  },
  {
    original_query: "stufenl",
    total_searches: 13,
  },
  {
    original_query: "kokosmatt",
    total_searches: 13,
  },
  {
    original_query: "rasentepich",
    total_searches: 13,
  },
  {
    original_query: "küchenläufee",
    total_searches: 13,
  },
  {
    original_query: "Klebeba",
    total_searches: 13,
  },
  {
    original_query: "high",
    total_searches: 13,
  },
  {
    original_query: "flurteppi",
    total_searches: 13,
  },
  {
    original_query: "Klickfl",
    total_searches: 13,
  },
  {
    original_query: "treppenstuf",
    total_searches: 13,
  },
  {
    original_query: "Lauf",
    total_searches: 13,
  },
  {
    original_query: "crystal",
    total_searches: 13,
  },
  {
    original_query: "rücksend",
    total_searches: 13,
  },
  {
    original_query: "thermorollo",
    total_searches: 13,
  },
  {
    original_query: "deko",
    total_searches: 13,
  },
  {
    original_query: "grillschutzm",
    total_searches: 13,
  },
  {
    original_query: "Casa",
    total_searches: 13,
  },
  {
    original_query: "kantenpr",
    total_searches: 13,
  },
  {
    original_query: "Versandkos",
    total_searches: 13,
  },
  {
    original_query: "davoli",
    total_searches: 13,
  },
  {
    original_query: "Antivib",
    total_searches: 13,
  },
  {
    original_query: "hohl",
    total_searches: 13,
  },
  {
    original_query: "bran",
    total_searches: 13,
  },
  {
    original_query: "Schwerla",
    total_searches: 13,
  },
  {
    original_query: "schrei",
    total_searches: 13,
  },
  {
    original_query: "kabelbin",
    total_searches: 13,
  },
  {
    original_query: "conny",
    total_searches: 13,
  },
  {
    original_query: "Flach",
    total_searches: 13,
  },
  {
    original_query: "treppenschutz",
    total_searches: 13,
  },
  {
    original_query: "Flurte",
    total_searches: 13,
  },
  {
    original_query: "Treppenläufer",
    total_searches: 13,
  },
  {
    original_query: "Schmutzm",
    total_searches: 13,
  },
  {
    original_query: "bautenschutzmatten",
    total_searches: 13,
  },
  {
    original_query: "Spanng",
    total_searches: 13,
  },
  {
    original_query: "Bettumran",
    total_searches: 13,
  },
  {
    original_query: "Balkontepp",
    total_searches: 13,
  },
  {
    original_query: "Schlingenmatte",
    total_searches: 13,
  },
  {
    original_query: "doppelstegplatt",
    total_searches: 13,
  },
  {
    original_query: "ubergangsprofil",
    total_searches: 13,
  },
  {
    original_query: "ocean",
    total_searches: 13,
  },
  {
    original_query: "amazona",
    total_searches: 13,
  },
  {
    original_query: "malervlies",
    total_searches: 13,
  },
  {
    original_query: "Gummimat",
    total_searches: 13,
  },
  {
    original_query: "Ringg",
    total_searches: 13,
  },
  {
    original_query: "Teppichb",
    total_searches: 13,
  },
  {
    original_query: "gewä",
    total_searches: 13,
  },
  {
    original_query: "Übergangsprof",
    total_searches: 13,
  },
  {
    original_query: "Klebeban",
    total_searches: 13,
  },
  {
    original_query: "schmutzteppich",
    total_searches: 13,
  },
  {
    original_query: "fensterfolie",
    total_searches: 13,
  },
  {
    original_query: "Octo",
    total_searches: 13,
  },
  {
    original_query: "rinde",
    total_searches: 13,
  },
  {
    original_query: "Leiste",
    total_searches: 13,
  },
  {
    original_query: "Autot",
    total_searches: 12,
  },
  {
    original_query: "fallsc",
    total_searches: 12,
  },
  {
    original_query: "Bambuss",
    total_searches: 12,
  },
  {
    original_query: "Schi",
    total_searches: 12,
  },
  {
    original_query: "selbs",
    total_searches: 12,
  },
  {
    original_query: "Unter",
    total_searches: 12,
  },
  {
    original_query: "Bodenschutzmatten",
    total_searches: 12,
  },
  {
    original_query: "aberdeen",
    total_searches: 12,
  },
  {
    original_query: "abschlusspro",
    total_searches: 12,
  },
  {
    original_query: "stanfo",
    total_searches: 12,
  },
  {
    original_query: "pres",
    total_searches: 12,
  },
  {
    original_query: "badet",
    total_searches: 12,
  },
  {
    original_query: "schaukast",
    total_searches: 12,
  },
  {
    original_query: "antistatisch",
    total_searches: 12,
  },
  {
    original_query: "Antivibra",
    total_searches: 12,
  },
  {
    original_query: "faltr",
    total_searches: 12,
  },
  {
    original_query: "linoleu",
    total_searches: 12,
  },
  {
    original_query: "mini",
    total_searches: 12,
  },
  {
    original_query: "heizm",
    total_searches: 12,
  },
  {
    original_query: "treppenma",
    total_searches: 12,
  },
  {
    original_query: "powe",
    total_searches: 12,
  },
  {
    original_query: "Whitebo",
    total_searches: 12,
  },
  {
    original_query: "Sonnenschir",
    total_searches: 12,
  },
  {
    original_query: "flachno",
    total_searches: 12,
  },
  {
    original_query: "Fliegen",
    total_searches: 12,
  },
  {
    original_query: "auslegeware",
    total_searches: 12,
  },
  {
    original_query: "erste",
    total_searches: 12,
  },
  {
    original_query: "sichtschutzm",
    total_searches: 12,
  },
  {
    original_query: "spagh",
    total_searches: 12,
  },
  {
    original_query: "gummigran",
    total_searches: 12,
  },
  {
    original_query: "gewäch",
    total_searches: 12,
  },
  {
    original_query: "Schmutzfangte",
    total_searches: 12,
  },
  {
    original_query: "maya",
    total_searches: 12,
  },
  {
    original_query: "bestellung",
    total_searches: 12,
  },
  {
    original_query: "magenta",
    total_searches: 12,
  },
  {
    original_query: "kind",
    total_searches: 12,
  },
  {
    original_query: "Wohn",
    total_searches: 12,
  },
  {
    original_query: "pfla",
    total_searches: 12,
  },
  {
    original_query: "vinta",
    total_searches: 12,
  },
  {
    original_query: "Rutschfe",
    total_searches: 12,
  },
  {
    original_query: "maschendra",
    total_searches: 12,
  },
  {
    original_query: "ausgleich",
    total_searches: 12,
  },
  {
    original_query: "duschho",
    total_searches: 12,
  },
  {
    original_query: "sisalo",
    total_searches: 12,
  },
  {
    original_query: "Gart",
    total_searches: 12,
  },
  {
    original_query: "Kratz",
    total_searches: 12,
  },
  {
    original_query: "wink",
    total_searches: 12,
  },
  {
    original_query: "sichtschutzma",
    total_searches: 12,
  },
  {
    original_query: "Küchentepp",
    total_searches: 12,
  },
  {
    original_query: "roter",
    total_searches: 12,
  },
  {
    original_query: "fliegengi",
    total_searches: 12,
  },
  {
    original_query: "vint",
    total_searches: 12,
  },
  {
    original_query: "verbi",
    total_searches: 12,
  },
  {
    original_query: "barcelon",
    total_searches: 12,
  },
  {
    original_query: "rücks",
    total_searches: 12,
  },
  {
    original_query: "bodenbeläge",
    total_searches: 12,
  },
  {
    original_query: "bank",
    total_searches: 12,
  },
  {
    original_query: "linu",
    total_searches: 12,
  },
  {
    original_query: "gewebep",
    total_searches: 12,
  },
  {
    original_query: "Befestigungs",
    total_searches: 12,
  },
  {
    original_query: "sitz",
    total_searches: 12,
  },
  {
    original_query: "Eingang",
    total_searches: 12,
  },
  {
    original_query: "rollhoc",
    total_searches: 12,
  },
  {
    original_query: "Selb",
    total_searches: 12,
  },
  {
    original_query: "palm",
    total_searches: 12,
  },
  {
    original_query: "venezia",
    total_searches: 12,
  },
  {
    original_query: "Einga",
    total_searches: 12,
  },
  {
    original_query: "Absch",
    total_searches: 12,
  },
  {
    original_query: "Fall",
    total_searches: 12,
  },
  {
    original_query: "handt",
    total_searches: 12,
  },
  {
    original_query: "tele",
    total_searches: 12,
  },
  {
    original_query: "Balkonsich",
    total_searches: 12,
  },
  {
    original_query: "stel",
    total_searches: 12,
  },
  {
    original_query: "Matten",
    total_searches: 12,
  },
  {
    original_query: "Pflan",
    total_searches: 12,
  },
  {
    original_query: "Wink",
    total_searches: 12,
  },
  {
    original_query: "teppichmesser",
    total_searches: 12,
  },
  {
    original_query: "arden",
    total_searches: 12,
  },
  {
    original_query: "bohemia",
    total_searches: 12,
  },
  {
    original_query: "swansea",
    total_searches: 12,
  },
  {
    original_query: "pferd",
    total_searches: 12,
  },
  {
    original_query: "luftpolsterfolie",
    total_searches: 12,
  },
  {
    original_query: "brei",
    total_searches: 12,
  },
  {
    original_query: "tran",
    total_searches: 12,
  },
  {
    original_query: "Bambuszaun",
    total_searches: 12,
  },
  {
    original_query: "aufbewahrung",
    total_searches: 12,
  },
  {
    original_query: "selbstklebe",
    total_searches: 12,
  },
  {
    original_query: "hongk",
    total_searches: 12,
  },
  {
    original_query: "schmutzfanfmatte",
    total_searches: 12,
  },
  {
    original_query: "sphinx",
    total_searches: 12,
  },
  {
    original_query: "terassenfli",
    total_searches: 12,
  },
  {
    original_query: "tischfol",
    total_searches: 12,
  },
  {
    original_query: "zeltplane",
    total_searches: 12,
  },
  {
    original_query: "rassente",
    total_searches: 12,
  },
  {
    original_query: "terrassenflie",
    total_searches: 12,
  },
  {
    original_query: "ausl",
    total_searches: 12,
  },
  {
    original_query: "teich",
    total_searches: 12,
  },
  {
    original_query: "Antivibr",
    total_searches: 12,
  },
  {
    original_query: "kokosläufer",
    total_searches: 12,
  },
  {
    original_query: "Flurl",
    total_searches: 12,
  },
  {
    original_query: "vinylte",
    total_searches: 12,
  },
  {
    original_query: "Balkonsichts",
    total_searches: 12,
  },
  {
    original_query: "ripp",
    total_searches: 12,
  },
  {
    original_query: "eingan",
    total_searches: 12,
  },
  {
    original_query: "gartenmöbel",
    total_searches: 12,
  },
  {
    original_query: "seattle",
    total_searches: 12,
  },
  {
    original_query: "heizmatt",
    total_searches: 12,
  },
  {
    original_query: "nadelfl",
    total_searches: 12,
  },
  {
    original_query: "läufee",
    total_searches: 12,
  },
  {
    original_query: "Weid",
    total_searches: 12,
  },
  {
    original_query: "heidekr",
    total_searches: 12,
  },
  {
    original_query: "sauberlaufläufer",
    total_searches: 12,
  },
  {
    original_query: "Fußmat",
    total_searches: 12,
  },
  {
    original_query: "Spanngu",
    total_searches: 12,
  },
  {
    original_query: "küchenmatte",
    total_searches: 12,
  },
  {
    original_query: "xtreme",
    total_searches: 12,
  },
  {
    original_query: "antivibrationsma",
    total_searches: 12,
  },
  {
    original_query: "Sichtschutzmatte",
    total_searches: 12,
  },
  {
    original_query: "sichtschutzstreifen",
    total_searches: 12,
  },
  {
    original_query: "Grandeu",
    total_searches: 12,
  },
  {
    original_query: "messer",
    total_searches: 12,
  },
  {
    original_query: "Gummimatten",
    total_searches: 12,
  },
  {
    original_query: "Cancun",
    total_searches: 12,
  },
  {
    original_query: "Gewä",
    total_searches: 12,
  },
  {
    original_query: "schmit",
    total_searches: 12,
  },
  {
    original_query: "brand",
    total_searches: 12,
  },
  {
    original_query: "fussleisten",
    total_searches: 12,
  },
  {
    original_query: "meta",
    total_searches: 12,
  },
  {
    original_query: "schutzplane",
    total_searches: 12,
  },
  {
    original_query: "tischfolien",
    total_searches: 12,
  },
  {
    original_query: "waschbare",
    total_searches: 12,
  },
  {
    original_query: "Schauk",
    total_searches: 12,
  },
  {
    original_query: "kunstkokos",
    total_searches: 12,
  },
  {
    original_query: "rankg",
    total_searches: 12,
  },
  {
    original_query: "teppichstange",
    total_searches: 12,
  },
  {
    original_query: "schutzh",
    total_searches: 12,
  },
  {
    original_query: "terassenflie",
    total_searches: 12,
  },
  {
    original_query: "fliesenprofile",
    total_searches: 12,
  },
  {
    original_query: "tarp",
    total_searches: 12,
  },
  {
    original_query: "Bettumrandun",
    total_searches: 12,
  },
  {
    original_query: "blech",
    total_searches: 12,
  },
  {
    original_query: "natu",
    total_searches: 12,
  },
  {
    original_query: "weitspannrega",
    total_searches: 12,
  },
  {
    original_query: "fellteppich",
    total_searches: 12,
  },
  {
    original_query: "werkstatt",
    total_searches: 12,
  },
  {
    original_query: "sicherheitsma",
    total_searches: 12,
  },
  {
    original_query: "fahrad",
    total_searches: 12,
  },
  {
    original_query: "bolo",
    total_searches: 12,
  },
  {
    original_query: "Pliss",
    total_searches: 12,
  },
  {
    original_query: "weichsockel",
    total_searches: 12,
  },
  {
    original_query: "Klickflie",
    total_searches: 12,
  },
  {
    original_query: "teppichsc",
    total_searches: 12,
  },
  {
    original_query: "coyote",
    total_searches: 12,
  },
  {
    original_query: "vero",
    total_searches: 12,
  },
  {
    original_query: "Amaz",
    total_searches: 12,
  },
  {
    original_query: "theo",
    total_searches: 12,
  },
  {
    original_query: "dynasti",
    total_searches: 12,
  },
  {
    original_query: "waschb",
    total_searches: 12,
  },
  {
    original_query: "Grand",
    total_searches: 12,
  },
  {
    original_query: "flipch",
    total_searches: 12,
  },
  {
    original_query: "epic",
    total_searches: 12,
  },
  {
    original_query: "Gummiläuf",
    total_searches: 12,
  },
  {
    original_query: "schutzfa",
    total_searches: 12,
  },
  {
    original_query: "kunsr",
    total_searches: 12,
  },
  {
    original_query: "dusti",
    total_searches: 12,
  },
  {
    original_query: "Sprühkleb",
    total_searches: 12,
  },
  {
    original_query: "tischde",
    total_searches: 12,
  },
  {
    original_query: "stanfor",
    total_searches: 12,
  },
  {
    original_query: "holzfliese",
    total_searches: 12,
  },
  {
    original_query: "Heide",
    total_searches: 11,
  },
  {
    original_query: "antiermüdung",
    total_searches: 11,
  },
  {
    original_query: "rankgitt",
    total_searches: 11,
  },
  {
    original_query: "jami",
    total_searches: 11,
  },
  {
    original_query: "Eingangs",
    total_searches: 11,
  },
  {
    original_query: "bautenschutzma",
    total_searches: 11,
  },
  {
    original_query: "teppichst",
    total_searches: 11,
  },
  {
    original_query: "kinderte",
    total_searches: 11,
  },
  {
    original_query: "ecken",
    total_searches: 11,
  },
  {
    original_query: "treppenleisten",
    total_searches: 11,
  },
  {
    original_query: "gartensack",
    total_searches: 11,
  },
  {
    original_query: "fussabtre",
    total_searches: 11,
  },
  {
    original_query: "türm",
    total_searches: 11,
  },
  {
    original_query: "aruba",
    total_searches: 11,
  },
  {
    original_query: "sissl",
    total_searches: 11,
  },
  {
    original_query: "Flokati",
    total_searches: 11,
  },
  {
    original_query: "selbstkleben",
    total_searches: 11,
  },
  {
    original_query: "ramp",
    total_searches: 11,
  },
  {
    original_query: "tasen",
    total_searches: 11,
  },
  {
    original_query: "kleopatra",
    total_searches: 11,
  },
  {
    original_query: "lichtschachtabdeckung",
    total_searches: 11,
  },
  {
    original_query: "weitspan",
    total_searches: 11,
  },
  {
    original_query: "klebefilz",
    total_searches: 11,
  },
  {
    original_query: "stellwände",
    total_searches: 11,
  },
  {
    original_query: "kontak",
    total_searches: 11,
  },
  {
    original_query: "Treppenläu",
    total_searches: 11,
  },
  {
    original_query: "lieferzeiten",
    total_searches: 11,
  },
  {
    original_query: "Weidenzau",
    total_searches: 11,
  },
  {
    original_query: "Treppenkantenprofi",
    total_searches: 11,
  },
  {
    original_query: "korkrollen",
    total_searches: 11,
  },
  {
    original_query: "balkonboden",
    total_searches: 11,
  },
  {
    original_query: "badvor",
    total_searches: 11,
  },
  {
    original_query: "moos",
    total_searches: 11,
  },
  {
    original_query: "kauri",
    total_searches: 11,
  },
  {
    original_query: "Gewächs",
    total_searches: 11,
  },
  {
    original_query: "logo",
    total_searches: 11,
  },
  {
    original_query: "waschmaschine",
    total_searches: 11,
  },
  {
    original_query: "träne",
    total_searches: 11,
  },
  {
    original_query: "bambusteppi",
    total_searches: 11,
  },
  {
    original_query: "hygienematte",
    total_searches: 11,
  },
  {
    original_query: "schmutzauffangmatte",
    total_searches: 11,
  },
  {
    original_query: "ringmatte",
    total_searches: 11,
  },
  {
    original_query: "treso",
    total_searches: 11,
  },
  {
    original_query: "grillm",
    total_searches: 11,
  },
  {
    original_query: "Hohl",
    total_searches: 11,
  },
  {
    original_query: "autoteppi",
    total_searches: 11,
  },
  {
    original_query: "unkrautv",
    total_searches: 11,
  },
  {
    original_query: "cora",
    total_searches: 11,
  },
  {
    original_query: "vinylteppi",
    total_searches: 11,
  },
  {
    original_query: "abdek",
    total_searches: 11,
  },
  {
    original_query: "blumenr",
    total_searches: 11,
  },
  {
    original_query: "Bettumrand",
    total_searches: 11,
  },
  {
    original_query: "kent",
    total_searches: 11,
  },
  {
    original_query: "Pflanz",
    total_searches: 11,
  },
  {
    original_query: "stang",
    total_searches: 11,
  },
  {
    original_query: "befestigungssc",
    total_searches: 11,
  },
  {
    original_query: "tischdec",
    total_searches: 11,
  },
  {
    original_query: "wasserdichte",
    total_searches: 11,
  },
  {
    original_query: "badm",
    total_searches: 11,
  },
  {
    original_query: "insekten",
    total_searches: 11,
  },
  {
    original_query: "abdeckplanne",
    total_searches: 11,
  },
  {
    original_query: "bücherregal",
    total_searches: 11,
  },
  {
    original_query: "Abschluss",
    total_searches: 11,
  },
  {
    original_query: "filzkleber",
    total_searches: 11,
  },
  {
    original_query: "dart",
    total_searches: 11,
  },
  {
    original_query: "selbstkle",
    total_searches: 11,
  },
  {
    original_query: "schnutzfang",
    total_searches: 11,
  },
  {
    original_query: "treppenstangen",
    total_searches: 11,
  },
  {
    original_query: "heid",
    total_searches: 11,
  },
  {
    original_query: "beheiz",
    total_searches: 11,
  },
  {
    original_query: "Grillsc",
    total_searches: 11,
  },
  {
    original_query: "teppuch",
    total_searches: 11,
  },
  {
    original_query: "woll",
    total_searches: 11,
  },
  {
    original_query: "Folie",
    total_searches: 11,
  },
  {
    original_query: "treppentepich",
    total_searches: 11,
  },
  {
    original_query: "Inte",
    total_searches: 11,
  },
  {
    original_query: "doppelseitiges",
    total_searches: 11,
  },
  {
    original_query: "riga",
    total_searches: 11,
  },
  {
    original_query: "Barcelona",
    total_searches: 11,
  },
  {
    original_query: "protex",
    total_searches: 11,
  },
  {
    original_query: "unterle",
    total_searches: 11,
  },
  {
    original_query: "bunt",
    total_searches: 11,
  },
  {
    original_query: "Treppenkantenpr",
    total_searches: 11,
  },
  {
    original_query: "steg",
    total_searches: 11,
  },
  {
    original_query: "böschungs",
    total_searches: 11,
  },
  {
    original_query: "bambusteppic",
    total_searches: 11,
  },
  {
    original_query: "halb",
    total_searches: 11,
  },
  {
    original_query: "schmutzfsngmatte",
    total_searches: 11,
  },
  {
    original_query: "impr",
    total_searches: 11,
  },
  {
    original_query: "granu",
    total_searches: 11,
  },
  {
    original_query: "kokosmat",
    total_searches: 11,
  },
  {
    original_query: "warsa",
    total_searches: 11,
  },
  {
    original_query: "bidenschutz",
    total_searches: 11,
  },
  {
    original_query: "gummipl",
    total_searches: 11,
  },
  {
    original_query: "filzfliesen",
    total_searches: 11,
  },
  {
    original_query: "gangläufer",
    total_searches: 11,
  },
  {
    original_query: "wandpa",
    total_searches: 11,
  },
  {
    original_query: "baden",
    total_searches: 11,
  },
  {
    original_query: "cudillero",
    total_searches: 11,
  },
  {
    original_query: "teppichklebeband",
    total_searches: 11,
  },
  {
    original_query: "Eingan",
    total_searches: 11,
  },
  {
    original_query: "wäschekorb",
    total_searches: 11,
  },
  {
    original_query: "prest",
    total_searches: 11,
  },
  {
    original_query: "Katze",
    total_searches: 11,
  },
  {
    original_query: "dämm",
    total_searches: 11,
  },
  {
    original_query: "nadeldilz",
    total_searches: 11,
  },
  {
    original_query: "bermuda",
    total_searches: 11,
  },
  {
    original_query: "auss",
    total_searches: 11,
  },
  {
    original_query: "Balkonsichtschu",
    total_searches: 11,
  },
  {
    original_query: "heimwerkervlies",
    total_searches: 11,
  },
  {
    original_query: "badezimmermatten",
    total_searches: 11,
  },
  {
    original_query: "Kanten",
    total_searches: 11,
  },
  {
    original_query: "binde",
    total_searches: 11,
  },
  {
    original_query: "Performa",
    total_searches: 11,
  },
  {
    original_query: "lochmatte",
    total_searches: 11,
  },
  {
    original_query: "Terrassenf",
    total_searches: 11,
  },
  {
    original_query: "fallschu",
    total_searches: 11,
  },
  {
    original_query: "treppenfliesen",
    total_searches: 11,
  },
  {
    original_query: "abfalleimer",
    total_searches: 11,
  },
  {
    original_query: "rückga",
    total_searches: 11,
  },
  {
    original_query: "stretch",
    total_searches: 11,
  },
  {
    original_query: "Erda",
    total_searches: 11,
  },
  {
    original_query: "moderation",
    total_searches: 11,
  },
  {
    original_query: "spannseil",
    total_searches: 11,
  },
  {
    original_query: "Hongkong",
    total_searches: 11,
  },
  {
    original_query: "nevada",
    total_searches: 11,
  },
  {
    original_query: "Treppenkantenprof",
    total_searches: 11,
  },
  {
    original_query: "bürost",
    total_searches: 11,
  },
  {
    original_query: "pont",
    total_searches: 11,
  },
  {
    original_query: "rolo",
    total_searches: 11,
  },
  {
    original_query: "kunstleder",
    total_searches: 11,
  },
  {
    original_query: "Trans",
    total_searches: 11,
  },
  {
    original_query: "sprin",
    total_searches: 11,
  },
  {
    original_query: "uber",
    total_searches: 11,
  },
  {
    original_query: "esszimmerteppich",
    total_searches: 11,
  },
  {
    original_query: "octa",
    total_searches: 11,
  },
  {
    original_query: "Shaggy",
    total_searches: 11,
  },
  {
    original_query: "Sicherheit",
    total_searches: 11,
  },
  {
    original_query: "schmitzfan",
    total_searches: 11,
  },
  {
    original_query: "integ",
    total_searches: 11,
  },
  {
    original_query: "kantenprof",
    total_searches: 11,
  },
  {
    original_query: "Unkrautvlies",
    total_searches: 11,
  },
  {
    original_query: "outdoorteppiche",
    total_searches: 11,
  },
  {
    original_query: "arbeitsmatte",
    total_searches: 11,
  },
  {
    original_query: "rollhock",
    total_searches: 11,
  },
  {
    original_query: "anker",
    total_searches: 11,
  },
  {
    original_query: "tape",
    total_searches: 11,
  },
  {
    original_query: "andrew",
    total_searches: 11,
  },
  {
    original_query: "veron",
    total_searches: 11,
  },
  {
    original_query: "fussbodenheizung",
    total_searches: 11,
  },
  {
    original_query: "Sicherhei",
    total_searches: 11,
  },
  {
    original_query: "sisalteppiche",
    total_searches: 11,
  },
  {
    original_query: "ausleg",
    total_searches: 11,
  },
  {
    original_query: "schuhe",
    total_searches: 11,
  },
  {
    original_query: "schmitzfa",
    total_searches: 11,
  },
  {
    original_query: "stre",
    total_searches: 11,
  },
  {
    original_query: "rollrasen",
    total_searches: 11,
  },
  {
    original_query: "dynastie",
    total_searches: 11,
  },
  {
    original_query: "badewa",
    total_searches: 11,
  },
  {
    original_query: "winkelpr",
    total_searches: 11,
  },
  {
    original_query: "rasenteppuch",
    total_searches: 11,
  },
  {
    original_query: "getr",
    total_searches: 11,
  },
  {
    original_query: "inse",
    total_searches: 11,
  },
  {
    original_query: "ausle",
    total_searches: 11,
  },
  {
    original_query: "chenille",
    total_searches: 11,
  },
  {
    original_query: "everes",
    total_searches: 11,
  },
  {
    original_query: "hartboden",
    total_searches: 11,
  },
  {
    original_query: "fliegengitte",
    total_searches: 11,
  },
  {
    original_query: "moder",
    total_searches: 11,
  },
  {
    original_query: "voli",
    total_searches: 11,
  },
  {
    original_query: "dünn",
    total_searches: 11,
  },
  {
    original_query: "teppichschutz",
    total_searches: 11,
  },
  {
    original_query: "antib",
    total_searches: 11,
  },
  {
    original_query: "winkelp",
    total_searches: 11,
  },
  {
    original_query: "Kalk",
    total_searches: 11,
  },
  {
    original_query: "tiffany",
    total_searches: 11,
  },
  {
    original_query: "voge",
    total_searches: 11,
  },
  {
    original_query: "Wühlmau",
    total_searches: 11,
  },
  {
    original_query: "platte",
    total_searches: 11,
  },
  {
    original_query: "Ringgu",
    total_searches: 11,
  },
  {
    original_query: "verdunkelungsrollo",
    total_searches: 11,
  },
  {
    original_query: "Abschlu",
    total_searches: 11,
  },
  {
    original_query: "terase",
    total_searches: 11,
  },
  {
    original_query: "Stallmatten",
    total_searches: 11,
  },
  {
    original_query: "kabelbi",
    total_searches: 11,
  },
  {
    original_query: "Rollenkor",
    total_searches: 11,
  },
  {
    original_query: "ermü",
    total_searches: 11,
  },
  {
    original_query: "katzenteppich",
    total_searches: 11,
  },
  {
    original_query: "cambridge",
    total_searches: 11,
  },
  {
    original_query: "vorhänge",
    total_searches: 11,
  },
  {
    original_query: "Treppente",
    total_searches: 10,
  },
  {
    original_query: "Gewäch",
    total_searches: 10,
  },
  {
    original_query: "edinburgh",
    total_searches: 10,
  },
  {
    original_query: "Stan",
    total_searches: 10,
  },
  {
    original_query: "stufenpr",
    total_searches: 10,
  },
  {
    original_query: "hochflorte",
    total_searches: 10,
  },
  {
    original_query: "filzboden",
    total_searches: 10,
  },
  {
    original_query: "gummibelag",
    total_searches: 10,
  },
  {
    original_query: "Shagg",
    total_searches: 10,
  },
  {
    original_query: "Flac",
    total_searches: 10,
  },
  {
    original_query: "verdunklungsr",
    total_searches: 10,
  },
  {
    original_query: "Nadelholz",
    total_searches: 10,
  },
  {
    original_query: "läfer",
    total_searches: 10,
  },
  {
    original_query: "glätte",
    total_searches: 10,
  },
  {
    original_query: "solar",
    total_searches: 10,
  },
  {
    original_query: "schmutzfabg",
    total_searches: 10,
  },
  {
    original_query: "schie",
    total_searches: 10,
  },
  {
    original_query: "Balkonsic",
    total_searches: 10,
  },
  {
    original_query: "rose",
    total_searches: 10,
  },
  {
    original_query: "Schlingenma",
    total_searches: 10,
  },
  {
    original_query: "kami",
    total_searches: 10,
  },
  {
    original_query: "bambusregal",
    total_searches: 10,
  },
  {
    original_query: "Versandk",
    total_searches: 10,
  },
  {
    original_query: "fallschutzmatten",
    total_searches: 10,
  },
  {
    original_query: "abschlussle",
    total_searches: 10,
  },
  {
    original_query: "tafe",
    total_searches: 10,
  },
  {
    original_query: "Soft",
    total_searches: 10,
  },
  {
    original_query: "teppichleisten",
    total_searches: 10,
  },
  {
    original_query: "schirm",
    total_searches: 10,
  },
  {
    original_query: "alexandria",
    total_searches: 10,
  },
  {
    original_query: "cardiff",
    total_searches: 10,
  },
  {
    original_query: "filzstoff",
    total_searches: 10,
  },
  {
    original_query: "abtropf",
    total_searches: 10,
  },
  {
    original_query: "lamina",
    total_searches: 10,
  },
  {
    original_query: "mode",
    total_searches: 10,
  },
  {
    original_query: "weitspannr",
    total_searches: 10,
  },
  {
    original_query: "kiste",
    total_searches: 10,
  },
  {
    original_query: "nice",
    total_searches: 10,
  },
  {
    original_query: "puzz",
    total_searches: 10,
  },
  {
    original_query: "prem",
    total_searches: 10,
  },
  {
    original_query: "badtep",
    total_searches: 10,
  },
  {
    original_query: "rankgi",
    total_searches: 10,
  },
  {
    original_query: "newport",
    total_searches: 10,
  },
  {
    original_query: "gummis",
    total_searches: 10,
  },
  {
    original_query: "nadefilz",
    total_searches: 10,
  },
  {
    original_query: "windsor",
    total_searches: 10,
  },
  {
    original_query: "Schmutzma",
    total_searches: 10,
  },
  {
    original_query: "vista",
    total_searches: 10,
  },
  {
    original_query: "maraba",
    total_searches: 10,
  },
  {
    original_query: "winds",
    total_searches: 10,
  },
  {
    original_query: "tret",
    total_searches: 10,
  },
  {
    original_query: "doppelrolle",
    total_searches: 10,
  },
  {
    original_query: "Weich",
    total_searches: 10,
  },
  {
    original_query: "aussenmatte",
    total_searches: 10,
  },
  {
    original_query: "heizt",
    total_searches: 10,
  },
  {
    original_query: "fusm",
    total_searches: 10,
  },
  {
    original_query: "Waschbar",
    total_searches: 10,
  },
  {
    original_query: "Maschendra",
    total_searches: 10,
  },
  {
    original_query: "imperial",
    total_searches: 10,
  },
  {
    original_query: "Retour",
    total_searches: 10,
  },
  {
    original_query: "Katzen",
    total_searches: 10,
  },
  {
    original_query: "Teras",
    total_searches: 10,
  },
  {
    original_query: "fliesenp",
    total_searches: 10,
  },
  {
    original_query: "elota",
    total_searches: 10,
  },
  {
    original_query: "küchenla",
    total_searches: 10,
  },
  {
    original_query: "poolplane",
    total_searches: 10,
  },
  {
    original_query: "fusslei",
    total_searches: 10,
  },
  {
    original_query: "Ausse",
    total_searches: 10,
  },
  {
    original_query: "Teppichboden",
    total_searches: 10,
  },
  {
    original_query: "stab",
    total_searches: 10,
  },
  {
    original_query: "hasendraht",
    total_searches: 10,
  },
  {
    original_query: "stone",
    total_searches: 10,
  },
  {
    original_query: "abdeckun",
    total_searches: 10,
  },
  {
    original_query: "Treppentepp",
    total_searches: 10,
  },
  {
    original_query: "ausg",
    total_searches: 10,
  },
  {
    original_query: "flurteppic",
    total_searches: 10,
  },
  {
    original_query: "stoff",
    total_searches: 10,
  },
  {
    original_query: "koffer",
    total_searches: 10,
  },
  {
    original_query: "katzenstreu",
    total_searches: 10,
  },
  {
    original_query: "Rutschfeste",
    total_searches: 10,
  },
  {
    original_query: "midas",
    total_searches: 10,
  },
  {
    original_query: "winkelpro",
    total_searches: 10,
  },
  {
    original_query: "bauplane",
    total_searches: 10,
  },
  {
    original_query: "insek",
    total_searches: 10,
  },
  {
    original_query: "verdunklungs",
    total_searches: 10,
  },
  {
    original_query: "selbstliegend",
    total_searches: 10,
  },
  {
    original_query: "Aussen",
    total_searches: 10,
  },
  {
    original_query: "treppenleiste",
    total_searches: 10,
  },
  {
    original_query: "tase",
    total_searches: 10,
  },
  {
    original_query: "teppichun",
    total_searches: 10,
  },
  {
    original_query: "sisl",
    total_searches: 10,
  },
  {
    original_query: "Unkrau",
    total_searches: 10,
  },
  {
    original_query: "abtr",
    total_searches: 10,
  },
  {
    original_query: "sisalopti",
    total_searches: 10,
  },
  {
    original_query: "Meterware",
    total_searches: 10,
  },
  {
    original_query: "boxen",
    total_searches: 10,
  },
  {
    original_query: "teppichbrücke",
    total_searches: 10,
  },
  {
    original_query: "löufer",
    total_searches: 10,
  },
  {
    original_query: "wasserd",
    total_searches: 10,
  },
  {
    original_query: "Cudilero",
    total_searches: 10,
  },
  {
    original_query: "tren",
    total_searches: 10,
  },
  {
    original_query: "raseb",
    total_searches: 10,
  },
  {
    original_query: "Pfla",
    total_searches: 10,
  },
  {
    original_query: "Gummigr",
    total_searches: 10,
  },
  {
    original_query: "Rankgi",
    total_searches: 10,
  },
  {
    original_query: "coton",
    total_searches: 10,
  },
  {
    original_query: "master",
    total_searches: 10,
  },
  {
    original_query: "Abdeckplanen",
    total_searches: 10,
  },
  {
    original_query: "Bautenschutz",
    total_searches: 10,
  },
  {
    original_query: "teppichrasen",
    total_searches: 10,
  },
  {
    original_query: "nadelflie",
    total_searches: 10,
  },
  {
    original_query: "Magn",
    total_searches: 10,
  },
  {
    original_query: "wohnwagen",
    total_searches: 10,
  },
  {
    original_query: "badewannen",
    total_searches: 10,
  },
  {
    original_query: "tomatenspiralstäbe",
    total_searches: 10,
  },
  {
    original_query: "Grau",
    total_searches: 10,
  },
  {
    original_query: "wandpan",
    total_searches: 10,
  },
  {
    original_query: "autotepp",
    total_searches: 10,
  },
  {
    original_query: "vene",
    total_searches: 10,
  },
  {
    original_query: "spar",
    total_searches: 10,
  },
  {
    original_query: "pavi",
    total_searches: 10,
  },
  {
    original_query: "horizont",
    total_searches: 10,
  },
  {
    original_query: "stufenlan",
    total_searches: 10,
  },
  {
    original_query: "bautenschutzm",
    total_searches: 10,
  },
  {
    original_query: "Cudi",
    total_searches: 10,
  },
  {
    original_query: "schmitzfangma",
    total_searches: 10,
  },
  {
    original_query: "maschendrah",
    total_searches: 10,
  },
  {
    original_query: "möbel",
    total_searches: 10,
  },
  {
    original_query: "maschendr",
    total_searches: 10,
  },
  {
    original_query: "tana",
    total_searches: 10,
  },
  {
    original_query: "akazie",
    total_searches: 10,
  },
  {
    original_query: "camp",
    total_searches: 10,
  },
  {
    original_query: "abschlusslei",
    total_searches: 10,
  },
  {
    original_query: "eingangsteppich",
    total_searches: 10,
  },
  {
    original_query: "esszimmer",
    total_searches: 10,
  },
  {
    original_query: "weinregal",
    total_searches: 10,
  },
  {
    original_query: "wandr",
    total_searches: 10,
  },
  {
    original_query: "Winkel",
    total_searches: 10,
  },
  {
    original_query: "shin",
    total_searches: 10,
  },
  {
    original_query: "schre",
    total_searches: 10,
  },
  {
    original_query: "schatt",
    total_searches: 10,
  },
  {
    original_query: "Markise",
    total_searches: 10,
  },
  {
    original_query: "messeteppic",
    total_searches: 10,
  },
  {
    original_query: "Antivibration",
    total_searches: 10,
  },
  {
    original_query: "schmitzf",
    total_searches: 10,
  },
  {
    original_query: "Balkonsichtsch",
    total_searches: 10,
  },
  {
    original_query: "treo",
    total_searches: 10,
  },
  {
    original_query: "montagekleber",
    total_searches: 10,
  },
  {
    original_query: "Sichtschutzma",
    total_searches: 10,
  },
  {
    original_query: "antirutschstreifen",
    total_searches: 10,
  },
  {
    original_query: "gummieinlage",
    total_searches: 10,
  },
  {
    original_query: "Wasser",
    total_searches: 10,
  },
  {
    original_query: "beton",
    total_searches: 10,
  },
  {
    original_query: "majesty",
    total_searches: 10,
  },
  {
    original_query: "chevron",
    total_searches: 10,
  },
  {
    original_query: "Pfosten",
    total_searches: 10,
  },
  {
    original_query: "haus",
    total_searches: 10,
  },
  {
    original_query: "Kinder",
    total_searches: 10,
  },
  {
    original_query: "konta",
    total_searches: 10,
  },
  {
    original_query: "Tepich",
    total_searches: 10,
  },
  {
    original_query: "kisten",
    total_searches: 10,
  },
  {
    original_query: "meterw",
    total_searches: 10,
  },
  {
    original_query: "grillschut",
    total_searches: 10,
  },
  {
    original_query: "Messe",
    total_searches: 10,
  },
  {
    original_query: "dublin",
    total_searches: 10,
  },
  {
    original_query: "Farbwund",
    total_searches: 10,
  },
  {
    original_query: "badmatt",
    total_searches: 10,
  },
  {
    original_query: "sligo",
    total_searches: 10,
  },
  {
    original_query: "kabelma",
    total_searches: 10,
  },
  {
    original_query: "Treppent",
    total_searches: 10,
  },
  {
    original_query: "sonen",
    total_searches: 10,
  },
  {
    original_query: "wandpane",
    total_searches: 10,
  },
  {
    original_query: "onyx",
    total_searches: 10,
  },
  {
    original_query: "zaunpfahl",
    total_searches: 10,
  },
  {
    original_query: "gart",
    total_searches: 10,
  },
  {
    original_query: "rücksendu",
    total_searches: 10,
  },
  {
    original_query: "rampenmatte",
    total_searches: 10,
  },
  {
    original_query: "korkwand",
    total_searches: 10,
  },
  {
    original_query: "kratztepp",
    total_searches: 10,
  },
  {
    original_query: "sege",
    total_searches: 10,
  },
  {
    original_query: "schmutzfank",
    total_searches: 10,
  },
  {
    original_query: "schattier",
    total_searches: 10,
  },
  {
    original_query: "hygi",
    total_searches: 10,
  },
  {
    original_query: "pavillion",
    total_searches: 10,
  },
  {
    original_query: "schmutzfangmstte",
    total_searches: 10,
  },
  {
    original_query: "Masche",
    total_searches: 10,
  },
  {
    original_query: "Fallschutz",
    total_searches: 10,
  },
  {
    original_query: "drahtspanner",
    total_searches: 10,
  },
  {
    original_query: "Seitenmark",
    total_searches: 10,
  },
  {
    original_query: "schlüssel",
    total_searches: 10,
  },
  {
    original_query: "spaghett",
    total_searches: 10,
  },
  {
    original_query: "Baumr",
    total_searches: 10,
  },
  {
    original_query: "antivibrati",
    total_searches: 10,
  },
  {
    original_query: "Schlingenm",
    total_searches: 10,
  },
  {
    original_query: "heimwerker",
    total_searches: 10,
  },
  {
    original_query: "Flurlä",
    total_searches: 10,
  },
  {
    original_query: "moosgummi",
    total_searches: 10,
  },
  {
    original_query: "akkustikpaneel",
    total_searches: 10,
  },
  {
    original_query: "Feuer",
    total_searches: 10,
  },
  {
    original_query: "rasenteppicj",
    total_searches: 10,
  },
  {
    original_query: "schutzmatt",
    total_searches: 10,
  },
  {
    original_query: "even",
    total_searches: 10,
  },
  {
    original_query: "kunststoff",
    total_searches: 10,
  },
  {
    original_query: "Heiz",
    total_searches: 10,
  },
  {
    original_query: "steckre",
    total_searches: 10,
  },
  {
    original_query: "epdm",
    total_searches: 10,
  },
  {
    original_query: "kantenprofi",
    total_searches: 10,
  },
  {
    original_query: "schattiergewebe",
    total_searches: 10,
  },
  {
    original_query: "glasb",
    total_searches: 10,
  },
  {
    original_query: "Verona",
    total_searches: 10,
  },
  {
    original_query: "Impr",
    total_searches: 10,
  },
  {
    original_query: "eckprofil",
    total_searches: 10,
  },
  {
    original_query: "vyni",
    total_searches: 10,
  },
  {
    original_query: "baumrin",
    total_searches: 10,
  },
  {
    original_query: "drahtz",
    total_searches: 10,
  },
  {
    original_query: "klickvinyl",
    total_searches: 10,
  },
  {
    original_query: "stifte",
    total_searches: 10,
  },
  {
    original_query: "spec",
    total_searches: 10,
  },
  {
    original_query: "Treppenkantenp",
    total_searches: 10,
  },
  {
    original_query: "balkonsichtschut",
    total_searches: 10,
  },
  {
    original_query: "dämmung",
    total_searches: 10,
  },
  {
    original_query: "Cudil",
    total_searches: 10,
  },
  {
    original_query: "stufenp",
    total_searches: 10,
  },
  {
    original_query: "busby",
    total_searches: 10,
  },
  {
    original_query: "sonnenschirme",
    total_searches: 10,
  },
  {
    original_query: "Teppichflies",
    total_searches: 10,
  },
  {
    original_query: "vikin",
    total_searches: 10,
  },
  {
    original_query: "selbstkl",
    total_searches: 10,
  },
  {
    original_query: "montage",
    total_searches: 10,
  },
  {
    original_query: "Wühlma",
    total_searches: 10,
  },
  {
    original_query: "fußab",
    total_searches: 10,
  },
  {
    original_query: "teppichbo",
    total_searches: 10,
  },
  {
    original_query: "türvor",
    total_searches: 10,
  },
  {
    original_query: "tischfoli",
    total_searches: 10,
  },
  {
    original_query: "spanner",
    total_searches: 10,
  },
  {
    original_query: "bide",
    total_searches: 10,
  },
  {
    original_query: "gummiwabenmatte",
    total_searches: 10,
  },
  {
    original_query: "venet",
    total_searches: 10,
  },
  {
    original_query: "akustikpa",
    total_searches: 10,
  },
  {
    original_query: "heidekra",
    total_searches: 10,
  },
  {
    original_query: "rückversand",
    total_searches: 10,
  },
  {
    original_query: "Cudile",
    total_searches: 9,
  },
  {
    original_query: "meterwa",
    total_searches: 9,
  },
  {
    original_query: "Eing",
    total_searches: 9,
  },
  {
    original_query: "Reto",
    total_searches: 9,
  },
  {
    original_query: "lagerregal",
    total_searches: 9,
  },
  {
    original_query: "nadelfilt",
    total_searches: 9,
  },
  {
    original_query: "holzregal",
    total_searches: 9,
  },
  {
    original_query: "falls",
    total_searches: 9,
  },
  {
    original_query: "Autotepp",
    total_searches: 9,
  },
  {
    original_query: "messetepp",
    total_searches: 9,
  },
  {
    original_query: "Schr",
    total_searches: 9,
  },
  {
    original_query: "Kurz",
    total_searches: 9,
  },
  {
    original_query: "staketenzaun",
    total_searches: 9,
  },
  {
    original_query: "nach",
    total_searches: 9,
  },
  {
    original_query: "weiß",
    total_searches: 9,
  },
  {
    original_query: "gummig",
    total_searches: 9,
  },
  {
    original_query: "wandpaneele",
    total_searches: 9,
  },
  {
    original_query: "Zaunblend",
    total_searches: 9,
  },
  {
    original_query: "rundteppich",
    total_searches: 9,
  },
  {
    original_query: "Erdan",
    total_searches: 9,
  },
  {
    original_query: "abschlussleisten",
    total_searches: 9,
  },
  {
    original_query: "vinylbo",
    total_searches: 9,
  },
  {
    original_query: "vinylb",
    total_searches: 9,
  },
  {
    original_query: "Stallmatt",
    total_searches: 9,
  },
  {
    original_query: "kunstrassen",
    total_searches: 9,
  },
  {
    original_query: "eddy",
    total_searches: 9,
  },
  {
    original_query: "bauschutz",
    total_searches: 9,
  },
  {
    original_query: "shar",
    total_searches: 9,
  },
  {
    original_query: "servierwagen",
    total_searches: 9,
  },
  {
    original_query: "Grillmatte",
    total_searches: 9,
  },
  {
    original_query: "Fußab",
    total_searches: 9,
  },
  {
    original_query: "balkonfliese",
    total_searches: 9,
  },
  {
    original_query: "rass",
    total_searches: 9,
  },
  {
    original_query: "verdunklu",
    total_searches: 9,
  },
  {
    original_query: "Sicherhe",
    total_searches: 9,
  },
  {
    original_query: "vinylt",
    total_searches: 9,
  },
  {
    original_query: "Hochfloor",
    total_searches: 9,
  },
  {
    original_query: "transparente",
    total_searches: 9,
  },
  {
    original_query: "tischdeck",
    total_searches: 9,
  },
  {
    original_query: "schutzhü",
    total_searches: 9,
  },
  {
    original_query: "scen",
    total_searches: 9,
  },
  {
    original_query: "getränkeregal",
    total_searches: 9,
  },
  {
    original_query: "lammfell",
    total_searches: 9,
  },
  {
    original_query: "stuffenma",
    total_searches: 9,
  },
  {
    original_query: "läufern",
    total_searches: 9,
  },
  {
    original_query: "Bademat",
    total_searches: 9,
  },
  {
    original_query: "naturste",
    total_searches: 9,
  },
  {
    original_query: "Leisten",
    total_searches: 9,
  },
  {
    original_query: "Geweb",
    total_searches: 9,
  },
  {
    original_query: "baumarkt",
    total_searches: 9,
  },
  {
    original_query: "türvorl",
    total_searches: 9,
  },
  {
    original_query: "fussb",
    total_searches: 9,
  },
  {
    original_query: "schmutzg",
    total_searches: 9,
  },
  {
    original_query: "abdecku",
    total_searches: 9,
  },
  {
    original_query: "Badez",
    total_searches: 9,
  },
  {
    original_query: "schlingenfloor",
    total_searches: 9,
  },
  {
    original_query: "spanngumm",
    total_searches: 9,
  },
  {
    original_query: "grana",
    total_searches: 9,
  },
  {
    original_query: "Falls",
    total_searches: 9,
  },
  {
    original_query: "nadelfli",
    total_searches: 9,
  },
  {
    original_query: "Wasc",
    total_searches: 9,
  },
  {
    original_query: "geträ",
    total_searches: 9,
  },
  {
    original_query: "eckleiste",
    total_searches: 9,
  },
  {
    original_query: "gitterreg",
    total_searches: 9,
  },
  {
    original_query: "schmutzfangteppi",
    total_searches: 9,
  },
  {
    original_query: "zäune",
    total_searches: 9,
  },
  {
    original_query: "Bettumrandu",
    total_searches: 9,
  },
  {
    original_query: "Hohlk",
    total_searches: 9,
  },
  {
    original_query: "mobi",
    total_searches: 9,
  },
  {
    original_query: "Sege",
    total_searches: 9,
  },
  {
    original_query: "badewanneneinlage",
    total_searches: 9,
  },
  {
    original_query: "unterl",
    total_searches: 9,
  },
  {
    original_query: "palerm",
    total_searches: 9,
  },
  {
    original_query: "bodenschtz",
    total_searches: 9,
  },
  {
    original_query: "garagen",
    total_searches: 9,
  },
  {
    original_query: "badewanne",
    total_searches: 9,
  },
  {
    original_query: "lampe",
    total_searches: 9,
  },
  {
    original_query: "siss",
    total_searches: 9,
  },
  {
    original_query: "Superflex",
    total_searches: 9,
  },
  {
    original_query: "Badezi",
    total_searches: 9,
  },
  {
    original_query: "drahtza",
    total_searches: 9,
  },
  {
    original_query: "sicherheitsstufenmatte",
    total_searches: 9,
  },
  {
    original_query: "polyca",
    total_searches: 9,
  },
  {
    original_query: "badeteppic",
    total_searches: 9,
  },
  {
    original_query: "kunstrasent",
    total_searches: 9,
  },
  {
    original_query: "Versandkost",
    total_searches: 9,
  },
  {
    original_query: "schmuz",
    total_searches: 9,
  },
  {
    original_query: "gummistufenmatte",
    total_searches: 9,
  },
  {
    original_query: "antiermüdu",
    total_searches: 9,
  },
  {
    original_query: "anpassungs",
    total_searches: 9,
  },
  {
    original_query: "türschwelle",
    total_searches: 9,
  },
  {
    original_query: "Dusc",
    total_searches: 9,
  },
  {
    original_query: "Fahrr",
    total_searches: 9,
  },
  {
    original_query: "kinderspielteppich",
    total_searches: 9,
  },
  {
    original_query: "Gewebepl",
    total_searches: 9,
  },
  {
    original_query: "floord",
    total_searches: 9,
  },
  {
    original_query: "arbeits",
    total_searches: 9,
  },
  {
    original_query: "vienn",
    total_searches: 9,
  },
  {
    original_query: "katzenstreumatte",
    total_searches: 9,
  },
  {
    original_query: "fahrradhalterung",
    total_searches: 9,
  },
  {
    original_query: "stah",
    total_searches: 9,
  },
  {
    original_query: "eingangsbereich",
    total_searches: 9,
  },
  {
    original_query: "markisenstoff",
    total_searches: 9,
  },
  {
    original_query: "hygienematten",
    total_searches: 9,
  },
  {
    original_query: "wandre",
    total_searches: 9,
  },
  {
    original_query: "nero",
    total_searches: 9,
  },
  {
    original_query: "tischauflage",
    total_searches: 9,
  },
  {
    original_query: "Gewebeplan",
    total_searches: 9,
  },
  {
    original_query: "terassenflies",
    total_searches: 9,
  },
  {
    original_query: "wandreg",
    total_searches: 9,
  },
  {
    original_query: "moonlight",
    total_searches: 9,
  },
  {
    original_query: "andorra",
    total_searches: 9,
  },
  {
    original_query: "weichschaumatte",
    total_searches: 9,
  },
  {
    original_query: "polyc",
    total_searches: 9,
  },
  {
    original_query: "kratzteppi",
    total_searches: 9,
  },
  {
    original_query: "lion",
    total_searches: 9,
  },
  {
    original_query: "plexi",
    total_searches: 9,
  },
  {
    original_query: "Schwerlastreg",
    total_searches: 9,
  },
  {
    original_query: "ubergan",
    total_searches: 9,
  },
  {
    original_query: "zuschneidbar",
    total_searches: 9,
  },
  {
    original_query: "boxwood",
    total_searches: 9,
  },
  {
    original_query: "akkustikpanele",
    total_searches: 9,
  },
  {
    original_query: "lich",
    total_searches: 9,
  },
  {
    original_query: "sitzkissen",
    total_searches: 9,
  },
  {
    original_query: "Sunda",
    total_searches: 9,
  },
  {
    original_query: "duschmatt",
    total_searches: 9,
  },
  {
    original_query: "balkonfl",
    total_searches: 9,
  },
  {
    original_query: "flurtep",
    total_searches: 9,
  },
  {
    original_query: "dreieck",
    total_searches: 9,
  },
  {
    original_query: "genu",
    total_searches: 9,
  },
  {
    original_query: "gitterplane",
    total_searches: 9,
  },
  {
    original_query: "teppichdiele",
    total_searches: 9,
  },
  {
    original_query: "Schmutzfangt",
    total_searches: 9,
  },
  {
    original_query: "schaf",
    total_searches: 9,
  },
  {
    original_query: "maru",
    total_searches: 9,
  },
  {
    original_query: "cott",
    total_searches: 9,
  },
  {
    original_query: "magnetleiste",
    total_searches: 9,
  },
  {
    original_query: "gummigranula",
    total_searches: 9,
  },
  {
    original_query: "Gewäc",
    total_searches: 9,
  },
  {
    original_query: "liefer",
    total_searches: 9,
  },
  {
    original_query: "radente",
    total_searches: 9,
  },
  {
    original_query: "kabelbind",
    total_searches: 9,
  },
  {
    original_query: "Rutschf",
    total_searches: 9,
  },
  {
    original_query: "korkro",
    total_searches: 9,
  },
  {
    original_query: "fliz",
    total_searches: 9,
  },
  {
    original_query: "Flurteppi",
    total_searches: 9,
  },
  {
    original_query: "bicolor",
    total_searches: 9,
  },
  {
    original_query: "Autoteppich",
    total_searches: 9,
  },
  {
    original_query: "kies",
    total_searches: 9,
  },
  {
    original_query: "Kund",
    total_searches: 9,
  },
  {
    original_query: "Weic",
    total_searches: 9,
  },
  {
    original_query: "kücheläufer",
    total_searches: 9,
  },
  {
    original_query: "unterleg",
    total_searches: 9,
  },
  {
    original_query: "messeteppi",
    total_searches: 9,
  },
  {
    original_query: "garden",
    total_searches: 9,
  },
  {
    original_query: "türv",
    total_searches: 9,
  },
  {
    original_query: "boxenmatten",
    total_searches: 9,
  },
  {
    original_query: "krokodil",
    total_searches: 9,
  },
  {
    original_query: "Drei",
    total_searches: 9,
  },
  {
    original_query: "Maschendrah",
    total_searches: 9,
  },
  {
    original_query: "schuhabstreifer",
    total_searches: 9,
  },
  {
    original_query: "antie",
    total_searches: 9,
  },
  {
    original_query: "gard",
    total_searches: 9,
  },
  {
    original_query: "char",
    total_searches: 9,
  },
  {
    original_query: "sockeleiste",
    total_searches: 9,
  },
  {
    original_query: "tepccih",
    total_searches: 9,
  },
  {
    original_query: "korkpla",
    total_searches: 9,
  },
  {
    original_query: "schutzf",
    total_searches: 9,
  },
  {
    original_query: "wühlmausg",
    total_searches: 9,
  },
  {
    original_query: "presti",
    total_searches: 9,
  },
  {
    original_query: "Roya",
    total_searches: 9,
  },
  {
    original_query: "rebel",
    total_searches: 9,
  },
  {
    original_query: "rattenfalle",
    total_searches: 9,
  },
  {
    original_query: "gumi",
    total_searches: 9,
  },
  {
    original_query: "sisalläufe",
    total_searches: 9,
  },
  {
    original_query: "fern",
    total_searches: 9,
  },
  {
    original_query: "bodenm",
    total_searches: 9,
  },
  {
    original_query: "würth",
    total_searches: 9,
  },
  {
    original_query: "Konta",
    total_searches: 9,
  },
  {
    original_query: "tischschutzfolie",
    total_searches: 9,
  },
  {
    original_query: "kunstrasenklebeband",
    total_searches: 9,
  },
  {
    original_query: "antiermüdungs",
    total_searches: 9,
  },
  {
    original_query: "trennwa",
    total_searches: 9,
  },
  {
    original_query: "Rollenko",
    total_searches: 9,
  },
  {
    original_query: "filztepp",
    total_searches: 9,
  },
  {
    original_query: "Tran",
    total_searches: 9,
  },
  {
    original_query: "magnett",
    total_searches: 9,
  },
  {
    original_query: "terrase",
    total_searches: 9,
  },
  {
    original_query: "kunstrasentepp",
    total_searches: 9,
  },
  {
    original_query: "runder",
    total_searches: 9,
  },
  {
    original_query: "sauberkaufmatte",
    total_searches: 9,
  },
  {
    original_query: "velourteppich",
    total_searches: 9,
  },
  {
    original_query: "transpa",
    total_searches: 9,
  },
  {
    original_query: "flickenteppich",
    total_searches: 9,
  },
  {
    original_query: "kont",
    total_searches: 9,
  },
  {
    original_query: "teoo",
    total_searches: 9,
  },
  {
    original_query: "autdoor",
    total_searches: 9,
  },
  {
    original_query: "verdunklung",
    total_searches: 9,
  },
  {
    original_query: "kinderzimmer",
    total_searches: 9,
  },
  {
    original_query: "panel",
    total_searches: 9,
  },
  {
    original_query: "fussboden",
    total_searches: 9,
  },
  {
    original_query: "wildz",
    total_searches: 9,
  },
  {
    original_query: "verdunklun",
    total_searches: 9,
  },
  {
    original_query: "akkustikpaneele",
    total_searches: 9,
  },
  {
    original_query: "zepp",
    total_searches: 9,
  },
  {
    original_query: "himala",
    total_searches: 9,
  },
  {
    original_query: "treppenläuf",
    total_searches: 9,
  },
  {
    original_query: "black",
    total_searches: 9,
  },
  {
    original_query: "moderationstafe",
    total_searches: 9,
  },
  {
    original_query: "akkustikp",
    total_searches: 9,
  },
  {
    original_query: "flachn",
    total_searches: 9,
  },
  {
    original_query: "Sisaltep",
    total_searches: 9,
  },
  {
    original_query: "spri",
    total_searches: 9,
  },
  {
    original_query: "Weidenz",
    total_searches: 9,
  },
  {
    original_query: "Kontakt",
    total_searches: 9,
  },
  {
    original_query: "noppenf",
    total_searches: 9,
  },
  {
    original_query: "tropical",
    total_searches: 9,
  },
  {
    original_query: "gitterre",
    total_searches: 9,
  },
  {
    original_query: "Bautensch",
    total_searches: 9,
  },
  {
    original_query: "Bodenbel",
    total_searches: 9,
  },
  {
    original_query: "Fußa",
    total_searches: 9,
  },
  {
    original_query: "rech",
    total_searches: 9,
  },
  {
    original_query: "rasse",
    total_searches: 9,
  },
  {
    original_query: "sandkasten",
    total_searches: 9,
  },
  {
    original_query: "pins",
    total_searches: 9,
  },
  {
    original_query: "tischd",
    total_searches: 9,
  },
  {
    original_query: "kokus",
    total_searches: 9,
  },
  {
    original_query: "kratzbaum",
    total_searches: 9,
  },
  {
    original_query: "Antirutschmatt",
    total_searches: 9,
  },
  {
    original_query: "schmutzmatt",
    total_searches: 9,
  },
  {
    original_query: "Selbstkl",
    total_searches: 9,
  },
  {
    original_query: "lamin",
    total_searches: 9,
  },
  {
    original_query: "Markis",
    total_searches: 9,
  },
  {
    original_query: "stufenleiste",
    total_searches: 9,
  },
  {
    original_query: "verdunklungsro",
    total_searches: 9,
  },
  {
    original_query: "kairo",
    total_searches: 9,
  },
  {
    original_query: "Schaukaste",
    total_searches: 9,
  },
  {
    original_query: "Glas",
    total_searches: 9,
  },
  {
    original_query: "vitrine",
    total_searches: 9,
  },
  {
    original_query: "mete",
    total_searches: 9,
  },
  {
    original_query: "rine",
    total_searches: 9,
  },
  {
    original_query: "ivory",
    total_searches: 9,
  },
  {
    original_query: "segeltuch",
    total_searches: 9,
  },
  {
    original_query: "Sund",
    total_searches: 9,
  },
  {
    original_query: "Stab",
    total_searches: 9,
  },
  {
    original_query: "brandschutz",
    total_searches: 9,
  },
  {
    original_query: "Mari",
    total_searches: 9,
  },
  {
    original_query: "monchrom",
    total_searches: 9,
  },
  {
    original_query: "farbe",
    total_searches: 9,
  },
  {
    original_query: "Plis",
    total_searches: 9,
  },
  {
    original_query: "vesta",
    total_searches: 9,
  },
  {
    original_query: "Schmutzfangläufer",
    total_searches: 9,
  },
  {
    original_query: "Tele",
    total_searches: 9,
  },
  {
    original_query: "carpet",
    total_searches: 9,
  },
  {
    original_query: "franklin",
    total_searches: 9,
  },
  {
    original_query: "kurzfl",
    total_searches: 9,
  },
  {
    original_query: "Magne",
    total_searches: 9,
  },
  {
    original_query: "Dynas",
    total_searches: 9,
  },
  {
    original_query: "bambussicht",
    total_searches: 9,
  },
  {
    original_query: "schmutzfangmattr",
    total_searches: 9,
  },
  {
    original_query: "clips",
    total_searches: 9,
  },
  {
    original_query: "tischfo",
    total_searches: 9,
  },
  {
    original_query: "doppelrol",
    total_searches: 9,
  },
  {
    original_query: "schmtz",
    total_searches: 9,
  },
  {
    original_query: "Super",
    total_searches: 9,
  },
  {
    original_query: "heim",
    total_searches: 9,
  },
  {
    original_query: "Leis",
    total_searches: 9,
  },
  {
    original_query: "Abschl",
    total_searches: 9,
  },
  {
    original_query: "pinwand",
    total_searches: 9,
  },
  {
    original_query: "tatami",
    total_searches: 9,
  },
  {
    original_query: "mülleime",
    total_searches: 9,
  },
  {
    original_query: "hochflort",
    total_searches: 9,
  },
  {
    original_query: "Bautenschu",
    total_searches: 9,
  },
  {
    original_query: "dokument",
    total_searches: 9,
  },
  {
    original_query: "fairplay",
    total_searches: 9,
  },
  {
    original_query: "Floo",
    total_searches: 9,
  },
  {
    original_query: "Treppenschoner",
    total_searches: 9,
  },
  {
    original_query: "wasserabweisend",
    total_searches: 9,
  },
  {
    original_query: "kubus",
    total_searches: 9,
  },
  {
    original_query: "heizma",
    total_searches: 9,
  },
  {
    original_query: "Abdeckun",
    total_searches: 9,
  },
  {
    original_query: "chero",
    total_searches: 9,
  },
  {
    original_query: "murano",
    total_searches: 9,
  },
  {
    original_query: "Voliere",
    total_searches: 8,
  },
  {
    original_query: "Rankgitter",
    total_searches: 8,
  },
  {
    original_query: "Volierendraht",
    total_searches: 8,
  },
  {
    original_query: "spagetti",
    total_searches: 8,
  },
  {
    original_query: "erdnägel",
    total_searches: 8,
  },
  {
    original_query: "andeckplane",
    total_searches: 8,
  },
  {
    original_query: "Beet",
    total_searches: 8,
  },
  {
    original_query: "schreibunterlage",
    total_searches: 8,
  },
  {
    original_query: "klebefolie",
    total_searches: 8,
  },
  {
    original_query: "cosen",
    total_searches: 8,
  },
  {
    original_query: "primaverum",
    total_searches: 8,
  },
  {
    original_query: "green",
    total_searches: 8,
  },
  {
    original_query: "supe",
    total_searches: 8,
  },
  {
    original_query: "cara",
    total_searches: 8,
  },
  {
    original_query: "Schmutzfänger",
    total_searches: 8,
  },
  {
    original_query: "hase",
    total_searches: 8,
  },
  {
    original_query: "Seil",
    total_searches: 8,
  },
  {
    original_query: "nikias",
    total_searches: 8,
  },
  {
    original_query: "reifen",
    total_searches: 8,
  },
  {
    original_query: "magnetic",
    total_searches: 8,
  },
  {
    original_query: "fusma",
    total_searches: 8,
  },
  {
    original_query: "tasche",
    total_searches: 8,
  },
  {
    original_query: "terrasen",
    total_searches: 8,
  },
  {
    original_query: "Mark",
    total_searches: 8,
  },
  {
    original_query: "inne",
    total_searches: 8,
  },
  {
    original_query: "softer",
    total_searches: 8,
  },
  {
    original_query: "capera",
    total_searches: 8,
  },
  {
    original_query: "Fallsch",
    total_searches: 8,
  },
  {
    original_query: "octag",
    total_searches: 8,
  },
  {
    original_query: "leine",
    total_searches: 8,
  },
  {
    original_query: "wühlmausdraht",
    total_searches: 8,
  },
  {
    original_query: "Schnu",
    total_searches: 8,
  },
  {
    original_query: "baumwoll",
    total_searches: 8,
  },
  {
    original_query: "polycar",
    total_searches: 8,
  },
  {
    original_query: "rasenteppis",
    total_searches: 8,
  },
  {
    original_query: "feue",
    total_searches: 8,
  },
  {
    original_query: "Außen",
    total_searches: 8,
  },
  {
    original_query: "rasenkante",
    total_searches: 8,
  },
  {
    original_query: "treppenprofile",
    total_searches: 8,
  },
  {
    original_query: "Weidenmatte",
    total_searches: 8,
  },
  {
    original_query: "Kunstrasente",
    total_searches: 8,
  },
  {
    original_query: "Sichtschutzm",
    total_searches: 8,
  },
  {
    original_query: "Runde",
    total_searches: 8,
  },
  {
    original_query: "Sichtschutzmatt",
    total_searches: 8,
  },
  {
    original_query: "Antivibratio",
    total_searches: 8,
  },
  {
    original_query: "tischmatte",
    total_searches: 8,
  },
  {
    original_query: "schuhab",
    total_searches: 8,
  },
  {
    original_query: "kabelm",
    total_searches: 8,
  },
  {
    original_query: "arbeit",
    total_searches: 8,
  },
  {
    original_query: "klebstoff",
    total_searches: 8,
  },
  {
    original_query: "treppenbelag",
    total_searches: 8,
  },
  {
    original_query: "Plissees",
    total_searches: 8,
  },
  {
    original_query: "glasregal",
    total_searches: 8,
  },
  {
    original_query: "gitterrega",
    total_searches: 8,
  },
  {
    original_query: "naturs",
    total_searches: 8,
  },
  {
    original_query: "schr",
    total_searches: 8,
  },
  {
    original_query: "Weidenza",
    total_searches: 8,
  },
  {
    original_query: "schien",
    total_searches: 8,
  },
  {
    original_query: "stufenpro",
    total_searches: 8,
  },
  {
    original_query: "keller",
    total_searches: 8,
  },
  {
    original_query: "Winkelprofil",
    total_searches: 8,
  },
  {
    original_query: "winterschutz",
    total_searches: 8,
  },
  {
    original_query: "Grillma",
    total_searches: 8,
  },
  {
    original_query: "Drahtgitt",
    total_searches: 8,
  },
  {
    original_query: "Garag",
    total_searches: 8,
  },
  {
    original_query: "montag",
    total_searches: 8,
  },
  {
    original_query: "schmutzfanh",
    total_searches: 8,
  },
  {
    original_query: "Sicherheits",
    total_searches: 8,
  },
  {
    original_query: "Flokat",
    total_searches: 8,
  },
  {
    original_query: "gummigranulatmatte",
    total_searches: 8,
  },
  {
    original_query: "markis",
    total_searches: 8,
  },
  {
    original_query: "kokusmatte",
    total_searches: 8,
  },
  {
    original_query: "bodenf",
    total_searches: 8,
  },
  {
    original_query: "tobago",
    total_searches: 8,
  },
  {
    original_query: "rüge",
    total_searches: 8,
  },
  {
    original_query: "abschlussleis",
    total_searches: 8,
  },
  {
    original_query: "Rasentepi",
    total_searches: 8,
  },
  {
    original_query: "stufente",
    total_searches: 8,
  },
  {
    original_query: "hochfloorte",
    total_searches: 8,
  },
  {
    original_query: "schmutzfangläufe",
    total_searches: 8,
  },
  {
    original_query: "duschhock",
    total_searches: 8,
  },
  {
    original_query: "Coral",
    total_searches: 8,
  },
  {
    original_query: "schmitzfangm",
    total_searches: 8,
  },
  {
    original_query: "Sicherh",
    total_searches: 8,
  },
  {
    original_query: "korkkle",
    total_searches: 8,
  },
  {
    original_query: "papier",
    total_searches: 8,
  },
  {
    original_query: "hohlkammerplatten",
    total_searches: 8,
  },
  {
    original_query: "alus",
    total_searches: 8,
  },
  {
    original_query: "klemm",
    total_searches: 8,
  },
  {
    original_query: "titanrack",
    total_searches: 8,
  },
  {
    original_query: "Radente",
    total_searches: 8,
  },
  {
    original_query: "veny",
    total_searches: 8,
  },
  {
    original_query: "Lucca",
    total_searches: 8,
  },
  {
    original_query: "wannen",
    total_searches: 8,
  },
  {
    original_query: "olymp",
    total_searches: 8,
  },
  {
    original_query: "Pflanzen",
    total_searches: 8,
  },
  {
    original_query: "fußa",
    total_searches: 8,
  },
  {
    original_query: "duscheinlage",
    total_searches: 8,
  },
  {
    original_query: "noppenboden",
    total_searches: 8,
  },
  {
    original_query: "Unkrautv",
    total_searches: 8,
  },
  {
    original_query: "sicherheitsglas",
    total_searches: 8,
  },
  {
    original_query: "Schmutzfanglä",
    total_searches: 8,
  },
  {
    original_query: "Winkelpro",
    total_searches: 8,
  },
  {
    original_query: "terrazzo",
    total_searches: 8,
  },
  {
    original_query: "abschlusspr",
    total_searches: 8,
  },
  {
    original_query: "kettelteppich",
    total_searches: 8,
  },
  {
    original_query: "Badezimmer",
    total_searches: 8,
  },
  {
    original_query: "vorzelt",
    total_searches: 8,
  },
  {
    original_query: "waben",
    total_searches: 8,
  },
  {
    original_query: "schmutzschleuse",
    total_searches: 8,
  },
  {
    original_query: "Winkelp",
    total_searches: 8,
  },
  {
    original_query: "Kunstrasenteppich",
    total_searches: 8,
  },
  {
    original_query: "Balkonsichtsc",
    total_searches: 8,
  },
  {
    original_query: "Gummigra",
    total_searches: 8,
  },
  {
    original_query: "Dyna",
    total_searches: 8,
  },
  {
    original_query: "Terassenf",
    total_searches: 8,
  },
  {
    original_query: "wohnzi",
    total_searches: 8,
  },
  {
    original_query: "faltro",
    total_searches: 8,
  },
  {
    original_query: "gara",
    total_searches: 8,
  },
  {
    original_query: "voliere",
    total_searches: 8,
  },
  {
    original_query: "hochflorteppi",
    total_searches: 8,
  },
  {
    original_query: "Bautens",
    total_searches: 8,
  },
  {
    original_query: "Acryl",
    total_searches: 8,
  },
  {
    original_query: "Fahrra",
    total_searches: 8,
  },
  {
    original_query: "uberga",
    total_searches: 8,
  },
  {
    original_query: "Raseb",
    total_searches: 8,
  },
  {
    original_query: "getränk",
    total_searches: 8,
  },
  {
    original_query: "thermor",
    total_searches: 8,
  },
  {
    original_query: "gummib",
    total_searches: 8,
  },
  {
    original_query: "schilfmatte",
    total_searches: 8,
  },
  {
    original_query: "disal",
    total_searches: 8,
  },
  {
    original_query: "schuhschrank",
    total_searches: 8,
  },
  {
    original_query: "bodenbel",
    total_searches: 8,
  },
  {
    original_query: "planne",
    total_searches: 8,
  },
  {
    original_query: "mäuse",
    total_searches: 8,
  },
  {
    original_query: "premi",
    total_searches: 8,
  },
  {
    original_query: "trennwan",
    total_searches: 8,
  },
  {
    original_query: "ausgl",
    total_searches: 8,
  },
  {
    original_query: "Schutzh",
    total_searches: 8,
  },
  {
    original_query: "balkonverkleidung",
    total_searches: 8,
  },
  {
    original_query: "selby",
    total_searches: 8,
  },
  {
    original_query: "schlaf",
    total_searches: 8,
  },
  {
    original_query: "Erdank",
    total_searches: 8,
  },
  {
    original_query: "Flurläuf",
    total_searches: 8,
  },
  {
    original_query: "teppichklebe",
    total_searches: 8,
  },
  {
    original_query: "spektral",
    total_searches: 8,
  },
  {
    original_query: "abschlußprofil",
    total_searches: 8,
  },
  {
    original_query: "Hohlkammerplatten",
    total_searches: 8,
  },
  {
    original_query: "cross",
    total_searches: 8,
  },
  {
    original_query: "abdeckf",
    total_searches: 8,
  },
  {
    original_query: "filzteppi",
    total_searches: 8,
  },
  {
    original_query: "terassenbelag",
    total_searches: 8,
  },
  {
    original_query: "cose",
    total_searches: 8,
  },
  {
    original_query: "wohnz",
    total_searches: 8,
  },
  {
    original_query: "Dynast",
    total_searches: 8,
  },
  {
    original_query: "Boot",
    total_searches: 8,
  },
  {
    original_query: "schirmständer",
    total_searches: 8,
  },
  {
    original_query: "fliesenpro",
    total_searches: 8,
  },
  {
    original_query: "rainbo",
    total_searches: 8,
  },
  {
    original_query: "zaunpfosten",
    total_searches: 8,
  },
  {
    original_query: "schmutzfangmatze",
    total_searches: 8,
  },
  {
    original_query: "gewürzregal",
    total_searches: 8,
  },
  {
    original_query: "beetumrandung",
    total_searches: 8,
  },
  {
    original_query: "Vikin",
    total_searches: 8,
  },
  {
    original_query: "tarpaulin",
    total_searches: 8,
  },
  {
    original_query: "läug",
    total_searches: 8,
  },
  {
    original_query: "panee",
    total_searches: 8,
  },
  {
    original_query: "rückg",
    total_searches: 8,
  },
  {
    original_query: "Gummig",
    total_searches: 8,
  },
  {
    original_query: "Rassen",
    total_searches: 8,
  },
  {
    original_query: "enni",
    total_searches: 8,
  },
  {
    original_query: "Kurzf",
    total_searches: 8,
  },
  {
    original_query: "drat",
    total_searches: 8,
  },
  {
    original_query: "velvet",
    total_searches: 8,
  },
  {
    original_query: "antirusch",
    total_searches: 8,
  },
  {
    original_query: "mull",
    total_searches: 8,
  },
  {
    original_query: "genova",
    total_searches: 8,
  },
  {
    original_query: "mause",
    total_searches: 8,
  },
  {
    original_query: "leiter",
    total_searches: 8,
  },
  {
    original_query: "blumenreg",
    total_searches: 8,
  },
  {
    original_query: "paler",
    total_searches: 8,
  },
  {
    original_query: "akkustikpan",
    total_searches: 8,
  },
  {
    original_query: "anhänger",
    total_searches: 8,
  },
  {
    original_query: "vinyltepp",
    total_searches: 8,
  },
  {
    original_query: "Fliegengitter",
    total_searches: 8,
  },
  {
    original_query: "Rollenk",
    total_searches: 8,
  },
  {
    original_query: "bambusläufer",
    total_searches: 8,
  },
  {
    original_query: "sparro",
    total_searches: 8,
  },
  {
    original_query: "spage",
    total_searches: 8,
  },
  {
    original_query: "stahlmatte",
    total_searches: 8,
  },
  {
    original_query: "rankhil",
    total_searches: 8,
  },
  {
    original_query: "telefo",
    total_searches: 8,
  },
  {
    original_query: "organizer",
    total_searches: 8,
  },
  {
    original_query: "balkonrasen",
    total_searches: 8,
  },
  {
    original_query: "ringgummimatten",
    total_searches: 8,
  },
  {
    original_query: "kosme",
    total_searches: 8,
  },
  {
    original_query: "baumrinde",
    total_searches: 8,
  },
  {
    original_query: "opti",
    total_searches: 8,
  },
  {
    original_query: "arezzo",
    total_searches: 8,
  },
  {
    original_query: "weidenzau",
    total_searches: 8,
  },
  {
    original_query: "Marki",
    total_searches: 8,
  },
  {
    original_query: "wasserdi",
    total_searches: 8,
  },
  {
    original_query: "zala",
    total_searches: 8,
  },
  {
    original_query: "paneel",
    total_searches: 8,
  },
  {
    original_query: "prome",
    total_searches: 8,
  },
  {
    original_query: "antivibrationsm",
    total_searches: 8,
  },
  {
    original_query: "läüfer",
    total_searches: 8,
  },
  {
    original_query: "bidens",
    total_searches: 8,
  },
  {
    original_query: "bürsten",
    total_searches: 8,
  },
  {
    original_query: "katzenkratz",
    total_searches: 8,
  },
  {
    original_query: "Kabelbind",
    total_searches: 8,
  },
  {
    original_query: "Rasse",
    total_searches: 8,
  },
  {
    original_query: "insekt",
    total_searches: 8,
  },
  {
    original_query: "rasentepi",
    total_searches: 8,
  },
  {
    original_query: "schmutzfangmattw",
    total_searches: 8,
  },
  {
    original_query: "klebestreifen",
    total_searches: 8,
  },
  {
    original_query: "innenverkleidung",
    total_searches: 8,
  },
  {
    original_query: "teppichla",
    total_searches: 8,
  },
  {
    original_query: "schmutzfangmattte",
    total_searches: 8,
  },
  {
    original_query: "raffrollo",
    total_searches: 8,
  },
  {
    original_query: "cube",
    total_searches: 8,
  },
  {
    original_query: "Kurzfl",
    total_searches: 8,
  },
  {
    original_query: "schutznetz",
    total_searches: 8,
  },
  {
    original_query: "Perf",
    total_searches: 8,
  },
  {
    original_query: "monta",
    total_searches: 8,
  },
  {
    original_query: "übergangsschienen",
    total_searches: 8,
  },
  {
    original_query: "maritim",
    total_searches: 8,
  },
  {
    original_query: "wandleisten",
    total_searches: 8,
  },
  {
    original_query: "logomatten",
    total_searches: 8,
  },
  {
    original_query: "flaschenk",
    total_searches: 8,
  },
  {
    original_query: "türstopper",
    total_searches: 8,
  },
  {
    original_query: "hart",
    total_searches: 8,
  },
  {
    original_query: "kistenregal",
    total_searches: 8,
  },
  {
    original_query: "Fallsc",
    total_searches: 8,
  },
  {
    original_query: "kuchenlaufer",
    total_searches: 8,
  },
  {
    original_query: "bodenflie",
    total_searches: 8,
  },
  {
    original_query: "gewebefolie",
    total_searches: 8,
  },
  {
    original_query: "Jute",
    total_searches: 8,
  },
  {
    original_query: "paddockmatte",
    total_searches: 8,
  },
  {
    original_query: "tasente",
    total_searches: 8,
  },
  {
    original_query: "Wühlmausg",
    total_searches: 8,
  },
  {
    original_query: "messetep",
    total_searches: 8,
  },
  {
    original_query: "malt",
    total_searches: 8,
  },
  {
    original_query: "Amazonas",
    total_searches: 8,
  },
  {
    original_query: "bodenfliese",
    total_searches: 8,
  },
  {
    original_query: "tischset",
    total_searches: 8,
  },
  {
    original_query: "sonnesegel",
    total_searches: 8,
  },
  {
    original_query: "schreibtischunter",
    total_searches: 8,
  },
  {
    original_query: "trapezble",
    total_searches: 8,
  },
  {
    original_query: "flachgewebe",
    total_searches: 8,
  },
  {
    original_query: "sone",
    total_searches: 8,
  },
  {
    original_query: "doppelsei",
    total_searches: 8,
  },
  {
    original_query: "lamm",
    total_searches: 8,
  },
  {
    original_query: "kosmetik",
    total_searches: 8,
  },
  {
    original_query: "mosk",
    total_searches: 8,
  },
  {
    original_query: "absperr",
    total_searches: 8,
  },
  {
    original_query: "anpassung",
    total_searches: 8,
  },
  {
    original_query: "warn",
    total_searches: 8,
  },
  {
    original_query: "Fahr",
    total_searches: 8,
  },
  {
    original_query: "Zauns",
    total_searches: 8,
  },
  {
    original_query: "Schuh",
    total_searches: 8,
  },
  {
    original_query: "Schaukasten",
    total_searches: 8,
  },
  {
    original_query: "terracotta",
    total_searches: 8,
  },
  {
    original_query: "akustikpan",
    total_searches: 8,
  },
  {
    original_query: "rankh",
    total_searches: 8,
  },
  {
    original_query: "leufer",
    total_searches: 8,
  },
  {
    original_query: "magnetfolie",
    total_searches: 8,
  },
  {
    original_query: "savannah",
    total_searches: 8,
  },
  {
    original_query: "stretchfilz",
    total_searches: 8,
  },
  {
    original_query: "Gewebepla",
    total_searches: 8,
  },
  {
    original_query: "tibe",
    total_searches: 8,
  },
  {
    original_query: "Fenster",
    total_searches: 8,
  },
  {
    original_query: "Treppenteppi",
    total_searches: 8,
  },
  {
    original_query: "Treppenläuf",
    total_searches: 8,
  },
  {
    original_query: "weiss",
    total_searches: 8,
  },
  {
    original_query: "loch",
    total_searches: 8,
  },
  {
    original_query: "destiny",
    total_searches: 8,
  },
  {
    original_query: "duschmatten",
    total_searches: 8,
  },
  {
    original_query: "badv",
    total_searches: 8,
  },
  {
    original_query: "logomatte",
    total_searches: 8,
  },
  {
    original_query: "frachtkosten",
    total_searches: 8,
  },
  {
    original_query: "Waschba",
    total_searches: 8,
  },
  {
    original_query: "rassentepp",
    total_searches: 8,
  },
  {
    original_query: "fußb",
    total_searches: 8,
  },
  {
    original_query: "vibrationsmatte",
    total_searches: 8,
  },
  {
    original_query: "Korkkleber",
    total_searches: 8,
  },
  {
    original_query: "schlingma",
    total_searches: 8,
  },
  {
    original_query: "memo",
    total_searches: 8,
  },
  {
    original_query: "park",
    total_searches: 8,
  },
  {
    original_query: "kuschel",
    total_searches: 8,
  },
  {
    original_query: "abschlussl",
    total_searches: 8,
  },
  {
    original_query: "Viking",
    total_searches: 8,
  },
  {
    original_query: "strandkorb",
    total_searches: 8,
  },
  {
    original_query: "tier",
    total_searches: 8,
  },
  {
    original_query: "mala",
    total_searches: 8,
  },
  {
    original_query: "eingangsma",
    total_searches: 8,
  },
  {
    original_query: "puzzl",
    total_searches: 8,
  },
  {
    original_query: "polycarbona",
    total_searches: 8,
  },
  {
    original_query: "teppichbode",
    total_searches: 8,
  },
  {
    original_query: "ausglei",
    total_searches: 8,
  },
  {
    original_query: "Rassente",
    total_searches: 8,
  },
  {
    original_query: "trani",
    total_searches: 8,
  },
  {
    original_query: "hochflortepp",
    total_searches: 8,
  },
  {
    original_query: "Meter",
    total_searches: 8,
  },
  {
    original_query: "heidekrau",
    total_searches: 8,
  },
  {
    original_query: "pontia",
    total_searches: 8,
  },
  {
    original_query: "schmutzfinks",
    total_searches: 8,
  },
  {
    original_query: "Abdecku",
    total_searches: 8,
  },
  {
    original_query: "Barcelon",
    total_searches: 8,
  },
  {
    original_query: "Flurläu",
    total_searches: 8,
  },
  {
    original_query: "unkrautfolie",
    total_searches: 8,
  },
  {
    original_query: "moderationskoffer",
    total_searches: 8,
  },
  {
    original_query: "prom",
    total_searches: 8,
  },
  {
    original_query: "lärm",
    total_searches: 8,
  },
  {
    original_query: "manta",
    total_searches: 8,
  },
  {
    original_query: "pink",
    total_searches: 8,
  },
  {
    original_query: "kleben",
    total_searches: 8,
  },
  {
    original_query: "türvorleg",
    total_searches: 8,
  },
  {
    original_query: "anit",
    total_searches: 8,
  },
  {
    original_query: "vogelschutznetz",
    total_searches: 8,
  },
  {
    original_query: "abschlus",
    total_searches: 8,
  },
  {
    original_query: "Maul",
    total_searches: 8,
  },
  {
    original_query: "fußbo",
    total_searches: 8,
  },
  {
    original_query: "Vero",
    total_searches: 8,
  },
  {
    original_query: "katzens",
    total_searches: 8,
  },
  {
    original_query: "rand",
    total_searches: 7,
  },
  {
    original_query: "zusch",
    total_searches: 7,
  },
  {
    original_query: "eingangsmatt",
    total_searches: 7,
  },
  {
    original_query: "Carlt",
    total_searches: 7,
  },
  {
    original_query: "Maschendr",
    total_searches: 7,
  },
  {
    original_query: "wandschutz",
    total_searches: 7,
  },
  {
    original_query: "Fallschu",
    total_searches: 7,
  },
  {
    original_query: "Treppenprofil",
    total_searches: 7,
  },
  {
    original_query: "bambuszau",
    total_searches: 7,
  },
  {
    original_query: "klickfließen",
    total_searches: 7,
  },
  {
    original_query: "trapezbl",
    total_searches: 7,
  },
  {
    original_query: "sportmatte",
    total_searches: 7,
  },
  {
    original_query: "fliesenschiene",
    total_searches: 7,
  },
  {
    original_query: "Mülleim",
    total_searches: 7,
  },
  {
    original_query: "rabattcod",
    total_searches: 7,
  },
  {
    original_query: "gummipla",
    total_searches: 7,
  },
  {
    original_query: "print",
    total_searches: 7,
  },
  {
    original_query: "grillabdeckung",
    total_searches: 7,
  },
  {
    original_query: "nörpel",
    total_searches: 7,
  },
  {
    original_query: "Ringgummimatte",
    total_searches: 7,
  },
  {
    original_query: "schlagzeug",
    total_searches: 7,
  },
  {
    original_query: "drahtgit",
    total_searches: 7,
  },
  {
    original_query: "rubber",
    total_searches: 7,
  },
  {
    original_query: "teppichsta",
    total_searches: 7,
  },
  {
    original_query: "Schmutzfangläu",
    total_searches: 7,
  },
  {
    original_query: "schreibtis",
    total_searches: 7,
  },
  {
    original_query: "rivie",
    total_searches: 7,
  },
  {
    original_query: "schlü",
    total_searches: 7,
  },
  {
    original_query: "Leno",
    total_searches: 7,
  },
  {
    original_query: "eagle",
    total_searches: 7,
  },
  {
    original_query: "hartböden",
    total_searches: 7,
  },
  {
    original_query: "teppicj",
    total_searches: 7,
  },
  {
    original_query: "poolmatte",
    total_searches: 7,
  },
  {
    original_query: "rabat",
    total_searches: 7,
  },
  {
    original_query: "saun",
    total_searches: 7,
  },
  {
    original_query: "padd",
    total_searches: 7,
  },
  {
    original_query: "treppenmatt",
    total_searches: 7,
  },
  {
    original_query: "Rinden",
    total_searches: 7,
  },
  {
    original_query: "tarkett",
    total_searches: 7,
  },
  {
    original_query: "radenteppich",
    total_searches: 7,
  },
  {
    original_query: "schattennetz",
    total_searches: 7,
  },
  {
    original_query: "wiese",
    total_searches: 7,
  },
  {
    original_query: "bolog",
    total_searches: 7,
  },
  {
    original_query: "balkontep",
    total_searches: 7,
  },
  {
    original_query: "stahlseil",
    total_searches: 7,
  },
  {
    original_query: "kunstst",
    total_searches: 7,
  },
  {
    original_query: "laeu",
    total_searches: 7,
  },
  {
    original_query: "sola",
    total_searches: 7,
  },
  {
    original_query: "Cala",
    total_searches: 7,
  },
  {
    original_query: "Fußmatten",
    total_searches: 7,
  },
  {
    original_query: "kundensto",
    total_searches: 7,
  },
  {
    original_query: "Hohlkammer",
    total_searches: 7,
  },
  {
    original_query: "poolru",
    total_searches: 7,
  },
  {
    original_query: "thermoro",
    total_searches: 7,
  },
  {
    original_query: "Treppensch",
    total_searches: 7,
  },
  {
    original_query: "rutschfester",
    total_searches: 7,
  },
  {
    original_query: "reinigung",
    total_searches: 7,
  },
  {
    original_query: "madr",
    total_searches: 7,
  },
  {
    original_query: "hochflorteppic",
    total_searches: 7,
  },
  {
    original_query: "treppenwinkel",
    total_searches: 7,
  },
  {
    original_query: "autoteppic",
    total_searches: 7,
  },
  {
    original_query: "Baumri",
    total_searches: 7,
  },
  {
    original_query: "george",
    total_searches: 7,
  },
  {
    original_query: "rindenmatten",
    total_searches: 7,
  },
  {
    original_query: "wohnm",
    total_searches: 7,
  },
  {
    original_query: "weidenmatten",
    total_searches: 7,
  },
  {
    original_query: "korkroll",
    total_searches: 7,
  },
  {
    original_query: "abtre",
    total_searches: 7,
  },
  {
    original_query: "candy",
    total_searches: 7,
  },
  {
    original_query: "weidenza",
    total_searches: 7,
  },
  {
    original_query: "badewann",
    total_searches: 7,
  },
  {
    original_query: "Natur",
    total_searches: 7,
  },
  {
    original_query: "doppelse",
    total_searches: 7,
  },
  {
    original_query: "rechnu",
    total_searches: 7,
  },
  {
    original_query: "Fliege",
    total_searches: 7,
  },
  {
    original_query: "zeltplätze",
    total_searches: 7,
  },
  {
    original_query: "balkonb",
    total_searches: 7,
  },
  {
    original_query: "eventte",
    total_searches: 7,
  },
  {
    original_query: "rückgab",
    total_searches: 7,
  },
  {
    original_query: "Auss",
    total_searches: 7,
  },
  {
    original_query: "badgarnitur",
    total_searches: 7,
  },
  {
    original_query: "Floor",
    total_searches: 7,
  },
  {
    original_query: "böschung",
    total_searches: 7,
  },
  {
    original_query: "webteppich",
    total_searches: 7,
  },
  {
    original_query: "zeppich",
    total_searches: 7,
  },
  {
    original_query: "rampen",
    total_searches: 7,
  },
  {
    original_query: "beheizbare",
    total_searches: 7,
  },
  {
    original_query: "homg",
    total_searches: 7,
  },
  {
    original_query: "teppichmatte",
    total_searches: 7,
  },
  {
    original_query: "vinylbode",
    total_searches: 7,
  },
  {
    original_query: "ausgle",
    total_searches: 7,
  },
  {
    original_query: "kunsts",
    total_searches: 7,
  },
  {
    original_query: "rasengi",
    total_searches: 7,
  },
  {
    original_query: "heimwe",
    total_searches: 7,
  },
  {
    original_query: "Balkonfli",
    total_searches: 7,
  },
  {
    original_query: "Kundt",
    total_searches: 7,
  },
  {
    original_query: "doppeleinfassleiste",
    total_searches: 7,
  },
  {
    original_query: "Treppenteppic",
    total_searches: 7,
  },
  {
    original_query: "Pfost",
    total_searches: 7,
  },
  {
    original_query: "Rücksendung",
    total_searches: 7,
  },
  {
    original_query: "hell",
    total_searches: 7,
  },
  {
    original_query: "noppenfol",
    total_searches: 7,
  },
  {
    original_query: "katzenkratzbox",
    total_searches: 7,
  },
  {
    original_query: "regen",
    total_searches: 7,
  },
  {
    original_query: "Schutzmatte",
    total_searches: 7,
  },
  {
    original_query: "Clyde",
    total_searches: 7,
  },
  {
    original_query: "ersa",
    total_searches: 7,
  },
  {
    original_query: "kuchenläufer",
    total_searches: 7,
  },
  {
    original_query: "azade",
    total_searches: 7,
  },
  {
    original_query: "Mülleimer",
    total_searches: 7,
  },
  {
    original_query: "Noppenfolie",
    total_searches: 7,
  },
  {
    original_query: "metal",
    total_searches: 7,
  },
  {
    original_query: "zierzaun",
    total_searches: 7,
  },
  {
    original_query: "elegance",
    total_searches: 7,
  },
  {
    original_query: "dylan",
    total_searches: 7,
  },
  {
    original_query: "Magnet",
    total_searches: 7,
  },
  {
    original_query: "schreibtischunt",
    total_searches: 7,
  },
  {
    original_query: "treppenstange",
    total_searches: 7,
  },
  {
    original_query: "tribe",
    total_searches: 7,
  },
  {
    original_query: "durch",
    total_searches: 7,
  },
  {
    original_query: "wäsche",
    total_searches: 7,
  },
  {
    original_query: "sprükleber",
    total_searches: 7,
  },
  {
    original_query: "Sale",
    total_searches: 7,
  },
  {
    original_query: "laufe",
    total_searches: 7,
  },
  {
    original_query: "Tischf",
    total_searches: 7,
  },
  {
    original_query: "korkr",
    total_searches: 7,
  },
  {
    original_query: "schmur",
    total_searches: 7,
  },
  {
    original_query: "duschh",
    total_searches: 7,
  },
  {
    original_query: "spaghe",
    total_searches: 7,
  },
  {
    original_query: "pflanzstäbe",
    total_searches: 7,
  },
  {
    original_query: "schal",
    total_searches: 7,
  },
  {
    original_query: "wohnmo",
    total_searches: 7,
  },
  {
    original_query: "Bodenbela",
    total_searches: 7,
  },
  {
    original_query: "waschm",
    total_searches: 7,
  },
  {
    original_query: "wandan",
    total_searches: 7,
  },
  {
    original_query: "alabama",
    total_searches: 7,
  },
  {
    original_query: "Carlto",
    total_searches: 7,
  },
  {
    original_query: "bambusmatten",
    total_searches: 7,
  },
  {
    original_query: "efeu",
    total_searches: 7,
  },
  {
    original_query: "stellwa",
    total_searches: 7,
  },
  {
    original_query: "Retou",
    total_searches: 7,
  },
  {
    original_query: "grillschutzmatt",
    total_searches: 7,
  },
  {
    original_query: "rechnun",
    total_searches: 7,
  },
  {
    original_query: "Rankg",
    total_searches: 7,
  },
  {
    original_query: "kunstfe",
    total_searches: 7,
  },
  {
    original_query: "schmutzl",
    total_searches: 7,
  },
  {
    original_query: "Rankgitt",
    total_searches: 7,
  },
  {
    original_query: "rhino",
    total_searches: 7,
  },
  {
    original_query: "fallsch",
    total_searches: 7,
  },
  {
    original_query: "filzma",
    total_searches: 7,
  },
  {
    original_query: "haifa",
    total_searches: 7,
  },
  {
    original_query: "schaumstoff",
    total_searches: 7,
  },
  {
    original_query: "Grillschutzmatte",
    total_searches: 7,
  },
  {
    original_query: "klettband",
    total_searches: 7,
  },
  {
    original_query: "vogelhaus",
    total_searches: 7,
  },
  {
    original_query: "filzstellwand",
    total_searches: 7,
  },
  {
    original_query: "Stegplatten",
    total_searches: 7,
  },
  {
    original_query: "honh",
    total_searches: 7,
  },
  {
    original_query: "Fussab",
    total_searches: 7,
  },
  {
    original_query: "Segel",
    total_searches: 7,
  },
  {
    original_query: "premiu",
    total_searches: 7,
  },
  {
    original_query: "teppichunterlagen",
    total_searches: 7,
  },
  {
    original_query: "bettwäsche",
    total_searches: 7,
  },
  {
    original_query: "santia",
    total_searches: 7,
  },
  {
    original_query: "Hochfloo",
    total_searches: 7,
  },
  {
    original_query: "winkelleiste",
    total_searches: 7,
  },
  {
    original_query: "alex",
    total_searches: 7,
  },
  {
    original_query: "rechn",
    total_searches: 7,
  },
  {
    original_query: "Bambussicht",
    total_searches: 7,
  },
  {
    original_query: "Floka",
    total_searches: 7,
  },
  {
    original_query: "azte",
    total_searches: 7,
  },
  {
    original_query: "pfoste",
    total_searches: 7,
  },
  {
    original_query: "Trape",
    total_searches: 7,
  },
  {
    original_query: "piet",
    total_searches: 7,
  },
  {
    original_query: "andec",
    total_searches: 7,
  },
  {
    original_query: "outdoortep",
    total_searches: 7,
  },
  {
    original_query: "stufenkantenprofiö",
    total_searches: 7,
  },
  {
    original_query: "Hand",
    total_searches: 7,
  },
  {
    original_query: "badmat",
    total_searches: 7,
  },
  {
    original_query: "william",
    total_searches: 7,
  },
  {
    original_query: "kabelschutz",
    total_searches: 7,
  },
  {
    original_query: "Duschv",
    total_searches: 7,
  },
  {
    original_query: "gummiteppich",
    total_searches: 7,
  },
  {
    original_query: "wandboard",
    total_searches: 7,
  },
  {
    original_query: "lastenregal",
    total_searches: 7,
  },
  {
    original_query: "schmutzfangmate",
    total_searches: 7,
  },
  {
    original_query: "kratzteppic",
    total_searches: 7,
  },
  {
    original_query: "bösc",
    total_searches: 7,
  },
  {
    original_query: "nagel",
    total_searches: 7,
  },
  {
    original_query: "treppenläufe",
    total_searches: 7,
  },
  {
    original_query: "edinb",
    total_searches: 7,
  },
  {
    original_query: "Bautensc",
    total_searches: 7,
  },
  {
    original_query: "rind",
    total_searches: 7,
  },
  {
    original_query: "aluflex",
    total_searches: 7,
  },
  {
    original_query: "Schmutzfangl",
    total_searches: 7,
  },
  {
    original_query: "andr",
    total_searches: 7,
  },
  {
    original_query: "Baste",
    total_searches: 7,
  },
  {
    original_query: "aber",
    total_searches: 7,
  },
  {
    original_query: "acrylglasplatten",
    total_searches: 7,
  },
  {
    original_query: "stufent",
    total_searches: 7,
  },
  {
    original_query: "barry",
    total_searches: 7,
  },
  {
    original_query: "balkonf",
    total_searches: 7,
  },
  {
    original_query: "rain",
    total_searches: 7,
  },
  {
    original_query: "Viki",
    total_searches: 7,
  },
  {
    original_query: "Schmutzfangteppi",
    total_searches: 7,
  },
  {
    original_query: "Bautenschutzmatte",
    total_searches: 7,
  },
  {
    original_query: "türmatt",
    total_searches: 7,
  },
  {
    original_query: "michigan",
    total_searches: 7,
  },
  {
    original_query: "Lami",
    total_searches: 7,
  },
  {
    original_query: "balkonmöbel",
    total_searches: 7,
  },
  {
    original_query: "zier",
    total_searches: 7,
  },
  {
    original_query: "doppelseitig",
    total_searches: 7,
  },
  {
    original_query: "waterford",
    total_searches: 7,
  },
  {
    original_query: "kenj",
    total_searches: 7,
  },
  {
    original_query: "Spri",
    total_searches: 7,
  },
  {
    original_query: "Dayt",
    total_searches: 7,
  },
  {
    original_query: "plise",
    total_searches: 7,
  },
  {
    original_query: "classi",
    total_searches: 7,
  },
  {
    original_query: "Bodenmatte",
    total_searches: 7,
  },
  {
    original_query: "linolium",
    total_searches: 7,
  },
  {
    original_query: "Sonnenschein",
    total_searches: 7,
  },
  {
    original_query: "Teppichbo",
    total_searches: 7,
  },
  {
    original_query: "baus",
    total_searches: 7,
  },
  {
    original_query: "drahtgitte",
    total_searches: 7,
  },
  {
    original_query: "Veron",
    total_searches: 7,
  },
  {
    original_query: "fitnes",
    total_searches: 7,
  },
  {
    original_query: "lippe",
    total_searches: 7,
  },
  {
    original_query: "werkstattboden",
    total_searches: 7,
  },
  {
    original_query: "maulwu",
    total_searches: 7,
  },
  {
    original_query: "ringgummima",
    total_searches: 7,
  },
  {
    original_query: "dich",
    total_searches: 7,
  },
  {
    original_query: "schachbrett",
    total_searches: 7,
  },
  {
    original_query: "antista",
    total_searches: 7,
  },
  {
    original_query: "sarah",
    total_searches: 7,
  },
  {
    original_query: "Weichs",
    total_searches: 7,
  },
  {
    original_query: "wanne",
    total_searches: 7,
  },
  {
    original_query: "korkpl",
    total_searches: 7,
  },
  {
    original_query: "weitspanregal",
    total_searches: 7,
  },
  {
    original_query: "stug",
    total_searches: 7,
  },
  {
    original_query: "Absc",
    total_searches: 7,
  },
  {
    original_query: "ever",
    total_searches: 7,
  },
  {
    original_query: "spectra",
    total_searches: 7,
  },
  {
    original_query: "verbind",
    total_searches: 7,
  },
  {
    original_query: "übergangss",
    total_searches: 7,
  },
  {
    original_query: "Kontak",
    total_searches: 7,
  },
  {
    original_query: "Tiger",
    total_searches: 7,
  },
  {
    original_query: "Grün",
    total_searches: 7,
  },
  {
    original_query: "stufenteppi",
    total_searches: 7,
  },
  {
    original_query: "Zelt",
    total_searches: 7,
  },
  {
    original_query: "schwerladtregal",
    total_searches: 7,
  },
  {
    original_query: "Unterl",
    total_searches: 7,
  },
  {
    original_query: "Barcel",
    total_searches: 7,
  },
  {
    original_query: "stufenmattem",
    total_searches: 7,
  },
  {
    original_query: "stuhlkissen",
    total_searches: 7,
  },
  {
    original_query: "zubeh",
    total_searches: 7,
  },
  {
    original_query: "kuch",
    total_searches: 7,
  },
  {
    original_query: "fitnessgeräte",
    total_searches: 7,
  },
  {
    original_query: "stufentepp",
    total_searches: 7,
  },
  {
    original_query: "santi",
    total_searches: 7,
  },
  {
    original_query: "Schmutzfangtepp",
    total_searches: 7,
  },
  {
    original_query: "teppischstufen",
    total_searches: 7,
  },
  {
    original_query: "sparr",
    total_searches: 7,
  },
  {
    original_query: "duschvorleger",
    total_searches: 7,
  },
  {
    original_query: "allen",
    total_searches: 7,
  },
  {
    original_query: "bodenma",
    total_searches: 7,
  },
  {
    original_query: "treppenstufenmatte",
    total_searches: 7,
  },
  {
    original_query: "vento",
    total_searches: 7,
  },
  {
    original_query: "schutzfan",
    total_searches: 7,
  },
  {
    original_query: "teppichunt",
    total_searches: 7,
  },
  {
    original_query: "kettel",
    total_searches: 7,
  },
  {
    original_query: "Terrassenfliesen",
    total_searches: 7,
  },
  {
    original_query: "türvo",
    total_searches: 7,
  },
  {
    original_query: "teppichstang",
    total_searches: 7,
  },
  {
    original_query: "urbano",
    total_searches: 7,
  },
  {
    original_query: "pietv",
    total_searches: 7,
  },
  {
    original_query: "moderationsta",
    total_searches: 7,
  },
  {
    original_query: "cotto",
    total_searches: 7,
  },
  {
    original_query: "hochfloort",
    total_searches: 7,
  },
  {
    original_query: "vinylböden",
    total_searches: 7,
  },
  {
    original_query: "design",
    total_searches: 7,
  },
  {
    original_query: "Holzfliesen",
    total_searches: 7,
  },
  {
    original_query: "reef",
    total_searches: 7,
  },
  {
    original_query: "bidenschutzmatte",
    total_searches: 7,
  },
  {
    original_query: "unkrautflies",
    total_searches: 7,
  },
  {
    original_query: "Netz",
    total_searches: 7,
  },
  {
    original_query: "floordi",
    total_searches: 7,
  },
  {
    original_query: "randlos",
    total_searches: 7,
  },
  {
    original_query: "treppenpr",
    total_searches: 7,
  },
  {
    original_query: "stachel",
    total_searches: 7,
  },
  {
    original_query: "kunstrasenteppi",
    total_searches: 7,
  },
  {
    original_query: "anto",
    total_searches: 7,
  },
  {
    original_query: "Rasentepich",
    total_searches: 7,
  },
  {
    original_query: "böschun",
    total_searches: 7,
  },
  {
    original_query: "terasen",
    total_searches: 7,
  },
  {
    original_query: "antiermüdun",
    total_searches: 7,
  },
  {
    original_query: "laeuf",
    total_searches: 7,
  },
  {
    original_query: "shagy",
    total_searches: 7,
  },
  {
    original_query: "Fahrradständer",
    total_searches: 7,
  },
  {
    original_query: "Kundtr",
    total_searches: 7,
  },
  {
    original_query: "Sisalläufer",
    total_searches: 7,
  },
  {
    original_query: "terrassendielen",
    total_searches: 7,
  },
  {
    original_query: "Schmutzfs",
    total_searches: 7,
  },
  {
    original_query: "square",
    total_searches: 7,
  },
  {
    original_query: "Kont",
    total_searches: 7,
  },
  {
    original_query: "Badete",
    total_searches: 7,
  },
  {
    original_query: "Gara",
    total_searches: 7,
  },
  {
    original_query: "Gewebep",
    total_searches: 7,
  },
  {
    original_query: "teppichunterla",
    total_searches: 7,
  },
  {
    original_query: "wandverkleidung",
    total_searches: 7,
  },
  {
    original_query: "bast",
    total_searches: 7,
  },
  {
    original_query: "veloursteppich",
    total_searches: 7,
  },
  {
    original_query: "Integra",
    total_searches: 7,
  },
  {
    original_query: "feuersch",
    total_searches: 7,
  },
  {
    original_query: "Amazo",
    total_searches: 7,
  },
  {
    original_query: "Selbstkle",
    total_searches: 7,
  },
  {
    original_query: "schwenkgrill",
    total_searches: 7,
  },
  {
    original_query: "schaukästen",
    total_searches: 7,
  },
  {
    original_query: "antiermüd",
    total_searches: 7,
  },
  {
    original_query: "rückgaberecht",
    total_searches: 7,
  },
  {
    original_query: "Spanngummi",
    total_searches: 7,
  },
  {
    original_query: "stahl",
    total_searches: 7,
  },
  {
    original_query: "fischgrät",
    total_searches: 7,
  },
  {
    original_query: "aluf",
    total_searches: 7,
  },
  {
    original_query: "anhä",
    total_searches: 7,
  },
  {
    original_query: "monika",
    total_searches: 7,
  },
  {
    original_query: "Abdeckung",
    total_searches: 7,
  },
  {
    original_query: "fils",
    total_searches: 7,
  },
  {
    original_query: "wandrega",
    total_searches: 7,
  },
  {
    original_query: "treppenteppiche",
    total_searches: 7,
  },
  {
    original_query: "tomatens",
    total_searches: 7,
  },
  {
    original_query: "feuerschutz",
    total_searches: 7,
  },
  {
    original_query: "schmutzfangtep",
    total_searches: 7,
  },
  {
    original_query: "Fallschutzmatte",
    total_searches: 7,
  },
  {
    original_query: "terassenteppich",
    total_searches: 7,
  },
  {
    original_query: "holza",
    total_searches: 7,
  },
  {
    original_query: "korkk",
    total_searches: 7,
  },
  {
    original_query: "Autoteppi",
    total_searches: 7,
  },
  {
    original_query: "Whiteboar",
    total_searches: 7,
  },
  {
    original_query: "duschvor",
    total_searches: 7,
  },
  {
    original_query: "Flachn",
    total_searches: 7,
  },
  {
    original_query: "polycarb",
    total_searches: 7,
  },
  {
    original_query: "kunstteppich",
    total_searches: 7,
  },
  {
    original_query: "Schmutzmatten",
    total_searches: 7,
  },
  {
    original_query: "tarnnetz",
    total_searches: 7,
  },
  {
    original_query: "hohlk",
    total_searches: 7,
  },
  {
    original_query: "kreidetafel",
    total_searches: 7,
  },
  {
    original_query: "korkkleb",
    total_searches: 7,
  },
  {
    original_query: "Ringgummi",
    total_searches: 7,
  },
  {
    original_query: "badvo",
    total_searches: 7,
  },
  {
    original_query: "mombasa",
    total_searches: 7,
  },
  {
    original_query: "schutzfangm",
    total_searches: 7,
  },
  {
    original_query: "spie",
    total_searches: 7,
  },
  {
    original_query: "wohnzimmerte",
    total_searches: 7,
  },
  {
    original_query: "barcelo",
    total_searches: 7,
  },
  {
    original_query: "Terrassenfliese",
    total_searches: 7,
  },
  {
    original_query: "schuhwanne",
    total_searches: 7,
  },
  {
    original_query: "button",
    total_searches: 7,
  },
  {
    original_query: "audre",
    total_searches: 7,
  },
  {
    original_query: "bubbl",
    total_searches: 7,
  },
  {
    original_query: "türsch",
    total_searches: 7,
  },
  {
    original_query: "heiztepp",
    total_searches: 7,
  },
  {
    original_query: "schubladenmatte",
    total_searches: 7,
  },
  {
    original_query: "bürostuhlmatte",
    total_searches: 7,
  },
  {
    original_query: "holzab",
    total_searches: 7,
  },
  {
    original_query: "abdekplane",
    total_searches: 7,
  },
  {
    original_query: "Valen",
    total_searches: 7,
  },
  {
    original_query: "Fliegengi",
    total_searches: 7,
  },
  {
    original_query: "Sockelleisten",
    total_searches: 7,
  },
  {
    original_query: "Tischd",
    total_searches: 7,
  },
  {
    original_query: "Perform",
    total_searches: 7,
  },
  {
    original_query: "katzenstre",
    total_searches: 7,
  },
  {
    original_query: "noppenfo",
    total_searches: 7,
  },
  {
    original_query: "fenst",
    total_searches: 7,
  },
  {
    original_query: "kundt",
    total_searches: 7,
  },
  {
    original_query: "pflanzstab",
    total_searches: 7,
  },
  {
    original_query: "safema",
    total_searches: 7,
  },
  {
    original_query: "badvorle",
    total_searches: 7,
  },
  {
    original_query: "metalregal",
    total_searches: 7,
  },
  {
    original_query: "sial",
    total_searches: 7,
  },
  {
    original_query: "paradise",
    total_searches: 7,
  },
  {
    original_query: "Profile",
    total_searches: 7,
  },
  {
    original_query: "Tischfolie",
    total_searches: 7,
  },
  {
    original_query: "stegpl",
    total_searches: 7,
  },
  {
    original_query: "wass",
    total_searches: 7,
  },
  {
    original_query: "Gummigranu",
    total_searches: 7,
  },
  {
    original_query: "Bambuszau",
    total_searches: 7,
  },
  {
    original_query: "Wind",
    total_searches: 7,
  },
  {
    original_query: "toronto",
    total_searches: 7,
  },
  {
    original_query: "Verd",
    total_searches: 7,
  },
  {
    original_query: "Hongkon",
    total_searches: 7,
  },
  {
    original_query: "briefkasten",
    total_searches: 7,
  },
  {
    original_query: "Vinylte",
    total_searches: 7,
  },
  {
    original_query: "bilder",
    total_searches: 7,
  },
  {
    original_query: "Sprühk",
    total_searches: 7,
  },
  {
    original_query: "sche",
    total_searches: 7,
  },
  {
    original_query: "schmutu",
    total_searches: 7,
  },
  {
    original_query: "hammerschlag",
    total_searches: 7,
  },
  {
    original_query: "luftpolster",
    total_searches: 7,
  },
  {
    original_query: "grasteppich",
    total_searches: 7,
  },
  {
    original_query: "Platten",
    total_searches: 7,
  },
  {
    original_query: "Sauberlaufmat",
    total_searches: 7,
  },
  {
    original_query: "stellwan",
    total_searches: 7,
  },
  {
    original_query: "balkonfli",
    total_searches: 7,
  },
  {
    original_query: "dchmutz",
    total_searches: 7,
  },
  {
    original_query: "balkonflie",
    total_searches: 7,
  },
  {
    original_query: "vinylteppic",
    total_searches: 7,
  },
  {
    original_query: "mater",
    total_searches: 7,
  },
  {
    original_query: "Leist",
    total_searches: 7,
  },
  {
    original_query: "Ausl",
    total_searches: 7,
  },
  {
    original_query: "höhen",
    total_searches: 7,
  },
  {
    original_query: "kratzma",
    total_searches: 7,
  },
  {
    original_query: "hellgrau",
    total_searches: 7,
  },
  {
    original_query: "kunstt",
    total_searches: 7,
  },
  {
    original_query: "flipc",
    total_searches: 7,
  },
  {
    original_query: "kette",
    total_searches: 7,
  },
  {
    original_query: "handtu",
    total_searches: 7,
  },
  {
    original_query: "automatte",
    total_searches: 7,
  },
  {
    original_query: "Fußabtreter",
    total_searches: 7,
  },
  {
    original_query: "hongkon",
    total_searches: 7,
  },
  {
    original_query: "ampelschirm",
    total_searches: 7,
  },
  {
    original_query: "sicherheitsmatten",
    total_searches: 7,
  },
  {
    original_query: "teppichschutzmatte",
    total_searches: 7,
  },
  {
    original_query: "Integral",
    total_searches: 7,
  },
  {
    original_query: "türvorle",
    total_searches: 7,
  },
  {
    original_query: "fussbo",
    total_searches: 7,
  },
  {
    original_query: "Kratzteppich",
    total_searches: 7,
  },
  {
    original_query: "badezimmerte",
    total_searches: 7,
  },
  {
    original_query: "teppichfliessen",
    total_searches: 7,
  },
  {
    original_query: "bodenschitz",
    total_searches: 7,
  },
  {
    original_query: "Pfos",
    total_searches: 6,
  },
  {
    original_query: "merci",
    total_searches: 6,
  },
  {
    original_query: "tretmülleimer",
    total_searches: 6,
  },
  {
    original_query: "tränenb",
    total_searches: 6,
  },
  {
    original_query: "Claire",
    total_searches: 6,
  },
  {
    original_query: "sicherheitsst",
    total_searches: 6,
  },
  {
    original_query: "korkbode",
    total_searches: 6,
  },
  {
    original_query: "bodenfli",
    total_searches: 6,
  },
  {
    original_query: "akustic",
    total_searches: 6,
  },
  {
    original_query: "Terase",
    total_searches: 6,
  },
  {
    original_query: "badregal",
    total_searches: 6,
  },
  {
    original_query: "Musta",
    total_searches: 6,
  },
  {
    original_query: "korkbo",
    total_searches: 6,
  },
  {
    original_query: "Terrassente",
    total_searches: 6,
  },
  {
    original_query: "Winkelpr",
    total_searches: 6,
  },
  {
    original_query: "Terras",
    total_searches: 6,
  },
  {
    original_query: "outdorr",
    total_searches: 6,
  },
  {
    original_query: "Masch",
    total_searches: 6,
  },
  {
    original_query: "staketen",
    total_searches: 6,
  },
  {
    original_query: "felle",
    total_searches: 6,
  },
  {
    original_query: "cuttermesser",
    total_searches: 6,
  },
  {
    original_query: "holzfli",
    total_searches: 6,
  },
  {
    original_query: "Feuerschale",
    total_searches: 6,
  },
  {
    original_query: "monsa",
    total_searches: 6,
  },
  {
    original_query: "kreide",
    total_searches: 6,
  },
  {
    original_query: "Fussa",
    total_searches: 6,
  },
  {
    original_query: "holzf",
    total_searches: 6,
  },
  {
    original_query: "Bautenschutzma",
    total_searches: 6,
  },
  {
    original_query: "Abschlussprofi",
    total_searches: 6,
  },
  {
    original_query: "dokumenten",
    total_searches: 6,
  },
  {
    original_query: "sichtschutzfolie",
    total_searches: 6,
  },
  {
    original_query: "intagra",
    total_searches: 6,
  },
  {
    original_query: "heizteppi",
    total_searches: 6,
  },
  {
    original_query: "schmz",
    total_searches: 6,
  },
  {
    original_query: "aluleiste",
    total_searches: 6,
  },
  {
    original_query: "zaub",
    total_searches: 6,
  },
  {
    original_query: "kinde",
    total_searches: 6,
  },
  {
    original_query: "hänge",
    total_searches: 6,
  },
  {
    original_query: "porta",
    total_searches: 6,
  },
  {
    original_query: "türs",
    total_searches: 6,
  },
  {
    original_query: "ermüd",
    total_searches: 6,
  },
  {
    original_query: "doppelseit",
    total_searches: 6,
  },
  {
    original_query: "erst",
    total_searches: 6,
  },
  {
    original_query: "stach",
    total_searches: 6,
  },
  {
    original_query: "nafilz",
    total_searches: 6,
  },
  {
    original_query: "rasenteppisch",
    total_searches: 6,
  },
  {
    original_query: "kaminhol",
    total_searches: 6,
  },
  {
    original_query: "grass",
    total_searches: 6,
  },
  {
    original_query: "Spectr",
    total_searches: 6,
  },
  {
    original_query: "Vlie",
    total_searches: 6,
  },
  {
    original_query: "hima",
    total_searches: 6,
  },
  {
    original_query: "gegen",
    total_searches: 6,
  },
  {
    original_query: "dokum",
    total_searches: 6,
  },
  {
    original_query: "auslegw",
    total_searches: 6,
  },
  {
    original_query: "Stufenl",
    total_searches: 6,
  },
  {
    original_query: "Schreibtisch",
    total_searches: 6,
  },
  {
    original_query: "Tischdecke",
    total_searches: 6,
  },
  {
    original_query: "safemaxx",
    total_searches: 6,
  },
  {
    original_query: "Flok",
    total_searches: 6,
  },
  {
    original_query: "kreidemarker",
    total_searches: 6,
  },
  {
    original_query: "klebevinyl",
    total_searches: 6,
  },
  {
    original_query: "schutzhüll",
    total_searches: 6,
  },
  {
    original_query: "gardinenzubehör",
    total_searches: 6,
  },
  {
    original_query: "ocker",
    total_searches: 6,
  },
  {
    original_query: "doppelklebeband",
    total_searches: 6,
  },
  {
    original_query: "gardeni",
    total_searches: 6,
  },
  {
    original_query: "winkelprofile",
    total_searches: 6,
  },
  {
    original_query: "gummiläufe",
    total_searches: 6,
  },
  {
    original_query: "cudil",
    total_searches: 6,
  },
  {
    original_query: "nasszonen",
    total_searches: 6,
  },
  {
    original_query: "kusch",
    total_searches: 6,
  },
  {
    original_query: "rollkor",
    total_searches: 6,
  },
  {
    original_query: "akustikpane",
    total_searches: 6,
  },
  {
    original_query: "filzwand",
    total_searches: 6,
  },
  {
    original_query: "rankhilf",
    total_searches: 6,
  },
  {
    original_query: "Fell",
    total_searches: 6,
  },
  {
    original_query: "autofil",
    total_searches: 6,
  },
  {
    original_query: "teppichu",
    total_searches: 6,
  },
  {
    original_query: "holzabdeckpla",
    total_searches: 6,
  },
  {
    original_query: "Barc",
    total_searches: 6,
  },
  {
    original_query: "salbei",
    total_searches: 6,
  },
  {
    original_query: "Rapi",
    total_searches: 6,
  },
  {
    original_query: "dämpfung",
    total_searches: 6,
  },
  {
    original_query: "holzabde",
    total_searches: 6,
  },
  {
    original_query: "sauberlaufte",
    total_searches: 6,
  },
  {
    original_query: "weidez",
    total_searches: 6,
  },
  {
    original_query: "grac",
    total_searches: 6,
  },
  {
    original_query: "wandteppich",
    total_searches: 6,
  },
  {
    original_query: "schnutzfa",
    total_searches: 6,
  },
  {
    original_query: "aluprofil",
    total_searches: 6,
  },
  {
    original_query: "Fahrrads",
    total_searches: 6,
  },
  {
    original_query: "tacker",
    total_searches: 6,
  },
  {
    original_query: "Winkelprof",
    total_searches: 6,
  },
  {
    original_query: "antivibrationsmatt",
    total_searches: 6,
  },
  {
    original_query: "santiag",
    total_searches: 6,
  },
  {
    original_query: "Schnutzfa",
    total_searches: 6,
  },
  {
    original_query: "sonnensegl",
    total_searches: 6,
  },
  {
    original_query: "carous",
    total_searches: 6,
  },
  {
    original_query: "Raswn",
    total_searches: 6,
  },
  {
    original_query: "duschhoc",
    total_searches: 6,
  },
  {
    original_query: "flis",
    total_searches: 6,
  },
  {
    original_query: "fussl",
    total_searches: 6,
  },
  {
    original_query: "ferrara",
    total_searches: 6,
  },
  {
    original_query: "Bambussichtschutz",
    total_searches: 6,
  },
  {
    original_query: "zaunsichtschutz",
    total_searches: 6,
  },
  {
    original_query: "spannse",
    total_searches: 6,
  },
  {
    original_query: "brotkasten",
    total_searches: 6,
  },
  {
    original_query: "Bambuste",
    total_searches: 6,
  },
  {
    original_query: "langfloor",
    total_searches: 6,
  },
  {
    original_query: "blackou",
    total_searches: 6,
  },
  {
    original_query: "außenmatte",
    total_searches: 6,
  },
  {
    original_query: "industrieteppich",
    total_searches: 6,
  },
  {
    original_query: "Hing",
    total_searches: 6,
  },
  {
    original_query: "acrylg",
    total_searches: 6,
  },
  {
    original_query: "weichschau",
    total_searches: 6,
  },
  {
    original_query: "befestigungsstange",
    total_searches: 6,
  },
  {
    original_query: "poolr",
    total_searches: 6,
  },
  {
    original_query: "tifa",
    total_searches: 6,
  },
  {
    original_query: "Velours",
    total_searches: 6,
  },
  {
    original_query: "korek",
    total_searches: 6,
  },
  {
    original_query: "innenra",
    total_searches: 6,
  },
  {
    original_query: "waschmaschinen",
    total_searches: 6,
  },
  {
    original_query: "ande",
    total_searches: 6,
  },
  {
    original_query: "Plisse",
    total_searches: 6,
  },
  {
    original_query: "gitterr",
    total_searches: 6,
  },
  {
    original_query: "schmutzfamg",
    total_searches: 6,
  },
  {
    original_query: "marisu",
    total_searches: 6,
  },
  {
    original_query: "kaur",
    total_searches: 6,
  },
  {
    original_query: "Stal",
    total_searches: 6,
  },
  {
    original_query: "teppichunterl",
    total_searches: 6,
  },
  {
    original_query: "wasse",
    total_searches: 6,
  },
  {
    original_query: "stret",
    total_searches: 6,
  },
  {
    original_query: "rsen",
    total_searches: 6,
  },
  {
    original_query: "kosmet",
    total_searches: 6,
  },
  {
    original_query: "probe",
    total_searches: 6,
  },
  {
    original_query: "Weidenma",
    total_searches: 6,
  },
  {
    original_query: "gartentisch",
    total_searches: 6,
  },
  {
    original_query: "rasenfliesen",
    total_searches: 6,
  },
  {
    original_query: "Dayl",
    total_searches: 6,
  },
  {
    original_query: "schmitzfangmatt",
    total_searches: 6,
  },
  {
    original_query: "mage",
    total_searches: 6,
  },
  {
    original_query: "Fußabstreifer",
    total_searches: 6,
  },
  {
    original_query: "fußbode",
    total_searches: 6,
  },
  {
    original_query: "transpare",
    total_searches: 6,
  },
  {
    original_query: "steckreg",
    total_searches: 6,
  },
  {
    original_query: "heizteppic",
    total_searches: 6,
  },
  {
    original_query: "stopper",
    total_searches: 6,
  },
  {
    original_query: "wood",
    total_searches: 6,
  },
  {
    original_query: "Laminat",
    total_searches: 6,
  },
  {
    original_query: "Bambusza",
    total_searches: 6,
  },
  {
    original_query: "vittoria",
    total_searches: 6,
  },
  {
    original_query: "Balkonteppic",
    total_searches: 6,
  },
  {
    original_query: "safem",
    total_searches: 6,
  },
  {
    original_query: "sitzbank",
    total_searches: 6,
  },
  {
    original_query: "sisalkratzteppich",
    total_searches: 6,
  },
  {
    original_query: "Lieferze",
    total_searches: 6,
  },
  {
    original_query: "plex",
    total_searches: 6,
  },
  {
    original_query: "Pietv",
    total_searches: 6,
  },
  {
    original_query: "Unterlage",
    total_searches: 6,
  },
  {
    original_query: "antist",
    total_searches: 6,
  },
  {
    original_query: "raumteiler",
    total_searches: 6,
  },
  {
    original_query: "flex",
    total_searches: 6,
  },
  {
    original_query: "Duschs",
    total_searches: 6,
  },
  {
    original_query: "glasgow",
    total_searches: 6,
  },
  {
    original_query: "rasem",
    total_searches: 6,
  },
  {
    original_query: "monochrome",
    total_searches: 6,
  },
  {
    original_query: "duschr",
    total_searches: 6,
  },
  {
    original_query: "Pinn",
    total_searches: 6,
  },
  {
    original_query: "schlingenflo",
    total_searches: 6,
  },
  {
    original_query: "badtepptich",
    total_searches: 6,
  },
  {
    original_query: "anleitung",
    total_searches: 6,
  },
  {
    original_query: "gold",
    total_searches: 6,
  },
  {
    original_query: "rekl",
    total_searches: 6,
  },
  {
    original_query: "fallschut",
    total_searches: 6,
  },
  {
    original_query: "atmungsaktiv",
    total_searches: 6,
  },
  {
    original_query: "vorz",
    total_searches: 6,
  },
  {
    original_query: "doppelstegplat",
    total_searches: 6,
  },
  {
    original_query: "windschutznetz",
    total_searches: 6,
  },
  {
    original_query: "damier",
    total_searches: 6,
  },
  {
    original_query: "duschrollos",
    total_searches: 6,
  },
  {
    original_query: "spagettimatte",
    total_searches: 6,
  },
  {
    original_query: "sichtschutzmatt",
    total_searches: 6,
  },
  {
    original_query: "antirutschläufer",
    total_searches: 6,
  },
  {
    original_query: "Tischde",
    total_searches: 6,
  },
  {
    original_query: "eingangsm",
    total_searches: 6,
  },
  {
    original_query: "badezimme",
    total_searches: 6,
  },
  {
    original_query: "teppichlaeufer",
    total_searches: 6,
  },
  {
    original_query: "botanika",
    total_searches: 6,
  },
  {
    original_query: "sonnenschut",
    total_searches: 6,
  },
  {
    original_query: "acrylplatte",
    total_searches: 6,
  },
  {
    original_query: "dunja",
    total_searches: 6,
  },
  {
    original_query: "Liefer",
    total_searches: 6,
  },
  {
    original_query: "schmutza",
    total_searches: 6,
  },
  {
    original_query: "korkkl",
    total_searches: 6,
  },
  {
    original_query: "abmelden",
    total_searches: 6,
  },
  {
    original_query: "Superfl",
    total_searches: 6,
  },
  {
    original_query: "whiteboards",
    total_searches: 6,
  },
  {
    original_query: "drei",
    total_searches: 6,
  },
  {
    original_query: "pflanze",
    total_searches: 6,
  },
  {
    original_query: "stufenla",
    total_searches: 6,
  },
  {
    original_query: "bautenschutzmatt",
    total_searches: 6,
  },
  {
    original_query: "teppichschiene",
    total_searches: 6,
  },
  {
    original_query: "Vorz",
    total_searches: 6,
  },
  {
    original_query: "flut",
    total_searches: 6,
  },
  {
    original_query: "lagma",
    total_searches: 6,
  },
  {
    original_query: "Kunstrasenteppi",
    total_searches: 6,
  },
  {
    original_query: "pinnadeln",
    total_searches: 6,
  },
  {
    original_query: "cutter",
    total_searches: 6,
  },
  {
    original_query: "köln",
    total_searches: 6,
  },
  {
    original_query: "Garagen",
    total_searches: 6,
  },
  {
    original_query: "fußlei",
    total_searches: 6,
  },
  {
    original_query: "Gummigran",
    total_searches: 6,
  },
  {
    original_query: "paravent",
    total_searches: 6,
  },
  {
    original_query: "duschvo",
    total_searches: 6,
  },
  {
    original_query: "antirus",
    total_searches: 6,
  },
  {
    original_query: "Kurzflo",
    total_searches: 6,
  },
  {
    original_query: "Balkonschutz",
    total_searches: 6,
  },
  {
    original_query: "ringgummim",
    total_searches: 6,
  },
  {
    original_query: "hacken",
    total_searches: 6,
  },
  {
    original_query: "Ösen",
    total_searches: 6,
  },
  {
    original_query: "spielte",
    total_searches: 6,
  },
  {
    original_query: "emco",
    total_searches: 6,
  },
  {
    original_query: "teppichbod",
    total_searches: 6,
  },
  {
    original_query: "moni",
    total_searches: 6,
  },
  {
    original_query: "waschbarer",
    total_searches: 6,
  },
  {
    original_query: "Flachno",
    total_searches: 6,
  },
  {
    original_query: "befestigungsstangen",
    total_searches: 6,
  },
  {
    original_query: "abtrop",
    total_searches: 6,
  },
  {
    original_query: "safemax",
    total_searches: 6,
  },
  {
    original_query: "nitril",
    total_searches: 6,
  },
  {
    original_query: "übergangssch",
    total_searches: 6,
  },
  {
    original_query: "anpas",
    total_searches: 6,
  },
  {
    original_query: "wühlmausgi",
    total_searches: 6,
  },
  {
    original_query: "auslegwa",
    total_searches: 6,
  },
  {
    original_query: "bern",
    total_searches: 6,
  },
  {
    original_query: "Flurtepp",
    total_searches: 6,
  },
  {
    original_query: "consenza",
    total_searches: 6,
  },
  {
    original_query: "gummistufenmatten",
    total_searches: 6,
  },
  {
    original_query: "nicosia",
    total_searches: 6,
  },
  {
    original_query: "Hohlkammerplatte",
    total_searches: 6,
  },
  {
    original_query: "sonnensegek",
    total_searches: 6,
  },
  {
    original_query: "Kurzfloor",
    total_searches: 6,
  },
  {
    original_query: "Korkkl",
    total_searches: 6,
  },
  {
    original_query: "angebot",
    total_searches: 6,
  },
  {
    original_query: "rutschschutz",
    total_searches: 6,
  },
  {
    original_query: "bambusma",
    total_searches: 6,
  },
  {
    original_query: "regál",
    total_searches: 6,
  },
  {
    original_query: "weihnachten",
    total_searches: 6,
  },
  {
    original_query: "pale",
    total_searches: 6,
  },
  {
    original_query: "paddoc",
    total_searches: 6,
  },
  {
    original_query: "eingangsdaten",
    total_searches: 6,
  },
  {
    original_query: "kokosmate",
    total_searches: 6,
  },
  {
    original_query: "treppensch",
    total_searches: 6,
  },
  {
    original_query: "stretchfil",
    total_searches: 6,
  },
  {
    original_query: "sichtschutznetz",
    total_searches: 6,
  },
  {
    original_query: "Schreib",
    total_searches: 6,
  },
  {
    original_query: "plisses",
    total_searches: 6,
  },
  {
    original_query: "bewertungen",
    total_searches: 6,
  },
  {
    original_query: "Gummigranulat",
    total_searches: 6,
  },
  {
    original_query: "flurläufe",
    total_searches: 6,
  },
  {
    original_query: "Heringe",
    total_searches: 6,
  },
  {
    original_query: "Voli",
    total_searches: 6,
  },
  {
    original_query: "fußbodenbelag",
    total_searches: 6,
  },
  {
    original_query: "kuche",
    total_searches: 6,
  },
  {
    original_query: "camouflage",
    total_searches: 6,
  },
  {
    original_query: "aufbauanleitung",
    total_searches: 6,
  },
  {
    original_query: "heimwer",
    total_searches: 6,
  },
  {
    original_query: "unte",
    total_searches: 6,
  },
  {
    original_query: "eckre",
    total_searches: 6,
  },
  {
    original_query: "Dreie",
    total_searches: 6,
  },
  {
    original_query: "silber",
    total_searches: 6,
  },
  {
    original_query: "Volier",
    total_searches: 6,
  },
  {
    original_query: "campin",
    total_searches: 6,
  },
  {
    original_query: "Sichtschutzzau",
    total_searches: 6,
  },
  {
    original_query: "bodenschi",
    total_searches: 6,
  },
  {
    original_query: "Linol",
    total_searches: 6,
  },
  {
    original_query: "Flash",
    total_searches: 6,
  },
  {
    original_query: "stuh",
    total_searches: 6,
  },
  {
    original_query: "Integ",
    total_searches: 6,
  },
  {
    original_query: "Balkonfl",
    total_searches: 6,
  },
  {
    original_query: "siesal",
    total_searches: 6,
  },
  {
    original_query: "aschenbecher",
    total_searches: 6,
  },
  {
    original_query: "stativ",
    total_searches: 6,
  },
  {
    original_query: "Teppichbode",
    total_searches: 6,
  },
  {
    original_query: "schaum",
    total_searches: 6,
  },
  {
    original_query: "buffalo",
    total_searches: 6,
  },
  {
    original_query: "calam",
    total_searches: 6,
  },
  {
    original_query: "bauschu",
    total_searches: 6,
  },
  {
    original_query: "balkonr",
    total_searches: 6,
  },
  {
    original_query: "vintag",
    total_searches: 6,
  },
  {
    original_query: "selec",
    total_searches: 6,
  },
  {
    original_query: "antistat",
    total_searches: 6,
  },
  {
    original_query: "insekte",
    total_searches: 6,
  },
  {
    original_query: "Polycarbonat",
    total_searches: 6,
  },
  {
    original_query: "Genua",
    total_searches: 6,
  },
  {
    original_query: "gewächsha",
    total_searches: 6,
  },
  {
    original_query: "kindert",
    total_searches: 6,
  },
  {
    original_query: "Schutzplane",
    total_searches: 6,
  },
  {
    original_query: "vigo",
    total_searches: 6,
  },
  {
    original_query: "steckrega",
    total_searches: 6,
  },
  {
    original_query: "Telefon",
    total_searches: 6,
  },
  {
    original_query: "inter",
    total_searches: 6,
  },
  {
    original_query: "Schmutzfangteppich",
    total_searches: 6,
  },
  {
    original_query: "rankhi",
    total_searches: 6,
  },
  {
    original_query: "rabatcode",
    total_searches: 6,
  },
  {
    original_query: "algarve",
    total_searches: 6,
  },
  {
    original_query: "grizzl",
    total_searches: 6,
  },
  {
    original_query: "sundea",
    total_searches: 6,
  },
  {
    original_query: "jutes",
    total_searches: 6,
  },
  {
    original_query: "adeckplane",
    total_searches: 6,
  },
  {
    original_query: "schwr",
    total_searches: 6,
  },
  {
    original_query: "nadelv",
    total_searches: 6,
  },
  {
    original_query: "unkrautf",
    total_searches: 6,
  },
  {
    original_query: "disa",
    total_searches: 6,
  },
  {
    original_query: "magen",
    total_searches: 6,
  },
  {
    original_query: "pfer",
    total_searches: 6,
  },
  {
    original_query: "tagesdecke",
    total_searches: 6,
  },
  {
    original_query: "Sichschu",
    total_searches: 6,
  },
  {
    original_query: "Pfoste",
    total_searches: 6,
  },
  {
    original_query: "abschlussp",
    total_searches: 6,
  },
  {
    original_query: "Terrassenteppich",
    total_searches: 6,
  },
  {
    original_query: "weidema",
    total_searches: 6,
  },
  {
    original_query: "gartenflies",
    total_searches: 6,
  },
  {
    original_query: "brazil",
    total_searches: 6,
  },
  {
    original_query: "edel",
    total_searches: 6,
  },
  {
    original_query: "kücj",
    total_searches: 6,
  },
  {
    original_query: "Rasenteppicj",
    total_searches: 6,
  },
  {
    original_query: "wohnte",
    total_searches: 6,
  },
  {
    original_query: "Flurteppic",
    total_searches: 6,
  },
  {
    original_query: "schmutzt",
    total_searches: 6,
  },
  {
    original_query: "wärmematte",
    total_searches: 6,
  },
  {
    original_query: "sicherheitsmatt",
    total_searches: 6,
  },
  {
    original_query: "polycarbo",
    total_searches: 6,
  },
  {
    original_query: "schallschut",
    total_searches: 6,
  },
  {
    original_query: "hochleistungs",
    total_searches: 6,
  },
  {
    original_query: "Hochbeet",
    total_searches: 6,
  },
  {
    original_query: "stud",
    total_searches: 6,
  },
  {
    original_query: "rutschma",
    total_searches: 6,
  },
  {
    original_query: "ersatz",
    total_searches: 6,
  },
  {
    original_query: "bodena",
    total_searches: 6,
  },
  {
    original_query: "stufenprofi",
    total_searches: 6,
  },
  {
    original_query: "schil",
    total_searches: 6,
  },
  {
    original_query: "farbwundee",
    total_searches: 6,
  },
  {
    original_query: "seitenmarkis",
    total_searches: 6,
  },
  {
    original_query: "innenrau",
    total_searches: 6,
  },
  {
    original_query: "maßgefertigt",
    total_searches: 6,
  },
  {
    original_query: "trapetzblech",
    total_searches: 6,
  },
  {
    original_query: "Bodenm",
    total_searches: 6,
  },
  {
    original_query: "gewäc",
    total_searches: 6,
  },
  {
    original_query: "herin",
    total_searches: 6,
  },
  {
    original_query: "rhien",
    total_searches: 6,
  },
  {
    original_query: "Badvor",
    total_searches: 6,
  },
  {
    original_query: "Flieg",
    total_searches: 6,
  },
  {
    original_query: "Volie",
    total_searches: 6,
  },
  {
    original_query: "Hohlka",
    total_searches: 6,
  },
  {
    original_query: "Müllei",
    total_searches: 6,
  },
  {
    original_query: "filztep",
    total_searches: 6,
  },
  {
    original_query: "teppichfiesen",
    total_searches: 6,
  },
  {
    original_query: "glasboards",
    total_searches: 6,
  },
  {
    original_query: "Gewächshaus",
    total_searches: 6,
  },
  {
    original_query: "Sichs",
    total_searches: 6,
  },
  {
    original_query: "handlauf",
    total_searches: 6,
  },
  {
    original_query: "alust",
    total_searches: 6,
  },
  {
    original_query: "susal",
    total_searches: 6,
  },
  {
    original_query: "antiruschmatte",
    total_searches: 6,
  },
  {
    original_query: "Foli",
    total_searches: 6,
  },
  {
    original_query: "weitspannre",
    total_searches: 6,
  },
  {
    original_query: "rasenteo",
    total_searches: 6,
  },
  {
    original_query: "feuers",
    total_searches: 6,
  },
  {
    original_query: "terrassenteppich",
    total_searches: 6,
  },
  {
    original_query: "floordire",
    total_searches: 6,
  },
  {
    original_query: "schreibtischu",
    total_searches: 6,
  },
  {
    original_query: "Sitz",
    total_searches: 6,
  },
  {
    original_query: "Stak",
    total_searches: 6,
  },
  {
    original_query: "vorzeltteppich",
    total_searches: 6,
  },
  {
    original_query: "türmat",
    total_searches: 6,
  },
  {
    original_query: "Bambusz",
    total_searches: 6,
  },
  {
    original_query: "Cudiler",
    total_searches: 6,
  },
  {
    original_query: "dais",
    total_searches: 6,
  },
  {
    original_query: "filzläufer",
    total_searches: 6,
  },
  {
    original_query: "stufenlanten",
    total_searches: 6,
  },
  {
    original_query: "casab",
    total_searches: 6,
  },
  {
    original_query: "ponti",
    total_searches: 6,
  },
  {
    original_query: "gerüst",
    total_searches: 6,
  },
  {
    original_query: "türleisten",
    total_searches: 6,
  },
  {
    original_query: "wollt",
    total_searches: 6,
  },
  {
    original_query: "derby",
    total_searches: 6,
  },
  {
    original_query: "rasenteppiv",
    total_searches: 6,
  },
  {
    original_query: "prin",
    total_searches: 6,
  },
  {
    original_query: "bodenfl",
    total_searches: 6,
  },
  {
    original_query: "granula",
    total_searches: 6,
  },
  {
    original_query: "küchenkräuter",
    total_searches: 6,
  },
  {
    original_query: "brau",
    total_searches: 6,
  },
  {
    original_query: "Steg",
    total_searches: 6,
  },
  {
    original_query: "kunstpflanze",
    total_searches: 6,
  },
  {
    original_query: "Winkelprofi",
    total_searches: 6,
  },
  {
    original_query: "schreibtischun",
    total_searches: 6,
  },
  {
    original_query: "Gummigranul",
    total_searches: 6,
  },
  {
    original_query: "venylteppich",
    total_searches: 6,
  },
  {
    original_query: "rhinr",
    total_searches: 6,
  },
  {
    original_query: "pber",
    total_searches: 6,
  },
  {
    original_query: "Sichtschutzzaun",
    total_searches: 6,
  },
  {
    original_query: "Fens",
    total_searches: 6,
  },
  {
    original_query: "filzmatten",
    total_searches: 6,
  },
  {
    original_query: "Riviera",
    total_searches: 6,
  },
  {
    original_query: "Dreiec",
    total_searches: 6,
  },
  {
    original_query: "bademate",
    total_searches: 6,
  },
  {
    original_query: "fens",
    total_searches: 6,
  },
  {
    original_query: "rankgit",
    total_searches: 6,
  },
  {
    original_query: "montagekle",
    total_searches: 6,
  },
  {
    original_query: "holzabdeckpl",
    total_searches: 6,
  },
  {
    original_query: "casablanca",
    total_searches: 6,
  },
  {
    original_query: "türleiste",
    total_searches: 6,
  },
  {
    original_query: "abtret",
    total_searches: 6,
  },
  {
    original_query: "Sichtschutzza",
    total_searches: 6,
  },
  {
    original_query: "teppisc",
    total_searches: 6,
  },
  {
    original_query: "retro",
    total_searches: 6,
  },
  {
    original_query: "Sichtschutzz",
    total_searches: 6,
  },
  {
    original_query: "Rückse",
    total_searches: 6,
  },
  {
    original_query: "lieferkosten",
    total_searches: 6,
  },
  {
    original_query: "noppenfoli",
    total_searches: 6,
  },
  {
    original_query: "treppenpro",
    total_searches: 6,
  },
  {
    original_query: "Antivibrationsma",
    total_searches: 6,
  },
  {
    original_query: "selbstkleb",
    total_searches: 6,
  },
  {
    original_query: "Krat",
    total_searches: 6,
  },
  {
    original_query: "schmutzfangteppic",
    total_searches: 6,
  },
  {
    original_query: "arbe",
    total_searches: 6,
  },
  {
    original_query: "gummibänder",
    total_searches: 6,
  },
  {
    original_query: "eint",
    total_searches: 6,
  },
  {
    original_query: "Balkonf",
    total_searches: 6,
  },
  {
    original_query: "lucan",
    total_searches: 6,
  },
  {
    original_query: "winkelprofi",
    total_searches: 6,
  },
  {
    original_query: "delhi",
    total_searches: 6,
  },
  {
    original_query: "Schwerlastr",
    total_searches: 6,
  },
  {
    original_query: "radenteppi",
    total_searches: 6,
  },
  {
    original_query: "weitspannregale",
    total_searches: 6,
  },
  {
    original_query: "Sport",
    total_searches: 6,
  },
  {
    original_query: "kaminh",
    total_searches: 6,
  },
  {
    original_query: "gummilau",
    total_searches: 6,
  },
  {
    original_query: "bril",
    total_searches: 6,
  },
  {
    original_query: "akkustikpa",
    total_searches: 6,
  },
  {
    original_query: "velu",
    total_searches: 6,
  },
  {
    original_query: "polyester",
    total_searches: 6,
  },
  {
    original_query: "stegpla",
    total_searches: 6,
  },
  {
    original_query: "bodenschutzmattr",
    total_searches: 6,
  },
  {
    original_query: "Kokosmatte",
    total_searches: 6,
  },
  {
    original_query: "Sprin",
    total_searches: 6,
  },
  {
    original_query: "transp",
    total_searches: 6,
  },
  {
    original_query: "schaukel",
    total_searches: 6,
  },
  {
    original_query: "geträn",
    total_searches: 6,
  },
  {
    original_query: "flicken",
    total_searches: 6,
  },
  {
    original_query: "kibek",
    total_searches: 6,
  },
  {
    original_query: "wohnzimm",
    total_searches: 6,
  },
  {
    original_query: "rücksendeschein",
    total_searches: 6,
  },
  {
    original_query: "treppenp",
    total_searches: 6,
  },
  {
    original_query: "teppichplanke",
    total_searches: 6,
  },
  {
    original_query: "algar",
    total_searches: 6,
  },
  {
    original_query: "buntregal",
    total_searches: 6,
  },
  {
    original_query: "andeck",
    total_searches: 6,
  },
  {
    original_query: "croco",
    total_searches: 6,
  },
  {
    original_query: "schwar",
    total_searches: 6,
  },
  {
    original_query: "Daytona",
    total_searches: 6,
  },
  {
    original_query: "holzabdeckplanen",
    total_searches: 6,
  },
  {
    original_query: "vien",
    total_searches: 6,
  },
  {
    original_query: "stuffenmatt",
    total_searches: 6,
  },
  {
    original_query: "Trapez",
    total_searches: 6,
  },
  {
    original_query: "Teppis",
    total_searches: 6,
  },
  {
    original_query: "schmutzfab",
    total_searches: 6,
  },
  {
    original_query: "lederteppich",
    total_searches: 6,
  },
  {
    original_query: "Spanngumm",
    total_searches: 6,
  },
  {
    original_query: "Kantenp",
    total_searches: 6,
  },
  {
    original_query: "koku",
    total_searches: 6,
  },
  {
    original_query: "Camp",
    total_searches: 6,
  },
  {
    original_query: "hochleistungsmatte",
    total_searches: 6,
  },
  {
    original_query: "Superfle",
    total_searches: 6,
  },
  {
    original_query: "Schmuz",
    total_searches: 6,
  },
  {
    original_query: "prestig",
    total_searches: 6,
  },
  {
    original_query: "rivier",
    total_searches: 6,
  },
  {
    original_query: "ermüdung",
    total_searches: 6,
  },
  {
    original_query: "sera",
    total_searches: 6,
  },
  {
    original_query: "Bambusmatte",
    total_searches: 6,
  },
  {
    original_query: "Kokosma",
    total_searches: 6,
  },
  {
    original_query: "melanche",
    total_searches: 6,
  },
  {
    original_query: "wollfilz",
    total_searches: 6,
  },
  {
    original_query: "Fliegeng",
    total_searches: 6,
  },
  {
    original_query: "rassenteppi",
    total_searches: 6,
  },
  {
    original_query: "vinylbelag",
    total_searches: 6,
  },
  {
    original_query: "pflanzs",
    total_searches: 6,
  },
  {
    original_query: "Rollenware",
    total_searches: 6,
  },
  {
    original_query: "Tepic",
    total_searches: 6,
  },
  {
    original_query: "Sichschutz",
    total_searches: 6,
  },
  {
    original_query: "wandfliesen",
    total_searches: 6,
  },
  {
    original_query: "alustik",
    total_searches: 6,
  },
  {
    original_query: "tischunterlage",
    total_searches: 6,
  },
  {
    original_query: "schwa",
    total_searches: 6,
  },
  {
    original_query: "limerick",
    total_searches: 6,
  },
  {
    original_query: "fliegengitt",
    total_searches: 6,
  },
  {
    original_query: "holzoptik",
    total_searches: 6,
  },
  {
    original_query: "weic",
    total_searches: 6,
  },
  {
    original_query: "desi",
    total_searches: 6,
  },
  {
    original_query: "baumwollmatte",
    total_searches: 6,
  },
  {
    original_query: "Lago",
    total_searches: 6,
  },
  {
    original_query: "Waschb",
    total_searches: 6,
  },
  {
    original_query: "musta",
    total_searches: 6,
  },
  {
    original_query: "eventt",
    total_searches: 6,
  },
  {
    original_query: "badvorl",
    total_searches: 6,
  },
  {
    original_query: "Terrassent",
    total_searches: 6,
  },
  {
    original_query: "pfos",
    total_searches: 6,
  },
  {
    original_query: "Kratzte",
    total_searches: 6,
  },
  {
    original_query: "Rückgabe",
    total_searches: 6,
  },
  {
    original_query: "rocke",
    total_searches: 6,
  },
  {
    original_query: "rollstuhl",
    total_searches: 6,
  },
  {
    original_query: "ersatzteile",
    total_searches: 6,
  },
  {
    original_query: "wandpanel",
    total_searches: 6,
  },
  {
    original_query: "brücken",
    total_searches: 6,
  },
  {
    original_query: "Terrassenflie",
    total_searches: 6,
  },
  {
    original_query: "dope",
    total_searches: 6,
  },
  {
    original_query: "Bambusmatten",
    total_searches: 6,
  },
  {
    original_query: "Jalo",
    total_searches: 6,
  },
  {
    original_query: "bausch",
    total_searches: 6,
  },
  {
    original_query: "akustikpanee",
    total_searches: 6,
  },
  {
    original_query: "hochfloorteppi",
    total_searches: 6,
  },
  {
    original_query: "Kante",
    total_searches: 6,
  },
  {
    original_query: "wabe",
    total_searches: 6,
  },
  {
    original_query: "Karo",
    total_searches: 6,
  },
  {
    original_query: "edelstahlmatte",
    total_searches: 6,
  },
  {
    original_query: "stallb",
    total_searches: 6,
  },
  {
    original_query: "Siche",
    total_searches: 6,
  },
  {
    original_query: "balkonschutz",
    total_searches: 6,
  },
  {
    original_query: "Stel",
    total_searches: 6,
  },
  {
    original_query: "teleskop",
    total_searches: 6,
  },
  {
    original_query: "bangor",
    total_searches: 6,
  },
  {
    original_query: "marmor",
    total_searches: 6,
  },
  {
    original_query: "Koku",
    total_searches: 6,
  },
  {
    original_query: "schnitz",
    total_searches: 6,
  },
  {
    original_query: "gewebeplanen",
    total_searches: 6,
  },
  {
    original_query: "Heri",
    total_searches: 6,
  },
  {
    original_query: "baumri",
    total_searches: 6,
  },
  {
    original_query: "läuger",
    total_searches: 6,
  },
  {
    original_query: "Herin",
    total_searches: 6,
  },
  {
    original_query: "hohlka",
    total_searches: 6,
  },
  {
    original_query: "teppichschu",
    total_searches: 6,
  },
  {
    original_query: "ziergeflecht",
    total_searches: 6,
  },
  {
    original_query: "pavia",
    total_searches: 6,
  },
  {
    original_query: "Büro",
    total_searches: 6,
  },
  {
    original_query: "schilfrohrmatte",
    total_searches: 6,
  },
  {
    original_query: "seitenmark",
    total_searches: 6,
  },
  {
    original_query: "gummila",
    total_searches: 6,
  },
  {
    original_query: "schlingenmatt",
    total_searches: 6,
  },
  {
    original_query: "übergangsl",
    total_searches: 6,
  },
  {
    original_query: "Taub",
    total_searches: 6,
  },
  {
    original_query: "schutzfangma",
    total_searches: 6,
  },
  {
    original_query: "industrieboden",
    total_searches: 6,
  },
  {
    original_query: "raymond",
    total_searches: 6,
  },
  {
    original_query: "lami",
    total_searches: 6,
  },
  {
    original_query: "tral",
    total_searches: 6,
  },
  {
    original_query: "anpassungspro",
    total_searches: 6,
  },
  {
    original_query: "lago",
    total_searches: 6,
  },
  {
    original_query: "jalou",
    total_searches: 6,
  },
  {
    original_query: "spagett",
    total_searches: 6,
  },
  {
    original_query: "mela",
    total_searches: 6,
  },
  {
    original_query: "antibi",
    total_searches: 6,
  },
  {
    original_query: "gardeur",
    total_searches: 6,
  },
  {
    original_query: "chev",
    total_searches: 6,
  },
  {
    original_query: "stifen",
    total_searches: 6,
  },
  {
    original_query: "antirusc",
    total_searches: 6,
  },
  {
    original_query: "flaschenkas",
    total_searches: 6,
  },
  {
    original_query: "Voge",
    total_searches: 6,
  },
  {
    original_query: "clyd",
    total_searches: 6,
  },
  {
    original_query: "granul",
    total_searches: 6,
  },
  {
    original_query: "nassz",
    total_searches: 6,
  },
  {
    original_query: "tritts",
    total_searches: 6,
  },
  {
    original_query: "bambussi",
    total_searches: 6,
  },
  {
    original_query: "kratzmatt",
    total_searches: 6,
  },
  {
    original_query: "larache",
    total_searches: 6,
  },
  {
    original_query: "spiegelfolie",
    total_searches: 6,
  },
  {
    original_query: "weichso",
    total_searches: 6,
  },
  {
    original_query: "messeboden",
    total_searches: 6,
  },
  {
    original_query: "Wühlmausgi",
    total_searches: 6,
  },
  {
    original_query: "polystyrolplatte",
    total_searches: 6,
  },
  {
    original_query: "cobble",
    total_searches: 6,
  },
  {
    original_query: "moderationstaf",
    total_searches: 6,
  },
  {
    original_query: "edelstah",
    total_searches: 6,
  },
  {
    original_query: "farben",
    total_searches: 6,
  },
  {
    original_query: "wandpanelle",
    total_searches: 6,
  },
  {
    original_query: "windsch",
    total_searches: 6,
  },
  {
    original_query: "seif",
    total_searches: 6,
  },
  {
    original_query: "carusel",
    total_searches: 6,
  },
  {
    original_query: "fahra",
    total_searches: 6,
  },
  {
    original_query: "klebepunkte",
    total_searches: 6,
  },
  {
    original_query: "Ausleg",
    total_searches: 5,
  },
  {
    original_query: "plexig",
    total_searches: 5,
  },
  {
    original_query: "exeter",
    total_searches: 5,
  },
  {
    original_query: "schadstofffrei",
    total_searches: 5,
  },
  {
    original_query: "Stuhl",
    total_searches: 5,
  },
  {
    original_query: "Schmutzfanf",
    total_searches: 5,
  },
  {
    original_query: "gummif",
    total_searches: 5,
  },
  {
    original_query: "weitspannreg",
    total_searches: 5,
  },
  {
    original_query: "Ausle",
    total_searches: 5,
  },
  {
    original_query: "Halt",
    total_searches: 5,
  },
  {
    original_query: "malag",
    total_searches: 5,
  },
  {
    original_query: "kasten",
    total_searches: 5,
  },
  {
    original_query: "Kantenprofil",
    total_searches: 5,
  },
  {
    original_query: "läifer",
    total_searches: 5,
  },
  {
    original_query: "zaunschutz",
    total_searches: 5,
  },
  {
    original_query: "toilettenvorleger",
    total_searches: 5,
  },
  {
    original_query: "gela",
    total_searches: 5,
  },
  {
    original_query: "hasen",
    total_searches: 5,
  },
  {
    original_query: "ubergangs",
    total_searches: 5,
  },
  {
    original_query: "brando",
    total_searches: 5,
  },
  {
    original_query: "ecke",
    total_searches: 5,
  },
  {
    original_query: "heimwerkervli",
    total_searches: 5,
  },
  {
    original_query: "Flurtep",
    total_searches: 5,
  },
  {
    original_query: "hygien",
    total_searches: 5,
  },
  {
    original_query: "Teppichk",
    total_searches: 5,
  },
  {
    original_query: "Eckp",
    total_searches: 5,
  },
  {
    original_query: "Bürost",
    total_searches: 5,
  },
  {
    original_query: "Badvorleger",
    total_searches: 5,
  },
  {
    original_query: "Sisallä",
    total_searches: 5,
  },
  {
    original_query: "beetu",
    total_searches: 5,
  },
  {
    original_query: "autd",
    total_searches: 5,
  },
  {
    original_query: "blacko",
    total_searches: 5,
  },
  {
    original_query: "sichtschutzplane",
    total_searches: 5,
  },
  {
    original_query: "davids",
    total_searches: 5,
  },
  {
    original_query: "ravenna",
    total_searches: 5,
  },
  {
    original_query: "loifa",
    total_searches: 5,
  },
  {
    original_query: "schutzpl",
    total_searches: 5,
  },
  {
    original_query: "ausgleic",
    total_searches: 5,
  },
  {
    original_query: "badetep",
    total_searches: 5,
  },
  {
    original_query: "whiteboardfarbe",
    total_searches: 5,
  },
  {
    original_query: "rabattc",
    total_searches: 5,
  },
  {
    original_query: "weidenm",
    total_searches: 5,
  },
  {
    original_query: "isal",
    total_searches: 5,
  },
  {
    original_query: "Kalkutt",
    total_searches: 5,
  },
  {
    original_query: "ubergang",
    total_searches: 5,
  },
  {
    original_query: "behei",
    total_searches: 5,
  },
  {
    original_query: "flachnop",
    total_searches: 5,
  },
  {
    original_query: "Fenst",
    total_searches: 5,
  },
  {
    original_query: "gree",
    total_searches: 5,
  },
  {
    original_query: "kunstraswn",
    total_searches: 5,
  },
  {
    original_query: "teppichstopper",
    total_searches: 5,
  },
  {
    original_query: "schmt",
    total_searches: 5,
  },
  {
    original_query: "schwamm",
    total_searches: 5,
  },
  {
    original_query: "holzabdec",
    total_searches: 5,
  },
  {
    original_query: "schmtzfang",
    total_searches: 5,
  },
  {
    original_query: "Expo",
    total_searches: 5,
  },
  {
    original_query: "Grillmatt",
    total_searches: 5,
  },
  {
    original_query: "Inse",
    total_searches: 5,
  },
  {
    original_query: "antiruch",
    total_searches: 5,
  },
  {
    original_query: "Oslo",
    total_searches: 5,
  },
  {
    original_query: "eckr",
    total_searches: 5,
  },
  {
    original_query: "rollteppich",
    total_searches: 5,
  },
  {
    original_query: "ebay",
    total_searches: 5,
  },
  {
    original_query: "Terasenfli",
    total_searches: 5,
  },
  {
    original_query: "garagenoden",
    total_searches: 5,
  },
  {
    original_query: "Arnold",
    total_searches: 5,
  },
  {
    original_query: "Regale",
    total_searches: 5,
  },
  {
    original_query: "sonensegel",
    total_searches: 5,
  },
  {
    original_query: "rasenteppu",
    total_searches: 5,
  },
  {
    original_query: "rasenkanten",
    total_searches: 5,
  },
  {
    original_query: "schwimm",
    total_searches: 5,
  },
  {
    original_query: "poolab",
    total_searches: 5,
  },
  {
    original_query: "Carousel",
    total_searches: 5,
  },
  {
    original_query: "therapy",
    total_searches: 5,
  },
  {
    original_query: "dabang",
    total_searches: 5,
  },
  {
    original_query: "antrazit",
    total_searches: 5,
  },
  {
    original_query: "kaninchen",
    total_searches: 5,
  },
  {
    original_query: "kabelmatt",
    total_searches: 5,
  },
  {
    original_query: "cudile",
    total_searches: 5,
  },
  {
    original_query: "Brück",
    total_searches: 5,
  },
  {
    original_query: "Kuch",
    total_searches: 5,
  },
  {
    original_query: "zahlungs",
    total_searches: 5,
  },
  {
    original_query: "Dayton",
    total_searches: 5,
  },
  {
    original_query: "badezimmert",
    total_searches: 5,
  },
  {
    original_query: "Weichsocke",
    total_searches: 5,
  },
  {
    original_query: "Terassenfli",
    total_searches: 5,
  },
  {
    original_query: "zuschnit",
    total_searches: 5,
  },
  {
    original_query: "lieferze",
    total_searches: 5,
  },
  {
    original_query: "Hongko",
    total_searches: 5,
  },
  {
    original_query: "audr",
    total_searches: 5,
  },
  {
    original_query: "elega",
    total_searches: 5,
  },
  {
    original_query: "teppichböden",
    total_searches: 5,
  },
  {
    original_query: "jalous",
    total_searches: 5,
  },
  {
    original_query: "Flas",
    total_searches: 5,
  },
  {
    original_query: "lastregal",
    total_searches: 5,
  },
  {
    original_query: "daisies",
    total_searches: 5,
  },
  {
    original_query: "outdoorl",
    total_searches: 5,
  },
  {
    original_query: "Spectral",
    total_searches: 5,
  },
  {
    original_query: "erde",
    total_searches: 5,
  },
  {
    original_query: "monocrom",
    total_searches: 5,
  },
  {
    original_query: "flaschenständer",
    total_searches: 5,
  },
  {
    original_query: "Terassendielen",
    total_searches: 5,
  },
  {
    original_query: "Duschst",
    total_searches: 5,
  },
  {
    original_query: "Grana",
    total_searches: 5,
  },
  {
    original_query: "kustrasen",
    total_searches: 5,
  },
  {
    original_query: "abschlussprof",
    total_searches: 5,
  },
  {
    original_query: "couchtisch",
    total_searches: 5,
  },
  {
    original_query: "Badeteppi",
    total_searches: 5,
  },
  {
    original_query: "tafelf",
    total_searches: 5,
  },
  {
    original_query: "zahlungsart",
    total_searches: 5,
  },
  {
    original_query: "einschubprofil",
    total_searches: 5,
  },
  {
    original_query: "sisalstufenmatten",
    total_searches: 5,
  },
  {
    original_query: "bronze",
    total_searches: 5,
  },
  {
    original_query: "Dreieck",
    total_searches: 5,
  },
  {
    original_query: "Treppenstufenmatte",
    total_searches: 5,
  },
  {
    original_query: "bettumrandungen",
    total_searches: 5,
  },
  {
    original_query: "fleckerlteppich",
    total_searches: 5,
  },
  {
    original_query: "schmutzfä",
    total_searches: 5,
  },
  {
    original_query: "vorha",
    total_searches: 5,
  },
  {
    original_query: "Clai",
    total_searches: 5,
  },
  {
    original_query: "Abschlussprofil",
    total_searches: 5,
  },
  {
    original_query: "ringgummimatt",
    total_searches: 5,
  },
  {
    original_query: "mikrofaser",
    total_searches: 5,
  },
  {
    original_query: "transparen",
    total_searches: 5,
  },
  {
    original_query: "trittscha",
    total_searches: 5,
  },
  {
    original_query: "octodoor",
    total_searches: 5,
  },
  {
    original_query: "radent",
    total_searches: 5,
  },
  {
    original_query: "Hund",
    total_searches: 5,
  },
  {
    original_query: "Kant",
    total_searches: 5,
  },
  {
    original_query: "Malaga",
    total_searches: 5,
  },
  {
    original_query: "Sichtschutzstreifen",
    total_searches: 5,
  },
  {
    original_query: "wachstuch",
    total_searches: 5,
  },
  {
    original_query: "Grillschutzma",
    total_searches: 5,
  },
  {
    original_query: "kosmeti",
    total_searches: 5,
  },
  {
    original_query: "teppichstan",
    total_searches: 5,
  },
  {
    original_query: "buchsbaumkugel",
    total_searches: 5,
  },
  {
    original_query: "schlingenf",
    total_searches: 5,
  },
  {
    original_query: "Brüc",
    total_searches: 5,
  },
  {
    original_query: "einfassleiste",
    total_searches: 5,
  },
  {
    original_query: "lärmschutz",
    total_searches: 5,
  },
  {
    original_query: "zugluftstopper",
    total_searches: 5,
  },
  {
    original_query: "Sichsch",
    total_searches: 5,
  },
  {
    original_query: "neody",
    total_searches: 5,
  },
  {
    original_query: "beetum",
    total_searches: 5,
  },
  {
    original_query: "maulwurfgi",
    total_searches: 5,
  },
  {
    original_query: "nicu",
    total_searches: 5,
  },
  {
    original_query: "Fallschutzm",
    total_searches: 5,
  },
  {
    original_query: "akkustikpanel",
    total_searches: 5,
  },
  {
    original_query: "akustikpanel",
    total_searches: 5,
  },
  {
    original_query: "bambusz",
    total_searches: 5,
  },
  {
    original_query: "Bambussichts",
    total_searches: 5,
  },
  {
    original_query: "antirursch",
    total_searches: 5,
  },
  {
    original_query: "sisalzeppich",
    total_searches: 5,
  },
  {
    original_query: "Sidal",
    total_searches: 5,
  },
  {
    original_query: "wendeltreppe",
    total_searches: 5,
  },
  {
    original_query: "glastafel",
    total_searches: 5,
  },
  {
    original_query: "Telef",
    total_searches: 5,
  },
  {
    original_query: "wach",
    total_searches: 5,
  },
  {
    original_query: "autof",
    total_searches: 5,
  },
  {
    original_query: "rollk",
    total_searches: 5,
  },
  {
    original_query: "nadelfikz",
    total_searches: 5,
  },
  {
    original_query: "ducato",
    total_searches: 5,
  },
  {
    original_query: "bürste",
    total_searches: 5,
  },
  {
    original_query: "schurwolle",
    total_searches: 5,
  },
  {
    original_query: "wave",
    total_searches: 5,
  },
  {
    original_query: "Laeufer",
    total_searches: 5,
  },
  {
    original_query: "email",
    total_searches: 5,
  },
  {
    original_query: "fliess",
    total_searches: 5,
  },
  {
    original_query: "arktik",
    total_searches: 5,
  },
  {
    original_query: "holzflie",
    total_searches: 5,
  },
  {
    original_query: "Korkkle",
    total_searches: 5,
  },
  {
    original_query: "panda",
    total_searches: 5,
  },
  {
    original_query: "Fliesenpro",
    total_searches: 5,
  },
  {
    original_query: "magent",
    total_searches: 5,
  },
  {
    original_query: "sack",
    total_searches: 5,
  },
  {
    original_query: "Schmutzmatt",
    total_searches: 5,
  },
  {
    original_query: "lampen",
    total_searches: 5,
  },
  {
    original_query: "büros",
    total_searches: 5,
  },
  {
    original_query: "lindon",
    total_searches: 5,
  },
  {
    original_query: "Fusm",
    total_searches: 5,
  },
  {
    original_query: "vibrationsmatten",
    total_searches: 5,
  },
  {
    original_query: "tige",
    total_searches: 5,
  },
  {
    original_query: "filzbelag",
    total_searches: 5,
  },
  {
    original_query: "fitnessmatte",
    total_searches: 5,
  },
  {
    original_query: "whie",
    total_searches: 5,
  },
  {
    original_query: "holzplane",
    total_searches: 5,
  },
  {
    original_query: "balkonrase",
    total_searches: 5,
  },
  {
    original_query: "gewächshau",
    total_searches: 5,
  },
  {
    original_query: "handschuhe",
    total_searches: 5,
  },
  {
    original_query: "Masc",
    total_searches: 5,
  },
  {
    original_query: "Abschlusspro",
    total_searches: 5,
  },
  {
    original_query: "hake",
    total_searches: 5,
  },
  {
    original_query: "weichsc",
    total_searches: 5,
  },
  {
    original_query: "twppich",
    total_searches: 5,
  },
  {
    original_query: "rutschmatten",
    total_searches: 5,
  },
  {
    original_query: "Pferd",
    total_searches: 5,
  },
  {
    original_query: "vakuum",
    total_searches: 5,
  },
  {
    original_query: "pavill",
    total_searches: 5,
  },
  {
    original_query: "Honh",
    total_searches: 5,
  },
  {
    original_query: "promen",
    total_searches: 5,
  },
  {
    original_query: "zaunelemente",
    total_searches: 5,
  },
  {
    original_query: "Abschlussp",
    total_searches: 5,
  },
  {
    original_query: "käfer",
    total_searches: 5,
  },
  {
    original_query: "Power",
    total_searches: 5,
  },
  {
    original_query: "schutzmat",
    total_searches: 5,
  },
  {
    original_query: "brillian",
    total_searches: 5,
  },
  {
    original_query: "kunstrad",
    total_searches: 5,
  },
  {
    original_query: "telef",
    total_searches: 5,
  },
  {
    original_query: "Heizmatte",
    total_searches: 5,
  },
  {
    original_query: "bidensc",
    total_searches: 5,
  },
  {
    original_query: "cuba",
    total_searches: 5,
  },
  {
    original_query: "oregon",
    total_searches: 5,
  },
  {
    original_query: "rege",
    total_searches: 5,
  },
  {
    original_query: "treppenstufenprofil",
    total_searches: 5,
  },
  {
    original_query: "rankgitte",
    total_searches: 5,
  },
  {
    original_query: "Badm",
    total_searches: 5,
  },
  {
    original_query: "Paddock",
    total_searches: 5,
  },
  {
    original_query: "wolldecken",
    total_searches: 5,
  },
  {
    original_query: "Natu",
    total_searches: 5,
  },
  {
    original_query: "binded",
    total_searches: 5,
  },
  {
    original_query: "stufenteppic",
    total_searches: 5,
  },
  {
    original_query: "kunstrasenklebe",
    total_searches: 5,
  },
  {
    original_query: "vibrations",
    total_searches: 5,
  },
  {
    original_query: "Badezimm",
    total_searches: 5,
  },
  {
    original_query: "mate",
    total_searches: 5,
  },
  {
    original_query: "Vorze",
    total_searches: 5,
  },
  {
    original_query: "durchsichtig",
    total_searches: 5,
  },
  {
    original_query: "fahradständer",
    total_searches: 5,
  },
  {
    original_query: "teppichstop",
    total_searches: 5,
  },
  {
    original_query: "jersey",
    total_searches: 5,
  },
  {
    original_query: "Stanf",
    total_searches: 5,
  },
  {
    original_query: "Gitte",
    total_searches: 5,
  },
  {
    original_query: "schmutzläu",
    total_searches: 5,
  },
  {
    original_query: "sichtschitz",
    total_searches: 5,
  },
  {
    original_query: "Schnutzf",
    total_searches: 5,
  },
  {
    original_query: "andeckpl",
    total_searches: 5,
  },
  {
    original_query: "flausch",
    total_searches: 5,
  },
  {
    original_query: "magnetboard",
    total_searches: 5,
  },
  {
    original_query: "mealnge",
    total_searches: 5,
  },
  {
    original_query: "treppenprof",
    total_searches: 5,
  },
  {
    original_query: "Schutzf",
    total_searches: 5,
  },
  {
    original_query: "Kunstrasent",
    total_searches: 5,
  },
  {
    original_query: "bambusza",
    total_searches: 5,
  },
  {
    original_query: "langflor",
    total_searches: 5,
  },
  {
    original_query: "gitterf",
    total_searches: 5,
  },
  {
    original_query: "abeckplane",
    total_searches: 5,
  },
  {
    original_query: "Elit",
    total_searches: 5,
  },
  {
    original_query: "treppem",
    total_searches: 5,
  },
  {
    original_query: "Piet",
    total_searches: 5,
  },
  {
    original_query: "absp",
    total_searches: 5,
  },
  {
    original_query: "mapple",
    total_searches: 5,
  },
  {
    original_query: "poolabdeckung",
    total_searches: 5,
  },
  {
    original_query: "rasenteppiche",
    total_searches: 5,
  },
  {
    original_query: "Taube",
    total_searches: 5,
  },
  {
    original_query: "mausefalle",
    total_searches: 5,
  },
  {
    original_query: "echt",
    total_searches: 5,
  },
  {
    original_query: "tomatenstab",
    total_searches: 5,
  },
  {
    original_query: "Schutzm",
    total_searches: 5,
  },
  {
    original_query: "kaninchendraht",
    total_searches: 5,
  },
  {
    original_query: "rindenma",
    total_searches: 5,
  },
  {
    original_query: "unico",
    total_searches: 5,
  },
  {
    original_query: "abdeckplne",
    total_searches: 5,
  },
  {
    original_query: "pearl",
    total_searches: 5,
  },
  {
    original_query: "türprofil",
    total_searches: 5,
  },
  {
    original_query: "schla",
    total_searches: 5,
  },
  {
    original_query: "getra",
    total_searches: 5,
  },
  {
    original_query: "rollko",
    total_searches: 5,
  },
  {
    original_query: "Schmutzfangläuf",
    total_searches: 5,
  },
  {
    original_query: "outdoorlä",
    total_searches: 5,
  },
  {
    original_query: "kiana",
    total_searches: 5,
  },
  {
    original_query: "zeppi",
    total_searches: 5,
  },
  {
    original_query: "musterbeste",
    total_searches: 5,
  },
  {
    original_query: "KUNSTRASEN",
    total_searches: 5,
  },
  {
    original_query: "Spec",
    total_searches: 5,
  },
  {
    original_query: "schmutzfän",
    total_searches: 5,
  },
  {
    original_query: "teppiv",
    total_searches: 5,
  },
  {
    original_query: "Barce",
    total_searches: 5,
  },
  {
    original_query: "drogheda",
    total_searches: 5,
  },
  {
    original_query: "Fussbo",
    total_searches: 5,
  },
  {
    original_query: "klickfi",
    total_searches: 5,
  },
  {
    original_query: "mont",
    total_searches: 5,
  },
  {
    original_query: "windsc",
    total_searches: 5,
  },
  {
    original_query: "riffel",
    total_searches: 5,
  },
  {
    original_query: "Terassenfl",
    total_searches: 5,
  },
  {
    original_query: "kurzfloo",
    total_searches: 5,
  },
  {
    original_query: "zaune",
    total_searches: 5,
  },
  {
    original_query: "vogelschutz",
    total_searches: 5,
  },
  {
    original_query: "Telefo",
    total_searches: 5,
  },
  {
    original_query: "noppenmatt",
    total_searches: 5,
  },
  {
    original_query: "lagam",
    total_searches: 5,
  },
  {
    original_query: "anpassungsp",
    total_searches: 5,
  },
  {
    original_query: "Rinde",
    total_searches: 5,
  },
  {
    original_query: "Mira",
    total_searches: 5,
  },
  {
    original_query: "Stakete",
    total_searches: 5,
  },
  {
    original_query: "Biden",
    total_searches: 5,
  },
  {
    original_query: "flipchar",
    total_searches: 5,
  },
  {
    original_query: "desig",
    total_searches: 5,
  },
  {
    original_query: "cosenz",
    total_searches: 5,
  },
  {
    original_query: "steckregale",
    total_searches: 5,
  },
  {
    original_query: "Garagenb",
    total_searches: 5,
  },
  {
    original_query: "Leni",
    total_searches: 5,
  },
  {
    original_query: "sisalm",
    total_searches: 5,
  },
  {
    original_query: "Terasen",
    total_searches: 5,
  },
  {
    original_query: "garagenmatte",
    total_searches: 5,
  },
  {
    original_query: "Desi",
    total_searches: 5,
  },
  {
    original_query: "Treppenp",
    total_searches: 5,
  },
  {
    original_query: "toledo",
    total_searches: 5,
  },
  {
    original_query: "bind",
    total_searches: 5,
  },
  {
    original_query: "laga",
    total_searches: 5,
  },
  {
    original_query: "akkustikpanee",
    total_searches: 5,
  },
  {
    original_query: "schmurt",
    total_searches: 5,
  },
  {
    original_query: "erdhaken",
    total_searches: 5,
  },
  {
    original_query: "google",
    total_searches: 5,
  },
  {
    original_query: "kantenleiste",
    total_searches: 5,
  },
  {
    original_query: "floordirek",
    total_searches: 5,
  },
  {
    original_query: "bodenlei",
    total_searches: 5,
  },
  {
    original_query: "class",
    total_searches: 5,
  },
  {
    original_query: "elekt",
    total_searches: 5,
  },
  {
    original_query: "teppichmatten",
    total_searches: 5,
  },
  {
    original_query: "eimer",
    total_searches: 5,
  },
  {
    original_query: "Superf",
    total_searches: 5,
  },
  {
    original_query: "Zaunsic",
    total_searches: 5,
  },
  {
    original_query: "Treppenkantenprofile",
    total_searches: 5,
  },
  {
    original_query: "magnetl",
    total_searches: 5,
  },
  {
    original_query: "vorzel",
    total_searches: 5,
  },
  {
    original_query: "berb",
    total_searches: 5,
  },
  {
    original_query: "tischläufer",
    total_searches: 5,
  },
  {
    original_query: "gewächsh",
    total_searches: 5,
  },
  {
    original_query: "schwimmb",
    total_searches: 5,
  },
  {
    original_query: "wands",
    total_searches: 5,
  },
  {
    original_query: "Schaukas",
    total_searches: 5,
  },
  {
    original_query: "sissal",
    total_searches: 5,
  },
  {
    original_query: "weidenmatt",
    total_searches: 5,
  },
  {
    original_query: "Palm",
    total_searches: 5,
  },
  {
    original_query: "durchs",
    total_searches: 5,
  },
  {
    original_query: "karabiner",
    total_searches: 5,
  },
  {
    original_query: "Antivibrationsm",
    total_searches: 5,
  },
  {
    original_query: "bodenank",
    total_searches: 5,
  },
  {
    original_query: "Hochbee",
    total_searches: 5,
  },
  {
    original_query: "Kunstst",
    total_searches: 5,
  },
  {
    original_query: "Autoteppic",
    total_searches: 5,
  },
  {
    original_query: "Schutzma",
    total_searches: 5,
  },
  {
    original_query: "auslege",
    total_searches: 5,
  },
  {
    original_query: "girloon",
    total_searches: 5,
  },
  {
    original_query: "bambustep",
    total_searches: 5,
  },
  {
    original_query: "wandpaneel",
    total_searches: 5,
  },
  {
    original_query: "Grillschutzm",
    total_searches: 5,
  },
  {
    original_query: "Weichsockel",
    total_searches: 5,
  },
  {
    original_query: "spektra",
    total_searches: 5,
  },
  {
    original_query: "Pflanzkübel",
    total_searches: 5,
  },
  {
    original_query: "vinil",
    total_searches: 5,
  },
  {
    original_query: "pflanzst",
    total_searches: 5,
  },
  {
    original_query: "teppichschoner",
    total_searches: 5,
  },
  {
    original_query: "Tischfoli",
    total_searches: 5,
  },
  {
    original_query: "küchenboden",
    total_searches: 5,
  },
  {
    original_query: "Schmutzfsn",
    total_searches: 5,
  },
  {
    original_query: "Stufenp",
    total_searches: 5,
  },
  {
    original_query: "holzfl",
    total_searches: 5,
  },
  {
    original_query: "Wass",
    total_searches: 5,
  },
  {
    original_query: "kpchen",
    total_searches: 5,
  },
  {
    original_query: "londom",
    total_searches: 5,
  },
  {
    original_query: "bauschut",
    total_searches: 5,
  },
  {
    original_query: "wolltepp",
    total_searches: 5,
  },
  {
    original_query: "anpass",
    total_searches: 5,
  },
  {
    original_query: "bodenschuz",
    total_searches: 5,
  },
  {
    original_query: "massanfertigung",
    total_searches: 5,
  },
  {
    original_query: "gummibo",
    total_searches: 5,
  },
  {
    original_query: "gittermatte",
    total_searches: 5,
  },
  {
    original_query: "kuhfell",
    total_searches: 5,
  },
  {
    original_query: "sonnensegeö",
    total_searches: 5,
  },
  {
    original_query: "baby",
    total_searches: 5,
  },
  {
    original_query: "Rankgit",
    total_searches: 5,
  },
  {
    original_query: "Ausgl",
    total_searches: 5,
  },
  {
    original_query: "Tauben",
    total_searches: 5,
  },
  {
    original_query: "antra",
    total_searches: 5,
  },
  {
    original_query: "prima",
    total_searches: 5,
  },
  {
    original_query: "Brücke",
    total_searches: 5,
  },
  {
    original_query: "Duschvor",
    total_searches: 5,
  },
  {
    original_query: "unkrautvli",
    total_searches: 5,
  },
  {
    original_query: "wandanschlussprofil",
    total_searches: 5,
  },
  {
    original_query: "badr",
    total_searches: 5,
  },
  {
    original_query: "Zuschnitt",
    total_searches: 5,
  },
  {
    original_query: "spanndra",
    total_searches: 5,
  },
  {
    original_query: "individuell",
    total_searches: 5,
  },
  {
    original_query: "Ausgleich",
    total_searches: 5,
  },
  {
    original_query: "garder",
    total_searches: 5,
  },
  {
    original_query: "porto",
    total_searches: 5,
  },
  {
    original_query: "naas",
    total_searches: 5,
  },
  {
    original_query: "Klickflies",
    total_searches: 5,
  },
  {
    original_query: "windschu",
    total_searches: 5,
  },
  {
    original_query: "Holzf",
    total_searches: 5,
  },
  {
    original_query: "klemmmarkise",
    total_searches: 5,
  },
  {
    original_query: "Kunststo",
    total_searches: 5,
  },
  {
    original_query: "behe",
    total_searches: 5,
  },
  {
    original_query: "cancan",
    total_searches: 5,
  },
  {
    original_query: "befestigungsst",
    total_searches: 5,
  },
  {
    original_query: "Teppichu",
    total_searches: 5,
  },
  {
    original_query: "gewürzre",
    total_searches: 5,
  },
  {
    original_query: "Schre",
    total_searches: 5,
  },
  {
    original_query: "handtuchhaken",
    total_searches: 5,
  },
  {
    original_query: "sint",
    total_searches: 5,
  },
  {
    original_query: "clay",
    total_searches: 5,
  },
  {
    original_query: "Meterwa",
    total_searches: 5,
  },
  {
    original_query: "grüner",
    total_searches: 5,
  },
  {
    original_query: "koos",
    total_searches: 5,
  },
  {
    original_query: "schmutzfabgmatte",
    total_searches: 5,
  },
  {
    original_query: "boots",
    total_searches: 5,
  },
  {
    original_query: "dreie",
    total_searches: 5,
  },
  {
    original_query: "teleskopstange",
    total_searches: 5,
  },
  {
    original_query: "Treppenpro",
    total_searches: 5,
  },
  {
    original_query: "Vogel",
    total_searches: 5,
  },
  {
    original_query: "gummiwa",
    total_searches: 5,
  },
  {
    original_query: "Sicherheitsmatte",
    total_searches: 5,
  },
  {
    original_query: "schlingenfl",
    total_searches: 5,
  },
  {
    original_query: "eckp",
    total_searches: 5,
  },
  {
    original_query: "sicherheitsstu",
    total_searches: 5,
  },
  {
    original_query: "badeteppiche",
    total_searches: 5,
  },
  {
    original_query: "Vienna",
    total_searches: 5,
  },
  {
    original_query: "gummilö",
    total_searches: 5,
  },
  {
    original_query: "Sonen",
    total_searches: 5,
  },
  {
    original_query: "Fusma",
    total_searches: 5,
  },
  {
    original_query: "wandspiegel",
    total_searches: 5,
  },
  {
    original_query: "ankica",
    total_searches: 5,
  },
  {
    original_query: "Kokosm",
    total_searches: 5,
  },
  {
    original_query: "kusche",
    total_searches: 5,
  },
  {
    original_query: "seitenmarkie",
    total_searches: 5,
  },
  {
    original_query: "Ringgummim",
    total_searches: 5,
  },
  {
    original_query: "teppichbodenschutzmatte",
    total_searches: 5,
  },
  {
    original_query: "hohlkammerpla",
    total_searches: 5,
  },
  {
    original_query: "gutter",
    total_searches: 5,
  },
  {
    original_query: "Ausgleichsprofil",
    total_searches: 5,
  },
  {
    original_query: "Bambusm",
    total_searches: 5,
  },
  {
    original_query: "trennw",
    total_searches: 5,
  },
  {
    original_query: "filzmatt",
    total_searches: 5,
  },
  {
    original_query: "Rassenteppich",
    total_searches: 5,
  },
  {
    original_query: "Mülle",
    total_searches: 5,
  },
  {
    original_query: "magneti",
    total_searches: 5,
  },
  {
    original_query: "magnetisch",
    total_searches: 5,
  },
  {
    original_query: "Pflege",
    total_searches: 5,
  },
  {
    original_query: "kell",
    total_searches: 5,
  },
  {
    original_query: "teüp",
    total_searches: 5,
  },
  {
    original_query: "besen",
    total_searches: 5,
  },
  {
    original_query: "hollywood",
    total_searches: 5,
  },
  {
    original_query: "Sura",
    total_searches: 5,
  },
  {
    original_query: "Bide",
    total_searches: 5,
  },
  {
    original_query: "vynilboden",
    total_searches: 5,
  },
  {
    original_query: "Rücks",
    total_searches: 5,
  },
  {
    original_query: "sicjt",
    total_searches: 5,
  },
  {
    original_query: "rasentwppich",
    total_searches: 5,
  },
  {
    original_query: "wexford",
    total_searches: 5,
  },
  {
    original_query: "bordeaux",
    total_searches: 5,
  },
  {
    original_query: "randleiste",
    total_searches: 5,
  },
  {
    original_query: "heri",
    total_searches: 5,
  },
  {
    original_query: "schmutzteppi",
    total_searches: 5,
  },
  {
    original_query: "Sichtschutzrollo",
    total_searches: 5,
  },
  {
    original_query: "alum",
    total_searches: 5,
  },
  {
    original_query: "schreibtischstuhl",
    total_searches: 5,
  },
  {
    original_query: "mustan",
    total_searches: 5,
  },
  {
    original_query: "velur",
    total_searches: 5,
  },
  {
    original_query: "Petrol",
    total_searches: 5,
  },
  {
    original_query: "doppelseiti",
    total_searches: 5,
  },
  {
    original_query: "rechteckig",
    total_searches: 5,
  },
  {
    original_query: "kust",
    total_searches: 5,
  },
  {
    original_query: "Ausgleichs",
    total_searches: 5,
  },
  {
    original_query: "Bonita",
    total_searches: 5,
  },
  {
    original_query: "terrassenplatten",
    total_searches: 5,
  },
  {
    original_query: "Badv",
    total_searches: 5,
  },
  {
    original_query: "pferdematte",
    total_searches: 5,
  },
  {
    original_query: "Befestigungss",
    total_searches: 5,
  },
  {
    original_query: "rabattco",
    total_searches: 5,
  },
  {
    original_query: "Sichtschutzro",
    total_searches: 5,
  },
  {
    original_query: "whiteboardf",
    total_searches: 5,
  },
  {
    original_query: "Flachnopp",
    total_searches: 5,
  },
  {
    original_query: "rasenmatte",
    total_searches: 5,
  },
  {
    original_query: "spruh",
    total_searches: 5,
  },
  {
    original_query: "stak",
    total_searches: 5,
  },
  {
    original_query: "lichtschacht",
    total_searches: 5,
  },
  {
    original_query: "klickvenyl",
    total_searches: 5,
  },
  {
    original_query: "fensterrollo",
    total_searches: 5,
  },
  {
    original_query: "barcel",
    total_searches: 5,
  },
  {
    original_query: "dunkel",
    total_searches: 5,
  },
  {
    original_query: "stäbe",
    total_searches: 5,
  },
  {
    original_query: "horizon",
    total_searches: 5,
  },
  {
    original_query: "Toma",
    total_searches: 5,
  },
  {
    original_query: "zube",
    total_searches: 5,
  },
  {
    original_query: "sichtschutzgewebe",
    total_searches: 5,
  },
  {
    original_query: "nadeld",
    total_searches: 5,
  },
  {
    original_query: "Korkk",
    total_searches: 5,
  },
  {
    original_query: "teppichbodens",
    total_searches: 5,
  },
  {
    original_query: "nägel",
    total_searches: 5,
  },
  {
    original_query: "übergabg",
    total_searches: 5,
  },
  {
    original_query: "autom",
    total_searches: 5,
  },
  {
    original_query: "fily",
    total_searches: 5,
  },
  {
    original_query: "Fallschutzma",
    total_searches: 5,
  },
  {
    original_query: "waschma",
    total_searches: 5,
  },
  {
    original_query: "türsc",
    total_searches: 5,
  },
  {
    original_query: "trittschalldä",
    total_searches: 5,
  },
  {
    original_query: "Kantenpr",
    total_searches: 5,
  },
  {
    original_query: "seitenmarkiese",
    total_searches: 5,
  },
  {
    original_query: "orientteppich",
    total_searches: 5,
  },
  {
    original_query: "holzabdeck",
    total_searches: 5,
  },
  {
    original_query: "gummibode",
    total_searches: 5,
  },
  {
    original_query: "Vinylt",
    total_searches: 5,
  },
  {
    original_query: "schir",
    total_searches: 5,
  },
  {
    original_query: "Noppenf",
    total_searches: 5,
  },
  {
    original_query: "feinschlingen",
    total_searches: 5,
  },
  {
    original_query: "riefen",
    total_searches: 5,
  },
  {
    original_query: "schreibtischunterlagen",
    total_searches: 5,
  },
  {
    original_query: "Zaunsichtschutz",
    total_searches: 5,
  },
  {
    original_query: "himal",
    total_searches: 5,
  },
  {
    original_query: "sichtschutzs",
    total_searches: 5,
  },
  {
    original_query: "stufenprof",
    total_searches: 5,
  },
  {
    original_query: "velourte",
    total_searches: 5,
  },
  {
    original_query: "fahrradstände",
    total_searches: 5,
  },
  {
    original_query: "kickfliesen",
    total_searches: 5,
  },
  {
    original_query: "baumr",
    total_searches: 5,
  },
  {
    original_query: "vorze",
    total_searches: 5,
  },
  {
    original_query: "spaghettimatte",
    total_searches: 5,
  },
  {
    original_query: "teppichm",
    total_searches: 5,
  },
  {
    original_query: "mulchscheiben",
    total_searches: 5,
  },
  {
    original_query: "rutschmatt",
    total_searches: 5,
  },
  {
    original_query: "kinderteppi",
    total_searches: 5,
  },
  {
    original_query: "Treppenschon",
    total_searches: 5,
  },
  {
    original_query: "Fahrradst",
    total_searches: 5,
  },
  {
    original_query: "böschu",
    total_searches: 5,
  },
  {
    original_query: "mosko",
    total_searches: 5,
  },
  {
    original_query: "gummispanner",
    total_searches: 5,
  },
  {
    original_query: "Badvo",
    total_searches: 5,
  },
  {
    original_query: "rasw",
    total_searches: 5,
  },
  {
    original_query: "balkonbodenbelag",
    total_searches: 5,
  },
  {
    original_query: "Stufente",
    total_searches: 5,
  },
  {
    original_query: "Chev",
    total_searches: 5,
  },
  {
    original_query: "ches",
    total_searches: 5,
  },
  {
    original_query: "Rügen",
    total_searches: 5,
  },
  {
    original_query: "sicherheitsstufenmatten",
    total_searches: 5,
  },
  {
    original_query: "gummikleber",
    total_searches: 5,
  },
  {
    original_query: "terrassendiele",
    total_searches: 5,
  },
  {
    original_query: "Gummiläufe",
    total_searches: 5,
  },
  {
    original_query: "automatten",
    total_searches: 5,
  },
  {
    original_query: "Feuers",
    total_searches: 5,
  },
  {
    original_query: "holzzaun",
    total_searches: 5,
  },
  {
    original_query: "teppichläfer",
    total_searches: 5,
  },
  {
    original_query: "Sichtschutzr",
    total_searches: 5,
  },
  {
    original_query: "expot",
    total_searches: 5,
  },
  {
    original_query: "caracterra",
    total_searches: 5,
  },
  {
    original_query: "canc",
    total_searches: 5,
  },
  {
    original_query: "Hering",
    total_searches: 5,
  },
  {
    original_query: "fahrradhalter",
    total_searches: 5,
  },
  {
    original_query: "Arbei",
    total_searches: 5,
  },
  {
    original_query: "Span",
    total_searches: 5,
  },
  {
    original_query: "Sisall",
    total_searches: 5,
  },
  {
    original_query: "Jalousie",
    total_searches: 5,
  },
  {
    original_query: "Lieferzeit",
    total_searches: 5,
  },
  {
    original_query: "schreibtischunterl",
    total_searches: 5,
  },
  {
    original_query: "maus",
    total_searches: 5,
  },
  {
    original_query: "wühlmausgitte",
    total_searches: 5,
  },
  {
    original_query: "cudi",
    total_searches: 5,
  },
  {
    original_query: "heavy",
    total_searches: 5,
  },
  {
    original_query: "sparta",
    total_searches: 5,
  },
  {
    original_query: "Ande",
    total_searches: 5,
  },
  {
    original_query: "anpassu",
    total_searches: 5,
  },
  {
    original_query: "bilderrahmen",
    total_searches: 5,
  },
  {
    original_query: "katzenst",
    total_searches: 5,
  },
  {
    original_query: "treppenläuferstange",
    total_searches: 5,
  },
  {
    original_query: "Hochb",
    total_searches: 5,
  },
  {
    original_query: "memoboard",
    total_searches: 5,
  },
  {
    original_query: "rhein",
    total_searches: 5,
  },
  {
    original_query: "weinrot",
    total_searches: 5,
  },
  {
    original_query: "agra",
    total_searches: 5,
  },
  {
    original_query: "Terassendi",
    total_searches: 5,
  },
  {
    original_query: "sebang",
    total_searches: 5,
  },
  {
    original_query: "volie",
    total_searches: 5,
  },
  {
    original_query: "Hochflorte",
    total_searches: 5,
  },
  {
    original_query: "Beetu",
    total_searches: 5,
  },
  {
    original_query: "vließ",
    total_searches: 5,
  },
  {
    original_query: "wann",
    total_searches: 5,
  },
  {
    original_query: "spanngur",
    total_searches: 5,
  },
  {
    original_query: "teppichfliesne",
    total_searches: 5,
  },
  {
    original_query: "Vorzelt",
    total_searches: 5,
  },
  {
    original_query: "trittschalld",
    total_searches: 5,
  },
  {
    original_query: "Stanfo",
    total_searches: 5,
  },
  {
    original_query: "Akzent",
    total_searches: 5,
  },
  {
    original_query: "ständer",
    total_searches: 5,
  },
  {
    original_query: "korkw",
    total_searches: 5,
  },
  {
    original_query: "Perfor",
    total_searches: 5,
  },
  {
    original_query: "kautschuk",
    total_searches: 5,
  },
  {
    original_query: "winkelprof",
    total_searches: 5,
  },
  {
    original_query: "akustikpanelle",
    total_searches: 5,
  },
  {
    original_query: "außenteppich",
    total_searches: 5,
  },
  {
    original_query: "autotep",
    total_searches: 5,
  },
  {
    original_query: "rasr",
    total_searches: 5,
  },
  {
    original_query: "stand",
    total_searches: 5,
  },
  {
    original_query: "kratzb",
    total_searches: 5,
  },
  {
    original_query: "linoliumboden",
    total_searches: 5,
  },
  {
    original_query: "antivibrationsmat",
    total_searches: 5,
  },
  {
    original_query: "Abdeckl",
    total_searches: 5,
  },
  {
    original_query: "panele",
    total_searches: 5,
  },
  {
    original_query: "duschroll",
    total_searches: 5,
  },
  {
    original_query: "promena",
    total_searches: 5,
  },
  {
    original_query: "sesal",
    total_searches: 5,
  },
  {
    original_query: "kosm",
    total_searches: 5,
  },
  {
    original_query: "polster",
    total_searches: 5,
  },
  {
    original_query: "kunstraseb",
    total_searches: 5,
  },
  {
    original_query: "filzgleiter",
    total_searches: 5,
  },
  {
    original_query: "gummigranul",
    total_searches: 5,
  },
  {
    original_query: "Rücksend",
    total_searches: 5,
  },
  {
    original_query: "heimwerk",
    total_searches: 5,
  },
  {
    original_query: "gerflor",
    total_searches: 5,
  },
  {
    original_query: "magnetta",
    total_searches: 5,
  },
  {
    original_query: "keil",
    total_searches: 5,
  },
  {
    original_query: "wollteppi",
    total_searches: 5,
  },
  {
    original_query: "stif",
    total_searches: 5,
  },
  {
    original_query: "feuersc",
    total_searches: 5,
  },
  {
    original_query: "Bambusmatt",
    total_searches: 5,
  },
  {
    original_query: "abdeckl",
    total_searches: 5,
  },
  {
    original_query: "Bambussichtsch",
    total_searches: 5,
  },
  {
    original_query: "Vorzel",
    total_searches: 5,
  },
  {
    original_query: "oeko",
    total_searches: 5,
  },
  {
    original_query: "step",
    total_searches: 5,
  },
  {
    original_query: "rivi",
    total_searches: 5,
  },
  {
    original_query: "camperfilz",
    total_searches: 5,
  },
  {
    original_query: "hochzeitsläufer",
    total_searches: 5,
  },
  {
    original_query: "ringgum",
    total_searches: 5,
  },
  {
    original_query: "kleiderständer",
    total_searches: 5,
  },
  {
    original_query: "schönen",
    total_searches: 5,
  },
  {
    original_query: "Camping",
    total_searches: 5,
  },
  {
    original_query: "gartenteppich",
    total_searches: 5,
  },
  {
    original_query: "sicherheitsstufen",
    total_searches: 5,
  },
  {
    original_query: "Stufent",
    total_searches: 5,
  },
  {
    original_query: "abschlussleist",
    total_searches: 5,
  },
  {
    original_query: "Stabi",
    total_searches: 5,
  },
  {
    original_query: "Bambusma",
    total_searches: 5,
  },
  {
    original_query: "farbwub",
    total_searches: 5,
  },
  {
    original_query: "Höhen",
    total_searches: 5,
  },
  {
    original_query: "baumw",
    total_searches: 5,
  },
  {
    original_query: "schmutfang",
    total_searches: 5,
  },
  {
    original_query: "gardine",
    total_searches: 5,
  },
  {
    original_query: "Balkonu",
    total_searches: 5,
  },
  {
    original_query: "raen",
    total_searches: 5,
  },
  {
    original_query: "brilli",
    total_searches: 5,
  },
  {
    original_query: "gewerbe",
    total_searches: 5,
  },
  {
    original_query: "koks",
    total_searches: 5,
  },
  {
    original_query: "grillmatt",
    total_searches: 5,
  },
  {
    original_query: "äufer",
    total_searches: 5,
  },
  {
    original_query: "garderobenstä",
    total_searches: 5,
  },
  {
    original_query: "Sonnenschut",
    total_searches: 5,
  },
  {
    original_query: "noppenm",
    total_searches: 5,
  },
  {
    original_query: "gardi",
    total_searches: 5,
  },
  {
    original_query: "elegant",
    total_searches: 5,
  },
  {
    original_query: "whitboard",
    total_searches: 5,
  },
  {
    original_query: "volier",
    total_searches: 5,
  },
  {
    original_query: "terassenplatten",
    total_searches: 5,
  },
  {
    original_query: "Dayto",
    total_searches: 5,
  },
  {
    original_query: "Hongk",
    total_searches: 5,
  },
  {
    original_query: "Mustang",
    total_searches: 5,
  },
  {
    original_query: "fliesenpr",
    total_searches: 5,
  },
  {
    original_query: "montana",
    total_searches: 5,
  },
  {
    original_query: "Runder",
    total_searches: 5,
  },
  {
    original_query: "innenecke",
    total_searches: 5,
  },
  {
    original_query: "kunststo",
    total_searches: 5,
  },
  {
    original_query: "clasi",
    total_searches: 5,
  },
  {
    original_query: "Schmutzfän",
    total_searches: 5,
  },
  {
    original_query: "autofi",
    total_searches: 5,
  },
  {
    original_query: "Rücksen",
    total_searches: 5,
  },
  {
    original_query: "schlingm",
    total_searches: 5,
  },
  {
    original_query: "Rückg",
    total_searches: 5,
  },
  {
    original_query: "gymnastikmatte",
    total_searches: 5,
  },
  {
    original_query: "lief",
    total_searches: 5,
  },
  {
    original_query: "tarnn",
    total_searches: 5,
  },
  {
    original_query: "Sisaloptik",
    total_searches: 5,
  },
  {
    original_query: "schmutzfangmar",
    total_searches: 5,
  },
  {
    original_query: "viki",
    total_searches: 5,
  },
  {
    original_query: "sonnensegal",
    total_searches: 5,
  },
  {
    original_query: "hich",
    total_searches: 5,
  },
  {
    original_query: "sisalmatt",
    total_searches: 5,
  },
  {
    original_query: "gardinenstange",
    total_searches: 5,
  },
  {
    original_query: "schmutf",
    total_searches: 5,
  },
  {
    original_query: "flür",
    total_searches: 5,
  },
  {
    original_query: "Selbstk",
    total_searches: 5,
  },
  {
    original_query: "Treppenmatten",
    total_searches: 5,
  },
  {
    original_query: "Bambussichtschu",
    total_searches: 5,
  },
  {
    original_query: "badezimmergarnitur",
    total_searches: 5,
  },
  {
    original_query: "Schlingenmatt",
    total_searches: 5,
  },
  {
    original_query: "antistati",
    total_searches: 5,
  },
  {
    original_query: "Terassend",
    total_searches: 5,
  },
  {
    original_query: "befestigungssta",
    total_searches: 5,
  },
  {
    original_query: "hori",
    total_searches: 5,
  },
  {
    original_query: "bürostu",
    total_searches: 5,
  },
  {
    original_query: "ampe",
    total_searches: 5,
  },
  {
    original_query: "eppich",
    total_searches: 5,
  },
  {
    original_query: "terrassendie",
    total_searches: 5,
  },
  {
    original_query: "teppichschi",
    total_searches: 5,
  },
  {
    original_query: "Schmutzfä",
    total_searches: 5,
  },
  {
    original_query: "graphit",
    total_searches: 5,
  },
  {
    original_query: "teppichstufe",
    total_searches: 5,
  },
  {
    original_query: "Gras",
    total_searches: 5,
  },
  {
    original_query: "Class",
    total_searches: 5,
  },
  {
    original_query: "poolabde",
    total_searches: 5,
  },
  {
    original_query: "sichtachutz",
    total_searches: 5,
  },
  {
    original_query: "balkonflies",
    total_searches: 5,
  },
  {
    original_query: "saug",
    total_searches: 5,
  },
  {
    original_query: "heizdecke",
    total_searches: 5,
  },
  {
    original_query: "multi",
    total_searches: 5,
  },
  {
    original_query: "nylon",
    total_searches: 5,
  },
  {
    original_query: "grillmatten",
    total_searches: 5,
  },
  {
    original_query: "schilfrohr",
    total_searches: 5,
  },
  {
    original_query: "gummikork",
    total_searches: 5,
  },
  {
    original_query: "bauzaun",
    total_searches: 5,
  },
  {
    original_query: "salva",
    total_searches: 5,
  },
  {
    original_query: "wabenmatte",
    total_searches: 5,
  },
  {
    original_query: "teppis",
    total_searches: 5,
  },
  {
    original_query: "schallsc",
    total_searches: 5,
  },
  {
    original_query: "zeltteppich",
    total_searches: 5,
  },
  {
    original_query: "ermüdungs",
    total_searches: 5,
  },
  {
    original_query: "tarn",
    total_searches: 5,
  },
  {
    original_query: "Gewächsha",
    total_searches: 5,
  },
  {
    original_query: "Terassenteppich",
    total_searches: 5,
  },
  {
    original_query: "Schmutzfangteppic",
    total_searches: 5,
  },
  {
    original_query: "Ches",
    total_searches: 5,
  },
  {
    original_query: "niederflor",
    total_searches: 5,
  },
  {
    original_query: "durc",
    total_searches: 5,
  },
  {
    original_query: "schine",
    total_searches: 5,
  },
  {
    original_query: "Holzfl",
    total_searches: 5,
  },
  {
    original_query: "treppenlantenprofil",
    total_searches: 5,
  },
  {
    original_query: "wühlmausgit",
    total_searches: 5,
  },
  {
    original_query: "türki",
    total_searches: 5,
  },
  {
    original_query: "gerüstplane",
    total_searches: 5,
  },
  {
    original_query: "Stufenkantenprofile",
    total_searches: 5,
  },
  {
    original_query: "zugluft",
    total_searches: 5,
  },
  {
    original_query: "Seitenmarkis",
    total_searches: 5,
  },
  {
    original_query: "Rapido",
    total_searches: 5,
  },
  {
    original_query: "Kratzteppi",
    total_searches: 5,
  },
  {
    original_query: "doppelstab",
    total_searches: 5,
  },
  {
    original_query: "aluleisten",
    total_searches: 5,
  },
  {
    original_query: "Ther",
    total_searches: 5,
  },
  {
    original_query: "Acry",
    total_searches: 5,
  },
  {
    original_query: "henri",
    total_searches: 5,
  },
  {
    original_query: "Fahrradstä",
    total_searches: 5,
  },
  {
    original_query: "bodenprofi",
    total_searches: 5,
  },
  {
    original_query: "anhe",
    total_searches: 5,
  },
  {
    original_query: "schmutzfngmatte",
    total_searches: 5,
  },
  {
    original_query: "nauru",
    total_searches: 5,
  },
  {
    original_query: "stufena",
    total_searches: 5,
  },
  {
    original_query: "terracott",
    total_searches: 5,
  },
  {
    original_query: "antis",
    total_searches: 5,
  },
  {
    original_query: "Woche",
    total_searches: 5,
  },
  {
    original_query: "Holzb",
    total_searches: 5,
  },
  {
    original_query: "casapura",
    total_searches: 5,
  },
  {
    original_query: "selbstklebender",
    total_searches: 4,
  },
  {
    original_query: "whitebor",
    total_searches: 4,
  },
  {
    original_query: "falle",
    total_searches: 4,
  },
  {
    original_query: "gardienen",
    total_searches: 4,
  },
  {
    original_query: "sportboden",
    total_searches: 4,
  },
  {
    original_query: "Telefonnummer",
    total_searches: 4,
  },
  {
    original_query: "sonnn",
    total_searches: 4,
  },
  {
    original_query: "doppelt",
    total_searches: 4,
  },
  {
    original_query: "wohnt",
    total_searches: 4,
  },
  {
    original_query: "laifer",
    total_searches: 4,
  },
  {
    original_query: "Bank",
    total_searches: 4,
  },
  {
    original_query: "Vinylboden",
    total_searches: 4,
  },
  {
    original_query: "Nadelfilt",
    total_searches: 4,
  },
  {
    original_query: "dayligh",
    total_searches: 4,
  },
  {
    original_query: "vakuumbeutel",
    total_searches: 4,
  },
  {
    original_query: "kundtrase",
    total_searches: 4,
  },
  {
    original_query: "kraty",
    total_searches: 4,
  },
  {
    original_query: "schmutzfann",
    total_searches: 4,
  },
  {
    original_query: "befestigungsschinen",
    total_searches: 4,
  },
  {
    original_query: "terrassenbelag",
    total_searches: 4,
  },
  {
    original_query: "balkongeländer",
    total_searches: 4,
  },
  {
    original_query: "sunday",
    total_searches: 4,
  },
  {
    original_query: "glasboar",
    total_searches: 4,
  },
  {
    original_query: "celes",
    total_searches: 4,
  },
  {
    original_query: "Surat",
    total_searches: 4,
  },
  {
    original_query: "kart",
    total_searches: 4,
  },
  {
    original_query: "klappt",
    total_searches: 4,
  },
  {
    original_query: "gitterzaun",
    total_searches: 4,
  },
  {
    original_query: "bettimrandung",
    total_searches: 4,
  },
  {
    original_query: "flache",
    total_searches: 4,
  },
  {
    original_query: "gummiläufee",
    total_searches: 4,
  },
  {
    original_query: "Ausgleichsprof",
    total_searches: 4,
  },
  {
    original_query: "Spiel",
    total_searches: 4,
  },
  {
    original_query: "Sprühklebe",
    total_searches: 4,
  },
  {
    original_query: "korkwa",
    total_searches: 4,
  },
  {
    original_query: "stufenmattr",
    total_searches: 4,
  },
  {
    original_query: "grull",
    total_searches: 4,
  },
  {
    original_query: "seatt",
    total_searches: 4,
  },
  {
    original_query: "Cancu",
    total_searches: 4,
  },
  {
    original_query: "alusti",
    total_searches: 4,
  },
  {
    original_query: "Tritt",
    total_searches: 4,
  },
  {
    original_query: "tire",
    total_searches: 4,
  },
  {
    original_query: "teppichstopp",
    total_searches: 4,
  },
  {
    original_query: "sisalteo",
    total_searches: 4,
  },
  {
    original_query: "Befestigungsschie",
    total_searches: 4,
  },
  {
    original_query: "adematten",
    total_searches: 4,
  },
  {
    original_query: "hichfloor",
    total_searches: 4,
  },
  {
    original_query: "rutschs",
    total_searches: 4,
  },
  {
    original_query: "stifenmatten",
    total_searches: 4,
  },
  {
    original_query: "Baumatten",
    total_searches: 4,
  },
  {
    original_query: "Licht",
    total_searches: 4,
  },
  {
    original_query: "Unterleg",
    total_searches: 4,
  },
  {
    original_query: "gummilaufer",
    total_searches: 4,
  },
  {
    original_query: "Schutzhü",
    total_searches: 4,
  },
  {
    original_query: "markisensto",
    total_searches: 4,
  },
  {
    original_query: "vinylbodenbelag",
    total_searches: 4,
  },
  {
    original_query: "duschro",
    total_searches: 4,
  },
  {
    original_query: "scatola",
    total_searches: 4,
  },
  {
    original_query: "mücke",
    total_searches: 4,
  },
  {
    original_query: "adresse",
    total_searches: 4,
  },
  {
    original_query: "dielen",
    total_searches: 4,
  },
  {
    original_query: "Sonnem",
    total_searches: 4,
  },
  {
    original_query: "Campin",
    total_searches: 4,
  },
  {
    original_query: "rassenteppic",
    total_searches: 4,
  },
  {
    original_query: "trepoen",
    total_searches: 4,
  },
  {
    original_query: "poola",
    total_searches: 4,
  },
  {
    original_query: "grillabde",
    total_searches: 4,
  },
  {
    original_query: "Rutschfester",
    total_searches: 4,
  },
  {
    original_query: "schmutzfn",
    total_searches: 4,
  },
  {
    original_query: "stufenkantprofil",
    total_searches: 4,
  },
  {
    original_query: "Unterla",
    total_searches: 4,
  },
  {
    original_query: "dämmmatte",
    total_searches: 4,
  },
  {
    original_query: "treppenabschluss",
    total_searches: 4,
  },
  {
    original_query: "beig",
    total_searches: 4,
  },
  {
    original_query: "dekorfolie",
    total_searches: 4,
  },
  {
    original_query: "servo",
    total_searches: 4,
  },
  {
    original_query: "rindenm",
    total_searches: 4,
  },
  {
    original_query: "fussbode",
    total_searches: 4,
  },
  {
    original_query: "babus",
    total_searches: 4,
  },
  {
    original_query: "Shine",
    total_searches: 4,
  },
  {
    original_query: "Poolunterlage",
    total_searches: 4,
  },
  {
    original_query: "holzleim",
    total_searches: 4,
  },
  {
    original_query: "müle",
    total_searches: 4,
  },
  {
    original_query: "Polycar",
    total_searches: 4,
  },
  {
    original_query: "Wachs",
    total_searches: 4,
  },
  {
    original_query: "Akze",
    total_searches: 4,
  },
  {
    original_query: "antirutz",
    total_searches: 4,
  },
  {
    original_query: "aussenbereich",
    total_searches: 4,
  },
  {
    original_query: "luis",
    total_searches: 4,
  },
  {
    original_query: "isomatte",
    total_searches: 4,
  },
  {
    original_query: "siliko",
    total_searches: 4,
  },
  {
    original_query: "bambusm",
    total_searches: 4,
  },
  {
    original_query: "einschub",
    total_searches: 4,
  },
  {
    original_query: "kundtrasen",
    total_searches: 4,
  },
  {
    original_query: "gummimate",
    total_searches: 4,
  },
  {
    original_query: "Lucan",
    total_searches: 4,
  },
  {
    original_query: "outdoormatte",
    total_searches: 4,
  },
  {
    original_query: "Schnutzfang",
    total_searches: 4,
  },
  {
    original_query: "bodenschutzmazte",
    total_searches: 4,
  },
  {
    original_query: "Arnol",
    total_searches: 4,
  },
  {
    original_query: "noppenma",
    total_searches: 4,
  },
  {
    original_query: "nadelfliz",
    total_searches: 4,
  },
  {
    original_query: "trapezblec",
    total_searches: 4,
  },
  {
    original_query: "ampel",
    total_searches: 4,
  },
  {
    original_query: "brill",
    total_searches: 4,
  },
  {
    original_query: "nave",
    total_searches: 4,
  },
  {
    original_query: "Rückgab",
    total_searches: 4,
  },
  {
    original_query: "rutschhemmende",
    total_searches: 4,
  },
  {
    original_query: "teppichfliesse",
    total_searches: 4,
  },
  {
    original_query: "outdor",
    total_searches: 4,
  },
  {
    original_query: "bodenschuttmatte",
    total_searches: 4,
  },
  {
    original_query: "sauberlauft",
    total_searches: 4,
  },
  {
    original_query: "Linoleum",
    total_searches: 4,
  },
  {
    original_query: "sessel",
    total_searches: 4,
  },
  {
    original_query: "treppenbe",
    total_searches: 4,
  },
  {
    original_query: "feinschlinge",
    total_searches: 4,
  },
  {
    original_query: "umrandung",
    total_searches: 4,
  },
  {
    original_query: "treppena",
    total_searches: 4,
  },
  {
    original_query: "bordürenteppich",
    total_searches: 4,
  },
  {
    original_query: "kunstrasentep",
    total_searches: 4,
  },
  {
    original_query: "badewannenmatte",
    total_searches: 4,
  },
  {
    original_query: "rasentw",
    total_searches: 4,
  },
  {
    original_query: "Noppenfo",
    total_searches: 4,
  },
  {
    original_query: "spiral",
    total_searches: 4,
  },
  {
    original_query: "kastenständer",
    total_searches: 4,
  },
  {
    original_query: "krei",
    total_searches: 4,
  },
  {
    original_query: "nasszone",
    total_searches: 4,
  },
  {
    original_query: "teppichleiste",
    total_searches: 4,
  },
  {
    original_query: "stufenprofile",
    total_searches: 4,
  },
  {
    original_query: "Lichts",
    total_searches: 4,
  },
  {
    original_query: "bidensch",
    total_searches: 4,
  },
  {
    original_query: "möbelfolie",
    total_searches: 4,
  },
  {
    original_query: "Terrassenfli",
    total_searches: 4,
  },
  {
    original_query: "anpassungsprof",
    total_searches: 4,
  },
  {
    original_query: "römö",
    total_searches: 4,
  },
  {
    original_query: "antibibr",
    total_searches: 4,
  },
  {
    original_query: "desinfektionsmatte",
    total_searches: 4,
  },
  {
    original_query: "Malta",
    total_searches: 4,
  },
  {
    original_query: "viva",
    total_searches: 4,
  },
  {
    original_query: "Lako",
    total_searches: 4,
  },
  {
    original_query: "Sintra",
    total_searches: 4,
  },
  {
    original_query: "Pietvo",
    total_searches: 4,
  },
  {
    original_query: "sonnensegwl",
    total_searches: 4,
  },
  {
    original_query: "Abtreter",
    total_searches: 4,
  },
  {
    original_query: "poolabd",
    total_searches: 4,
  },
  {
    original_query: "gewürz",
    total_searches: 4,
  },
  {
    original_query: "klar",
    total_searches: 4,
  },
  {
    original_query: "Waschbare",
    total_searches: 4,
  },
  {
    original_query: "ceao",
    total_searches: 4,
  },
  {
    original_query: "colom",
    total_searches: 4,
  },
  {
    original_query: "wandver",
    total_searches: 4,
  },
  {
    original_query: "gaderobe",
    total_searches: 4,
  },
  {
    original_query: "antiruc",
    total_searches: 4,
  },
  {
    original_query: "cuban",
    total_searches: 4,
  },
  {
    original_query: "leufe",
    total_searches: 4,
  },
  {
    original_query: "hotline",
    total_searches: 4,
  },
  {
    original_query: "ladung",
    total_searches: 4,
  },
  {
    original_query: "Bambussich",
    total_searches: 4,
  },
  {
    original_query: "Rsen",
    total_searches: 4,
  },
  {
    original_query: "wandsp",
    total_searches: 4,
  },
  {
    original_query: "Weichsoc",
    total_searches: 4,
  },
  {
    original_query: "Bambusteppich",
    total_searches: 4,
  },
  {
    original_query: "naveli",
    total_searches: 4,
  },
  {
    original_query: "wohnwa",
    total_searches: 4,
  },
  {
    original_query: "toscana",
    total_searches: 4,
  },
  {
    original_query: "Antirutschmat",
    total_searches: 4,
  },
  {
    original_query: "übergab",
    total_searches: 4,
  },
  {
    original_query: "schmuty",
    total_searches: 4,
  },
  {
    original_query: "Sichtachutz",
    total_searches: 4,
  },
  {
    original_query: "Wach",
    total_searches: 4,
  },
  {
    original_query: "Kami",
    total_searches: 4,
  },
  {
    original_query: "poolma",
    total_searches: 4,
  },
  {
    original_query: "sitzauflage",
    total_searches: 4,
  },
  {
    original_query: "bürotepp",
    total_searches: 4,
  },
  {
    original_query: "balkonplatten",
    total_searches: 4,
  },
  {
    original_query: "Eckpr",
    total_searches: 4,
  },
  {
    original_query: "Jalous",
    total_searches: 4,
  },
  {
    original_query: "socl",
    total_searches: 4,
  },
  {
    original_query: "spannband",
    total_searches: 4,
  },
  {
    original_query: "strick",
    total_searches: 4,
  },
  {
    original_query: "fussmate",
    total_searches: 4,
  },
  {
    original_query: "rutschh",
    total_searches: 4,
  },
  {
    original_query: "Fußb",
    total_searches: 4,
  },
  {
    original_query: "karabi",
    total_searches: 4,
  },
  {
    original_query: "schwi",
    total_searches: 4,
  },
  {
    original_query: "kpche",
    total_searches: 4,
  },
  {
    original_query: "abdeckplatte",
    total_searches: 4,
  },
  {
    original_query: "gummibodenbelag",
    total_searches: 4,
  },
  {
    original_query: "Schilf",
    total_searches: 4,
  },
  {
    original_query: "Erdanke",
    total_searches: 4,
  },
  {
    original_query: "verdunklungsroll",
    total_searches: 4,
  },
  {
    original_query: "Turb",
    total_searches: 4,
  },
  {
    original_query: "Outdoorläufer",
    total_searches: 4,
  },
  {
    original_query: "Cuba",
    total_searches: 4,
  },
  {
    original_query: "bari",
    total_searches: 4,
  },
  {
    original_query: "kunstoff",
    total_searches: 4,
  },
  {
    original_query: "andeckpla",
    total_searches: 4,
  },
  {
    original_query: "Pflanze",
    total_searches: 4,
  },
  {
    original_query: "bürostuhlunter",
    total_searches: 4,
  },
  {
    original_query: "kuala",
    total_searches: 4,
  },
  {
    original_query: "ölbeständig",
    total_searches: 4,
  },
  {
    original_query: "Toiletten",
    total_searches: 4,
  },
  {
    original_query: "gardien",
    total_searches: 4,
  },
  {
    original_query: "innenraumverkl",
    total_searches: 4,
  },
  {
    original_query: "Badvorl",
    total_searches: 4,
  },
  {
    original_query: "leipzi",
    total_searches: 4,
  },
  {
    original_query: "nieder",
    total_searches: 4,
  },
  {
    original_query: "pberg",
    total_searches: 4,
  },
  {
    original_query: "zuschnei",
    total_searches: 4,
  },
  {
    original_query: "Treppenstufenm",
    total_searches: 4,
  },
  {
    original_query: "überdachung",
    total_searches: 4,
  },
  {
    original_query: "Nice",
    total_searches: 4,
  },
  {
    original_query: "aberd",
    total_searches: 4,
  },
  {
    original_query: "Kundtrasen",
    total_searches: 4,
  },
  {
    original_query: "schallsch",
    total_searches: 4,
  },
  {
    original_query: "polypro",
    total_searches: 4,
  },
  {
    original_query: "arizona",
    total_searches: 4,
  },
  {
    original_query: "Abschlussleist",
    total_searches: 4,
  },
  {
    original_query: "Korkbo",
    total_searches: 4,
  },
  {
    original_query: "hobbyglas",
    total_searches: 4,
  },
  {
    original_query: "bsmbus",
    total_searches: 4,
  },
  {
    original_query: "univers",
    total_searches: 4,
  },
  {
    original_query: "stars",
    total_searches: 4,
  },
  {
    original_query: "Rollos",
    total_searches: 4,
  },
  {
    original_query: "alfo",
    total_searches: 4,
  },
  {
    original_query: "salvado",
    total_searches: 4,
  },
  {
    original_query: "kupfer",
    total_searches: 4,
  },
  {
    original_query: "Mustan",
    total_searches: 4,
  },
  {
    original_query: "lichterkette",
    total_searches: 4,
  },
  {
    original_query: "kofferraummatte",
    total_searches: 4,
  },
  {
    original_query: "thermoroll",
    total_searches: 4,
  },
  {
    original_query: "haustür",
    total_searches: 4,
  },
  {
    original_query: "Ausgleichspr",
    total_searches: 4,
  },
  {
    original_query: "vest",
    total_searches: 4,
  },
  {
    original_query: "bodenvertiefung",
    total_searches: 4,
  },
  {
    original_query: "unive",
    total_searches: 4,
  },
  {
    original_query: "creme",
    total_searches: 4,
  },
  {
    original_query: "schallschu",
    total_searches: 4,
  },
  {
    original_query: "octago",
    total_searches: 4,
  },
  {
    original_query: "küchenleufer",
    total_searches: 4,
  },
  {
    original_query: "schatti",
    total_searches: 4,
  },
  {
    original_query: "trapet",
    total_searches: 4,
  },
  {
    original_query: "kabelbrücke",
    total_searches: 4,
  },
  {
    original_query: "Bautenschutzm",
    total_searches: 4,
  },
  {
    original_query: "Duschsta",
    total_searches: 4,
  },
  {
    original_query: "terassendiele",
    total_searches: 4,
  },
  {
    original_query: "Spieltepp",
    total_searches: 4,
  },
  {
    original_query: "musterbestellung",
    total_searches: 4,
  },
  {
    original_query: "Ringgummima",
    total_searches: 4,
  },
  {
    original_query: "getränkekisten",
    total_searches: 4,
  },
  {
    original_query: "Sichtschutt",
    total_searches: 4,
  },
  {
    original_query: "feuerschutzmatte",
    total_searches: 4,
  },
  {
    original_query: "Kind",
    total_searches: 4,
  },
  {
    original_query: "zahlun",
    total_searches: 4,
  },
  {
    original_query: "bodenflies",
    total_searches: 4,
  },
  {
    original_query: "Abschlusspr",
    total_searches: 4,
  },
  {
    original_query: "Handtücher",
    total_searches: 4,
  },
  {
    original_query: "rundte",
    total_searches: 4,
  },
  {
    original_query: "Korkboden",
    total_searches: 4,
  },
  {
    original_query: "Badetepp",
    total_searches: 4,
  },
  {
    original_query: "hartbo",
    total_searches: 4,
  },
  {
    original_query: "kunstrasenteppic",
    total_searches: 4,
  },
  {
    original_query: "polyamid",
    total_searches: 4,
  },
  {
    original_query: "sokelleiste",
    total_searches: 4,
  },
  {
    original_query: "blin",
    total_searches: 4,
  },
  {
    original_query: "besteck",
    total_searches: 4,
  },
  {
    original_query: "Terassente",
    total_searches: 4,
  },
  {
    original_query: "mausgitter",
    total_searches: 4,
  },
  {
    original_query: "Geneva",
    total_searches: 4,
  },
  {
    original_query: "moderationstafeln",
    total_searches: 4,
  },
  {
    original_query: "verz",
    total_searches: 4,
  },
  {
    original_query: "pira",
    total_searches: 4,
  },
  {
    original_query: "duschvorlage",
    total_searches: 4,
  },
  {
    original_query: "badezimmertrppich",
    total_searches: 4,
  },
  {
    original_query: "Kettelteppich",
    total_searches: 4,
  },
  {
    original_query: "treppenstufenschutz",
    total_searches: 4,
  },
  {
    original_query: "schmutzgan",
    total_searches: 4,
  },
  {
    original_query: "panelle",
    total_searches: 4,
  },
  {
    original_query: "badvorleg",
    total_searches: 4,
  },
  {
    original_query: "Terrassenteppic",
    total_searches: 4,
  },
  {
    original_query: "werk",
    total_searches: 4,
  },
  {
    original_query: "seifenspender",
    total_searches: 4,
  },
  {
    original_query: "flurvorleger",
    total_searches: 4,
  },
  {
    original_query: "lamellen",
    total_searches: 4,
  },
  {
    original_query: "zuschn",
    total_searches: 4,
  },
  {
    original_query: "Steegplatten",
    total_searches: 4,
  },
  {
    original_query: "Outdoortep",
    total_searches: 4,
  },
  {
    original_query: "boxenmatte",
    total_searches: 4,
  },
  {
    original_query: "Jazz",
    total_searches: 4,
  },
  {
    original_query: "Badeteppich",
    total_searches: 4,
  },
  {
    original_query: "terrac",
    total_searches: 4,
  },
  {
    original_query: "cheni",
    total_searches: 4,
  },
  {
    original_query: "grillteppich",
    total_searches: 4,
  },
  {
    original_query: "Stra",
    total_searches: 4,
  },
  {
    original_query: "mäuseg",
    total_searches: 4,
  },
  {
    original_query: "drain",
    total_searches: 4,
  },
  {
    original_query: "schmutzfangmazte",
    total_searches: 4,
  },
  {
    original_query: "fußabs",
    total_searches: 4,
  },
  {
    original_query: "Hohlkam",
    total_searches: 4,
  },
  {
    original_query: "andeckplan",
    total_searches: 4,
  },
  {
    original_query: "ause",
    total_searches: 4,
  },
  {
    original_query: "camo",
    total_searches: 4,
  },
  {
    original_query: "strapazierfähig",
    total_searches: 4,
  },
  {
    original_query: "badtepich",
    total_searches: 4,
  },
  {
    original_query: "wollteppiche",
    total_searches: 4,
  },
  {
    original_query: "duschmat",
    total_searches: 4,
  },
  {
    original_query: "nadelfilztepp",
    total_searches: 4,
  },
  {
    original_query: "antirutschsicherheitsmatte",
    total_searches: 4,
  },
  {
    original_query: "albus",
    total_searches: 4,
  },
  {
    original_query: "trop",
    total_searches: 4,
  },
  {
    original_query: "mülltonne",
    total_searches: 4,
  },
  {
    original_query: "versanddauer",
    total_searches: 4,
  },
  {
    original_query: "Aufbewahrung",
    total_searches: 4,
  },
  {
    original_query: "hartbode",
    total_searches: 4,
  },
  {
    original_query: "sportmatten",
    total_searches: 4,
  },
  {
    original_query: "kindertepp",
    total_searches: 4,
  },
  {
    original_query: "Sisalläu",
    total_searches: 4,
  },
  {
    original_query: "tasenteppich",
    total_searches: 4,
  },
  {
    original_query: "lammfe",
    total_searches: 4,
  },
  {
    original_query: "grillschutzmat",
    total_searches: 4,
  },
  {
    original_query: "gurt",
    total_searches: 4,
  },
  {
    original_query: "Treppenstufenmatten",
    total_searches: 4,
  },
  {
    original_query: "abdecknetz",
    total_searches: 4,
  },
  {
    original_query: "absper",
    total_searches: 4,
  },
  {
    original_query: "kratzbo",
    total_searches: 4,
  },
  {
    original_query: "heizung",
    total_searches: 4,
  },
  {
    original_query: "sichschutz",
    total_searches: 4,
  },
  {
    original_query: "murica",
    total_searches: 4,
  },
  {
    original_query: "wandprofil",
    total_searches: 4,
  },
  {
    original_query: "Stufenteppi",
    total_searches: 4,
  },
  {
    original_query: "kundenstoper",
    total_searches: 4,
  },
  {
    original_query: "Grillm",
    total_searches: 4,
  },
  {
    original_query: "Schienen",
    total_searches: 4,
  },
  {
    original_query: "Jalou",
    total_searches: 4,
  },
  {
    original_query: "stufeb",
    total_searches: 4,
  },
  {
    original_query: "übergabgs",
    total_searches: 4,
  },
  {
    original_query: "übergangsle",
    total_searches: 4,
  },
  {
    original_query: "sprühl",
    total_searches: 4,
  },
  {
    original_query: "lang",
    total_searches: 4,
  },
  {
    original_query: "zeltte",
    total_searches: 4,
  },
  {
    original_query: "zeltplanen",
    total_searches: 4,
  },
  {
    original_query: "raswn",
    total_searches: 4,
  },
  {
    original_query: "anpa",
    total_searches: 4,
  },
  {
    original_query: "Stallmat",
    total_searches: 4,
  },
  {
    original_query: "zeltteppi",
    total_searches: 4,
  },
  {
    original_query: "planr",
    total_searches: 4,
  },
  {
    original_query: "pinnw",
    total_searches: 4,
  },
  {
    original_query: "sonnenseh",
    total_searches: 4,
  },
  {
    original_query: "Linole",
    total_searches: 4,
  },
  {
    original_query: "teüpich",
    total_searches: 4,
  },
  {
    original_query: "Feuerschal",
    total_searches: 4,
  },
  {
    original_query: "dokumenthalter",
    total_searches: 4,
  },
  {
    original_query: "anthra",
    total_searches: 4,
  },
  {
    original_query: "schwerlastregaö",
    total_searches: 4,
  },
  {
    original_query: "bürsteneinsätze",
    total_searches: 4,
  },
  {
    original_query: "Holzabdeckplane",
    total_searches: 4,
  },
  {
    original_query: "stufenkantwn",
    total_searches: 4,
  },
  {
    original_query: "schafwollteppich",
    total_searches: 4,
  },
  {
    original_query: "kantensch",
    total_searches: 4,
  },
  {
    original_query: "elit",
    total_searches: 4,
  },
  {
    original_query: "Lucano",
    total_searches: 4,
  },
  {
    original_query: "emma",
    total_searches: 4,
  },
  {
    original_query: "Zaunschutz",
    total_searches: 4,
  },
  {
    original_query: "Turbo",
    total_searches: 4,
  },
  {
    original_query: "designboden",
    total_searches: 4,
  },
  {
    original_query: "antirutch",
    total_searches: 4,
  },
  {
    original_query: "Thermo",
    total_searches: 4,
  },
  {
    original_query: "kuechen",
    total_searches: 4,
  },
  {
    original_query: "Vinyltepp",
    total_searches: 4,
  },
  {
    original_query: "eckstück",
    total_searches: 4,
  },
  {
    original_query: "Stabil",
    total_searches: 4,
  },
  {
    original_query: "telefonnu",
    total_searches: 4,
  },
  {
    original_query: "sufen",
    total_searches: 4,
  },
  {
    original_query: "Tischdeck",
    total_searches: 4,
  },
  {
    original_query: "sonnensegrl",
    total_searches: 4,
  },
  {
    original_query: "Fußbo",
    total_searches: 4,
  },
  {
    original_query: "nadelfilzt",
    total_searches: 4,
  },
  {
    original_query: "Befestigungsschi",
    total_searches: 4,
  },
  {
    original_query: "bild",
    total_searches: 4,
  },
  {
    original_query: "gleitschutz",
    total_searches: 4,
  },
  {
    original_query: "leinwand",
    total_searches: 4,
  },
  {
    original_query: "maulwur",
    total_searches: 4,
  },
  {
    original_query: "zaunpfähle",
    total_searches: 4,
  },
  {
    original_query: "transpar",
    total_searches: 4,
  },
  {
    original_query: "role",
    total_searches: 4,
  },
  {
    original_query: "dakota",
    total_searches: 4,
  },
  {
    original_query: "magnetle",
    total_searches: 4,
  },
  {
    original_query: "Kabelbinde",
    total_searches: 4,
  },
  {
    original_query: "bauhaus",
    total_searches: 4,
  },
  {
    original_query: "Noppenfoli",
    total_searches: 4,
  },
  {
    original_query: "Treppenläufe",
    total_searches: 4,
  },
  {
    original_query: "dalas",
    total_searches: 4,
  },
  {
    original_query: "schaff",
    total_searches: 4,
  },
  {
    original_query: "kunstrasenfliesen",
    total_searches: 4,
  },
  {
    original_query: "schlu",
    total_searches: 4,
  },
  {
    original_query: "Lieferzei",
    total_searches: 4,
  },
  {
    original_query: "ampels",
    total_searches: 4,
  },
  {
    original_query: "Decke",
    total_searches: 4,
  },
  {
    original_query: "dichtung",
    total_searches: 4,
  },
  {
    original_query: "Radenteppich",
    total_searches: 4,
  },
  {
    original_query: "abdeckolane",
    total_searches: 4,
  },
  {
    original_query: "küchrn",
    total_searches: 4,
  },
  {
    original_query: "schwelle",
    total_searches: 4,
  },
  {
    original_query: "messeb",
    total_searches: 4,
  },
  {
    original_query: "miniripp",
    total_searches: 4,
  },
  {
    original_query: "spanngum",
    total_searches: 4,
  },
  {
    original_query: "Kunststoff",
    total_searches: 4,
  },
  {
    original_query: "zubehö",
    total_searches: 4,
  },
  {
    original_query: "amou",
    total_searches: 4,
  },
  {
    original_query: "Cross",
    total_searches: 4,
  },
  {
    original_query: "dtufe",
    total_searches: 4,
  },
  {
    original_query: "Sichtschutzmatten",
    total_searches: 4,
  },
  {
    original_query: "teppuc",
    total_searches: 4,
  },
  {
    original_query: "schmuzt",
    total_searches: 4,
  },
  {
    original_query: "gartenf",
    total_searches: 4,
  },
  {
    original_query: "Tischdec",
    total_searches: 4,
  },
  {
    original_query: "verzi",
    total_searches: 4,
  },
  {
    original_query: "stufenmatteb",
    total_searches: 4,
  },
  {
    original_query: "linoli",
    total_searches: 4,
  },
  {
    original_query: "blende",
    total_searches: 4,
  },
  {
    original_query: "bamus",
    total_searches: 4,
  },
  {
    original_query: "campe",
    total_searches: 4,
  },
  {
    original_query: "dchmu",
    total_searches: 4,
  },
  {
    original_query: "Angebote",
    total_searches: 4,
  },
  {
    original_query: "nfilz",
    total_searches: 4,
  },
  {
    original_query: "jutese",
    total_searches: 4,
  },
  {
    original_query: "maßanfertigung",
    total_searches: 4,
  },
  {
    original_query: "bodenschutzmate",
    total_searches: 4,
  },
  {
    original_query: "klein",
    total_searches: 4,
  },
  {
    original_query: "mückennetz",
    total_searches: 4,
  },
  {
    original_query: "gartenstuhl",
    total_searches: 4,
  },
  {
    original_query: "abse",
    total_searches: 4,
  },
  {
    original_query: "sisaltreppenstufen",
    total_searches: 4,
  },
  {
    original_query: "garagenbelag",
    total_searches: 4,
  },
  {
    original_query: "Erdenket",
    total_searches: 4,
  },
  {
    original_query: "evers",
    total_searches: 4,
  },
  {
    original_query: "Susal",
    total_searches: 4,
  },
  {
    original_query: "insektenschutz",
    total_searches: 4,
  },
  {
    original_query: "küchenwagen",
    total_searches: 4,
  },
  {
    original_query: "plat",
    total_searches: 4,
  },
  {
    original_query: "terraco",
    total_searches: 4,
  },
  {
    original_query: "buchsbaum",
    total_searches: 4,
  },
  {
    original_query: "müleime",
    total_searches: 4,
  },
  {
    original_query: "glatt",
    total_searches: 4,
  },
  {
    original_query: "rassentep",
    total_searches: 4,
  },
  {
    original_query: "Metall",
    total_searches: 4,
  },
  {
    original_query: "treff",
    total_searches: 4,
  },
  {
    original_query: "aussente",
    total_searches: 4,
  },
  {
    original_query: "wabenplissee",
    total_searches: 4,
  },
  {
    original_query: "Schmutzfsngmatte",
    total_searches: 4,
  },
  {
    original_query: "teppichläifer",
    total_searches: 4,
  },
  {
    original_query: "Staketen",
    total_searches: 4,
  },
  {
    original_query: "Küchenregal",
    total_searches: 4,
  },
  {
    original_query: "campi",
    total_searches: 4,
  },
  {
    original_query: "Steckregal",
    total_searches: 4,
  },
  {
    original_query: "Autof",
    total_searches: 4,
  },
  {
    original_query: "schin",
    total_searches: 4,
  },
  {
    original_query: "Platte",
    total_searches: 4,
  },
  {
    original_query: "türst",
    total_searches: 4,
  },
  {
    original_query: "korkmatten",
    total_searches: 4,
  },
  {
    original_query: "sonnsegel",
    total_searches: 4,
  },
  {
    original_query: "Fahrzeug",
    total_searches: 4,
  },
  {
    original_query: "brennholzregal",
    total_searches: 4,
  },
  {
    original_query: "schni",
    total_searches: 4,
  },
  {
    original_query: "hochfloortepp",
    total_searches: 4,
  },
  {
    original_query: "tanag",
    total_searches: 4,
  },
  {
    original_query: "badezimmertepp",
    total_searches: 4,
  },
  {
    original_query: "kabelmatten",
    total_searches: 4,
  },
  {
    original_query: "gummist",
    total_searches: 4,
  },
  {
    original_query: "Selbstklebend",
    total_searches: 4,
  },
  {
    original_query: "eleg",
    total_searches: 4,
  },
  {
    original_query: "prinz",
    total_searches: 4,
  },
  {
    original_query: "industrie",
    total_searches: 4,
  },
  {
    original_query: "zuschni",
    total_searches: 4,
  },
  {
    original_query: "Promenade",
    total_searches: 4,
  },
  {
    original_query: "flurmatte",
    total_searches: 4,
  },
  {
    original_query: "tanz",
    total_searches: 4,
  },
  {
    original_query: "bodeschutzmatte",
    total_searches: 4,
  },
  {
    original_query: "planzenwand",
    total_searches: 4,
  },
  {
    original_query: "Sonnensegek",
    total_searches: 4,
  },
  {
    original_query: "silikonmatte",
    total_searches: 4,
  },
  {
    original_query: "Premi",
    total_searches: 4,
  },
  {
    original_query: "Treppensc",
    total_searches: 4,
  },
  {
    original_query: "gummip",
    total_searches: 4,
  },
  {
    original_query: "doppell",
    total_searches: 4,
  },
  {
    original_query: "gummifu",
    total_searches: 4,
  },
  {
    original_query: "wasserdurch",
    total_searches: 4,
  },
  {
    original_query: "vorl",
    total_searches: 4,
  },
  {
    original_query: "spruhkleber",
    total_searches: 4,
  },
  {
    original_query: "trittsc",
    total_searches: 4,
  },
  {
    original_query: "rhne",
    total_searches: 4,
  },
  {
    original_query: "nadelfilzteppic",
    total_searches: 4,
  },
  {
    original_query: "lieferzei",
    total_searches: 4,
  },
  {
    original_query: "eiche",
    total_searches: 4,
  },
  {
    original_query: "abdeckpls",
    total_searches: 4,
  },
  {
    original_query: "Boxwood",
    total_searches: 4,
  },
  {
    original_query: "Winds",
    total_searches: 4,
  },
  {
    original_query: "Fussabtreter",
    total_searches: 4,
  },
  {
    original_query: "Noppenb",
    total_searches: 4,
  },
  {
    original_query: "Octagon",
    total_searches: 4,
  },
  {
    original_query: "holzabdeckplan",
    total_searches: 4,
  },
  {
    original_query: "würfelregal",
    total_searches: 4,
  },
  {
    original_query: "schilfr",
    total_searches: 4,
  },
  {
    original_query: "stufenmazte",
    total_searches: 4,
  },
  {
    original_query: "Korkrolle",
    total_searches: 4,
  },
  {
    original_query: "weidematte",
    total_searches: 4,
  },
  {
    original_query: "silo",
    total_searches: 4,
  },
  {
    original_query: "Rasw",
    total_searches: 4,
  },
  {
    original_query: "door",
    total_searches: 4,
  },
  {
    original_query: "floortex",
    total_searches: 4,
  },
  {
    original_query: "Schreibt",
    total_searches: 4,
  },
  {
    original_query: "einteilig",
    total_searches: 4,
  },
  {
    original_query: "Teic",
    total_searches: 4,
  },
  {
    original_query: "Supe",
    total_searches: 4,
  },
  {
    original_query: "spek",
    total_searches: 4,
  },
  {
    original_query: "plastik",
    total_searches: 4,
  },
  {
    original_query: "ökotex",
    total_searches: 4,
  },
  {
    original_query: "Pietvoss",
    total_searches: 4,
  },
  {
    original_query: "kinderspiel",
    total_searches: 4,
  },
  {
    original_query: "eckpr",
    total_searches: 4,
  },
  {
    original_query: "toom",
    total_searches: 4,
  },
  {
    original_query: "Möbe",
    total_searches: 4,
  },
  {
    original_query: "Rundte",
    total_searches: 4,
  },
  {
    original_query: "bafe",
    total_searches: 4,
  },
  {
    original_query: "wildza",
    total_searches: 4,
  },
  {
    original_query: "Fussboden",
    total_searches: 4,
  },
  {
    original_query: "rattan",
    total_searches: 4,
  },
  {
    original_query: "Gummigranula",
    total_searches: 4,
  },
  {
    original_query: "sosal",
    total_searches: 4,
  },
  {
    original_query: "Klappr",
    total_searches: 4,
  },
  {
    original_query: "sonj",
    total_searches: 4,
  },
  {
    original_query: "rassent",
    total_searches: 4,
  },
  {
    original_query: "Kratzbrett",
    total_searches: 4,
  },
  {
    original_query: "milch",
    total_searches: 4,
  },
  {
    original_query: "Schrei",
    total_searches: 4,
  },
  {
    original_query: "saunamatten",
    total_searches: 4,
  },
  {
    original_query: "ives",
    total_searches: 4,
  },
  {
    original_query: "fliesenprofi",
    total_searches: 4,
  },
  {
    original_query: "Schnutzfan",
    total_searches: 4,
  },
  {
    original_query: "antirutschte",
    total_searches: 4,
  },
  {
    original_query: "hamat",
    total_searches: 4,
  },
  {
    original_query: "flurteppisch",
    total_searches: 4,
  },
  {
    original_query: "rasenfliese",
    total_searches: 4,
  },
  {
    original_query: "erdanke",
    total_searches: 4,
  },
  {
    original_query: "anri",
    total_searches: 4,
  },
  {
    original_query: "Fracht",
    total_searches: 4,
  },
  {
    original_query: "Schmutzfangmazte",
    total_searches: 4,
  },
  {
    original_query: "Schil",
    total_searches: 4,
  },
  {
    original_query: "geschirr",
    total_searches: 4,
  },
  {
    original_query: "Duschvo",
    total_searches: 4,
  },
  {
    original_query: "Breit",
    total_searches: 4,
  },
  {
    original_query: "Lichtscha",
    total_searches: 4,
  },
  {
    original_query: "Fußabs",
    total_searches: 4,
  },
  {
    original_query: "vorratsdose",
    total_searches: 4,
  },
  {
    original_query: "rheine",
    total_searches: 4,
  },
  {
    original_query: "flaschenkast",
    total_searches: 4,
  },
  {
    original_query: "Gitterre",
    total_searches: 4,
  },
  {
    original_query: "pola",
    total_searches: 4,
  },
  {
    original_query: "gastronomie",
    total_searches: 4,
  },
  {
    original_query: "pberga",
    total_searches: 4,
  },
  {
    original_query: "Windsch",
    total_searches: 4,
  },
  {
    original_query: "Premium",
    total_searches: 4,
  },
  {
    original_query: "Sicherheitsma",
    total_searches: 4,
  },
  {
    original_query: "kunstko",
    total_searches: 4,
  },
  {
    original_query: "wandhalterung",
    total_searches: 4,
  },
  {
    original_query: "arbeitsplatz",
    total_searches: 4,
  },
  {
    original_query: "Rasenteppicg",
    total_searches: 4,
  },
  {
    original_query: "sonnes",
    total_searches: 4,
  },
  {
    original_query: "schreibtisc",
    total_searches: 4,
  },
  {
    original_query: "Vale",
    total_searches: 4,
  },
  {
    original_query: "gewächshausplatten",
    total_searches: 4,
  },
  {
    original_query: "Kundtras",
    total_searches: 4,
  },
  {
    original_query: "schilfro",
    total_searches: 4,
  },
  {
    original_query: "yoga",
    total_searches: 4,
  },
  {
    original_query: "Farbwunde",
    total_searches: 4,
  },
  {
    original_query: "senkrecht",
    total_searches: 4,
  },
  {
    original_query: "Fussabtre",
    total_searches: 4,
  },
  {
    original_query: "glassboard",
    total_searches: 4,
  },
  {
    original_query: "schmutzfanga",
    total_searches: 4,
  },
  {
    original_query: "KUNSTRASE",
    total_searches: 4,
  },
  {
    original_query: "Türmatte",
    total_searches: 4,
  },
  {
    original_query: "trofast",
    total_searches: 4,
  },
  {
    original_query: "scher",
    total_searches: 4,
  },
  {
    original_query: "läufr",
    total_searches: 4,
  },
  {
    original_query: "Magnett",
    total_searches: 4,
  },
  {
    original_query: "unterla",
    total_searches: 4,
  },
  {
    original_query: "basil",
    total_searches: 4,
  },
  {
    original_query: "klammer",
    total_searches: 4,
  },
  {
    original_query: "terasenflie",
    total_searches: 4,
  },
  {
    original_query: "Akzen",
    total_searches: 4,
  },
  {
    original_query: "Terassenfliesen",
    total_searches: 4,
  },
  {
    original_query: "wachstu",
    total_searches: 4,
  },
  {
    original_query: "windnetz",
    total_searches: 4,
  },
  {
    original_query: "doppelstabmattenzaun",
    total_searches: 4,
  },
  {
    original_query: "madra",
    total_searches: 4,
  },
  {
    original_query: "sonnesege",
    total_searches: 4,
  },
  {
    original_query: "raseng",
    total_searches: 4,
  },
  {
    original_query: "magbet",
    total_searches: 4,
  },
  {
    original_query: "kuchenregal",
    total_searches: 4,
  },
  {
    original_query: "Arbe",
    total_searches: 4,
  },
  {
    original_query: "muste",
    total_searches: 4,
  },
  {
    original_query: "kett",
    total_searches: 4,
  },
  {
    original_query: "jimmy",
    total_searches: 4,
  },
  {
    original_query: "kantenleisten",
    total_searches: 4,
  },
  {
    original_query: "schalldämmung",
    total_searches: 4,
  },
  {
    original_query: "Sisalopt",
    total_searches: 4,
  },
  {
    original_query: "Rasentw",
    total_searches: 4,
  },
  {
    original_query: "Büros",
    total_searches: 4,
  },
  {
    original_query: "Mala",
    total_searches: 4,
  },
  {
    original_query: "vorgebohrt",
    total_searches: 4,
  },
  {
    original_query: "garantie",
    total_searches: 4,
  },
  {
    original_query: "antirutschunterlage",
    total_searches: 4,
  },
  {
    original_query: "paddo",
    total_searches: 4,
  },
  {
    original_query: "kokosn",
    total_searches: 4,
  },
  {
    original_query: "gewächshausklammern",
    total_searches: 4,
  },
  {
    original_query: "kabelbinde",
    total_searches: 4,
  },
  {
    original_query: "bray",
    total_searches: 4,
  },
  {
    original_query: "lärms",
    total_searches: 4,
  },
  {
    original_query: "schwehrlastregal",
    total_searches: 4,
  },
  {
    original_query: "teppichunterlag",
    total_searches: 4,
  },
  {
    original_query: "Rass",
    total_searches: 4,
  },
  {
    original_query: "fussabstre",
    total_searches: 4,
  },
  {
    original_query: "antirutschteppich",
    total_searches: 4,
  },
  {
    original_query: "grillma",
    total_searches: 4,
  },
  {
    original_query: "lichts",
    total_searches: 4,
  },
  {
    original_query: "pinnwan",
    total_searches: 4,
  },
  {
    original_query: "wachs",
    total_searches: 4,
  },
  {
    original_query: "Stuff",
    total_searches: 4,
  },
  {
    original_query: "gummiwabenma",
    total_searches: 4,
  },
  {
    original_query: "sisalma",
    total_searches: 4,
  },
  {
    original_query: "tapis",
    total_searches: 4,
  },
  {
    original_query: "Treppenstufenabschlußprofil",
    total_searches: 4,
  },
  {
    original_query: "Sichtschutzroll",
    total_searches: 4,
  },
  {
    original_query: "lenolium",
    total_searches: 4,
  },
  {
    original_query: "heimwerkerv",
    total_searches: 4,
  },
  {
    original_query: "schuha",
    total_searches: 4,
  },
  {
    original_query: "Holzfli",
    total_searches: 4,
  },
  {
    original_query: "Moscow",
    total_searches: 4,
  },
  {
    original_query: "unterlegma",
    total_searches: 4,
  },
  {
    original_query: "automa",
    total_searches: 4,
  },
  {
    original_query: "schmal",
    total_searches: 4,
  },
  {
    original_query: "glass",
    total_searches: 4,
  },
  {
    original_query: "univ",
    total_searches: 4,
  },
  {
    original_query: "zaum",
    total_searches: 4,
  },
  {
    original_query: "interg",
    total_searches: 4,
  },
  {
    original_query: "Kaur",
    total_searches: 4,
  },
  {
    original_query: "stretchfi",
    total_searches: 4,
  },
  {
    original_query: "sonense",
    total_searches: 4,
  },
  {
    original_query: "hang",
    total_searches: 4,
  },
  {
    original_query: "eckprofi",
    total_searches: 4,
  },
  {
    original_query: "daylig",
    total_searches: 4,
  },
  {
    original_query: "velourt",
    total_searches: 4,
  },
  {
    original_query: "flurteppiche",
    total_searches: 4,
  },
  {
    original_query: "Outdoorläu",
    total_searches: 4,
  },
  {
    original_query: "schutzhüllen",
    total_searches: 4,
  },
  {
    original_query: "Gewächshau",
    total_searches: 4,
  },
  {
    original_query: "hanf",
    total_searches: 4,
  },
  {
    original_query: "Mosc",
    total_searches: 4,
  },
  {
    original_query: "katzenschut",
    total_searches: 4,
  },
  {
    original_query: "Spag",
    total_searches: 4,
  },
  {
    original_query: "paddockmatten",
    total_searches: 4,
  },
  {
    original_query: "Zaunsi",
    total_searches: 4,
  },
  {
    original_query: "Zaunsicht",
    total_searches: 4,
  },
  {
    original_query: "wandspi",
    total_searches: 4,
  },
  {
    original_query: "Steck",
    total_searches: 4,
  },
  {
    original_query: "kugelgarn",
    total_searches: 4,
  },
  {
    original_query: "spiege",
    total_searches: 4,
  },
  {
    original_query: "Palermo",
    total_searches: 4,
  },
  {
    original_query: "edelst",
    total_searches: 4,
  },
  {
    original_query: "Outdoorl",
    total_searches: 4,
  },
  {
    original_query: "flaschenkaste",
    total_searches: 4,
  },
  {
    original_query: "Holza",
    total_searches: 4,
  },
  {
    original_query: "Paddo",
    total_searches: 4,
  },
  {
    original_query: "akustikfilz",
    total_searches: 4,
  },
  {
    original_query: "schmutzte",
    total_searches: 4,
  },
  {
    original_query: "Monoch",
    total_searches: 4,
  },
  {
    original_query: "mina",
    total_searches: 4,
  },
  {
    original_query: "mumb",
    total_searches: 4,
  },
  {
    original_query: "wandf",
    total_searches: 4,
  },
  {
    original_query: "bambussich",
    total_searches: 4,
  },
  {
    original_query: "getränkek",
    total_searches: 4,
  },
  {
    original_query: "hochzeitsteppich",
    total_searches: 4,
  },
  {
    original_query: "Sichschut",
    total_searches: 4,
  },
  {
    original_query: "salonlöwe",
    total_searches: 4,
  },
  {
    original_query: "puzzlematte",
    total_searches: 4,
  },
  {
    original_query: "kokoserde",
    total_searches: 4,
  },
  {
    original_query: "cheops",
    total_searches: 4,
  },
  {
    original_query: "Garagenbode",
    total_searches: 4,
  },
  {
    original_query: "überha",
    total_searches: 4,
  },
  {
    original_query: "Hohlkammerpla",
    total_searches: 4,
  },
  {
    original_query: "Kunstrs",
    total_searches: 4,
  },
  {
    original_query: "Hochflort",
    total_searches: 4,
  },
  {
    original_query: "fussbod",
    total_searches: 4,
  },
  {
    original_query: "überganga",
    total_searches: 4,
  },
  {
    original_query: "rollenmodell",
    total_searches: 4,
  },
  {
    original_query: "läfe",
    total_searches: 4,
  },
  {
    original_query: "dalt",
    total_searches: 4,
  },
  {
    original_query: "Feuerscha",
    total_searches: 4,
  },
  {
    original_query: "flilz",
    total_searches: 4,
  },
  {
    original_query: "bodenachutz",
    total_searches: 4,
  },
  {
    original_query: "strech",
    total_searches: 4,
  },
  {
    original_query: "schuhparkplatz",
    total_searches: 4,
  },
  {
    original_query: "Campi",
    total_searches: 4,
  },
  {
    original_query: "Rollho",
    total_searches: 4,
  },
  {
    original_query: "mäusegi",
    total_searches: 4,
  },
  {
    original_query: "ermüdungsmatten",
    total_searches: 4,
  },
  {
    original_query: "Teppichrasen",
    total_searches: 4,
  },
  {
    original_query: "dunkelgrau",
    total_searches: 4,
  },
  {
    original_query: "ratten",
    total_searches: 4,
  },
  {
    original_query: "kuscheldecken",
    total_searches: 4,
  },
  {
    original_query: "Stake",
    total_searches: 4,
  },
  {
    original_query: "Maschend",
    total_searches: 4,
  },
  {
    original_query: "sichtschutu",
    total_searches: 4,
  },
  {
    original_query: "Stange",
    total_searches: 4,
  },
  {
    original_query: "fulz",
    total_searches: 4,
  },
  {
    original_query: "Kurzflor",
    total_searches: 4,
  },
  {
    original_query: "Rasentepic",
    total_searches: 4,
  },
  {
    original_query: "strand",
    total_searches: 4,
  },
  {
    original_query: "kratzen",
    total_searches: 4,
  },
  {
    original_query: "bambo",
    total_searches: 4,
  },
  {
    original_query: "schlagschutz",
    total_searches: 4,
  },
  {
    original_query: "Outdoorteppuch",
    total_searches: 4,
  },
  {
    original_query: "dreiec",
    total_searches: 4,
  },
  {
    original_query: "bodenteppich",
    total_searches: 4,
  },
  {
    original_query: "Garagenboden",
    total_searches: 4,
  },
  {
    original_query: "daisie",
    total_searches: 4,
  },
  {
    original_query: "Elite",
    total_searches: 4,
  },
  {
    original_query: "filzta",
    total_searches: 4,
  },
  {
    original_query: "Sichtschutzstrei",
    total_searches: 4,
  },
  {
    original_query: "Fliegengitt",
    total_searches: 4,
  },
  {
    original_query: "Selbstkleben",
    total_searches: 4,
  },
  {
    original_query: "teppicg",
    total_searches: 4,
  },
  {
    original_query: "louis",
    total_searches: 4,
  },
  {
    original_query: "dursch",
    total_searches: 4,
  },
  {
    original_query: "siya",
    total_searches: 4,
  },
  {
    original_query: "dachplane",
    total_searches: 4,
  },
  {
    original_query: "cycas",
    total_searches: 4,
  },
  {
    original_query: "polyst",
    total_searches: 4,
  },
  {
    original_query: "laurel",
    total_searches: 4,
  },
  {
    original_query: "wagen",
    total_searches: 4,
  },
  {
    original_query: "Unkrautvli",
    total_searches: 4,
  },
  {
    original_query: "quadratisch",
    total_searches: 4,
  },
  {
    original_query: "celesta",
    total_searches: 4,
  },
  {
    original_query: "schmutzfsn",
    total_searches: 4,
  },
  {
    original_query: "kunstrasem",
    total_searches: 4,
  },
  {
    original_query: "flec",
    total_searches: 4,
  },
  {
    original_query: "Bodenschutzmat",
    total_searches: 4,
  },
  {
    original_query: "steckr",
    total_searches: 4,
  },
  {
    original_query: "Schmit",
    total_searches: 4,
  },
  {
    original_query: "Volierendra",
    total_searches: 4,
  },
  {
    original_query: "sechseck",
    total_searches: 4,
  },
  {
    original_query: "Wachst",
    total_searches: 4,
  },
  {
    original_query: "Terrassenteppi",
    total_searches: 4,
  },
  {
    original_query: "Antirutschs",
    total_searches: 4,
  },
  {
    original_query: "Klapp",
    total_searches: 4,
  },
  {
    original_query: "gartens",
    total_searches: 4,
  },
  {
    original_query: "outdoorteppuch",
    total_searches: 4,
  },
  {
    original_query: "galwa",
    total_searches: 4,
  },
  {
    original_query: "eckrega",
    total_searches: 4,
  },
  {
    original_query: "sprühen",
    total_searches: 4,
  },
  {
    original_query: "stahlsei",
    total_searches: 4,
  },
  {
    original_query: "teppichrase",
    total_searches: 4,
  },
  {
    original_query: "vollgummi",
    total_searches: 4,
  },
  {
    original_query: "teppichkanten",
    total_searches: 4,
  },
  {
    original_query: "Riverbay",
    total_searches: 4,
  },
  {
    original_query: "Rindenm",
    total_searches: 4,
  },
  {
    original_query: "neod",
    total_searches: 4,
  },
  {
    original_query: "Messeteppich",
    total_searches: 4,
  },
  {
    original_query: "stufenleisten",
    total_searches: 4,
  },
  {
    original_query: "KUNSTRAS",
    total_searches: 4,
  },
  {
    original_query: "flaschenkastenstä",
    total_searches: 4,
  },
  {
    original_query: "pine",
    total_searches: 4,
  },
  {
    original_query: "Vinylteppi",
    total_searches: 4,
  },
  {
    original_query: "Gewächsh",
    total_searches: 4,
  },
  {
    original_query: "leit",
    total_searches: 4,
  },
  {
    original_query: "verdunklungsrollos",
    total_searches: 4,
  },
  {
    original_query: "feuerfeste",
    total_searches: 4,
  },
  {
    original_query: "Andeckplane",
    total_searches: 4,
  },
  {
    original_query: "Luca",
    total_searches: 4,
  },
  {
    original_query: "stol",
    total_searches: 4,
  },
  {
    original_query: "Rückga",
    total_searches: 4,
  },
  {
    original_query: "sili",
    total_searches: 4,
  },
  {
    original_query: "Teppichs",
    total_searches: 4,
  },
  {
    original_query: "tasent",
    total_searches: 4,
  },
  {
    original_query: "fußbodenleiste",
    total_searches: 4,
  },
  {
    original_query: "vorr",
    total_searches: 4,
  },
  {
    original_query: "vibra",
    total_searches: 4,
  },
  {
    original_query: "fleckerl",
    total_searches: 4,
  },
  {
    original_query: "außenbereich",
    total_searches: 4,
  },
  {
    original_query: "fussabt",
    total_searches: 4,
  },
  {
    original_query: "bausc",
    total_searches: 4,
  },
  {
    original_query: "teppci",
    total_searches: 4,
  },
  {
    original_query: "treppenstufenteppich",
    total_searches: 4,
  },
  {
    original_query: "Bambustepp",
    total_searches: 4,
  },
  {
    original_query: "pbergang",
    total_searches: 4,
  },
  {
    original_query: "schmutzfagmatte",
    total_searches: 4,
  },
  {
    original_query: "Atlanta",
    total_searches: 4,
  },
  {
    original_query: "univer",
    total_searches: 4,
  },
  {
    original_query: "Spring",
    total_searches: 4,
  },
  {
    original_query: "Siss",
    total_searches: 4,
  },
  {
    original_query: "venylboden",
    total_searches: 4,
  },
  {
    original_query: "eckpro",
    total_searches: 4,
  },
  {
    original_query: "grillmat",
    total_searches: 4,
  },
  {
    original_query: "staubsauger",
    total_searches: 4,
  },
  {
    original_query: "Jalousi",
    total_searches: 4,
  },
  {
    original_query: "panam",
    total_searches: 4,
  },
  {
    original_query: "bodenmarkierung",
    total_searches: 4,
  },
  {
    original_query: "filzrolle",
    total_searches: 4,
  },
  {
    original_query: "Verdu",
    total_searches: 4,
  },
  {
    original_query: "stretchf",
    total_searches: 4,
  },
  {
    original_query: "bambussichts",
    total_searches: 4,
  },
  {
    original_query: "klammern",
    total_searches: 4,
  },
  {
    original_query: "Möbel",
    total_searches: 4,
  },
  {
    original_query: "Schauka",
    total_searches: 4,
  },
  {
    original_query: "Bambzs",
    total_searches: 4,
  },
  {
    original_query: "marig",
    total_searches: 4,
  },
  {
    original_query: "rasemteppich",
    total_searches: 4,
  },
  {
    original_query: "pure",
    total_searches: 4,
  },
  {
    original_query: "abdeckhaube",
    total_searches: 4,
  },
  {
    original_query: "Kettel",
    total_searches: 4,
  },
  {
    original_query: "zaunp",
    total_searches: 4,
  },
  {
    original_query: "wohnzimmerteppi",
    total_searches: 4,
  },
  {
    original_query: "weise",
    total_searches: 4,
  },
  {
    original_query: "schnutzfan",
    total_searches: 4,
  },
  {
    original_query: "Holzfliese",
    total_searches: 4,
  },
  {
    original_query: "tere",
    total_searches: 4,
  },
  {
    original_query: "dartmatte",
    total_searches: 4,
  },
  {
    original_query: "fliesenteppich",
    total_searches: 4,
  },
  {
    original_query: "klett",
    total_searches: 4,
  },
  {
    original_query: "Schnutzfangm",
    total_searches: 4,
  },
  {
    original_query: "schitz",
    total_searches: 4,
  },
  {
    original_query: "elegan",
    total_searches: 4,
  },
  {
    original_query: "markiese",
    total_searches: 4,
  },
  {
    original_query: "schmutzfangteppiche",
    total_searches: 4,
  },
  {
    original_query: "grillabdeck",
    total_searches: 4,
  },
  {
    original_query: "stallbode",
    total_searches: 4,
  },
  {
    original_query: "kunstpflanzen",
    total_searches: 4,
  },
  {
    original_query: "katzenkratzmatte",
    total_searches: 4,
  },
  {
    original_query: "hellbeige",
    total_searches: 4,
  },
  {
    original_query: "korkma",
    total_searches: 4,
  },
  {
    original_query: "gartenbank",
    total_searches: 4,
  },
  {
    original_query: "Stec",
    total_searches: 4,
  },
  {
    original_query: "Andeck",
    total_searches: 4,
  },
  {
    original_query: "wohnzimme",
    total_searches: 4,
  },
  {
    original_query: "duschv",
    total_searches: 4,
  },
  {
    original_query: "garderobens",
    total_searches: 4,
  },
  {
    original_query: "dyny",
    total_searches: 4,
  },
  {
    original_query: "Teppichkl",
    total_searches: 4,
  },
  {
    original_query: "mumbai",
    total_searches: 4,
  },
  {
    original_query: "pinnnadeln",
    total_searches: 4,
  },
  {
    original_query: "schuhabs",
    total_searches: 4,
  },
  {
    original_query: "Mode",
    total_searches: 4,
  },
  {
    original_query: "plann",
    total_searches: 4,
  },
  {
    original_query: "boni",
    total_searches: 4,
  },
  {
    original_query: "dunkelbraun",
    total_searches: 4,
  },
  {
    original_query: "gang",
    total_searches: 4,
  },
  {
    original_query: "Radenteppi",
    total_searches: 4,
  },
  {
    original_query: "monochron",
    total_searches: 4,
  },
  {
    original_query: "Stufenpro",
    total_searches: 4,
  },
  {
    original_query: "fussabtr",
    total_searches: 4,
  },
  {
    original_query: "teppischläufer",
    total_searches: 4,
  },
  {
    original_query: "einl",
    total_searches: 4,
  },
  {
    original_query: "kundenstoppe",
    total_searches: 4,
  },
  {
    original_query: "Korkkleb",
    total_searches: 4,
  },
  {
    original_query: "Schmutzfangtep",
    total_searches: 4,
  },
  {
    original_query: "Outdoorlä",
    total_searches: 4,
  },
  {
    original_query: "moskow",
    total_searches: 4,
  },
  {
    original_query: "schlingmatt",
    total_searches: 4,
  },
  {
    original_query: "Schaf",
    total_searches: 4,
  },
  {
    original_query: "klickl",
    total_searches: 4,
  },
  {
    original_query: "Drahtgitte",
    total_searches: 4,
  },
  {
    original_query: "Fussabt",
    total_searches: 4,
  },
  {
    original_query: "klebst",
    total_searches: 4,
  },
  {
    original_query: "venez",
    total_searches: 4,
  },
  {
    original_query: "Stabilisierung",
    total_searches: 4,
  },
  {
    original_query: "übergans",
    total_searches: 4,
  },
  {
    original_query: "strei",
    total_searches: 4,
  },
  {
    original_query: "tapete",
    total_searches: 4,
  },
  {
    original_query: "lyan",
    total_searches: 4,
  },
  {
    original_query: "Pavillon",
    total_searches: 4,
  },
  {
    original_query: "feuerschu",
    total_searches: 4,
  },
  {
    original_query: "schattiernetz",
    total_searches: 4,
  },
  {
    original_query: "Treppenstufenma",
    total_searches: 4,
  },
  {
    original_query: "pass",
    total_searches: 4,
  },
  {
    original_query: "Schwarz",
    total_searches: 4,
  },
  {
    original_query: "schmutt",
    total_searches: 4,
  },
  {
    original_query: "heidi",
    total_searches: 4,
  },
  {
    original_query: "fliegengit",
    total_searches: 4,
  },
  {
    original_query: "schwerlasteckregal",
    total_searches: 4,
  },
  {
    original_query: "sxhmutz",
    total_searches: 4,
  },
  {
    original_query: "Sche",
    total_searches: 4,
  },
  {
    original_query: "stife",
    total_searches: 4,
  },
  {
    original_query: "Bauzaun",
    total_searches: 4,
  },
  {
    original_query: "Magnettafel",
    total_searches: 4,
  },
  {
    original_query: "dall",
    total_searches: 4,
  },
  {
    original_query: "sauberlaufteppi",
    total_searches: 4,
  },
  {
    original_query: "poolrun",
    total_searches: 4,
  },
  {
    original_query: "gitterma",
    total_searches: 4,
  },
  {
    original_query: "nahtklebeband",
    total_searches: 4,
  },
  {
    original_query: "treppenmat",
    total_searches: 4,
  },
  {
    original_query: "hasendra",
    total_searches: 4,
  },
  {
    original_query: "Hochflorteppich",
    total_searches: 4,
  },
  {
    original_query: "glasbo",
    total_searches: 4,
  },
  {
    original_query: "Tomate",
    total_searches: 4,
  },
  {
    original_query: "edels",
    total_searches: 4,
  },
  {
    original_query: "nadelfiz",
    total_searches: 4,
  },
  {
    original_query: "Dicht",
    total_searches: 4,
  },
  {
    original_query: "Wohnw",
    total_searches: 4,
  },
  {
    original_query: "kunststoffmatte",
    total_searches: 4,
  },
  {
    original_query: "fensterfol",
    total_searches: 4,
  },
  {
    original_query: "Classi",
    total_searches: 4,
  },
  {
    original_query: "schmutufang",
    total_searches: 4,
  },
  {
    original_query: "Glory",
    total_searches: 4,
  },
  {
    original_query: "übergangsschien",
    total_searches: 4,
  },
  {
    original_query: "filzf",
    total_searches: 4,
  },
  {
    original_query: "sichtschtz",
    total_searches: 4,
  },
  {
    original_query: "whiteboardmarker",
    total_searches: 4,
  },
  {
    original_query: "azure",
    total_searches: 4,
  },
  {
    original_query: "Rollkork",
    total_searches: 4,
  },
  {
    original_query: "silofolie",
    total_searches: 4,
  },
  {
    original_query: "durchsichtige",
    total_searches: 4,
  },
  {
    original_query: "Flor",
    total_searches: 4,
  },
  {
    original_query: "magnetlei",
    total_searches: 4,
  },
  {
    original_query: "Terasenf",
    total_searches: 4,
  },
  {
    original_query: "Schaukast",
    total_searches: 4,
  },
  {
    original_query: "koek",
    total_searches: 4,
  },
  {
    original_query: "xtre",
    total_searches: 4,
  },
  {
    original_query: "Rasentwpp",
    total_searches: 4,
  },
  {
    original_query: "mara",
    total_searches: 4,
  },
  {
    original_query: "korkteppich",
    total_searches: 4,
  },
  {
    original_query: "türschiene",
    total_searches: 4,
  },
  {
    original_query: "übergangsprifil",
    total_searches: 4,
  },
  {
    original_query: "brief",
    total_searches: 4,
  },
  {
    original_query: "venezi",
    total_searches: 4,
  },
  {
    original_query: "Rollh",
    total_searches: 4,
  },
  {
    original_query: "Heidekr",
    total_searches: 4,
  },
  {
    original_query: "Honk",
    total_searches: 4,
  },
  {
    original_query: "wili",
    total_searches: 4,
  },
  {
    original_query: "Vibr",
    total_searches: 4,
  },
  {
    original_query: "Eingangsm",
    total_searches: 4,
  },
  {
    original_query: "piran",
    total_searches: 4,
  },
  {
    original_query: "bindedr",
    total_searches: 4,
  },
  {
    original_query: "terrasenfliese",
    total_searches: 4,
  },
  {
    original_query: "verzink",
    total_searches: 4,
  },
  {
    original_query: "Kinde",
    total_searches: 4,
  },
  {
    original_query: "weidem",
    total_searches: 4,
  },
  {
    original_query: "bodenleis",
    total_searches: 4,
  },
  {
    original_query: "Bast",
    total_searches: 4,
  },
  {
    original_query: "pinnadel",
    total_searches: 4,
  },
  {
    original_query: "getrank",
    total_searches: 4,
  },
  {
    original_query: "teläufer",
    total_searches: 4,
  },
  {
    original_query: "Holzmatte",
    total_searches: 4,
  },
  {
    original_query: "feuchtraum",
    total_searches: 4,
  },
  {
    original_query: "Dublin",
    total_searches: 4,
  },
  {
    original_query: "expoto",
    total_searches: 4,
  },
  {
    original_query: "stornieren",
    total_searches: 4,
  },
  {
    original_query: "hygienema",
    total_searches: 4,
  },
  {
    original_query: "grillab",
    total_searches: 4,
  },
  {
    original_query: "maschendrahtza",
    total_searches: 4,
  },
  {
    original_query: "matratze",
    total_searches: 4,
  },
  {
    original_query: "hochl",
    total_searches: 4,
  },
  {
    original_query: "Wand",
    total_searches: 4,
  },
  {
    original_query: "einlage",
    total_searches: 4,
  },
  {
    original_query: "teppichlae",
    total_searches: 4,
  },
  {
    original_query: "deke",
    total_searches: 4,
  },
  {
    original_query: "westwood",
    total_searches: 4,
  },
  {
    original_query: "streifen",
    total_searches: 4,
  },
  {
    original_query: "plexigl",
    total_searches: 4,
  },
  {
    original_query: "abschlussprofi",
    total_searches: 4,
  },
  {
    original_query: "küchenteppiche",
    total_searches: 4,
  },
  {
    original_query: "messetepich",
    total_searches: 4,
  },
  {
    original_query: "rollenware",
    total_searches: 4,
  },
  {
    original_query: "trennwände",
    total_searches: 4,
  },
  {
    original_query: "Windschutz",
    total_searches: 4,
  },
  {
    original_query: "tennis",
    total_searches: 4,
  },
  {
    original_query: "nadelfo",
    total_searches: 4,
  },
  {
    original_query: "dichtungsband",
    total_searches: 4,
  },
  {
    original_query: "Sichtschutzs",
    total_searches: 4,
  },
  {
    original_query: "Mobi",
    total_searches: 4,
  },
  {
    original_query: "Lamin",
    total_searches: 4,
  },
  {
    original_query: "Bambussi",
    total_searches: 4,
  },
  {
    original_query: "läufwe",
    total_searches: 4,
  },
  {
    original_query: "jutesei",
    total_searches: 4,
  },
  {
    original_query: "schurwollteppich",
    total_searches: 4,
  },
  {
    original_query: "Oval",
    total_searches: 4,
  },
  {
    original_query: "fallschutzm",
    total_searches: 4,
  },
  {
    original_query: "ösenzange",
    total_searches: 4,
  },
  {
    original_query: "KUNSTR",
    total_searches: 4,
  },
  {
    original_query: "eleganc",
    total_searches: 4,
  },
  {
    original_query: "blumentopf",
    total_searches: 4,
  },
  {
    original_query: "hellkork",
    total_searches: 4,
  },
  {
    original_query: "Kunsr",
    total_searches: 4,
  },
  {
    original_query: "trittstufe",
    total_searches: 4,
  },
  {
    original_query: "Weichso",
    total_searches: 4,
  },
  {
    original_query: "vibrat",
    total_searches: 4,
  },
  {
    original_query: "Stegp",
    total_searches: 4,
  },
  {
    original_query: "zmat",
    total_searches: 4,
  },
  {
    original_query: "duschvorhangstange",
    total_searches: 4,
  },
  {
    original_query: "grillage",
    total_searches: 4,
  },
  {
    original_query: "fussleis",
    total_searches: 4,
  },
  {
    original_query: "bodenschuty",
    total_searches: 4,
  },
  {
    original_query: "hygie",
    total_searches: 4,
  },
  {
    original_query: "planenspa",
    total_searches: 4,
  },
  {
    original_query: "schmutzfangmattt",
    total_searches: 4,
  },
  {
    original_query: "west",
    total_searches: 4,
  },
  {
    original_query: "drahtzau",
    total_searches: 4,
  },
  {
    original_query: "Treppenprofi",
    total_searches: 4,
  },
  {
    original_query: "kustrase",
    total_searches: 4,
  },
  {
    original_query: "gull",
    total_searches: 4,
  },
  {
    original_query: "rundtepp",
    total_searches: 4,
  },
  {
    original_query: "organi",
    total_searches: 4,
  },
  {
    original_query: "Grillschut",
    total_searches: 4,
  },
  {
    original_query: "vibr",
    total_searches: 4,
  },
  {
    original_query: "garag",
    total_searches: 4,
  },
  {
    original_query: "fussball",
    total_searches: 4,
  },
  {
    original_query: "tanzboden",
    total_searches: 4,
  },
  {
    original_query: "vogelnetz",
    total_searches: 4,
  },
  {
    original_query: "mäusegitt",
    total_searches: 4,
  },
  {
    original_query: "schallschutzmatten",
    total_searches: 4,
  },
  {
    original_query: "scmutzfangmatte",
    total_searches: 4,
  },
  {
    original_query: "filzteppic",
    total_searches: 4,
  },
  {
    original_query: "Tirana",
    total_searches: 4,
  },
  {
    original_query: "Atlan",
    total_searches: 4,
  },
  {
    original_query: "riffelblech",
    total_searches: 4,
  },
  {
    original_query: "ringloch",
    total_searches: 4,
  },
  {
    original_query: "Schuha",
    total_searches: 4,
  },
  {
    original_query: "rasentete",
    total_searches: 4,
  },
  {
    original_query: "mülei",
    total_searches: 4,
  },
  {
    original_query: "Antirutschmatten",
    total_searches: 4,
  },
  {
    original_query: "Kuche",
    total_searches: 4,
  },
  {
    original_query: "Wühlmausgitt",
    total_searches: 4,
  },
  {
    original_query: "schnutzf",
    total_searches: 4,
  },
  {
    original_query: "bürote",
    total_searches: 4,
  },
  {
    original_query: "parke",
    total_searches: 4,
  },
  {
    original_query: "Antra",
    total_searches: 4,
  },
  {
    original_query: "nadelfilzteppi",
    total_searches: 4,
  },
  {
    original_query: "thom",
    total_searches: 4,
  },
  {
    original_query: "Fliesenprofil",
    total_searches: 4,
  },
  {
    original_query: "Garagenbod",
    total_searches: 4,
  },
  {
    original_query: "rote",
    total_searches: 4,
  },
  {
    original_query: "Gartenflies",
    total_searches: 4,
  },
  {
    original_query: "mass",
    total_searches: 4,
  },
  {
    original_query: "rasene",
    total_searches: 4,
  },
  {
    original_query: "filzb",
    total_searches: 4,
  },
  {
    original_query: "geill",
    total_searches: 4,
  },
  {
    original_query: "teppichbrücken",
    total_searches: 4,
  },
  {
    original_query: "leipz",
    total_searches: 4,
  },
  {
    original_query: "Treppenpr",
    total_searches: 4,
  },
  {
    original_query: "zeltt",
    total_searches: 4,
  },
  {
    original_query: "clas",
    total_searches: 4,
  },
  {
    original_query: "wachst",
    total_searches: 4,
  },
  {
    original_query: "relief",
    total_searches: 4,
  },
  {
    original_query: "holzpfosten",
    total_searches: 4,
  },
  {
    original_query: "Stuh",
    total_searches: 4,
  },
  {
    original_query: "Rasentrpp",
    total_searches: 4,
  },
  {
    original_query: "sirat",
    total_searches: 4,
  },
  {
    original_query: "wetter",
    total_searches: 4,
  },
  {
    original_query: "Stegplatte",
    total_searches: 4,
  },
  {
    original_query: "luna",
    total_searches: 4,
  },
  {
    original_query: "relax",
    total_searches: 4,
  },
  {
    original_query: "sichtschutzro",
    total_searches: 4,
  },
  {
    original_query: "edelsta",
    total_searches: 4,
  },
  {
    original_query: "nelson",
    total_searches: 4,
  },
  {
    original_query: "vinyltep",
    total_searches: 4,
  },
  {
    original_query: "teppichk",
    total_searches: 4,
  },
  {
    original_query: "Radentepp",
    total_searches: 4,
  },
  {
    original_query: "Granada",
    total_searches: 4,
  },
  {
    original_query: "boxw",
    total_searches: 4,
  },
  {
    original_query: "sauberlauftepp",
    total_searches: 4,
  },
  {
    original_query: "Lamina",
    total_searches: 4,
  },
  {
    original_query: "Zahl",
    total_searches: 4,
  },
  {
    original_query: "buche",
    total_searches: 4,
  },
  {
    original_query: "luftp",
    total_searches: 4,
  },
  {
    original_query: "Heidek",
    total_searches: 4,
  },
  {
    original_query: "voll",
    total_searches: 4,
  },
  {
    original_query: "Bodenma",
    total_searches: 4,
  },
  {
    original_query: "prim",
    total_searches: 4,
  },
  {
    original_query: "farbeunder",
    total_searches: 4,
  },
  {
    original_query: "sicherheitss",
    total_searches: 4,
  },
  {
    original_query: "Vorhan",
    total_searches: 4,
  },
  {
    original_query: "Sichsc",
    total_searches: 4,
  },
  {
    original_query: "tafelfoli",
    total_searches: 4,
  },
  {
    original_query: "Cuban",
    total_searches: 4,
  },
  {
    original_query: "Hohlkamm",
    total_searches: 4,
  },
  {
    original_query: "Auslege",
    total_searches: 4,
  },
  {
    original_query: "teppichr",
    total_searches: 4,
  },
  {
    original_query: "kunstf",
    total_searches: 4,
  },
  {
    original_query: "kuechenlaeufer",
    total_searches: 4,
  },
  {
    original_query: "übergansprofil",
    total_searches: 4,
  },
  {
    original_query: "unkrautvl",
    total_searches: 4,
  },
  {
    original_query: "anthrazi",
    total_searches: 4,
  },
  {
    original_query: "Kuchen",
    total_searches: 4,
  },
  {
    original_query: "Abschlussleiste",
    total_searches: 4,
  },
  {
    original_query: "zahlungsarten",
    total_searches: 4,
  },
  {
    original_query: "transportrollen",
    total_searches: 4,
  },
  {
    original_query: "hygene",
    total_searches: 4,
  },
  {
    original_query: "Weichsock",
    total_searches: 4,
  },
  {
    original_query: "trepe",
    total_searches: 4,
  },
  {
    original_query: "Inter",
    total_searches: 4,
  },
  {
    original_query: "sonnese",
    total_searches: 4,
  },
  {
    original_query: "sonnensega",
    total_searches: 4,
  },
  {
    original_query: "windschutzscheibe",
    total_searches: 4,
  },
  {
    original_query: "ausgleichprofil",
    total_searches: 4,
  },
  {
    original_query: "Premiu",
    total_searches: 4,
  },
  {
    original_query: "Übergangsleist",
    total_searches: 4,
  },
  {
    original_query: "schutzhül",
    total_searches: 4,
  },
  {
    original_query: "Volierendrah",
    total_searches: 4,
  },
  {
    original_query: "Sichtschutzstre",
    total_searches: 4,
  },
  {
    original_query: "zahl",
    total_searches: 4,
  },
  {
    original_query: "glitzer",
    total_searches: 4,
  },
  {
    original_query: "moderationst",
    total_searches: 4,
  },
  {
    original_query: "aussenteppi",
    total_searches: 4,
  },
  {
    original_query: "Caro",
    total_searches: 4,
  },
  {
    original_query: "sisalstufen",
    total_searches: 4,
  },
  {
    original_query: "batenschutz",
    total_searches: 4,
  },
  {
    original_query: "abdeckfo",
    total_searches: 4,
  },
  {
    original_query: "abdeckplann",
    total_searches: 4,
  },
  {
    original_query: "Hohlkammerp",
    total_searches: 4,
  },
  {
    original_query: "Lino",
    total_searches: 4,
  },
  {
    original_query: "wanda",
    total_searches: 4,
  },
  {
    original_query: "Befestigungssch",
    total_searches: 4,
  },
  {
    original_query: "whitebord",
    total_searches: 4,
  },
  {
    original_query: "tischschutzmatte",
    total_searches: 4,
  },
  {
    original_query: "KUNS",
    total_searches: 4,
  },
  {
    original_query: "Bambusteppi",
    total_searches: 4,
  },
  {
    original_query: "gardero",
    total_searches: 4,
  },
  {
    original_query: "lichtsch",
    total_searches: 4,
  },
  {
    original_query: "Sone",
    total_searches: 4,
  },
  {
    original_query: "kunstkoko",
    total_searches: 4,
  },
  {
    original_query: "auße",
    total_searches: 4,
  },
  {
    original_query: "termo",
    total_searches: 4,
  },
  {
    original_query: "sprinter",
    total_searches: 4,
  },
  {
    original_query: "rivera",
    total_searches: 4,
  },
  {
    original_query: "chios",
    total_searches: 4,
  },
  {
    original_query: "hasendrah",
    total_searches: 4,
  },
  {
    original_query: "Terassendie",
    total_searches: 4,
  },
  {
    original_query: "Mein",
    total_searches: 4,
  },
  {
    original_query: "kinderteppichgrun",
    total_searches: 4,
  },
  {
    original_query: "holzplatte",
    total_searches: 4,
  },
  {
    original_query: "badezim",
    total_searches: 4,
  },
  {
    original_query: "Terassendiel",
    total_searches: 4,
  },
  {
    original_query: "Bastel",
    total_searches: 4,
  },
  {
    original_query: "antiri",
    total_searches: 4,
  },
  {
    original_query: "zellkautschuk",
    total_searches: 4,
  },
  {
    original_query: "küchentisch",
    total_searches: 4,
  },
  {
    original_query: "übergangssc",
    total_searches: 4,
  },
  {
    original_query: "shag",
    total_searches: 4,
  },
  {
    original_query: "teüü",
    total_searches: 4,
  },
  {
    original_query: "transport",
    total_searches: 4,
  },
  {
    original_query: "schmutztepp",
    total_searches: 4,
  },
  {
    original_query: "korkb",
    total_searches: 4,
  },
  {
    original_query: "folz",
    total_searches: 4,
  },
  {
    original_query: "Kaminh",
    total_searches: 4,
  },
  {
    original_query: "cele",
    total_searches: 4,
  },
  {
    original_query: "stallbo",
    total_searches: 4,
  },
  {
    original_query: "filztafel",
    total_searches: 4,
  },
  {
    original_query: "Hohlkamme",
    total_searches: 4,
  },
  {
    original_query: "stuhlunterlage",
    total_searches: 4,
  },
  {
    original_query: "waschbecken",
    total_searches: 4,
  },
  {
    original_query: "Terrassenfl",
    total_searches: 4,
  },
  {
    original_query: "fahradst",
    total_searches: 4,
  },
  {
    original_query: "gekettelt",
    total_searches: 4,
  },
  {
    original_query: "fussbodenleiste",
    total_searches: 4,
  },
  {
    original_query: "stoffe",
    total_searches: 4,
  },
  {
    original_query: "Rapid",
    total_searches: 4,
  },
  {
    original_query: "stufenkantenproful",
    total_searches: 4,
  },
  {
    original_query: "abdeckpö",
    total_searches: 4,
  },
  {
    original_query: "Bambussic",
    total_searches: 4,
  },
  {
    original_query: "rasenw",
    total_searches: 4,
  },
  {
    original_query: "click",
    total_searches: 4,
  },
  {
    original_query: "Dach",
    total_searches: 4,
  },
  {
    original_query: "abti",
    total_searches: 4,
  },
  {
    original_query: "treppenlan",
    total_searches: 4,
  },
  {
    original_query: "Puzz",
    total_searches: 4,
  },
  {
    original_query: "luftpol",
    total_searches: 4,
  },
  {
    original_query: "lieferz",
    total_searches: 4,
  },
  {
    original_query: "fitne",
    total_searches: 4,
  },
  {
    original_query: "Arbeits",
    total_searches: 4,
  },
  {
    original_query: "markisenst",
    total_searches: 4,
  },
  {
    original_query: "wandspie",
    total_searches: 4,
  },
  {
    original_query: "Brasil",
    total_searches: 4,
  },
  {
    original_query: "schutzp",
    total_searches: 4,
  },
  {
    original_query: "Volieren",
    total_searches: 4,
  },
  {
    original_query: "antiermüdungsmatten",
    total_searches: 4,
  },
  {
    original_query: "abstreicher",
    total_searches: 4,
  },
  {
    original_query: "rasentrppich",
    total_searches: 4,
  },
  {
    original_query: "peta",
    total_searches: 4,
  },
  {
    original_query: "handtuc",
    total_searches: 4,
  },
  {
    original_query: "Drahtgit",
    total_searches: 4,
  },
  {
    original_query: "teppichlaüfer",
    total_searches: 4,
  },
  {
    original_query: "korde",
    total_searches: 4,
  },
  {
    original_query: "pfost",
    total_searches: 4,
  },
  {
    original_query: "dopel",
    total_searches: 4,
  },
  {
    original_query: "musterbe",
    total_searches: 4,
  },
  {
    original_query: "filzfliese",
    total_searches: 4,
  },
  {
    original_query: "Fitn",
    total_searches: 4,
  },
  {
    original_query: "autofussmatten",
    total_searches: 4,
  },
  {
    original_query: "ersatzteil",
    total_searches: 4,
  },
  {
    original_query: "rasenr",
    total_searches: 4,
  },
  {
    original_query: "cambr",
    total_searches: 4,
  },
  {
    original_query: "Schuhs",
    total_searches: 4,
  },
  {
    original_query: "niko",
    total_searches: 4,
  },
  {
    original_query: "boardmaker",
    total_searches: 4,
  },
  {
    original_query: "erdha",
    total_searches: 4,
  },
  {
    original_query: "elektr",
    total_searches: 4,
  },
  {
    original_query: "Padd",
    total_searches: 4,
  },
  {
    original_query: "farbmuster",
    total_searches: 4,
  },
  {
    original_query: "outdoorläu",
    total_searches: 4,
  },
  {
    original_query: "einfassprofil",
    total_searches: 4,
  },
  {
    original_query: "Paddoc",
    total_searches: 4,
  },
  {
    original_query: "schwerentflammbar",
    total_searches: 4,
  },
  {
    original_query: "Schmutzfsng",
    total_searches: 4,
  },
  {
    original_query: "Fano",
    total_searches: 4,
  },
  {
    original_query: "fliesenoptik",
    total_searches: 4,
  },
  {
    original_query: "mulleimer",
    total_searches: 4,
  },
  {
    original_query: "acrylplatten",
    total_searches: 4,
  },
  {
    original_query: "kurzfloorteppich",
    total_searches: 4,
  },
  {
    original_query: "fussle",
    total_searches: 4,
  },
  {
    original_query: "Solar",
    total_searches: 4,
  },
  {
    original_query: "lack",
    total_searches: 4,
  },
  {
    original_query: "tepisch",
    total_searches: 4,
  },
  {
    original_query: "garda",
    total_searches: 4,
  },
  {
    original_query: "korkmeterware",
    total_searches: 4,
  },
  {
    original_query: "Lieferz",
    total_searches: 4,
  },
  {
    original_query: "Vorhang",
    total_searches: 4,
  },
  {
    original_query: "schreibtischunterla",
    total_searches: 4,
  },
  {
    original_query: "Küchenteppic",
    total_searches: 4,
  },
  {
    original_query: "Perfo",
    total_searches: 4,
  },
  {
    original_query: "kunstrasenfliese",
    total_searches: 4,
  },
  {
    original_query: "antiermüdungsm",
    total_searches: 4,
  },
  {
    original_query: "Terassendiele",
    total_searches: 4,
  },
  {
    original_query: "pinsel",
    total_searches: 4,
  },
  {
    original_query: "gummiert",
    total_searches: 4,
  },
  {
    original_query: "weidematten",
    total_searches: 4,
  },
  {
    original_query: "Atla",
    total_searches: 4,
  },
  {
    original_query: "schmutzfanfmatten",
    total_searches: 4,
  },
  {
    original_query: "sisaö",
    total_searches: 4,
  },
  {
    original_query: "malerflies",
    total_searches: 4,
  },
  {
    original_query: "Handt",
    total_searches: 4,
  },
  {
    original_query: "Sisalop",
    total_searches: 4,
  },
  {
    original_query: "trenwand",
    total_searches: 3,
  },
  {
    original_query: "Duschvorhang",
    total_searches: 3,
  },
  {
    original_query: "gartenstuh",
    total_searches: 3,
  },
  {
    original_query: "dämpfu",
    total_searches: 3,
  },
  {
    original_query: "teppichmuster",
    total_searches: 3,
  },
  {
    original_query: "messetepi",
    total_searches: 3,
  },
  {
    original_query: "Türkis",
    total_searches: 3,
  },
  {
    original_query: "individuelle",
    total_searches: 3,
  },
  {
    original_query: "bademattenset",
    total_searches: 3,
  },
  {
    original_query: "Bambz",
    total_searches: 3,
  },
  {
    original_query: "Ringgummimatt",
    total_searches: 3,
  },
  {
    original_query: "Bautenschutzmatt",
    total_searches: 3,
  },
  {
    original_query: "bettlaken",
    total_searches: 3,
  },
  {
    original_query: "Pflanzkübe",
    total_searches: 3,
  },
  {
    original_query: "sisalk",
    total_searches: 3,
  },
  {
    original_query: "Fußabtret",
    total_searches: 3,
  },
  {
    original_query: "küchenlau",
    total_searches: 3,
  },
  {
    original_query: "granulatmatte",
    total_searches: 3,
  },
  {
    original_query: "Frachtko",
    total_searches: 3,
  },
  {
    original_query: "Treppenscho",
    total_searches: 3,
  },
  {
    original_query: "gestell",
    total_searches: 3,
  },
  {
    original_query: "stallmatre",
    total_searches: 3,
  },
  {
    original_query: "nadelfilu",
    total_searches: 3,
  },
  {
    original_query: "doppelrolleo",
    total_searches: 3,
  },
  {
    original_query: "tidchfolie",
    total_searches: 3,
  },
  {
    original_query: "teles",
    total_searches: 3,
  },
  {
    original_query: "gewürzr",
    total_searches: 3,
  },
  {
    original_query: "treppenstufenprofile",
    total_searches: 3,
  },
  {
    original_query: "home",
    total_searches: 3,
  },
  {
    original_query: "schmutzfanmatten",
    total_searches: 3,
  },
  {
    original_query: "Chevr",
    total_searches: 3,
  },
  {
    original_query: "Floordi",
    total_searches: 3,
  },
  {
    original_query: "Fussb",
    total_searches: 3,
  },
  {
    original_query: "grilla",
    total_searches: 3,
  },
  {
    original_query: "Scmu",
    total_searches: 3,
  },
  {
    original_query: "Erdnägel",
    total_searches: 3,
  },
  {
    original_query: "Well",
    total_searches: 3,
  },
  {
    original_query: "tepichfl",
    total_searches: 3,
  },
  {
    original_query: "taubblinde",
    total_searches: 3,
  },
  {
    original_query: "teppichplanken",
    total_searches: 3,
  },
  {
    original_query: "holzflies",
    total_searches: 3,
  },
  {
    original_query: "Promen",
    total_searches: 3,
  },
  {
    original_query: "katzenstr",
    total_searches: 3,
  },
  {
    original_query: "Verdunklungsrollo",
    total_searches: 3,
  },
  {
    original_query: "höhenausgleich",
    total_searches: 3,
  },
  {
    original_query: "Neodym",
    total_searches: 3,
  },
  {
    original_query: "sonnensee",
    total_searches: 3,
  },
  {
    original_query: "haft",
    total_searches: 3,
  },
  {
    original_query: "teppichläi",
    total_searches: 3,
  },
  {
    original_query: "gitterm",
    total_searches: 3,
  },
  {
    original_query: "krakau",
    total_searches: 3,
  },
  {
    original_query: "tierbedarf",
    total_searches: 3,
  },
  {
    original_query: "durchsichti",
    total_searches: 3,
  },
  {
    original_query: "produktion",
    total_searches: 3,
  },
  {
    original_query: "Werksta",
    total_searches: 3,
  },
  {
    original_query: "getränkeki",
    total_searches: 3,
  },
  {
    original_query: "badereppi",
    total_searches: 3,
  },
  {
    original_query: "kleberband",
    total_searches: 3,
  },
  {
    original_query: "Garagenbo",
    total_searches: 3,
  },
  {
    original_query: "kofferr",
    total_searches: 3,
  },
  {
    original_query: "rhie",
    total_searches: 3,
  },
  {
    original_query: "marigol",
    total_searches: 3,
  },
  {
    original_query: "schlingenmat",
    total_searches: 3,
  },
  {
    original_query: "webtepp",
    total_searches: 3,
  },
  {
    original_query: "drahtseil",
    total_searches: 3,
  },
  {
    original_query: "unterlagen",
    total_searches: 3,
  },
  {
    original_query: "Lakota",
    total_searches: 3,
  },
  {
    original_query: "Laeuf",
    total_searches: 3,
  },
  {
    original_query: "Classic",
    total_searches: 3,
  },
  {
    original_query: "Fenste",
    total_searches: 3,
  },
  {
    original_query: "unkrautvlie",
    total_searches: 3,
  },
  {
    original_query: "Korkklebe",
    total_searches: 3,
  },
  {
    original_query: "griz",
    total_searches: 3,
  },
  {
    original_query: "bodehanker",
    total_searches: 3,
  },
  {
    original_query: "zahlu",
    total_searches: 3,
  },
  {
    original_query: "badhocker",
    total_searches: 3,
  },
  {
    original_query: "badezimmerteppi",
    total_searches: 3,
  },
  {
    original_query: "messina",
    total_searches: 3,
  },
  {
    original_query: "Poolunter",
    total_searches: 3,
  },
  {
    original_query: "ehine",
    total_searches: 3,
  },
  {
    original_query: "Beetum",
    total_searches: 3,
  },
  {
    original_query: "sitzhocker",
    total_searches: 3,
  },
  {
    original_query: "Sisaltr",
    total_searches: 3,
  },
  {
    original_query: "schuhteppich",
    total_searches: 3,
  },
  {
    original_query: "Plisee",
    total_searches: 3,
  },
  {
    original_query: "conse",
    total_searches: 3,
  },
  {
    original_query: "pbergan",
    total_searches: 3,
  },
  {
    original_query: "gittermatten",
    total_searches: 3,
  },
  {
    original_query: "heuga",
    total_searches: 3,
  },
  {
    original_query: "kantenprofile",
    total_searches: 3,
  },
  {
    original_query: "vorle",
    total_searches: 3,
  },
  {
    original_query: "beheizt",
    total_searches: 3,
  },
  {
    original_query: "polystorol",
    total_searches: 3,
  },
  {
    original_query: "handwebteppich",
    total_searches: 3,
  },
  {
    original_query: "Sauberlaufteppich",
    total_searches: 3,
  },
  {
    original_query: "sicjtschutz",
    total_searches: 3,
  },
  {
    original_query: "netze",
    total_searches: 3,
  },
  {
    original_query: "viel",
    total_searches: 3,
  },
  {
    original_query: "schmutfangmatte",
    total_searches: 3,
  },
  {
    original_query: "moderati",
    total_searches: 3,
  },
  {
    original_query: "rampenm",
    total_searches: 3,
  },
  {
    original_query: "kuchenl",
    total_searches: 3,
  },
  {
    original_query: "Sicherheitsm",
    total_searches: 3,
  },
  {
    original_query: "northrugs",
    total_searches: 3,
  },
  {
    original_query: "flaschenregal",
    total_searches: 3,
  },
  {
    original_query: "teppichschienen",
    total_searches: 3,
  },
  {
    original_query: "greenhouse",
    total_searches: 3,
  },
  {
    original_query: "terrassente",
    total_searches: 3,
  },
  {
    original_query: "Sauberlaufte",
    total_searches: 3,
  },
  {
    original_query: "dundal",
    total_searches: 3,
  },
  {
    original_query: "Gartent",
    total_searches: 3,
  },
  {
    original_query: "Kunsts",
    total_searches: 3,
  },
  {
    original_query: "korkmatt",
    total_searches: 3,
  },
  {
    original_query: "lauder",
    total_searches: 3,
  },
  {
    original_query: "Poolu",
    total_searches: 3,
  },
  {
    original_query: "Schutzfa",
    total_searches: 3,
  },
  {
    original_query: "Pflanzkü",
    total_searches: 3,
  },
  {
    original_query: "milano",
    total_searches: 3,
  },
  {
    original_query: "abme",
    total_searches: 3,
  },
  {
    original_query: "klickfließ",
    total_searches: 3,
  },
  {
    original_query: "kunstrasenkl",
    total_searches: 3,
  },
  {
    original_query: "abschlußprof",
    total_searches: 3,
  },
  {
    original_query: "käufer",
    total_searches: 3,
  },
  {
    original_query: "Amazona",
    total_searches: 3,
  },
  {
    original_query: "kundenstop",
    total_searches: 3,
  },
  {
    original_query: "hängeschrank",
    total_searches: 3,
  },
  {
    original_query: "rein",
    total_searches: 3,
  },
  {
    original_query: "Arno",
    total_searches: 3,
  },
  {
    original_query: "abdeckplsne",
    total_searches: 3,
  },
  {
    original_query: "Doppelro",
    total_searches: 3,
  },
  {
    original_query: "Eckpro",
    total_searches: 3,
  },
  {
    original_query: "isomatten",
    total_searches: 3,
  },
  {
    original_query: "treppenf",
    total_searches: 3,
  },
  {
    original_query: "bodenausgleich",
    total_searches: 3,
  },
  {
    original_query: "lichter",
    total_searches: 3,
  },
  {
    original_query: "Meine",
    total_searches: 3,
  },
  {
    original_query: "fahrradhal",
    total_searches: 3,
  },
  {
    original_query: "Guss",
    total_searches: 3,
  },
  {
    original_query: "dauber",
    total_searches: 3,
  },
  {
    original_query: "teic",
    total_searches: 3,
  },
  {
    original_query: "Weit",
    total_searches: 3,
  },
  {
    original_query: "agadir",
    total_searches: 3,
  },
  {
    original_query: "teppichband",
    total_searches: 3,
  },
  {
    original_query: "Marker",
    total_searches: 3,
  },
  {
    original_query: "surat",
    total_searches: 3,
  },
  {
    original_query: "eins",
    total_searches: 3,
  },
  {
    original_query: "camouflag",
    total_searches: 3,
  },
  {
    original_query: "Pflanzst",
    total_searches: 3,
  },
  {
    original_query: "treppenschiene",
    total_searches: 3,
  },
  {
    original_query: "schaufel",
    total_searches: 3,
  },
  {
    original_query: "Orna",
    total_searches: 3,
  },
  {
    original_query: "Carou",
    total_searches: 3,
  },
  {
    original_query: "dämpfun",
    total_searches: 3,
  },
  {
    original_query: "schuhre",
    total_searches: 3,
  },
  {
    original_query: "Maßa",
    total_searches: 3,
  },
  {
    original_query: "mons",
    total_searches: 3,
  },
  {
    original_query: "antirutschst",
    total_searches: 3,
  },
  {
    original_query: "poolabdeckplane",
    total_searches: 3,
  },
  {
    original_query: "beschattung",
    total_searches: 3,
  },
  {
    original_query: "salonloewe",
    total_searches: 3,
  },
  {
    original_query: "abwas",
    total_searches: 3,
  },
  {
    original_query: "tepichfli",
    total_searches: 3,
  },
  {
    original_query: "Stufenwi",
    total_searches: 3,
  },
  {
    original_query: "weidenma",
    total_searches: 3,
  },
  {
    original_query: "Drahtzau",
    total_searches: 3,
  },
  {
    original_query: "Drahtz",
    total_searches: 3,
  },
  {
    original_query: "skys",
    total_searches: 3,
  },
  {
    original_query: "Malt",
    total_searches: 3,
  },
  {
    original_query: "Paddockmatte",
    total_searches: 3,
  },
  {
    original_query: "Treppenschiene",
    total_searches: 3,
  },
  {
    original_query: "schwimmbadmatte",
    total_searches: 3,
  },
  {
    original_query: "klips",
    total_searches: 3,
  },
  {
    original_query: "milchweiß",
    total_searches: 3,
  },
  {
    original_query: "ersatzt",
    total_searches: 3,
  },
  {
    original_query: "wühlmausgitt",
    total_searches: 3,
  },
  {
    original_query: "Rive",
    total_searches: 3,
  },
  {
    original_query: "abdeckfli",
    total_searches: 3,
  },
  {
    original_query: "bädermatte",
    total_searches: 3,
  },
  {
    original_query: "ikar",
    total_searches: 3,
  },
  {
    original_query: "eckprof",
    total_searches: 3,
  },
  {
    original_query: "Schlingenf",
    total_searches: 3,
  },
  {
    original_query: "lküchenläufer",
    total_searches: 3,
  },
  {
    original_query: "arbei",
    total_searches: 3,
  },
  {
    original_query: "türschwell",
    total_searches: 3,
  },
  {
    original_query: "Octago",
    total_searches: 3,
  },
  {
    original_query: "maki",
    total_searches: 3,
  },
  {
    original_query: "Uber",
    total_searches: 3,
  },
  {
    original_query: "spanngummies",
    total_searches: 3,
  },
  {
    original_query: "klapprahmen",
    total_searches: 3,
  },
  {
    original_query: "Wasserd",
    total_searches: 3,
  },
  {
    original_query: "Boni",
    total_searches: 3,
  },
  {
    original_query: "Teppichka",
    total_searches: 3,
  },
  {
    original_query: "reifenreg",
    total_searches: 3,
  },
  {
    original_query: "Brei",
    total_searches: 3,
  },
  {
    original_query: "montageständer",
    total_searches: 3,
  },
  {
    original_query: "klapptri",
    total_searches: 3,
  },
  {
    original_query: "wandanschlu",
    total_searches: 3,
  },
  {
    original_query: "Sida",
    total_searches: 3,
  },
  {
    original_query: "bodenschutzmstte",
    total_searches: 3,
  },
  {
    original_query: "melan",
    total_searches: 3,
  },
  {
    original_query: "Petr",
    total_searches: 3,
  },
  {
    original_query: "RASEN",
    total_searches: 3,
  },
  {
    original_query: "kunsrasen",
    total_searches: 3,
  },
  {
    original_query: "Farbeunder",
    total_searches: 3,
  },
  {
    original_query: "innenve",
    total_searches: 3,
  },
  {
    original_query: "getranke",
    total_searches: 3,
  },
  {
    original_query: "rundteppi",
    total_searches: 3,
  },
  {
    original_query: "teppichmess",
    total_searches: 3,
  },
  {
    original_query: "bodenrost",
    total_searches: 3,
  },
  {
    original_query: "sauberls",
    total_searches: 3,
  },
  {
    original_query: "tapi",
    total_searches: 3,
  },
  {
    original_query: "abdeku",
    total_searches: 3,
  },
  {
    original_query: "desinfe",
    total_searches: 3,
  },
  {
    original_query: "wein",
    total_searches: 3,
  },
  {
    original_query: "sokell",
    total_searches: 3,
  },
  {
    original_query: "Aussente",
    total_searches: 3,
  },
  {
    original_query: "motorrad",
    total_searches: 3,
  },
  {
    original_query: "küchenlöufer",
    total_searches: 3,
  },
  {
    original_query: "gummit",
    total_searches: 3,
  },
  {
    original_query: "bidenschu",
    total_searches: 3,
  },
  {
    original_query: "boxwoo",
    total_searches: 3,
  },
  {
    original_query: "ersatzte",
    total_searches: 3,
  },
  {
    original_query: "dunda",
    total_searches: 3,
  },
  {
    original_query: "Maschendrahtzau",
    total_searches: 3,
  },
  {
    original_query: "velourst",
    total_searches: 3,
  },
  {
    original_query: "caper",
    total_searches: 3,
  },
  {
    original_query: "trepoenkanten",
    total_searches: 3,
  },
  {
    original_query: "Fussbode",
    total_searches: 3,
  },
  {
    original_query: "zaunpf",
    total_searches: 3,
  },
  {
    original_query: "stufenkatenprofil",
    total_searches: 3,
  },
  {
    original_query: "RHINE",
    total_searches: 3,
  },
  {
    original_query: "rutch",
    total_searches: 3,
  },
  {
    original_query: "Duschr",
    total_searches: 3,
  },
  {
    original_query: "heizmat",
    total_searches: 3,
  },
  {
    original_query: "Lichtsc",
    total_searches: 3,
  },
  {
    original_query: "Teppichkan",
    total_searches: 3,
  },
  {
    original_query: "badtr",
    total_searches: 3,
  },
  {
    original_query: "ringl",
    total_searches: 3,
  },
  {
    original_query: "Wohnzimmer",
    total_searches: 3,
  },
  {
    original_query: "protect",
    total_searches: 3,
  },
  {
    original_query: "abwaschb",
    total_searches: 3,
  },
  {
    original_query: "aussenm",
    total_searches: 3,
  },
  {
    original_query: "maler",
    total_searches: 3,
  },
  {
    original_query: "garagenb",
    total_searches: 3,
  },
  {
    original_query: "Schreibtischunterlage",
    total_searches: 3,
  },
  {
    original_query: "spielplatz",
    total_searches: 3,
  },
  {
    original_query: "Befestigungsschiene",
    total_searches: 3,
  },
  {
    original_query: "glasreg",
    total_searches: 3,
  },
  {
    original_query: "rosina",
    total_searches: 3,
  },
  {
    original_query: "Steckre",
    total_searches: 3,
  },
  {
    original_query: "moosgrün",
    total_searches: 3,
  },
  {
    original_query: "klapptr",
    total_searches: 3,
  },
  {
    original_query: "Esszimmerteppich",
    total_searches: 3,
  },
  {
    original_query: "brad",
    total_searches: 3,
  },
  {
    original_query: "stake",
    total_searches: 3,
  },
  {
    original_query: "Schutzhüll",
    total_searches: 3,
  },
  {
    original_query: "wohnw",
    total_searches: 3,
  },
  {
    original_query: "bouclé",
    total_searches: 3,
  },
  {
    original_query: "zusc",
    total_searches: 3,
  },
  {
    original_query: "nahtband",
    total_searches: 3,
  },
  {
    original_query: "Fusmatte",
    total_searches: 3,
  },
  {
    original_query: "alule",
    total_searches: 3,
  },
  {
    original_query: "perlgold",
    total_searches: 3,
  },
  {
    original_query: "teppichbodenschutz",
    total_searches: 3,
  },
  {
    original_query: "vist",
    total_searches: 3,
  },
  {
    original_query: "Feuersch",
    total_searches: 3,
  },
  {
    original_query: "flicke",
    total_searches: 3,
  },
  {
    original_query: "sichtschutzg",
    total_searches: 3,
  },
  {
    original_query: "sabag",
    total_searches: 3,
  },
  {
    original_query: "Terassenfliese",
    total_searches: 3,
  },
  {
    original_query: "metallzaun",
    total_searches: 3,
  },
  {
    original_query: "antr",
    total_searches: 3,
  },
  {
    original_query: "Breite",
    total_searches: 3,
  },
  {
    original_query: "Zahlung",
    total_searches: 3,
  },
  {
    original_query: "garderobenstände",
    total_searches: 3,
  },
  {
    original_query: "gewebeband",
    total_searches: 3,
  },
  {
    original_query: "Pflanzk",
    total_searches: 3,
  },
  {
    original_query: "aberde",
    total_searches: 3,
  },
  {
    original_query: "Metal",
    total_searches: 3,
  },
  {
    original_query: "Farbe",
    total_searches: 3,
  },
  {
    original_query: "crokodil",
    total_searches: 3,
  },
  {
    original_query: "warnumrandung",
    total_searches: 3,
  },
  {
    original_query: "Pavillo",
    total_searches: 3,
  },
  {
    original_query: "mast",
    total_searches: 3,
  },
  {
    original_query: "regenplane",
    total_searches: 3,
  },
  {
    original_query: "geovlies",
    total_searches: 3,
  },
  {
    original_query: "holly",
    total_searches: 3,
  },
  {
    original_query: "schwenk",
    total_searches: 3,
  },
  {
    original_query: "outdoorvorhang",
    total_searches: 3,
  },
  {
    original_query: "bologn",
    total_searches: 3,
  },
  {
    original_query: "wohnteppi",
    total_searches: 3,
  },
  {
    original_query: "heidekrautmatt",
    total_searches: 3,
  },
  {
    original_query: "Duschro",
    total_searches: 3,
  },
  {
    original_query: "tepo",
    total_searches: 3,
  },
  {
    original_query: "balkonv",
    total_searches: 3,
  },
  {
    original_query: "schoner",
    total_searches: 3,
  },
  {
    original_query: "Meterw",
    total_searches: 3,
  },
  {
    original_query: "danach",
    total_searches: 3,
  },
  {
    original_query: "rasenfl",
    total_searches: 3,
  },
  {
    original_query: "wassera",
    total_searches: 3,
  },
  {
    original_query: "terasenfliese",
    total_searches: 3,
  },
  {
    original_query: "Antirutschsich",
    total_searches: 3,
  },
  {
    original_query: "sauberkau",
    total_searches: 3,
  },
  {
    original_query: "Abschlussleis",
    total_searches: 3,
  },
  {
    original_query: "Genu",
    total_searches: 3,
  },
  {
    original_query: "klass",
    total_searches: 3,
  },
  {
    original_query: "Messete",
    total_searches: 3,
  },
  {
    original_query: "fussleist",
    total_searches: 3,
  },
  {
    original_query: "nadelfilzte",
    total_searches: 3,
  },
  {
    original_query: "bodenschutt",
    total_searches: 3,
  },
  {
    original_query: "Fußboden",
    total_searches: 3,
  },
  {
    original_query: "teppichfließe",
    total_searches: 3,
  },
  {
    original_query: "Bürostuh",
    total_searches: 3,
  },
  {
    original_query: "teppichecken",
    total_searches: 3,
  },
  {
    original_query: "flurlaüfer",
    total_searches: 3,
  },
  {
    original_query: "Tischmatte",
    total_searches: 3,
  },
  {
    original_query: "fallschutzma",
    total_searches: 3,
  },
  {
    original_query: "Antivibrationsmatt",
    total_searches: 3,
  },
  {
    original_query: "bango",
    total_searches: 3,
  },
  {
    original_query: "bonit",
    total_searches: 3,
  },
  {
    original_query: "naturteppich",
    total_searches: 3,
  },
  {
    original_query: "abdecklei",
    total_searches: 3,
  },
  {
    original_query: "Werkstatt",
    total_searches: 3,
  },
  {
    original_query: "Duschrollo",
    total_searches: 3,
  },
  {
    original_query: "Doppelr",
    total_searches: 3,
  },
  {
    original_query: "schmutzfangmattrn",
    total_searches: 3,
  },
  {
    original_query: "Treppenm",
    total_searches: 3,
  },
  {
    original_query: "terasef",
    total_searches: 3,
  },
  {
    original_query: "floort",
    total_searches: 3,
  },
  {
    original_query: "profilleisten",
    total_searches: 3,
  },
  {
    original_query: "anpassprofil",
    total_searches: 3,
  },
  {
    original_query: "büromatte",
    total_searches: 3,
  },
  {
    original_query: "korkfliesen",
    total_searches: 3,
  },
  {
    original_query: "moscau",
    total_searches: 3,
  },
  {
    original_query: "Maulwurfgitter",
    total_searches: 3,
  },
  {
    original_query: "Schmutzfsngm",
    total_searches: 3,
  },
  {
    original_query: "Vibrations",
    total_searches: 3,
  },
  {
    original_query: "puzzlematten",
    total_searches: 3,
  },
  {
    original_query: "stugenmatten",
    total_searches: 3,
  },
  {
    original_query: "Staket",
    total_searches: 3,
  },
  {
    original_query: "gummischnur",
    total_searches: 3,
  },
  {
    original_query: "lärmschu",
    total_searches: 3,
  },
  {
    original_query: "tesa",
    total_searches: 3,
  },
  {
    original_query: "Insekten",
    total_searches: 3,
  },
  {
    original_query: "mosaik",
    total_searches: 3,
  },
  {
    original_query: "Sisalo",
    total_searches: 3,
  },
  {
    original_query: "printo",
    total_searches: 3,
  },
  {
    original_query: "Horiz",
    total_searches: 3,
  },
  {
    original_query: "Eingangsmatte",
    total_searches: 3,
  },
  {
    original_query: "spah",
    total_searches: 3,
  },
  {
    original_query: "Orname",
    total_searches: 3,
  },
  {
    original_query: "innenr",
    total_searches: 3,
  },
  {
    original_query: "kret",
    total_searches: 3,
  },
  {
    original_query: "blumenkübel",
    total_searches: 3,
  },
  {
    original_query: "sicherheitsmängel",
    total_searches: 3,
  },
  {
    original_query: "bambusre",
    total_searches: 3,
  },
  {
    original_query: "Geträn",
    total_searches: 3,
  },
  {
    original_query: "Übergangsleiste",
    total_searches: 3,
  },
  {
    original_query: "teppichbodensc",
    total_searches: 3,
  },
  {
    original_query: "friend",
    total_searches: 3,
  },
  {
    original_query: "plisseee",
    total_searches: 3,
  },
  {
    original_query: "kuechente",
    total_searches: 3,
  },
  {
    original_query: "rutschhemmer",
    total_searches: 3,
  },
  {
    original_query: "wasserab",
    total_searches: 3,
  },
  {
    original_query: "Nadeld",
    total_searches: 3,
  },
  {
    original_query: "sicherheitsmat",
    total_searches: 3,
  },
  {
    original_query: "Pink",
    total_searches: 3,
  },
  {
    original_query: "Radent",
    total_searches: 3,
  },
  {
    original_query: "abschlusswinkel",
    total_searches: 3,
  },
  {
    original_query: "tafelfo",
    total_searches: 3,
  },
  {
    original_query: "saubermatte",
    total_searches: 3,
  },
  {
    original_query: "Tepichl",
    total_searches: 3,
  },
  {
    original_query: "rasenteppp",
    total_searches: 3,
  },
  {
    original_query: "Toil",
    total_searches: 3,
  },
  {
    original_query: "Schutzfangmatte",
    total_searches: 3,
  },
  {
    original_query: "crocodile",
    total_searches: 3,
  },
  {
    original_query: "kisse",
    total_searches: 3,
  },
  {
    original_query: "spanns",
    total_searches: 3,
  },
  {
    original_query: "lkwp",
    total_searches: 3,
  },
  {
    original_query: "Outdoorläufe",
    total_searches: 3,
  },
  {
    original_query: "kokosl",
    total_searches: 3,
  },
  {
    original_query: "schafwoll",
    total_searches: 3,
  },
  {
    original_query: "Achmu",
    total_searches: 3,
  },
  {
    original_query: "kariert",
    total_searches: 3,
  },
  {
    original_query: "absperrzaune",
    total_searches: 3,
  },
  {
    original_query: "Lammfell",
    total_searches: 3,
  },
  {
    original_query: "Rolls",
    total_searches: 3,
  },
  {
    original_query: "schmutzlaufmatte",
    total_searches: 3,
  },
  {
    original_query: "brennh",
    total_searches: 3,
  },
  {
    original_query: "ging",
    total_searches: 3,
  },
  {
    original_query: "kaminholzre",
    total_searches: 3,
  },
  {
    original_query: "Nikosia",
    total_searches: 3,
  },
  {
    original_query: "Grüne",
    total_searches: 3,
  },
  {
    original_query: "abbdeckpl",
    total_searches: 3,
  },
  {
    original_query: "bufallo",
    total_searches: 3,
  },
  {
    original_query: "Gummir",
    total_searches: 3,
  },
  {
    original_query: "rhodos",
    total_searches: 3,
  },
  {
    original_query: "Holzabdeck",
    total_searches: 3,
  },
  {
    original_query: "Therm",
    total_searches: 3,
  },
  {
    original_query: "Puzzl",
    total_searches: 3,
  },
  {
    original_query: "schmutzfangsmatte",
    total_searches: 3,
  },
  {
    original_query: "Fussabs",
    total_searches: 3,
  },
  {
    original_query: "moskitonetz",
    total_searches: 3,
  },
  {
    original_query: "Sucht",
    total_searches: 3,
  },
  {
    original_query: "treppenstufenma",
    total_searches: 3,
  },
  {
    original_query: "Multi",
    total_searches: 3,
  },
  {
    original_query: "sucht",
    total_searches: 3,
  },
  {
    original_query: "badtepi",
    total_searches: 3,
  },
  {
    original_query: "schmutzla",
    total_searches: 3,
  },
  {
    original_query: "vinylfliesen",
    total_searches: 3,
  },
  {
    original_query: "klebeleisten",
    total_searches: 3,
  },
  {
    original_query: "Rasenz",
    total_searches: 3,
  },
  {
    original_query: "gumminoppen",
    total_searches: 3,
  },
  {
    original_query: "inta",
    total_searches: 3,
  },
  {
    original_query: "schreibtischauflage",
    total_searches: 3,
  },
  {
    original_query: "Lammf",
    total_searches: 3,
  },
  {
    original_query: "schmtzf",
    total_searches: 3,
  },
  {
    original_query: "sauberlaufzone",
    total_searches: 3,
  },
  {
    original_query: "klickvi",
    total_searches: 3,
  },
  {
    original_query: "Croc",
    total_searches: 3,
  },
  {
    original_query: "Bürostuhl",
    total_searches: 3,
  },
  {
    original_query: "eingangsmat",
    total_searches: 3,
  },
  {
    original_query: "wandsc",
    total_searches: 3,
  },
  {
    original_query: "Grüner",
    total_searches: 3,
  },
  {
    original_query: "Leuf",
    total_searches: 3,
  },
  {
    original_query: "farbwubder",
    total_searches: 3,
  },
  {
    original_query: "manhattan",
    total_searches: 3,
  },
  {
    original_query: "drahtsp",
    total_searches: 3,
  },
  {
    original_query: "niedrig",
    total_searches: 3,
  },
  {
    original_query: "waldboden",
    total_searches: 3,
  },
  {
    original_query: "sendungsverfolgung",
    total_searches: 3,
  },
  {
    original_query: "minir",
    total_searches: 3,
  },
  {
    original_query: "schra",
    total_searches: 3,
  },
  {
    original_query: "Kinderte",
    total_searches: 3,
  },
  {
    original_query: "fussmatre",
    total_searches: 3,
  },
  {
    original_query: "schmutzschl",
    total_searches: 3,
  },
  {
    original_query: "halbtransparent",
    total_searches: 3,
  },
  {
    original_query: "sandkas",
    total_searches: 3,
  },
  {
    original_query: "pavil",
    total_searches: 3,
  },
  {
    original_query: "randabschlussleiste",
    total_searches: 3,
  },
  {
    original_query: "wohntepp",
    total_searches: 3,
  },
  {
    original_query: "Tasen",
    total_searches: 3,
  },
  {
    original_query: "sixht",
    total_searches: 3,
  },
  {
    original_query: "Badezimme",
    total_searches: 3,
  },
  {
    original_query: "Pietviss",
    total_searches: 3,
  },
  {
    original_query: "bambuskorb",
    total_searches: 3,
  },
  {
    original_query: "gitterschutz",
    total_searches: 3,
  },
  {
    original_query: "kratzbre",
    total_searches: 3,
  },
  {
    original_query: "Klapprahme",
    total_searches: 3,
  },
  {
    original_query: "sonnse",
    total_searches: 3,
  },
  {
    original_query: "stufenmattw",
    total_searches: 3,
  },
  {
    original_query: "werks",
    total_searches: 3,
  },
  {
    original_query: "maja",
    total_searches: 3,
  },
  {
    original_query: "verlegung",
    total_searches: 3,
  },
  {
    original_query: "wohnwagenteppich",
    total_searches: 3,
  },
  {
    original_query: "rolloleinwand",
    total_searches: 3,
  },
  {
    original_query: "wohnwage",
    total_searches: 3,
  },
  {
    original_query: "klebs",
    total_searches: 3,
  },
  {
    original_query: "stufn",
    total_searches: 3,
  },
  {
    original_query: "nadelflis",
    total_searches: 3,
  },
  {
    original_query: "velor",
    total_searches: 3,
  },
  {
    original_query: "Handtü",
    total_searches: 3,
  },
  {
    original_query: "abdeckfoli",
    total_searches: 3,
  },
  {
    original_query: "Rundteppich",
    total_searches: 3,
  },
  {
    original_query: "Heizma",
    total_searches: 3,
  },
  {
    original_query: "Somme",
    total_searches: 3,
  },
  {
    original_query: "antibibrationsmatte",
    total_searches: 3,
  },
  {
    original_query: "gardiene",
    total_searches: 3,
  },
  {
    original_query: "tasentepp",
    total_searches: 3,
  },
  {
    original_query: "rela",
    total_searches: 3,
  },
  {
    original_query: "Teppichkant",
    total_searches: 3,
  },
  {
    original_query: "beetbegrenzung",
    total_searches: 3,
  },
  {
    original_query: "best",
    total_searches: 3,
  },
  {
    original_query: "telefonn",
    total_searches: 3,
  },
  {
    original_query: "wandpanele",
    total_searches: 3,
  },
  {
    original_query: "garderobenständ",
    total_searches: 3,
  },
  {
    original_query: "such",
    total_searches: 3,
  },
  {
    original_query: "clickfliesen",
    total_searches: 3,
  },
  {
    original_query: "turnmatte",
    total_searches: 3,
  },
  {
    original_query: "stacheld",
    total_searches: 3,
  },
  {
    original_query: "Erdnä",
    total_searches: 3,
  },
  {
    original_query: "ttre",
    total_searches: 3,
  },
  {
    original_query: "mamut",
    total_searches: 3,
  },
  {
    original_query: "schlingflor",
    total_searches: 3,
  },
  {
    original_query: "bubb",
    total_searches: 3,
  },
  {
    original_query: "Grillschutzmatt",
    total_searches: 3,
  },
  {
    original_query: "tiere",
    total_searches: 3,
  },
  {
    original_query: "lavendel",
    total_searches: 3,
  },
  {
    original_query: "hummi",
    total_searches: 3,
  },
  {
    original_query: "karos",
    total_searches: 3,
  },
  {
    original_query: "fußmar",
    total_searches: 3,
  },
  {
    original_query: "Stuffen",
    total_searches: 3,
  },
  {
    original_query: "versandzeit",
    total_searches: 3,
  },
  {
    original_query: "kaminholzreg",
    total_searches: 3,
  },
  {
    original_query: "verbindung",
    total_searches: 3,
  },
  {
    original_query: "grillabdec",
    total_searches: 3,
  },
  {
    original_query: "sten",
    total_searches: 3,
  },
  {
    original_query: "eckprofile",
    total_searches: 3,
  },
  {
    original_query: "tira",
    total_searches: 3,
  },
  {
    original_query: "befestigungschiene",
    total_searches: 3,
  },
  {
    original_query: "fußabstr",
    total_searches: 3,
  },
  {
    original_query: "doku",
    total_searches: 3,
  },
  {
    original_query: "bodenprofile",
    total_searches: 3,
  },
  {
    original_query: "flaschenkastenstän",
    total_searches: 3,
  },
  {
    original_query: "treppenprofi",
    total_searches: 3,
  },
  {
    original_query: "terazz",
    total_searches: 3,
  },
  {
    original_query: "filztas",
    total_searches: 3,
  },
  {
    original_query: "Tischmatt",
    total_searches: 3,
  },
  {
    original_query: "srufe",
    total_searches: 3,
  },
  {
    original_query: "terazza",
    total_searches: 3,
  },
  {
    original_query: "Korkbode",
    total_searches: 3,
  },
  {
    original_query: "Suchtschu",
    total_searches: 3,
  },
  {
    original_query: "tell",
    total_searches: 3,
  },
  {
    original_query: "Windschu",
    total_searches: 3,
  },
  {
    original_query: "kosmetikspi",
    total_searches: 3,
  },
  {
    original_query: "schmutzmat",
    total_searches: 3,
  },
  {
    original_query: "Vorha",
    total_searches: 3,
  },
  {
    original_query: "fußabst",
    total_searches: 3,
  },
  {
    original_query: "verf",
    total_searches: 3,
  },
  {
    original_query: "hochzeit",
    total_searches: 3,
  },
  {
    original_query: "gartensichtschutz",
    total_searches: 3,
  },
  {
    original_query: "Magnettafe",
    total_searches: 3,
  },
  {
    original_query: "schale",
    total_searches: 3,
  },
  {
    original_query: "galerie",
    total_searches: 3,
  },
  {
    original_query: "Zaunp",
    total_searches: 3,
  },
  {
    original_query: "piranh",
    total_searches: 3,
  },
  {
    original_query: "brauner",
    total_searches: 3,
  },
  {
    original_query: "Kabelmatte",
    total_searches: 3,
  },
  {
    original_query: "Kunstrasenk",
    total_searches: 3,
  },
  {
    original_query: "Korkro",
    total_searches: 3,
  },
  {
    original_query: "Getr",
    total_searches: 3,
  },
  {
    original_query: "Vienn",
    total_searches: 3,
  },
  {
    original_query: "umrand",
    total_searches: 3,
  },
  {
    original_query: "blak",
    total_searches: 3,
  },
  {
    original_query: "gilz",
    total_searches: 3,
  },
  {
    original_query: "grillhaube",
    total_searches: 3,
  },
  {
    original_query: "buch",
    total_searches: 3,
  },
  {
    original_query: "Badezimmermatte",
    total_searches: 3,
  },
  {
    original_query: "refle",
    total_searches: 3,
  },
  {
    original_query: "stufenabschluss",
    total_searches: 3,
  },
  {
    original_query: "bentzon",
    total_searches: 3,
  },
  {
    original_query: "Kette",
    total_searches: 3,
  },
  {
    original_query: "Kettelte",
    total_searches: 3,
  },
  {
    original_query: "Suchtschutz",
    total_searches: 3,
  },
  {
    original_query: "rsente",
    total_searches: 3,
  },
  {
    original_query: "Schutzfang",
    total_searches: 3,
  },
  {
    original_query: "abschlusprofil",
    total_searches: 3,
  },
  {
    original_query: "Zerasse",
    total_searches: 3,
  },
  {
    original_query: "Fallschutzmatten",
    total_searches: 3,
  },
  {
    original_query: "fußleis",
    total_searches: 3,
  },
  {
    original_query: "orang",
    total_searches: 3,
  },
  {
    original_query: "Korkb",
    total_searches: 3,
  },
  {
    original_query: "sonnensegeln",
    total_searches: 3,
  },
  {
    original_query: "tafelofolie",
    total_searches: 3,
  },
  {
    original_query: "Korkr",
    total_searches: 3,
  },
  {
    original_query: "valen",
    total_searches: 3,
  },
  {
    original_query: "bestellu",
    total_searches: 3,
  },
  {
    original_query: "rasrn",
    total_searches: 3,
  },
  {
    original_query: "gymnastik",
    total_searches: 3,
  },
  {
    original_query: "Leufe",
    total_searches: 3,
  },
  {
    original_query: "balkonm",
    total_searches: 3,
  },
  {
    original_query: "Heidekrautmatte",
    total_searches: 3,
  },
  {
    original_query: "teppichlaü",
    total_searches: 3,
  },
  {
    original_query: "juteteppich",
    total_searches: 3,
  },
  {
    original_query: "fussabstr",
    total_searches: 3,
  },
  {
    original_query: "Antirutschsicher",
    total_searches: 3,
  },
  {
    original_query: "bers",
    total_searches: 3,
  },
  {
    original_query: "vogels",
    total_searches: 3,
  },
  {
    original_query: "Teppichbr",
    total_searches: 3,
  },
  {
    original_query: "übergangsschi",
    total_searches: 3,
  },
  {
    original_query: "stretc",
    total_searches: 3,
  },
  {
    original_query: "nadelfilr",
    total_searches: 3,
  },
  {
    original_query: "schallschutzma",
    total_searches: 3,
  },
  {
    original_query: "poolunterl",
    total_searches: 3,
  },
  {
    original_query: "stfe",
    total_searches: 3,
  },
  {
    original_query: "gymnast",
    total_searches: 3,
  },
  {
    original_query: "mant",
    total_searches: 3,
  },
  {
    original_query: "fahrradf",
    total_searches: 3,
  },
  {
    original_query: "Teppisc",
    total_searches: 3,
  },
  {
    original_query: "schnee",
    total_searches: 3,
  },
  {
    original_query: "pegulan",
    total_searches: 3,
  },
  {
    original_query: "Weisen",
    total_searches: 3,
  },
  {
    original_query: "fahhrad",
    total_searches: 3,
  },
  {
    original_query: "wandanschluss",
    total_searches: 3,
  },
  {
    original_query: "Böschungsmatte",
    total_searches: 3,
  },
  {
    original_query: "drahtgeflecht",
    total_searches: 3,
  },
  {
    original_query: "vliess",
    total_searches: 3,
  },
  {
    original_query: "Diamon",
    total_searches: 3,
  },
  {
    original_query: "kratzm",
    total_searches: 3,
  },
  {
    original_query: "hochfli",
    total_searches: 3,
  },
  {
    original_query: "Insek",
    total_searches: 3,
  },
  {
    original_query: "Kratzt",
    total_searches: 3,
  },
  {
    original_query: "Camper",
    total_searches: 3,
  },
  {
    original_query: "köick",
    total_searches: 3,
  },
  {
    original_query: "primavera",
    total_searches: 3,
  },
  {
    original_query: "Fils",
    total_searches: 3,
  },
  {
    original_query: "stallmate",
    total_searches: 3,
  },
  {
    original_query: "teppichvorleg",
    total_searches: 3,
  },
  {
    original_query: "Zerassen",
    total_searches: 3,
  },
  {
    original_query: "rolos",
    total_searches: 3,
  },
  {
    original_query: "Sichtschitz",
    total_searches: 3,
  },
  {
    original_query: "höhenausgleichsprofil",
    total_searches: 3,
  },
  {
    original_query: "ekby",
    total_searches: 3,
  },
  {
    original_query: "navo",
    total_searches: 3,
  },
  {
    original_query: "hauben",
    total_searches: 3,
  },
  {
    original_query: "gitterfoli",
    total_searches: 3,
  },
  {
    original_query: "salvator",
    total_searches: 3,
  },
  {
    original_query: "schmutzfangam",
    total_searches: 3,
  },
  {
    original_query: "straßenteppich",
    total_searches: 3,
  },
  {
    original_query: "moquette",
    total_searches: 3,
  },
  {
    original_query: "Teppichrase",
    total_searches: 3,
  },
  {
    original_query: "Kunstrasenkle",
    total_searches: 3,
  },
  {
    original_query: "rasenteppisc",
    total_searches: 3,
  },
  {
    original_query: "schmutzfu",
    total_searches: 3,
  },
  {
    original_query: "Treppenma",
    total_searches: 3,
  },
  {
    original_query: "Leipzig",
    total_searches: 3,
  },
  {
    original_query: "bambusmatt",
    total_searches: 3,
  },
  {
    original_query: "Prom",
    total_searches: 3,
  },
  {
    original_query: "schlüsseltre",
    total_searches: 3,
  },
  {
    original_query: "Boots",
    total_searches: 3,
  },
  {
    original_query: "gera",
    total_searches: 3,
  },
  {
    original_query: "antirutschmattw",
    total_searches: 3,
  },
  {
    original_query: "zaunverkleidung",
    total_searches: 3,
  },
  {
    original_query: "Balkonsichtschut",
    total_searches: 3,
  },
  {
    original_query: "klassisch",
    total_searches: 3,
  },
  {
    original_query: "schmutzang",
    total_searches: 3,
  },
  {
    original_query: "coot",
    total_searches: 3,
  },
  {
    original_query: "Badet",
    total_searches: 3,
  },
  {
    original_query: "abtrete",
    total_searches: 3,
  },
  {
    original_query: "Turk",
    total_searches: 3,
  },
  {
    original_query: "überganspr",
    total_searches: 3,
  },
  {
    original_query: "Mäuse",
    total_searches: 3,
  },
  {
    original_query: "avondale",
    total_searches: 3,
  },
  {
    original_query: "bodenschutumatte",
    total_searches: 3,
  },
  {
    original_query: "eucalyptus",
    total_searches: 3,
  },
  {
    original_query: "fussabstreif",
    total_searches: 3,
  },
  {
    original_query: "verbinde",
    total_searches: 3,
  },
  {
    original_query: "kars",
    total_searches: 3,
  },
  {
    original_query: "kusc",
    total_searches: 3,
  },
  {
    original_query: "katzente",
    total_searches: 3,
  },
  {
    original_query: "kosmetic",
    total_searches: 3,
  },
  {
    original_query: "Cora",
    total_searches: 3,
  },
  {
    original_query: "Filtz",
    total_searches: 3,
  },
  {
    original_query: "marbe",
    total_searches: 3,
  },
  {
    original_query: "smutzfangmatte",
    total_searches: 3,
  },
  {
    original_query: "paracord",
    total_searches: 3,
  },
  {
    original_query: "Bologna",
    total_searches: 3,
  },
  {
    original_query: "rucksen",
    total_searches: 3,
  },
  {
    original_query: "befestigungsstang",
    total_searches: 3,
  },
  {
    original_query: "Stabilisierungs",
    total_searches: 3,
  },
  {
    original_query: "klickfließe",
    total_searches: 3,
  },
  {
    original_query: "Nadelfl",
    total_searches: 3,
  },
  {
    original_query: "pavilion",
    total_searches: 3,
  },
  {
    original_query: "velourteppi",
    total_searches: 3,
  },
  {
    original_query: "Sola",
    total_searches: 3,
  },
  {
    original_query: "rillenmatte",
    total_searches: 3,
  },
  {
    original_query: "seat",
    total_searches: 3,
  },
  {
    original_query: "mehrzweckregal",
    total_searches: 3,
  },
  {
    original_query: "Sisalläufe",
    total_searches: 3,
  },
  {
    original_query: "Badmatt",
    total_searches: 3,
  },
  {
    original_query: "Raset",
    total_searches: 3,
  },
  {
    original_query: "raasente",
    total_searches: 3,
  },
  {
    original_query: "klebebe",
    total_searches: 3,
  },
  {
    original_query: "expan",
    total_searches: 3,
  },
  {
    original_query: "magnum",
    total_searches: 3,
  },
  {
    original_query: "Amazon",
    total_searches: 3,
  },
  {
    original_query: "wetterfest",
    total_searches: 3,
  },
  {
    original_query: "Bidenschutz",
    total_searches: 3,
  },
  {
    original_query: "getränkeständer",
    total_searches: 3,
  },
  {
    original_query: "terrr",
    total_searches: 3,
  },
  {
    original_query: "stufenmaz",
    total_searches: 3,
  },
  {
    original_query: "Poolun",
    total_searches: 3,
  },
  {
    original_query: "gummibodenmatte",
    total_searches: 3,
  },
  {
    original_query: "coir",
    total_searches: 3,
  },
  {
    original_query: "bürostuhlun",
    total_searches: 3,
  },
  {
    original_query: "Rege",
    total_searches: 3,
  },
  {
    original_query: "fleece",
    total_searches: 3,
  },
  {
    original_query: "abschluß",
    total_searches: 3,
  },
  {
    original_query: "silbergrau",
    total_searches: 3,
  },
  {
    original_query: "rollhocj",
    total_searches: 3,
  },
  {
    original_query: "rampenma",
    total_searches: 3,
  },
  {
    original_query: "Balkonr",
    total_searches: 3,
  },
  {
    original_query: "abdekun",
    total_searches: 3,
  },
  {
    original_query: "chenill",
    total_searches: 3,
  },
  {
    original_query: "zaunblenden",
    total_searches: 3,
  },
  {
    original_query: "Flickente",
    total_searches: 3,
  },
  {
    original_query: "plachta",
    total_searches: 3,
  },
  {
    original_query: "biotopia",
    total_searches: 3,
  },
  {
    original_query: "sisalkratz",
    total_searches: 3,
  },
  {
    original_query: "Rasenk",
    total_searches: 3,
  },
  {
    original_query: "plies",
    total_searches: 3,
  },
  {
    original_query: "korkklebe",
    total_searches: 3,
  },
  {
    original_query: "duschstange",
    total_searches: 3,
  },
  {
    original_query: "stufenmar",
    total_searches: 3,
  },
  {
    original_query: "feinschlingenteppich",
    total_searches: 3,
  },
  {
    original_query: "stiefel",
    total_searches: 3,
  },
  {
    original_query: "regensegel",
    total_searches: 3,
  },
  {
    original_query: "mantua",
    total_searches: 3,
  },
  {
    original_query: "Stufenpr",
    total_searches: 3,
  },
  {
    original_query: "sugher",
    total_searches: 3,
  },
  {
    original_query: "Clair",
    total_searches: 3,
  },
  {
    original_query: "gummiwabe",
    total_searches: 3,
  },
  {
    original_query: "naples",
    total_searches: 3,
  },
  {
    original_query: "Stanfor",
    total_searches: 3,
  },
  {
    original_query: "Holzflie",
    total_searches: 3,
  },
  {
    original_query: "abmel",
    total_searches: 3,
  },
  {
    original_query: "Zaunpf",
    total_searches: 3,
  },
  {
    original_query: "rasenm",
    total_searches: 3,
  },
  {
    original_query: "Pflanzstäbe",
    total_searches: 3,
  },
  {
    original_query: "rhune",
    total_searches: 3,
  },
  {
    original_query: "katyen",
    total_searches: 3,
  },
  {
    original_query: "magnettafeln",
    total_searches: 3,
  },
  {
    original_query: "bauschutzma",
    total_searches: 3,
  },
  {
    original_query: "desso",
    total_searches: 3,
  },
  {
    original_query: "filzm",
    total_searches: 3,
  },
  {
    original_query: "spektr",
    total_searches: 3,
  },
  {
    original_query: "eventteppi",
    total_searches: 3,
  },
  {
    original_query: "Nadelh",
    total_searches: 3,
  },
  {
    original_query: "stuftenmatten",
    total_searches: 3,
  },
  {
    original_query: "sauberlai",
    total_searches: 3,
  },
  {
    original_query: "warsch",
    total_searches: 3,
  },
  {
    original_query: "fussmtte",
    total_searches: 3,
  },
  {
    original_query: "gewerbeplane",
    total_searches: 3,
  },
  {
    original_query: "Zaunpfosten",
    total_searches: 3,
  },
  {
    original_query: "Zaub",
    total_searches: 3,
  },
  {
    original_query: "Nadelfiz",
    total_searches: 3,
  },
  {
    original_query: "Doppelsei",
    total_searches: 3,
  },
  {
    original_query: "gerüs",
    total_searches: 3,
  },
  {
    original_query: "anhängernetz",
    total_searches: 3,
  },
  {
    original_query: "selbsklebend",
    total_searches: 3,
  },
  {
    original_query: "fussbodenmatte",
    total_searches: 3,
  },
  {
    original_query: "trittsch",
    total_searches: 3,
  },
  {
    original_query: "fiat",
    total_searches: 3,
  },
  {
    original_query: "lichtdurchlässiges",
    total_searches: 3,
  },
  {
    original_query: "Selbstklebe",
    total_searches: 3,
  },
  {
    original_query: "kznst",
    total_searches: 3,
  },
  {
    original_query: "bodenschutzpla",
    total_searches: 3,
  },
  {
    original_query: "Rind",
    total_searches: 3,
  },
  {
    original_query: "saunamatte",
    total_searches: 3,
  },
  {
    original_query: "treppenhaus",
    total_searches: 3,
  },
  {
    original_query: "sockelei",
    total_searches: 3,
  },
  {
    original_query: "Ausglei",
    total_searches: 3,
  },
  {
    original_query: "Abdex",
    total_searches: 3,
  },
  {
    original_query: "fikz",
    total_searches: 3,
  },
  {
    original_query: "bambusr",
    total_searches: 3,
  },
  {
    original_query: "mamm",
    total_searches: 3,
  },
  {
    original_query: "rutschhe",
    total_searches: 3,
  },
  {
    original_query: "stufenkantenprofu",
    total_searches: 3,
  },
  {
    original_query: "marr",
    total_searches: 3,
  },
  {
    original_query: "Duschhocker",
    total_searches: 3,
  },
  {
    original_query: "abdeckvlies",
    total_searches: 3,
  },
  {
    original_query: "Balkonrasen",
    total_searches: 3,
  },
  {
    original_query: "sischtschutz",
    total_searches: 3,
  },
  {
    original_query: "schmutzfankmatte",
    total_searches: 3,
  },
  {
    original_query: "befestigungsmaterial",
    total_searches: 3,
  },
  {
    original_query: "Balkonum",
    total_searches: 3,
  },
  {
    original_query: "Doppelse",
    total_searches: 3,
  },
  {
    original_query: "Ornam",
    total_searches: 3,
  },
  {
    original_query: "fußabstre",
    total_searches: 3,
  },
  {
    original_query: "Wischmopp",
    total_searches: 3,
  },
  {
    original_query: "regl",
    total_searches: 3,
  },
  {
    original_query: "treooe",
    total_searches: 3,
  },
  {
    original_query: "klickfliesw",
    total_searches: 3,
  },
  {
    original_query: "Kunstrasentepp",
    total_searches: 3,
  },
  {
    original_query: "Leip",
    total_searches: 3,
  },
  {
    original_query: "melang",
    total_searches: 3,
  },
  {
    original_query: "Teppichbrücke",
    total_searches: 3,
  },
  {
    original_query: "aussentepp",
    total_searches: 3,
  },
  {
    original_query: "grillschutzmatten",
    total_searches: 3,
  },
  {
    original_query: "balkonbo",
    total_searches: 3,
  },
  {
    original_query: "reifenrega",
    total_searches: 3,
  },
  {
    original_query: "gardarobenständer",
    total_searches: 3,
  },
  {
    original_query: "amti",
    total_searches: 3,
  },
  {
    original_query: "Bodenschi",
    total_searches: 3,
  },
  {
    original_query: "sauberlaufmate",
    total_searches: 3,
  },
  {
    original_query: "kurzform",
    total_searches: 3,
  },
  {
    original_query: "übergangsprofiel",
    total_searches: 3,
  },
  {
    original_query: "uberg",
    total_searches: 3,
  },
  {
    original_query: "modica",
    total_searches: 3,
  },
  {
    original_query: "rasentepisch",
    total_searches: 3,
  },
  {
    original_query: "Badevorleger",
    total_searches: 3,
  },
  {
    original_query: "Rasenteppiv",
    total_searches: 3,
  },
  {
    original_query: "geländer",
    total_searches: 3,
  },
  {
    original_query: "Transpa",
    total_searches: 3,
  },
  {
    original_query: "Prome",
    total_searches: 3,
  },
  {
    original_query: "treteimer",
    total_searches: 3,
  },
  {
    original_query: "metallgitter",
    total_searches: 3,
  },
  {
    original_query: "fellte",
    total_searches: 3,
  },
  {
    original_query: "stoc",
    total_searches: 3,
  },
  {
    original_query: "Pflanzs",
    total_searches: 3,
  },
  {
    original_query: "bambusmat",
    total_searches: 3,
  },
  {
    original_query: "halbr",
    total_searches: 3,
  },
  {
    original_query: "abtropfmatte",
    total_searches: 3,
  },
  {
    original_query: "Kurzfloo",
    total_searches: 3,
  },
  {
    original_query: "tränenble",
    total_searches: 3,
  },
  {
    original_query: "kunstteppi",
    total_searches: 3,
  },
  {
    original_query: "sinnen",
    total_searches: 3,
  },
  {
    original_query: "wohnwag",
    total_searches: 3,
  },
  {
    original_query: "abdeckplanr",
    total_searches: 3,
  },
  {
    original_query: "hochbee",
    total_searches: 3,
  },
  {
    original_query: "duschvorl",
    total_searches: 3,
  },
  {
    original_query: "Stufenteppich",
    total_searches: 3,
  },
  {
    original_query: "Gewächshauspl",
    total_searches: 3,
  },
  {
    original_query: "Stufenla",
    total_searches: 3,
  },
  {
    original_query: "Segeltuch",
    total_searches: 3,
  },
  {
    original_query: "ausen",
    total_searches: 3,
  },
  {
    original_query: "filzfli",
    total_searches: 3,
  },
  {
    original_query: "Bonit",
    total_searches: 3,
  },
  {
    original_query: "athen",
    total_searches: 3,
  },
  {
    original_query: "polhöhe",
    total_searches: 3,
  },
  {
    original_query: "holl",
    total_searches: 3,
  },
  {
    original_query: "bodenscht",
    total_searches: 3,
  },
  {
    original_query: "Kopfstützen",
    total_searches: 3,
  },
  {
    original_query: "schlingente",
    total_searches: 3,
  },
  {
    original_query: "Pber",
    total_searches: 3,
  },
  {
    original_query: "Holzabdec",
    total_searches: 3,
  },
  {
    original_query: "Klapprah",
    total_searches: 3,
  },
  {
    original_query: "bademstten",
    total_searches: 3,
  },
  {
    original_query: "rasenwunder",
    total_searches: 3,
  },
  {
    original_query: "Schutzhülle",
    total_searches: 3,
  },
  {
    original_query: "regalsystem",
    total_searches: 3,
  },
  {
    original_query: "willkommen",
    total_searches: 3,
  },
  {
    original_query: "Keller",
    total_searches: 3,
  },
  {
    original_query: "bidenschutzma",
    total_searches: 3,
  },
  {
    original_query: "sisallaeufer",
    total_searches: 3,
  },
  {
    original_query: "buchs",
    total_searches: 3,
  },
  {
    original_query: "holzabdeckp",
    total_searches: 3,
  },
  {
    original_query: "Bettvor",
    total_searches: 3,
  },
  {
    original_query: "Ella",
    total_searches: 3,
  },
  {
    original_query: "santorini",
    total_searches: 3,
  },
  {
    original_query: "Louis",
    total_searches: 3,
  },
  {
    original_query: "dämpf",
    total_searches: 3,
  },
  {
    original_query: "Flachnoppen",
    total_searches: 3,
  },
  {
    original_query: "baumwo",
    total_searches: 3,
  },
  {
    original_query: "Magnetta",
    total_searches: 3,
  },
  {
    original_query: "plinthe",
    total_searches: 3,
  },
  {
    original_query: "telpich",
    total_searches: 3,
  },
  {
    original_query: "nely",
    total_searches: 3,
  },
  {
    original_query: "schublade",
    total_searches: 3,
  },
  {
    original_query: "aussenmatten",
    total_searches: 3,
  },
  {
    original_query: "steine",
    total_searches: 3,
  },
  {
    original_query: "abdexk",
    total_searches: 3,
  },
  {
    original_query: "anpassungsprofi",
    total_searches: 3,
  },
  {
    original_query: "gartent",
    total_searches: 3,
  },
  {
    original_query: "eich",
    total_searches: 3,
  },
  {
    original_query: "Pavi",
    total_searches: 3,
  },
  {
    original_query: "Sisaltreppen",
    total_searches: 3,
  },
  {
    original_query: "küchenö",
    total_searches: 3,
  },
  {
    original_query: "teppichsto",
    total_searches: 3,
  },
  {
    original_query: "Sisalopti",
    total_searches: 3,
  },
  {
    original_query: "bambuskor",
    total_searches: 3,
  },
  {
    original_query: "sisak",
    total_searches: 3,
  },
  {
    original_query: "küchenleiter",
    total_searches: 3,
  },
  {
    original_query: "schit",
    total_searches: 3,
  },
  {
    original_query: "cala",
    total_searches: 3,
  },
  {
    original_query: "regenschutz",
    total_searches: 3,
  },
  {
    original_query: "Hohlkammerplatt",
    total_searches: 3,
  },
  {
    original_query: "treppenbel",
    total_searches: 3,
  },
  {
    original_query: "wachstuc",
    total_searches: 3,
  },
  {
    original_query: "baumwollmatten",
    total_searches: 3,
  },
  {
    original_query: "Industrie",
    total_searches: 3,
  },
  {
    original_query: "läuft",
    total_searches: 3,
  },
  {
    original_query: "sbdeck",
    total_searches: 3,
  },
  {
    original_query: "Läfer",
    total_searches: 3,
  },
  {
    original_query: "daisi",
    total_searches: 3,
  },
  {
    original_query: "sach",
    total_searches: 3,
  },
  {
    original_query: "Clips",
    total_searches: 3,
  },
  {
    original_query: "Schmur",
    total_searches: 3,
  },
  {
    original_query: "abschlußpro",
    total_searches: 3,
  },
  {
    original_query: "cony",
    total_searches: 3,
  },
  {
    original_query: "schlüsseltres",
    total_searches: 3,
  },
  {
    original_query: "befestigungsstan",
    total_searches: 3,
  },
  {
    original_query: "volierendrah",
    total_searches: 3,
  },
  {
    original_query: "Rasengitter",
    total_searches: 3,
  },
  {
    original_query: "Sisalläuf",
    total_searches: 3,
  },
  {
    original_query: "automatt",
    total_searches: 3,
  },
  {
    original_query: "Dynasti",
    total_searches: 3,
  },
  {
    original_query: "wandhaken",
    total_searches: 3,
  },
  {
    original_query: "stufenle",
    total_searches: 3,
  },
  {
    original_query: "nadelfils",
    total_searches: 3,
  },
  {
    original_query: "Autofil",
    total_searches: 3,
  },
  {
    original_query: "Sichtschutzstreife",
    total_searches: 3,
  },
  {
    original_query: "dtufen",
    total_searches: 3,
  },
  {
    original_query: "treoo",
    total_searches: 3,
  },
  {
    original_query: "universal",
    total_searches: 3,
  },
  {
    original_query: "knick",
    total_searches: 3,
  },
  {
    original_query: "Vinylteppich",
    total_searches: 3,
  },
  {
    original_query: "Holzab",
    total_searches: 3,
  },
  {
    original_query: "katzenk",
    total_searches: 3,
  },
  {
    original_query: "eckschiene",
    total_searches: 3,
  },
  {
    original_query: "stabmatten",
    total_searches: 3,
  },
  {
    original_query: "gummisch",
    total_searches: 3,
  },
  {
    original_query: "rasenteteppich",
    total_searches: 3,
  },
  {
    original_query: "ermüdungsma",
    total_searches: 3,
  },
  {
    original_query: "Fußabstre",
    total_searches: 3,
  },
  {
    original_query: "stei",
    total_searches: 3,
  },
  {
    original_query: "Sinne",
    total_searches: 3,
  },
  {
    original_query: "Schmutzfangmate",
    total_searches: 3,
  },
  {
    original_query: "hochbeetfolie",
    total_searches: 3,
  },
  {
    original_query: "regak",
    total_searches: 3,
  },
  {
    original_query: "pflanzennetz",
    total_searches: 3,
  },
  {
    original_query: "latex",
    total_searches: 3,
  },
  {
    original_query: "balkonbespannung",
    total_searches: 3,
  },
  {
    original_query: "abdeckprofil",
    total_searches: 3,
  },
  {
    original_query: "umra",
    total_searches: 3,
  },
  {
    original_query: "dunkelblau",
    total_searches: 3,
  },
  {
    original_query: "wandabschluss",
    total_searches: 3,
  },
  {
    original_query: "ausgleichschienen",
    total_searches: 3,
  },
  {
    original_query: "zaunf",
    total_searches: 3,
  },
  {
    original_query: "alumi",
    total_searches: 3,
  },
  {
    original_query: "aussenfussmatte",
    total_searches: 3,
  },
  {
    original_query: "Fitne",
    total_searches: 3,
  },
  {
    original_query: "badezimmerteppic",
    total_searches: 3,
  },
  {
    original_query: "türschwe",
    total_searches: 3,
  },
  {
    original_query: "fussabtret",
    total_searches: 3,
  },
  {
    original_query: "vogela",
    total_searches: 3,
  },
  {
    original_query: "wäsches",
    total_searches: 3,
  },
  {
    original_query: "wpcflie",
    total_searches: 3,
  },
  {
    original_query: "stufenlantenprofil",
    total_searches: 3,
  },
  {
    original_query: "farbwi",
    total_searches: 3,
  },
  {
    original_query: "nadeln",
    total_searches: 3,
  },
  {
    original_query: "kaminbesteck",
    total_searches: 3,
  },
  {
    original_query: "gartenfolie",
    total_searches: 3,
  },
  {
    original_query: "bodenläufer",
    total_searches: 3,
  },
  {
    original_query: "angebote",
    total_searches: 3,
  },
  {
    original_query: "lederte",
    total_searches: 3,
  },
  {
    original_query: "Teppichun",
    total_searches: 3,
  },
  {
    original_query: "Tiran",
    total_searches: 3,
  },
  {
    original_query: "Antirutschsi",
    total_searches: 3,
  },
  {
    original_query: "klickfliw",
    total_searches: 3,
  },
  {
    original_query: "pferdeanhänger",
    total_searches: 3,
  },
  {
    original_query: "sess",
    total_searches: 3,
  },
  {
    original_query: "vorra",
    total_searches: 3,
  },
  {
    original_query: "selbstk",
    total_searches: 3,
  },
  {
    original_query: "tepichfliese",
    total_searches: 3,
  },
  {
    original_query: "putd",
    total_searches: 3,
  },
  {
    original_query: "kunststofffliese",
    total_searches: 3,
  },
  {
    original_query: "Dust",
    total_searches: 3,
  },
  {
    original_query: "Teppisch",
    total_searches: 3,
  },
  {
    original_query: "Zaunpfos",
    total_searches: 3,
  },
  {
    original_query: "mücken",
    total_searches: 3,
  },
  {
    original_query: "Treppenhausläufer",
    total_searches: 3,
  },
  {
    original_query: "Meta",
    total_searches: 3,
  },
  {
    original_query: "Mumb",
    total_searches: 3,
  },
  {
    original_query: "noppenbe",
    total_searches: 3,
  },
  {
    original_query: "Stell",
    total_searches: 3,
  },
  {
    original_query: "filztrennwand",
    total_searches: 3,
  },
  {
    original_query: "wohnmob",
    total_searches: 3,
  },
  {
    original_query: "Stei",
    total_searches: 3,
  },
  {
    original_query: "outdoormatten",
    total_searches: 3,
  },
  {
    original_query: "Teppichkle",
    total_searches: 3,
  },
  {
    original_query: "azur",
    total_searches: 3,
  },
  {
    original_query: "pads",
    total_searches: 3,
  },
  {
    original_query: "rasenteppicch",
    total_searches: 3,
  },
  {
    original_query: "spro",
    total_searches: 3,
  },
  {
    original_query: "mida",
    total_searches: 3,
  },
  {
    original_query: "schnellspanner",
    total_searches: 3,
  },
  {
    original_query: "duschregal",
    total_searches: 3,
  },
  {
    original_query: "schmutzlä",
    total_searches: 3,
  },
  {
    original_query: "stufenartig",
    total_searches: 3,
  },
  {
    original_query: "Feuersc",
    total_searches: 3,
  },
  {
    original_query: "bernie",
    total_searches: 3,
  },
  {
    original_query: "wuhl",
    total_searches: 3,
  },
  {
    original_query: "panama",
    total_searches: 3,
  },
  {
    original_query: "Holzbre",
    total_searches: 3,
  },
  {
    original_query: "Floord",
    total_searches: 3,
  },
  {
    original_query: "rosen",
    total_searches: 3,
  },
  {
    original_query: "Liege",
    total_searches: 3,
  },
  {
    original_query: "fußabtret",
    total_searches: 3,
  },
  {
    original_query: "hohlkamme",
    total_searches: 3,
  },
  {
    original_query: "dalto",
    total_searches: 3,
  },
  {
    original_query: "dielenläufer",
    total_searches: 3,
  },
  {
    original_query: "schnutzfangmatten",
    total_searches: 3,
  },
  {
    original_query: "kleiderbügel",
    total_searches: 3,
  },
  {
    original_query: "katzenne",
    total_searches: 3,
  },
  {
    original_query: "Sinn",
    total_searches: 3,
  },
  {
    original_query: "bodensh",
    total_searches: 3,
  },
  {
    original_query: "Kunden",
    total_searches: 3,
  },
  {
    original_query: "andre",
    total_searches: 3,
  },
  {
    original_query: "maßteppich",
    total_searches: 3,
  },
  {
    original_query: "tepichläufer",
    total_searches: 3,
  },
  {
    original_query: "markisens",
    total_searches: 3,
  },
  {
    original_query: "Weidezaun",
    total_searches: 3,
  },
  {
    original_query: "platt",
    total_searches: 3,
  },
  {
    original_query: "gram",
    total_searches: 3,
  },
  {
    original_query: "badenmatte",
    total_searches: 3,
  },
  {
    original_query: "schutzkanten",
    total_searches: 3,
  },
  {
    original_query: "control",
    total_searches: 3,
  },
  {
    original_query: "flauschig",
    total_searches: 3,
  },
  {
    original_query: "teppichläufee",
    total_searches: 3,
  },
  {
    original_query: "colomb",
    total_searches: 3,
  },
  {
    original_query: "Nadeldilz",
    total_searches: 3,
  },
  {
    original_query: "sonnenseegel",
    total_searches: 3,
  },
  {
    original_query: "karabin",
    total_searches: 3,
  },
  {
    original_query: "gartenhaus",
    total_searches: 3,
  },
  {
    original_query: "schmutzgang",
    total_searches: 3,
  },
  {
    original_query: "Rasenr",
    total_searches: 3,
  },
  {
    original_query: "Tritts",
    total_searches: 3,
  },
  {
    original_query: "umran",
    total_searches: 3,
  },
  {
    original_query: "Schmutzg",
    total_searches: 3,
  },
  {
    original_query: "horizo",
    total_searches: 3,
  },
  {
    original_query: "terassenplane",
    total_searches: 3,
  },
  {
    original_query: "sntir",
    total_searches: 3,
  },
  {
    original_query: "rundteppic",
    total_searches: 3,
  },
  {
    original_query: "kuech",
    total_searches: 3,
  },
  {
    original_query: "Chevron",
    total_searches: 3,
  },
  {
    original_query: "mesh",
    total_searches: 3,
  },
  {
    original_query: "gummilöufer",
    total_searches: 3,
  },
  {
    original_query: "fische",
    total_searches: 3,
  },
  {
    original_query: "Klappra",
    total_searches: 3,
  },
  {
    original_query: "gerippt",
    total_searches: 3,
  },
  {
    original_query: "Granulat",
    total_searches: 3,
  },
  {
    original_query: "zaunsicht",
    total_searches: 3,
  },
  {
    original_query: "fensterf",
    total_searches: 3,
  },
  {
    original_query: "bitumen",
    total_searches: 3,
  },
  {
    original_query: "balkonblende",
    total_searches: 3,
  },
  {
    original_query: "Doppelseit",
    total_searches: 3,
  },
  {
    original_query: "rampenmatt",
    total_searches: 3,
  },
  {
    original_query: "horiz",
    total_searches: 3,
  },
  {
    original_query: "beetumr",
    total_searches: 3,
  },
  {
    original_query: "lamellenmatte",
    total_searches: 3,
  },
  {
    original_query: "terrassend",
    total_searches: 3,
  },
  {
    original_query: "flipboard",
    total_searches: 3,
  },
  {
    original_query: "Rankgitte",
    total_searches: 3,
  },
  {
    original_query: "befestigungschienen",
    total_searches: 3,
  },
  {
    original_query: "Drahtza",
    total_searches: 3,
  },
  {
    original_query: "stakk",
    total_searches: 3,
  },
  {
    original_query: "Sichtschi",
    total_searches: 3,
  },
  {
    original_query: "nepal",
    total_searches: 3,
  },
  {
    original_query: "karab",
    total_searches: 3,
  },
  {
    original_query: "babm",
    total_searches: 3,
  },
  {
    original_query: "badems",
    total_searches: 3,
  },
  {
    original_query: "Badma",
    total_searches: 3,
  },
  {
    original_query: "expa",
    total_searches: 3,
  },
  {
    original_query: "bodenschutymatte",
    total_searches: 3,
  },
  {
    original_query: "Teppichkanten",
    total_searches: 3,
  },
  {
    original_query: "balkonras",
    total_searches: 3,
  },
  {
    original_query: "schuhmacher",
    total_searches: 3,
  },
  {
    original_query: "dehli",
    total_searches: 3,
  },
  {
    original_query: "turn",
    total_searches: 3,
  },
  {
    original_query: "hitzeschutz",
    total_searches: 3,
  },
  {
    original_query: "glasrega",
    total_searches: 3,
  },
  {
    original_query: "teppichra",
    total_searches: 3,
  },
  {
    original_query: "Abschlussl",
    total_searches: 3,
  },
  {
    original_query: "sitzauflagen",
    total_searches: 3,
  },
  {
    original_query: "polycarbonate",
    total_searches: 3,
  },
  {
    original_query: "bürostuh",
    total_searches: 3,
  },
  {
    original_query: "acri",
    total_searches: 3,
  },
  {
    original_query: "dayton",
    total_searches: 3,
  },
  {
    original_query: "fußbodenleisten",
    total_searches: 3,
  },
  {
    original_query: "oesen",
    total_searches: 3,
  },
  {
    original_query: "bodenscv",
    total_searches: 3,
  },
  {
    original_query: "bamu",
    total_searches: 3,
  },
  {
    original_query: "Velor",
    total_searches: 3,
  },
  {
    original_query: "latsche",
    total_searches: 3,
  },
  {
    original_query: "rücksendungen",
    total_searches: 3,
  },
  {
    original_query: "granulate",
    total_searches: 3,
  },
  {
    original_query: "florena",
    total_searches: 3,
  },
  {
    original_query: "korkbelag",
    total_searches: 3,
  },
  {
    original_query: "hochleis",
    total_searches: 3,
  },
  {
    original_query: "Hohlkammerpl",
    total_searches: 3,
  },
  {
    original_query: "feinriefen",
    total_searches: 3,
  },
  {
    original_query: "kunsra",
    total_searches: 3,
  },
  {
    original_query: "kantens",
    total_searches: 3,
  },
  {
    original_query: "spin",
    total_searches: 3,
  },
  {
    original_query: "gummiplane",
    total_searches: 3,
  },
  {
    original_query: "heimwerkerplatten",
    total_searches: 3,
  },
  {
    original_query: "Ausgleichsprofi",
    total_searches: 3,
  },
  {
    original_query: "halbtrans",
    total_searches: 3,
  },
  {
    original_query: "Glasregal",
    total_searches: 3,
  },
  {
    original_query: "sechs",
    total_searches: 3,
  },
  {
    original_query: "rasenfli",
    total_searches: 3,
  },
  {
    original_query: "schmutzauffa",
    total_searches: 3,
  },
  {
    original_query: "Dunj",
    total_searches: 3,
  },
  {
    original_query: "hochflorr",
    total_searches: 3,
  },
  {
    original_query: "putdoor",
    total_searches: 3,
  },
  {
    original_query: "korkp",
    total_searches: 3,
  },
  {
    original_query: "vorhan",
    total_searches: 3,
  },
  {
    original_query: "badezimmerm",
    total_searches: 3,
  },
  {
    original_query: "Rand",
    total_searches: 3,
  },
  {
    original_query: "rechtec",
    total_searches: 3,
  },
  {
    original_query: "uaun",
    total_searches: 3,
  },
  {
    original_query: "otto",
    total_searches: 3,
  },
  {
    original_query: "Insekt",
    total_searches: 3,
  },
  {
    original_query: "Teppichbrü",
    total_searches: 3,
  },
  {
    original_query: "Schnut",
    total_searches: 3,
  },
  {
    original_query: "camou",
    total_searches: 3,
  },
  {
    original_query: "gangl",
    total_searches: 3,
  },
  {
    original_query: "sofas",
    total_searches: 3,
  },
  {
    original_query: "stakete",
    total_searches: 3,
  },
  {
    original_query: "Honko",
    total_searches: 3,
  },
  {
    original_query: "treop",
    total_searches: 3,
  },
  {
    original_query: "gartenst",
    total_searches: 3,
  },
  {
    original_query: "cancu",
    total_searches: 3,
  },
  {
    original_query: "Teppichunt",
    total_searches: 3,
  },
  {
    original_query: "Clyd",
    total_searches: 3,
  },
  {
    original_query: "adagio",
    total_searches: 3,
  },
  {
    original_query: "mülleimar",
    total_searches: 3,
  },
  {
    original_query: "Honkong",
    total_searches: 3,
  },
  {
    original_query: "schwerlastrehgal",
    total_searches: 3,
  },
  {
    original_query: "Prem",
    total_searches: 3,
  },
  {
    original_query: "hochbeetf",
    total_searches: 3,
  },
  {
    original_query: "ladungssicherung",
    total_searches: 3,
  },
  {
    original_query: "baumrind",
    total_searches: 3,
  },
  {
    original_query: "gaderobenständer",
    total_searches: 3,
  },
  {
    original_query: "Autd",
    total_searches: 3,
  },
  {
    original_query: "rasentwppi",
    total_searches: 3,
  },
  {
    original_query: "Wanne",
    total_searches: 3,
  },
  {
    original_query: "Badewa",
    total_searches: 3,
  },
  {
    original_query: "tierhaltung",
    total_searches: 3,
  },
  {
    original_query: "velourtepp",
    total_searches: 3,
  },
  {
    original_query: "magnetb",
    total_searches: 3,
  },
  {
    original_query: "Kamin",
    total_searches: 3,
  },
  {
    original_query: "maschenweite",
    total_searches: 3,
  },
  {
    original_query: "sira",
    total_searches: 3,
  },
  {
    original_query: "Flachnoppe",
    total_searches: 3,
  },
  {
    original_query: "flachflor",
    total_searches: 3,
  },
  {
    original_query: "Stanford",
    total_searches: 3,
  },
  {
    original_query: "Fliesens",
    total_searches: 3,
  },
  {
    original_query: "hochb",
    total_searches: 3,
  },
  {
    original_query: "schwerlastmatten",
    total_searches: 3,
  },
  {
    original_query: "Aussenteppi",
    total_searches: 3,
  },
  {
    original_query: "chen",
    total_searches: 3,
  },
  {
    original_query: "baumwolltepp",
    total_searches: 3,
  },
  {
    original_query: "mäus",
    total_searches: 3,
  },
  {
    original_query: "Gewächshausp",
    total_searches: 3,
  },
  {
    original_query: "amaza",
    total_searches: 3,
  },
  {
    original_query: "terrassendi",
    total_searches: 3,
  },
  {
    original_query: "outdoorteppichläufer",
    total_searches: 3,
  },
  {
    original_query: "unicolor",
    total_searches: 3,
  },
  {
    original_query: "Pfer",
    total_searches: 3,
  },
  {
    original_query: "nant",
    total_searches: 3,
  },
  {
    original_query: "Toile",
    total_searches: 3,
  },
  {
    original_query: "Teppichunterla",
    total_searches: 3,
  },
  {
    original_query: "Bologn",
    total_searches: 3,
  },
  {
    original_query: "abtropfschale",
    total_searches: 3,
  },
  {
    original_query: "steckzaun",
    total_searches: 3,
  },
  {
    original_query: "boardm",
    total_searches: 3,
  },
  {
    original_query: "wandsch",
    total_searches: 3,
  },
  {
    original_query: "verdung",
    total_searches: 3,
  },
  {
    original_query: "radständer",
    total_searches: 3,
  },
  {
    original_query: "Kokus",
    total_searches: 3,
  },
  {
    original_query: "häringe",
    total_searches: 3,
  },
  {
    original_query: "fliesenprof",
    total_searches: 3,
  },
  {
    original_query: "Treppenstufenpro",
    total_searches: 3,
  },
  {
    original_query: "Fussabtret",
    total_searches: 3,
  },
  {
    original_query: "autdo",
    total_searches: 3,
  },
  {
    original_query: "lckiert",
    total_searches: 3,
  },
  {
    original_query: "Übergans",
    total_searches: 3,
  },
  {
    original_query: "floormat",
    total_searches: 3,
  },
  {
    original_query: "abdex",
    total_searches: 3,
  },
  {
    original_query: "Abdeckplab",
    total_searches: 3,
  },
  {
    original_query: "regalböden",
    total_searches: 3,
  },
  {
    original_query: "antif",
    total_searches: 3,
  },
  {
    original_query: "Tase",
    total_searches: 3,
  },
  {
    original_query: "stam",
    total_searches: 3,
  },
  {
    original_query: "bodenl",
    total_searches: 3,
  },
  {
    original_query: "Doppelseitig",
    total_searches: 3,
  },
  {
    original_query: "Kinderzimmer",
    total_searches: 3,
  },
  {
    original_query: "fangs",
    total_searches: 3,
  },
  {
    original_query: "drahts",
    total_searches: 3,
  },
  {
    original_query: "Unte",
    total_searches: 3,
  },
  {
    original_query: "Nadelv",
    total_searches: 3,
  },
  {
    original_query: "chevr",
    total_searches: 3,
  },
  {
    original_query: "fussabs",
    total_searches: 3,
  },
  {
    original_query: "orga",
    total_searches: 3,
  },
  {
    original_query: "werkst",
    total_searches: 3,
  },
  {
    original_query: "Übergangsl",
    total_searches: 3,
  },
  {
    original_query: "Wohnz",
    total_searches: 3,
  },
  {
    original_query: "rasenf",
    total_searches: 3,
  },
  {
    original_query: "kakutta",
    total_searches: 3,
  },
  {
    original_query: "stuffenkantenprofil",
    total_searches: 3,
  },
  {
    original_query: "coretec",
    total_searches: 3,
  },
  {
    original_query: "anki",
    total_searches: 3,
  },
  {
    original_query: "schutzhulle",
    total_searches: 3,
  },
  {
    original_query: "Autdoor",
    total_searches: 3,
  },
  {
    original_query: "tische",
    total_searches: 3,
  },
  {
    original_query: "konos",
    total_searches: 3,
  },
  {
    original_query: "Rassenteppi",
    total_searches: 3,
  },
  {
    original_query: "slimline",
    total_searches: 3,
  },
  {
    original_query: "schmutfa",
    total_searches: 3,
  },
  {
    original_query: "limeric",
    total_searches: 3,
  },
  {
    original_query: "Holzm",
    total_searches: 3,
  },
  {
    original_query: "kettelung",
    total_searches: 3,
  },
  {
    original_query: "fisch",
    total_searches: 3,
  },
  {
    original_query: "Sicjt",
    total_searches: 3,
  },
  {
    original_query: "feuertonne",
    total_searches: 3,
  },
  {
    original_query: "umrandu",
    total_searches: 3,
  },
  {
    original_query: "rebe",
    total_searches: 3,
  },
  {
    original_query: "kunstte",
    total_searches: 3,
  },
  {
    original_query: "brot",
    total_searches: 3,
  },
  {
    original_query: "Treppenstufenprofil",
    total_searches: 3,
  },
  {
    original_query: "gartenvlies",
    total_searches: 3,
  },
  {
    original_query: "holzspalter",
    total_searches: 3,
  },
  {
    original_query: "bale",
    total_searches: 3,
  },
  {
    original_query: "teppiläufer",
    total_searches: 3,
  },
  {
    original_query: "Zeppi",
    total_searches: 3,
  },
  {
    original_query: "narzissa",
    total_searches: 3,
  },
  {
    original_query: "Schuhregal",
    total_searches: 3,
  },
  {
    original_query: "weichschaumma",
    total_searches: 3,
  },
  {
    original_query: "kugel",
    total_searches: 3,
  },
  {
    original_query: "feuerlöscher",
    total_searches: 3,
  },
  {
    original_query: "Terrasen",
    total_searches: 3,
  },
  {
    original_query: "viskose",
    total_searches: 3,
  },
  {
    original_query: "siloplane",
    total_searches: 3,
  },
  {
    original_query: "Calam",
    total_searches: 3,
  },
  {
    original_query: "rasenteppci",
    total_searches: 3,
  },
  {
    original_query: "kücken",
    total_searches: 3,
  },
  {
    original_query: "abstreifer",
    total_searches: 3,
  },
  {
    original_query: "schmutzfagma",
    total_searches: 3,
  },
  {
    original_query: "keder",
    total_searches: 3,
  },
  {
    original_query: "zeltpl",
    total_searches: 3,
  },
  {
    original_query: "Läuft",
    total_searches: 3,
  },
  {
    original_query: "mulch",
    total_searches: 3,
  },
  {
    original_query: "zaunstäbe",
    total_searches: 3,
  },
  {
    original_query: "Steeg",
    total_searches: 3,
  },
  {
    original_query: "Schlingematt",
    total_searches: 3,
  },
  {
    original_query: "transportrolle",
    total_searches: 3,
  },
  {
    original_query: "arbeitspl",
    total_searches: 3,
  },
  {
    original_query: "resen",
    total_searches: 3,
  },
  {
    original_query: "rücklieferung",
    total_searches: 3,
  },
  {
    original_query: "Werks",
    total_searches: 3,
  },
  {
    original_query: "marti",
    total_searches: 3,
  },
  {
    original_query: "stufem",
    total_searches: 3,
  },
  {
    original_query: "Übergangsle",
    total_searches: 3,
  },
  {
    original_query: "teppih",
    total_searches: 3,
  },
  {
    original_query: "Geträ",
    total_searches: 3,
  },
  {
    original_query: "Türma",
    total_searches: 3,
  },
  {
    original_query: "spieltepp",
    total_searches: 3,
  },
  {
    original_query: "eckleisten",
    total_searches: 3,
  },
  {
    original_query: "Spagh",
    total_searches: 3,
  },
  {
    original_query: "aussenteppic",
    total_searches: 3,
  },
  {
    original_query: "Terasenflie",
    total_searches: 3,
  },
  {
    original_query: "innenraumver",
    total_searches: 3,
  },
  {
    original_query: "spiralstab",
    total_searches: 3,
  },
  {
    original_query: "rapids",
    total_searches: 3,
  },
  {
    original_query: "wohnzimmertepp",
    total_searches: 3,
  },
  {
    original_query: "trale",
    total_searches: 3,
  },
  {
    original_query: "Andeckp",
    total_searches: 3,
  },
  {
    original_query: "Stabilisierungst",
    total_searches: 3,
  },
  {
    original_query: "Rasete",
    total_searches: 3,
  },
  {
    original_query: "kanin",
    total_searches: 3,
  },
  {
    original_query: "teppixh",
    total_searches: 3,
  },
  {
    original_query: "contact",
    total_searches: 3,
  },
  {
    original_query: "treppenläuferstangen",
    total_searches: 3,
  },
  {
    original_query: "Badew",
    total_searches: 3,
  },
  {
    original_query: "magnetwände",
    total_searches: 3,
  },
  {
    original_query: "siena",
    total_searches: 3,
  },
  {
    original_query: "vera",
    total_searches: 3,
  },
  {
    original_query: "farbeun",
    total_searches: 3,
  },
  {
    original_query: "meterwar",
    total_searches: 3,
  },
  {
    original_query: "Pach",
    total_searches: 3,
  },
  {
    original_query: "gege",
    total_searches: 3,
  },
  {
    original_query: "schwerlaster",
    total_searches: 3,
  },
  {
    original_query: "honm",
    total_searches: 3,
  },
  {
    original_query: "coco",
    total_searches: 3,
  },
  {
    original_query: "Rollr",
    total_searches: 3,
  },
  {
    original_query: "Laeu",
    total_searches: 3,
  },
  {
    original_query: "drai",
    total_searches: 3,
  },
  {
    original_query: "verzin",
    total_searches: 3,
  },
  {
    original_query: "montagekleb",
    total_searches: 3,
  },
  {
    original_query: "bindedra",
    total_searches: 3,
  },
  {
    original_query: "weis",
    total_searches: 3,
  },
  {
    original_query: "himalay",
    total_searches: 3,
  },
  {
    original_query: "nava",
    total_searches: 3,
  },
  {
    original_query: "aluleis",
    total_searches: 3,
  },
  {
    original_query: "pbergangs",
    total_searches: 3,
  },
  {
    original_query: "vermont",
    total_searches: 3,
  },
  {
    original_query: "wohnzimmerteppic",
    total_searches: 3,
  },
  {
    original_query: "stra",
    total_searches: 3,
  },
  {
    original_query: "Stufenprofil",
    total_searches: 3,
  },
  {
    original_query: "Natura",
    total_searches: 3,
  },
  {
    original_query: "Kabelma",
    total_searches: 3,
  },
  {
    original_query: "nadelg",
    total_searches: 3,
  },
  {
    original_query: "badew",
    total_searches: 3,
  },
  {
    original_query: "kosmetikspiege",
    total_searches: 3,
  },
  {
    original_query: "wärme",
    total_searches: 3,
  },
  {
    original_query: "Sicherheitsmatt",
    total_searches: 3,
  },
  {
    original_query: "minca",
    total_searches: 3,
  },
  {
    original_query: "Weichsc",
    total_searches: 3,
  },
  {
    original_query: "somme",
    total_searches: 3,
  },
  {
    original_query: "treppensta",
    total_searches: 3,
  },
  {
    original_query: "schlüs",
    total_searches: 3,
  },
  {
    original_query: "gummimaten",
    total_searches: 3,
  },
  {
    original_query: "Weichsch",
    total_searches: 3,
  },
  {
    original_query: "Baden",
    total_searches: 3,
  },
  {
    original_query: "sofa",
    total_searches: 3,
  },
  {
    original_query: "dunj",
    total_searches: 3,
  },
  {
    original_query: "wasserdu",
    total_searches: 3,
  },
  {
    original_query: "übergangprofil",
    total_searches: 3,
  },
  {
    original_query: "treppengepp",
    total_searches: 3,
  },
  {
    original_query: "Madras",
    total_searches: 3,
  },
  {
    original_query: "golf",
    total_searches: 3,
  },
  {
    original_query: "petar",
    total_searches: 3,
  },
  {
    original_query: "Sichtschutzstreif",
    total_searches: 3,
  },
  {
    original_query: "Ausgle",
    total_searches: 3,
  },
  {
    original_query: "schwimmba",
    total_searches: 3,
  },
  {
    original_query: "alulei",
    total_searches: 3,
  },
  {
    original_query: "Pietvi",
    total_searches: 3,
  },
  {
    original_query: "schutzfangmatten",
    total_searches: 3,
  },
  {
    original_query: "flipcha",
    total_searches: 3,
  },
  {
    original_query: "essz",
    total_searches: 3,
  },
  {
    original_query: "safty",
    total_searches: 3,
  },
  {
    original_query: "klicke",
    total_searches: 3,
  },
  {
    original_query: "Grilla",
    total_searches: 3,
  },
  {
    original_query: "Nico",
    total_searches: 3,
  },
  {
    original_query: "gummiringmatte",
    total_searches: 3,
  },
  {
    original_query: "Poolunt",
    total_searches: 3,
  },
  {
    original_query: "niedrigfloor",
    total_searches: 3,
  },
  {
    original_query: "Aussenteppich",
    total_searches: 3,
  },
  {
    original_query: "Hart",
    total_searches: 3,
  },
  {
    original_query: "sisla",
    total_searches: 3,
  },
  {
    original_query: "Spielteppich",
    total_searches: 3,
  },
  {
    original_query: "doppelseitige",
    total_searches: 3,
  },
  {
    original_query: "klarsicht",
    total_searches: 3,
  },
  {
    original_query: "rollregal",
    total_searches: 3,
  },
  {
    original_query: "rasenre",
    total_searches: 3,
  },
  {
    original_query: "treppenlanten",
    total_searches: 3,
  },
  {
    original_query: "müleim",
    total_searches: 3,
  },
  {
    original_query: "gewächshauspl",
    total_searches: 3,
  },
  {
    original_query: "schlafz",
    total_searches: 3,
  },
  {
    original_query: "samia",
    total_searches: 3,
  },
  {
    original_query: "eckreg",
    total_searches: 3,
  },
  {
    original_query: "isolier",
    total_searches: 3,
  },
  {
    original_query: "treppestufen",
    total_searches: 3,
  },
  {
    original_query: "color",
    total_searches: 3,
  },
  {
    original_query: "schmutzfanmat",
    total_searches: 3,
  },
  {
    original_query: "anthraz",
    total_searches: 3,
  },
  {
    original_query: "klarsi",
    total_searches: 3,
  },
  {
    original_query: "abdeckpane",
    total_searches: 3,
  },
  {
    original_query: "dost",
    total_searches: 3,
  },
  {
    original_query: "pado",
    total_searches: 3,
  },
  {
    original_query: "batensc",
    total_searches: 3,
  },
  {
    original_query: "weih",
    total_searches: 3,
  },
  {
    original_query: "luxury",
    total_searches: 3,
  },
  {
    original_query: "kuec",
    total_searches: 3,
  },
  {
    original_query: "flurvorkeger",
    total_searches: 3,
  },
  {
    original_query: "treppenstang",
    total_searches: 3,
  },
  {
    original_query: "teppivh",
    total_searches: 3,
  },
  {
    original_query: "gutt",
    total_searches: 3,
  },
  {
    original_query: "Kunstrasenklebe",
    total_searches: 3,
  },
  {
    original_query: "Heidekraut",
    total_searches: 3,
  },
  {
    original_query: "plie",
    total_searches: 3,
  },
  {
    original_query: "aussenma",
    total_searches: 3,
  },
  {
    original_query: "telefonnumm",
    total_searches: 3,
  },
  {
    original_query: "consen",
    total_searches: 3,
  },
  {
    original_query: "auslegeare",
    total_searches: 3,
  },
  {
    original_query: "wandkosmetikspiegel",
    total_searches: 3,
  },
  {
    original_query: "diele",
    total_searches: 3,
  },
  {
    original_query: "Guts",
    total_searches: 3,
  },
  {
    original_query: "tretfort",
    total_searches: 3,
  },
  {
    original_query: "karst",
    total_searches: 3,
  },
  {
    original_query: "eckschutz",
    total_searches: 3,
  },
  {
    original_query: "feucht",
    total_searches: 3,
  },
  {
    original_query: "poolun",
    total_searches: 3,
  },
  {
    original_query: "Transparen",
    total_searches: 3,
  },
  {
    original_query: "Gartenvlies",
    total_searches: 3,
  },
  {
    original_query: "Canc",
    total_searches: 3,
  },
  {
    original_query: "Schmutzl",
    total_searches: 3,
  },
  {
    original_query: "halbgarage",
    total_searches: 3,
  },
  {
    original_query: "play",
    total_searches: 3,
  },
  {
    original_query: "magnettafe",
    total_searches: 3,
  },
  {
    original_query: "sophie",
    total_searches: 3,
  },
  {
    original_query: "ringgummimat",
    total_searches: 3,
  },
  {
    original_query: "alumatte",
    total_searches: 3,
  },
  {
    original_query: "Balkonsu",
    total_searches: 3,
  },
  {
    original_query: "sintr",
    total_searches: 3,
  },
  {
    original_query: "gronau",
    total_searches: 3,
  },
  {
    original_query: "Badvorleg",
    total_searches: 3,
  },
  {
    original_query: "Kratztep",
    total_searches: 3,
  },
  {
    original_query: "spruhkl",
    total_searches: 3,
  },
  {
    original_query: "tifann",
    total_searches: 3,
  },
  {
    original_query: "Transparent",
    total_searches: 3,
  },
  {
    original_query: "halrund",
    total_searches: 3,
  },
  {
    original_query: "schalls",
    total_searches: 3,
  },
  {
    original_query: "skysoft",
    total_searches: 3,
  },
  {
    original_query: "tredford",
    total_searches: 3,
  },
  {
    original_query: "Spielt",
    total_searches: 3,
  },
  {
    original_query: "Katzenschutznetz",
    total_searches: 3,
  },
  {
    original_query: "Flicken",
    total_searches: 3,
  },
  {
    original_query: "abseckplane",
    total_searches: 3,
  },
  {
    original_query: "abeeck",
    total_searches: 3,
  },
  {
    original_query: "fußle",
    total_searches: 3,
  },
  {
    original_query: "teppuchfliesen",
    total_searches: 3,
  },
  {
    original_query: "shyggy",
    total_searches: 3,
  },
  {
    original_query: "fußl",
    total_searches: 3,
  },
  {
    original_query: "klassisc",
    total_searches: 3,
  },
  {
    original_query: "rasenteppih",
    total_searches: 3,
  },
  {
    original_query: "anhängerplane",
    total_searches: 3,
  },
  {
    original_query: "übergangsleis",
    total_searches: 3,
  },
  {
    original_query: "Dunkelblau",
    total_searches: 3,
  },
  {
    original_query: "johnny",
    total_searches: 3,
  },
  {
    original_query: "tomatenspiral",
    total_searches: 3,
  },
  {
    original_query: "bautenschutzmat",
    total_searches: 3,
  },
  {
    original_query: "bettzmrandung",
    total_searches: 3,
  },
  {
    original_query: "fiss",
    total_searches: 3,
  },
  {
    original_query: "retu",
    total_searches: 3,
  },
  {
    original_query: "spaghet",
    total_searches: 3,
  },
  {
    original_query: "rasenteooich",
    total_searches: 3,
  },
  {
    original_query: "raum",
    total_searches: 3,
  },
  {
    original_query: "handtuchständer",
    total_searches: 3,
  },
  {
    original_query: "schmutzfabgma",
    total_searches: 3,
  },
  {
    original_query: "rucksendung",
    total_searches: 3,
  },
  {
    original_query: "hohlkamm",
    total_searches: 3,
  },
  {
    original_query: "flaschenkastenst",
    total_searches: 3,
  },
  {
    original_query: "teppichvorleger",
    total_searches: 3,
  },
  {
    original_query: "brennholz",
    total_searches: 3,
  },
  {
    original_query: "abdekc",
    total_searches: 3,
  },
  {
    original_query: "bademstt",
    total_searches: 3,
  },
  {
    original_query: "sonnensehel",
    total_searches: 3,
  },
  {
    original_query: "Schallschutz",
    total_searches: 3,
  },
  {
    original_query: "grast",
    total_searches: 3,
  },
  {
    original_query: "wpcfliesen",
    total_searches: 3,
  },
  {
    original_query: "Türm",
    total_searches: 3,
  },
  {
    original_query: "terrassent",
    total_searches: 3,
  },
  {
    original_query: "tich",
    total_searches: 3,
  },
  {
    original_query: "Dubli",
    total_searches: 3,
  },
  {
    original_query: "velourste",
    total_searches: 3,
  },
  {
    original_query: "teppichbodenfliesen",
    total_searches: 3,
  },
  {
    original_query: "bitonto",
    total_searches: 3,
  },
  {
    original_query: "Teppichsch",
    total_searches: 3,
  },
  {
    original_query: "Leipzi",
    total_searches: 3,
  },
  {
    original_query: "gerüstpl",
    total_searches: 3,
  },
  {
    original_query: "lochblech",
    total_searches: 3,
  },
  {
    original_query: "Stang",
    total_searches: 3,
  },
  {
    original_query: "Laufe",
    total_searches: 3,
  },
  {
    original_query: "rahm",
    total_searches: 3,
  },
  {
    original_query: "sichtw",
    total_searches: 3,
  },
  {
    original_query: "Flickenteppich",
    total_searches: 3,
  },
  {
    original_query: "eckl",
    total_searches: 3,
  },
  {
    original_query: "teppichma",
    total_searches: 3,
  },
  {
    original_query: "schuhschale",
    total_searches: 3,
  },
  {
    original_query: "Verdunklung",
    total_searches: 3,
  },
  {
    original_query: "filzs",
    total_searches: 3,
  },
  {
    original_query: "willi",
    total_searches: 3,
  },
  {
    original_query: "Keder",
    total_searches: 3,
  },
  {
    original_query: "Duschvorla",
    total_searches: 3,
  },
  {
    original_query: "Holzmatt",
    total_searches: 3,
  },
  {
    original_query: "treppenauflagen",
    total_searches: 3,
  },
  {
    original_query: "Luft",
    total_searches: 3,
  },
  {
    original_query: "Teppichra",
    total_searches: 3,
  },
  {
    original_query: "betti",
    total_searches: 3,
  },
  {
    original_query: "sonnensegw",
    total_searches: 3,
  },
  {
    original_query: "Abfall",
    total_searches: 3,
  },
  {
    original_query: "viena",
    total_searches: 3,
  },
  {
    original_query: "schaummatte",
    total_searches: 3,
  },
  {
    original_query: "Rost",
    total_searches: 3,
  },
  {
    original_query: "Lich",
    total_searches: 3,
  },
  {
    original_query: "Schmutzs",
    total_searches: 3,
  },
  {
    original_query: "Badmatte",
    total_searches: 3,
  },
  {
    original_query: "schnurr",
    total_searches: 3,
  },
  {
    original_query: "adira",
    total_searches: 3,
  },
  {
    original_query: "leidt",
    total_searches: 3,
  },
  {
    original_query: "kokosfußmatte",
    total_searches: 3,
  },
  {
    original_query: "Bras",
    total_searches: 3,
  },
  {
    original_query: "viertelstab",
    total_searches: 3,
  },
  {
    original_query: "warnung",
    total_searches: 3,
  },
  {
    original_query: "libre",
    total_searches: 3,
  },
  {
    original_query: "Fußabtr",
    total_searches: 3,
  },
  {
    original_query: "zahlungsbedingungen",
    total_searches: 3,
  },
  {
    original_query: "bsde",
    total_searches: 3,
  },
  {
    original_query: "fussabstrei",
    total_searches: 3,
  },
  {
    original_query: "flickentepp",
    total_searches: 3,
  },
  {
    original_query: "hartb",
    total_searches: 3,
  },
  {
    original_query: "Eingangsma",
    total_searches: 3,
  },
  {
    original_query: "tischplatte",
    total_searches: 3,
  },
  {
    original_query: "Bodenfli",
    total_searches: 3,
  },
  {
    original_query: "abdeckfol",
    total_searches: 3,
  },
  {
    original_query: "KUNSTRA",
    total_searches: 3,
  },
  {
    original_query: "Gelb",
    total_searches: 3,
  },
  {
    original_query: "feinriefenmatte",
    total_searches: 3,
  },
  {
    original_query: "heidekrautma",
    total_searches: 3,
  },
  {
    original_query: "liefe",
    total_searches: 3,
  },
  {
    original_query: "beste",
    total_searches: 3,
  },
  {
    original_query: "katzenklo",
    total_searches: 3,
  },
  {
    original_query: "kunszra",
    total_searches: 3,
  },
  {
    original_query: "polycarbon",
    total_searches: 3,
  },
  {
    original_query: "metallband",
    total_searches: 3,
  },
  {
    original_query: "adrai",
    total_searches: 3,
  },
  {
    original_query: "outdoorläuf",
    total_searches: 3,
  },
  {
    original_query: "sauberlaufn",
    total_searches: 3,
  },
  {
    original_query: "nadeldil",
    total_searches: 3,
  },
  {
    original_query: "marrakesch",
    total_searches: 3,
  },
  {
    original_query: "roller",
    total_searches: 3,
  },
  {
    original_query: "trittschallschutz",
    total_searches: 3,
  },
  {
    original_query: "sphi",
    total_searches: 3,
  },
  {
    original_query: "hochflors",
    total_searches: 3,
  },
  {
    original_query: "sofadecken",
    total_searches: 3,
  },
  {
    original_query: "gitterroststufen",
    total_searches: 3,
  },
  {
    original_query: "Octa",
    total_searches: 3,
  },
  {
    original_query: "weideza",
    total_searches: 3,
  },
  {
    original_query: "stelling",
    total_searches: 3,
  },
  {
    original_query: "bodenmatt",
    total_searches: 3,
  },
  {
    original_query: "Ketteltepp",
    total_searches: 3,
  },
  {
    original_query: "bestell",
    total_searches: 3,
  },
  {
    original_query: "Niko",
    total_searches: 3,
  },
  {
    original_query: "brüc",
    total_searches: 3,
  },
  {
    original_query: "bettvor",
    total_searches: 3,
  },
  {
    original_query: "milchglas",
    total_searches: 3,
  },
  {
    original_query: "scho",
    total_searches: 3,
  },
  {
    original_query: "fußabstrei",
    total_searches: 3,
  },
  {
    original_query: "Magnete",
    total_searches: 3,
  },
  {
    original_query: "alle",
    total_searches: 3,
  },
  {
    original_query: "Gartenmöbel",
    total_searches: 3,
  },
  {
    original_query: "gummibod",
    total_searches: 3,
  },
  {
    original_query: "teppichlaeu",
    total_searches: 3,
  },
  {
    original_query: "Promena",
    total_searches: 3,
  },
  {
    original_query: "schuhbank",
    total_searches: 3,
  },
  {
    original_query: "outdoot",
    total_searches: 3,
  },
  {
    original_query: "schmutzteppic",
    total_searches: 3,
  },
  {
    original_query: "strips",
    total_searches: 3,
  },
  {
    original_query: "naht",
    total_searches: 3,
  },
  {
    original_query: "holzp",
    total_searches: 3,
  },
  {
    original_query: "ivor",
    total_searches: 3,
  },
  {
    original_query: "oden",
    total_searches: 3,
  },
  {
    original_query: "arbeitspla",
    total_searches: 3,
  },
  {
    original_query: "zuschne",
    total_searches: 3,
  },
  {
    original_query: "balkonbesp",
    total_searches: 3,
  },
  {
    original_query: "fair",
    total_searches: 3,
  },
  {
    original_query: "Linoleu",
    total_searches: 3,
  },
  {
    original_query: "ampelschi",
    total_searches: 3,
  },
  {
    original_query: "terrassendiel",
    total_searches: 3,
  },
  {
    original_query: "Hori",
    total_searches: 3,
  },
  {
    original_query: "klassis",
    total_searches: 3,
  },
  {
    original_query: "schmutzfanglaufer",
    total_searches: 3,
  },
  {
    original_query: "anpassungsprozesse",
    total_searches: 3,
  },
  {
    original_query: "korkwan",
    total_searches: 3,
  },
  {
    original_query: "magnettaf",
    total_searches: 3,
  },
  {
    original_query: "prote",
    total_searches: 3,
  },
  {
    original_query: "klickfliessen",
    total_searches: 3,
  },
  {
    original_query: "Sparr",
    total_searches: 3,
  },
  {
    original_query: "outdorteppich",
    total_searches: 3,
  },
  {
    original_query: "kabelabdeckung",
    total_searches: 3,
  },
  {
    original_query: "ausgleichschiene",
    total_searches: 3,
  },
  {
    original_query: "Unterlegma",
    total_searches: 3,
  },
  {
    original_query: "fahrradhalterun",
    total_searches: 3,
  },
  {
    original_query: "ikea",
    total_searches: 3,
  },
  {
    original_query: "klemmma",
    total_searches: 3,
  },
  {
    original_query: "graphi",
    total_searches: 3,
  },
  {
    original_query: "schmutufangmatte",
    total_searches: 3,
  },
  {
    original_query: "Fallschut",
    total_searches: 3,
  },
  {
    original_query: "zsun",
    total_searches: 3,
  },
  {
    original_query: "kleine",
    total_searches: 3,
  },
  {
    original_query: "magnetband",
    total_searches: 3,
  },
  {
    original_query: "Sichtscutz",
    total_searches: 3,
  },
  {
    original_query: "Bbus",
    total_searches: 3,
  },
  {
    original_query: "Rasentrppich",
    total_searches: 3,
  },
  {
    original_query: "flachwebteppich",
    total_searches: 3,
  },
  {
    original_query: "Boxw",
    total_searches: 3,
  },
  {
    original_query: "farad",
    total_searches: 3,
  },
  {
    original_query: "floorteppich",
    total_searches: 3,
  },
  {
    original_query: "outdooteppich",
    total_searches: 3,
  },
  {
    original_query: "plüsch",
    total_searches: 3,
  },
  {
    original_query: "profiel",
    total_searches: 3,
  },
  {
    original_query: "Zaunsichts",
    total_searches: 3,
  },
  {
    original_query: "Werk",
    total_searches: 3,
  },
  {
    original_query: "quadrati",
    total_searches: 3,
  },
  {
    original_query: "autoab",
    total_searches: 3,
  },
  {
    original_query: "terasenf",
    total_searches: 3,
  },
  {
    original_query: "Rasetep",
    total_searches: 3,
  },
  {
    original_query: "Kantenpro",
    total_searches: 3,
  },
  {
    original_query: "Schlingem",
    total_searches: 3,
  },
  {
    original_query: "Badewannenmatte",
    total_searches: 3,
  },
  {
    original_query: "Zaunsichtsc",
    total_searches: 3,
  },
  {
    original_query: "Luftpolter",
    total_searches: 3,
  },
  {
    original_query: "Übergangslei",
    total_searches: 3,
  },
  {
    original_query: "bücherr",
    total_searches: 3,
  },
  {
    original_query: "teppichläug",
    total_searches: 3,
  },
  {
    original_query: "bungee",
    total_searches: 3,
  },
  {
    original_query: "schwerlaste",
    total_searches: 3,
  },
  {
    original_query: "Mosco",
    total_searches: 3,
  },
  {
    original_query: "terraz",
    total_searches: 3,
  },
  {
    original_query: "stufenlant",
    total_searches: 3,
  },
  {
    original_query: "hello",
    total_searches: 3,
  },
  {
    original_query: "küchentepich",
    total_searches: 3,
  },
  {
    original_query: "Noppenfol",
    total_searches: 3,
  },
  {
    original_query: "stufenmstten",
    total_searches: 3,
  },
  {
    original_query: "sauberkauf",
    total_searches: 3,
  },
  {
    original_query: "gutsche",
    total_searches: 3,
  },
  {
    original_query: "teppichstu",
    total_searches: 3,
  },
  {
    original_query: "sauberlu",
    total_searches: 3,
  },
  {
    original_query: "Stabilisieru",
    total_searches: 3,
  },
  {
    original_query: "fleck",
    total_searches: 3,
  },
  {
    original_query: "Maßan",
    total_searches: 3,
  },
  {
    original_query: "Fallschutzmatt",
    total_searches: 3,
  },
  {
    original_query: "Moni",
    total_searches: 3,
  },
  {
    original_query: "wasserfest",
    total_searches: 3,
  },
  {
    original_query: "stalllaterne",
    total_searches: 3,
  },
  {
    original_query: "korkm",
    total_searches: 3,
  },
  {
    original_query: "Reklamation",
    total_searches: 3,
  },
  {
    original_query: "Vorzeltteppich",
    total_searches: 3,
  },
  {
    original_query: "brenn",
    total_searches: 3,
  },
  {
    original_query: "teppichreste",
    total_searches: 3,
  },
  {
    original_query: "Sportboden",
    total_searches: 3,
  },
  {
    original_query: "teppichvlies",
    total_searches: 3,
  },
  {
    original_query: "interface",
    total_searches: 3,
  },
  {
    original_query: "klemmm",
    total_searches: 3,
  },
  {
    original_query: "sisalmat",
    total_searches: 3,
  },
  {
    original_query: "Bettvo",
    total_searches: 3,
  },
  {
    original_query: "Teppichunterlage",
    total_searches: 3,
  },
  {
    original_query: "schlingem",
    total_searches: 3,
  },
  {
    original_query: "Bolo",
    total_searches: 3,
  },
  {
    original_query: "desin",
    total_searches: 3,
  },
  {
    original_query: "dynsty",
    total_searches: 3,
  },
  {
    original_query: "schum",
    total_searches: 3,
  },
  {
    original_query: "duschsäcke",
    total_searches: 3,
  },
  {
    original_query: "Holzma",
    total_searches: 3,
  },
  {
    original_query: "Sichtschutzst",
    total_searches: 3,
  },
  {
    original_query: "Stabilisierungstu",
    total_searches: 3,
  },
  {
    original_query: "pfeffer",
    total_searches: 3,
  },
  {
    original_query: "windmühle",
    total_searches: 3,
  },
  {
    original_query: "Fußabtre",
    total_searches: 3,
  },
  {
    original_query: "sict",
    total_searches: 3,
  },
  {
    original_query: "befestigungen",
    total_searches: 3,
  },
  {
    original_query: "gummiwaben",
    total_searches: 3,
  },
  {
    original_query: "hasendr",
    total_searches: 3,
  },
  {
    original_query: "kons",
    total_searches: 3,
  },
  {
    original_query: "gänseblümchen",
    total_searches: 3,
  },
  {
    original_query: "Autdoo",
    total_searches: 3,
  },
  {
    original_query: "Riverba",
    total_searches: 3,
  },
  {
    original_query: "ruck",
    total_searches: 3,
  },
  {
    original_query: "rasentrpp",
    total_searches: 3,
  },
  {
    original_query: "gummise",
    total_searches: 3,
  },
  {
    original_query: "terassendielen",
    total_searches: 3,
  },
  {
    original_query: "schlingmatten",
    total_searches: 3,
  },
  {
    original_query: "Text",
    total_searches: 3,
  },
  {
    original_query: "unterlegmatt",
    total_searches: 3,
  },
  {
    original_query: "batenschutzmatte",
    total_searches: 3,
  },
  {
    original_query: "Suchtsch",
    total_searches: 3,
  },
  {
    original_query: "nadelvl",
    total_searches: 3,
  },
  {
    original_query: "sparow",
    total_searches: 3,
  },
  {
    original_query: "Doppelrollo",
    total_searches: 3,
  },
  {
    original_query: "Baumwoll",
    total_searches: 3,
  },
  {
    original_query: "Insekte",
    total_searches: 3,
  },
  {
    original_query: "stock",
    total_searches: 3,
  },
  {
    original_query: "girlande",
    total_searches: 3,
  },
  {
    original_query: "übergand",
    total_searches: 3,
  },
  {
    original_query: "zaunelement",
    total_searches: 3,
  },
  {
    original_query: "sech",
    total_searches: 3,
  },
  {
    original_query: "Dunkelgrau",
    total_searches: 3,
  },
  {
    original_query: "wandpanee",
    total_searches: 3,
  },
  {
    original_query: "windso",
    total_searches: 3,
  },
  {
    original_query: "Drahtzaun",
    total_searches: 3,
  },
  {
    original_query: "terrassenboden",
    total_searches: 3,
  },
  {
    original_query: "georg",
    total_searches: 3,
  },
  {
    original_query: "arbeitsplatzma",
    total_searches: 3,
  },
  {
    original_query: "Outdoorteppiche",
    total_searches: 3,
  },
  {
    original_query: "pflanzkübel",
    total_searches: 3,
  },
  {
    original_query: "holzo",
    total_searches: 3,
  },
  {
    original_query: "wpcf",
    total_searches: 3,
  },
  {
    original_query: "antirutschsicherheits",
    total_searches: 3,
  },
  {
    original_query: "nadelvli",
    total_searches: 3,
  },
  {
    original_query: "Grillab",
    total_searches: 3,
  },
  {
    original_query: "konstrase",
    total_searches: 3,
  },
  {
    original_query: "sisalbrücke",
    total_searches: 3,
  },
  {
    original_query: "elek",
    total_searches: 3,
  },
  {
    original_query: "Spark",
    total_searches: 3,
  },
  {
    original_query: "Diamond",
    total_searches: 3,
  },
  {
    original_query: "ampelschir",
    total_searches: 3,
  },
  {
    original_query: "poolunter",
    total_searches: 3,
  },
  {
    original_query: "elfenbein",
    total_searches: 3,
  },
  {
    original_query: "schmutzfangmazze",
    total_searches: 3,
  },
  {
    original_query: "sichtschutzroll",
    total_searches: 3,
  },
  {
    original_query: "teppichmatt",
    total_searches: 3,
  },
  {
    original_query: "carac",
    total_searches: 3,
  },
  {
    original_query: "gartenstühle",
    total_searches: 3,
  },
  {
    original_query: "winter",
    total_searches: 3,
  },
  {
    original_query: "schmutzfangf",
    total_searches: 3,
  },
  {
    original_query: "durchsi",
    total_searches: 3,
  },
  {
    original_query: "gewürzrega",
    total_searches: 3,
  },
  {
    original_query: "zuschneiden",
    total_searches: 3,
  },
  {
    original_query: "balkonver",
    total_searches: 3,
  },
  {
    original_query: "Zaunsichtschu",
    total_searches: 3,
  },
  {
    original_query: "tesor",
    total_searches: 3,
  },
  {
    original_query: "heimw",
    total_searches: 3,
  },
  {
    original_query: "dämp",
    total_searches: 3,
  },
  {
    original_query: "magnetische",
    total_searches: 3,
  },
  {
    original_query: "geräte",
    total_searches: 3,
  },
  {
    original_query: "teraa",
    total_searches: 3,
  },
  {
    original_query: "achmutz",
    total_searches: 3,
  },
  {
    original_query: "tasenteppi",
    total_searches: 3,
  },
  {
    original_query: "Integr",
    total_searches: 3,
  },
  {
    original_query: "Verdunklungs",
    total_searches: 3,
  },
  {
    original_query: "sandsack",
    total_searches: 3,
  },
  {
    original_query: "Terrassentepp",
    total_searches: 3,
  },
  {
    original_query: "camb",
    total_searches: 3,
  },
  {
    original_query: "phan",
    total_searches: 3,
  },
  {
    original_query: "poolu",
    total_searches: 3,
  },
  {
    original_query: "Fitness",
    total_searches: 3,
  },
  {
    original_query: "Heidekra",
    total_searches: 3,
  },
  {
    original_query: "duschhocke",
    total_searches: 3,
  },
  {
    original_query: "teppichstuf",
    total_searches: 3,
  },
  {
    original_query: "noppenbelag",
    total_searches: 3,
  },
  {
    original_query: "treppenstufenm",
    total_searches: 3,
  },
  {
    original_query: "gartenfl",
    total_searches: 3,
  },
  {
    original_query: "isom",
    total_searches: 3,
  },
  {
    original_query: "wollteppic",
    total_searches: 3,
  },
  {
    original_query: "Bodenf",
    total_searches: 3,
  },
  {
    original_query: "rampenmat",
    total_searches: 3,
  },
  {
    original_query: "sisaltreppe",
    total_searches: 3,
  },
  {
    original_query: "kletter",
    total_searches: 3,
  },
  {
    original_query: "wohndecken",
    total_searches: 3,
  },
  {
    original_query: "sisalteppuch",
    total_searches: 3,
  },
  {
    original_query: "baufolie",
    total_searches: 3,
  },
  {
    original_query: "rillen",
    total_searches: 3,
  },
  {
    original_query: "coto",
    total_searches: 3,
  },
  {
    original_query: "randleisten",
    total_searches: 3,
  },
  {
    original_query: "Zahnblende",
    total_searches: 3,
  },
  {
    original_query: "tläufer",
    total_searches: 3,
  },
  {
    original_query: "kunstraden",
    total_searches: 3,
  },
  {
    original_query: "schiefer",
    total_searches: 3,
  },
  {
    original_query: "linoleumboden",
    total_searches: 3,
  },
  {
    original_query: "kuechenteppich",
    total_searches: 3,
  },
  {
    original_query: "Mäus",
    total_searches: 3,
  },
  {
    original_query: "nassraummatte",
    total_searches: 3,
  },
  {
    original_query: "haustier",
    total_searches: 3,
  },
  {
    original_query: "Zaunpfost",
    total_searches: 3,
  },
  {
    original_query: "Stegpla",
    total_searches: 3,
  },
  {
    original_query: "schilff",
    total_searches: 3,
  },
  {
    original_query: "brandschutzklasse",
    total_searches: 3,
  },
  {
    original_query: "Werkst",
    total_searches: 3,
  },
  {
    original_query: "daisy",
    total_searches: 3,
  },
  {
    original_query: "Teppichschutz",
    total_searches: 3,
  },
  {
    original_query: "jalousien",
    total_searches: 3,
  },
  {
    original_query: "korkplatt",
    total_searches: 3,
  },
  {
    original_query: "Kalkut",
    total_searches: 3,
  },
  {
    original_query: "wandbe",
    total_searches: 3,
  },
  {
    original_query: "Schattier",
    total_searches: 3,
  },
  {
    original_query: "Kratztepp",
    total_searches: 3,
  },
  {
    original_query: "mobiles",
    total_searches: 3,
  },
  {
    original_query: "trittschalldämmun",
    total_searches: 3,
  },
  {
    original_query: "rasensamen",
    total_searches: 3,
  },
  {
    original_query: "segelt",
    total_searches: 3,
  },
  {
    original_query: "niedrigflor",
    total_searches: 3,
  },
  {
    original_query: "Fliesenp",
    total_searches: 3,
  },
  {
    original_query: "hock",
    total_searches: 3,
  },
  {
    original_query: "wasserdic",
    total_searches: 3,
  },
  {
    original_query: "Muste",
    total_searches: 3,
  },
  {
    original_query: "schmutzfanatte",
    total_searches: 3,
  },
  {
    original_query: "kletterseil",
    total_searches: 3,
  },
  {
    original_query: "megic",
    total_searches: 3,
  },
  {
    original_query: "stufenkantenpri",
    total_searches: 3,
  },
  {
    original_query: "durchsich",
    total_searches: 3,
  },
  {
    original_query: "Ausgleichsp",
    total_searches: 3,
  },
  {
    original_query: "Cham",
    total_searches: 3,
  },
  {
    original_query: "artikel",
    total_searches: 3,
  },
  {
    original_query: "bastell",
    total_searches: 3,
  },
  {
    original_query: "wasserdurchlässig",
    total_searches: 3,
  },
  {
    original_query: "alurahmen",
    total_searches: 3,
  },
  {
    original_query: "antik",
    total_searches: 3,
  },
  {
    original_query: "Kell",
    total_searches: 3,
  },
  {
    original_query: "klieck",
    total_searches: 3,
  },
  {
    original_query: "Telefonn",
    total_searches: 3,
  },
  {
    original_query: "bodenschurt",
    total_searches: 3,
  },
  {
    original_query: "wandpanell",
    total_searches: 3,
  },
  {
    original_query: "soon",
    total_searches: 3,
  },
  {
    original_query: "Amor",
    total_searches: 3,
  },
  {
    original_query: "schmutufan",
    total_searches: 3,
  },
  {
    original_query: "nadrlfilz",
    total_searches: 3,
  },
  {
    original_query: "wandleiste",
    total_searches: 3,
  },
  {
    original_query: "halbrun",
    total_searches: 3,
  },
  {
    original_query: "Fußbode",
    total_searches: 3,
  },
  {
    original_query: "Aufb",
    total_searches: 3,
  },
  {
    original_query: "Chevro",
    total_searches: 3,
  },
  {
    original_query: "Andec",
    total_searches: 3,
  },
  {
    original_query: "abdekung",
    total_searches: 3,
  },
  {
    original_query: "kofferra",
    total_searches: 3,
  },
  {
    original_query: "flachfloor",
    total_searches: 3,
  },
  {
    original_query: "heizmaterial",
    total_searches: 3,
  },
  {
    original_query: "Hell",
    total_searches: 3,
  },
  {
    original_query: "stahlmatten",
    total_searches: 3,
  },
  {
    original_query: "Ware",
    total_searches: 3,
  },
  {
    original_query: "badetu",
    total_searches: 3,
  },
  {
    original_query: "ikat",
    total_searches: 3,
  },
  {
    original_query: "Weidematte",
    total_searches: 3,
  },
  {
    original_query: "outdoorteü",
    total_searches: 3,
  },
  {
    original_query: "Stre",
    total_searches: 3,
  },
  {
    original_query: "antivibrationmatte",
    total_searches: 3,
  },
  {
    original_query: "küchenrückwand",
    total_searches: 3,
  },
  {
    original_query: "Suchts",
    total_searches: 3,
  },
  {
    original_query: "Trpp",
    total_searches: 3,
  },
  {
    original_query: "strec",
    total_searches: 3,
  },
  {
    original_query: "gummistreifen",
    total_searches: 3,
  },
  {
    original_query: "fussmattw",
    total_searches: 3,
  },
  {
    original_query: "graste",
    total_searches: 3,
  },
  {
    original_query: "schuhregale",
    total_searches: 3,
  },
  {
    original_query: "Ausgleichspro",
    total_searches: 3,
  },
  {
    original_query: "Terrase",
    total_searches: 3,
  },
  {
    original_query: "fussmstte",
    total_searches: 3,
  },
  {
    original_query: "kred",
    total_searches: 3,
  },
  {
    original_query: "baumrindenmatten",
    total_searches: 3,
  },
  {
    original_query: "ankic",
    total_searches: 3,
  },
  {
    original_query: "wäsch",
    total_searches: 3,
  },
  {
    original_query: "rollenl",
    total_searches: 3,
  },
  {
    original_query: "klars",
    total_searches: 3,
  },
  {
    original_query: "schmutzfangtepich",
    total_searches: 3,
  },
  {
    original_query: "bademantel",
    total_searches: 3,
  },
  {
    original_query: "türschutz",
    total_searches: 3,
  },
  {
    original_query: "sonns",
    total_searches: 3,
  },
  {
    original_query: "anrirutsch",
    total_searches: 3,
  },
  {
    original_query: "mausef",
    total_searches: 3,
  },
  {
    original_query: "Bodenschitz",
    total_searches: 3,
  },
  {
    original_query: "dundee",
    total_searches: 3,
  },
  {
    original_query: "whitheboard",
    total_searches: 3,
  },
  {
    original_query: "stühle",
    total_searches: 3,
  },
  {
    original_query: "teppichfließ",
    total_searches: 3,
  },
  {
    original_query: "fence",
    total_searches: 3,
  },
  {
    original_query: "magnetw",
    total_searches: 3,
  },
  {
    original_query: "gummifussmatte",
    total_searches: 3,
  },
  {
    original_query: "Stegpl",
    total_searches: 3,
  },
  {
    original_query: "schmutufangma",
    total_searches: 3,
  },
  {
    original_query: "Stufenprofi",
    total_searches: 3,
  },
  {
    original_query: "filzplatten",
    total_searches: 3,
  },
  {
    original_query: "gummifußmatten",
    total_searches: 3,
  },
  {
    original_query: "bodes",
    total_searches: 3,
  },
  {
    original_query: "cardif",
    total_searches: 3,
  },
  {
    original_query: "teppicläufer",
    total_searches: 3,
  },
  {
    original_query: "Segeltu",
    total_searches: 3,
  },
  {
    original_query: "lenol",
    total_searches: 3,
  },
  {
    original_query: "teichnetz",
    total_searches: 3,
  },
  {
    original_query: "runner",
    total_searches: 3,
  },
  {
    original_query: "Baumrinden",
    total_searches: 3,
  },
  {
    original_query: "heidekrautmatten",
    total_searches: 3,
  },
  {
    original_query: "Platt",
    total_searches: 3,
  },
  {
    original_query: "Rocket",
    total_searches: 3,
  },
  {
    original_query: "Grillt",
    total_searches: 3,
  },
  {
    original_query: "sauberkaufma",
    total_searches: 3,
  },
  {
    original_query: "gummiwab",
    total_searches: 3,
  },
  {
    original_query: "boho",
    total_searches: 3,
  },
  {
    original_query: "treppenkantenschutz",
    total_searches: 3,
  },
  {
    original_query: "Dielen",
    total_searches: 3,
  },
  {
    original_query: "Fahrradstän",
    total_searches: 3,
  },
  {
    original_query: "Matera",
    total_searches: 3,
  },
  {
    original_query: "Hunde",
    total_searches: 3,
  },
  {
    original_query: "dreiecksegel",
    total_searches: 3,
  },
  {
    original_query: "schmutzsch",
    total_searches: 3,
  },
  {
    original_query: "fußbod",
    total_searches: 3,
  },
  {
    original_query: "petr",
    total_searches: 3,
  },
  {
    original_query: "kurzflorte",
    total_searches: 3,
  },
  {
    original_query: "küchenlufer",
    total_searches: 3,
  },
  {
    original_query: "alusch",
    total_searches: 3,
  },
  {
    original_query: "Steckreg",
    total_searches: 3,
  },
  {
    original_query: "Sintr",
    total_searches: 3,
  },
  {
    original_query: "Bodenflies",
    total_searches: 3,
  },
  {
    original_query: "klickv",
    total_searches: 3,
  },
  {
    original_query: "Schutzhullen",
    total_searches: 3,
  },
  {
    original_query: "terrasenfliesen",
    total_searches: 3,
  },
  {
    original_query: "unkrautfo",
    total_searches: 3,
  },
  {
    original_query: "bodenachutzmatte",
    total_searches: 3,
  },
  {
    original_query: "Valencia",
    total_searches: 3,
  },
  {
    original_query: "Mint",
    total_searches: 3,
  },
  {
    original_query: "schnutzfanh",
    total_searches: 3,
  },
  {
    original_query: "fahrradhalteru",
    total_searches: 3,
  },
  {
    original_query: "Unterlegmatte",
    total_searches: 3,
  },
  {
    original_query: "schuhabstre",
    total_searches: 3,
  },
  {
    original_query: "schmutzga",
    total_searches: 3,
  },
  {
    original_query: "Dich",
    total_searches: 3,
  },
  {
    original_query: "Duschvorlage",
    total_searches: 3,
  },
  {
    original_query: "Klap",
    total_searches: 3,
  },
  {
    original_query: "sauberk",
    total_searches: 3,
  },
  {
    original_query: "doppelseitigesklebeband",
    total_searches: 3,
  },
  {
    original_query: "Outdoorläuf",
    total_searches: 3,
  },
  {
    original_query: "senkrechtmarkise",
    total_searches: 3,
  },
  {
    original_query: "schmutzfangmap",
    total_searches: 3,
  },
  {
    original_query: "Lamm",
    total_searches: 3,
  },
  {
    original_query: "Plise",
    total_searches: 3,
  },
  {
    original_query: "Schmutzsch",
    total_searches: 3,
  },
  {
    original_query: "rasenteppoch",
    total_searches: 3,
  },
  {
    original_query: "antirur",
    total_searches: 3,
  },
  {
    original_query: "Schmutzfsngma",
    total_searches: 3,
  },
  {
    original_query: "hochleistung",
    total_searches: 3,
  },
  {
    original_query: "Riverb",
    total_searches: 3,
  },
  {
    original_query: "abdecplane",
    total_searches: 3,
  },
  {
    original_query: "nature",
    total_searches: 3,
  },
  {
    original_query: "rolety",
    total_searches: 3,
  },
  {
    original_query: "Transp",
    total_searches: 3,
  },
  {
    original_query: "loifer",
    total_searches: 3,
  },
  {
    original_query: "Verdun",
    total_searches: 3,
  },
  {
    original_query: "trittschalldämmu",
    total_searches: 3,
  },
  {
    original_query: "filzst",
    total_searches: 3,
  },
  {
    original_query: "filzband",
    total_searches: 3,
  },
  {
    original_query: "Arbeit",
    total_searches: 3,
  },
  {
    original_query: "dunkelgrün",
    total_searches: 3,
  },
  {
    original_query: "terasenfli",
    total_searches: 3,
  },
  {
    original_query: "hochflorstufenmatte",
    total_searches: 3,
  },
  {
    original_query: "Bettv",
    total_searches: 3,
  },
  {
    original_query: "schwearlastregal",
    total_searches: 3,
  },
  {
    original_query: "küchenleiste",
    total_searches: 3,
  },
  {
    original_query: "Bodenmatt",
    total_searches: 3,
  },
  {
    original_query: "badematee",
    total_searches: 3,
  },
  {
    original_query: "noppenb",
    total_searches: 3,
  },
  {
    original_query: "treppeläufer",
    total_searches: 3,
  },
  {
    original_query: "teso",
    total_searches: 3,
  },
  {
    original_query: "Mass",
    total_searches: 3,
  },
  {
    original_query: "Honkon",
    total_searches: 3,
  },
  {
    original_query: "Teppichläufee",
    total_searches: 3,
  },
  {
    original_query: "antirutschband",
    total_searches: 3,
  },
  {
    original_query: "Zaunsich",
    total_searches: 3,
  },
  {
    original_query: "Mast",
    total_searches: 3,
  },
  {
    original_query: "filtz",
    total_searches: 3,
  },
  {
    original_query: "verban",
    total_searches: 3,
  },
  {
    original_query: "Segelt",
    total_searches: 3,
  },
  {
    original_query: "mousepad",
    total_searches: 3,
  },
  {
    original_query: "Baumrin",
    total_searches: 3,
  },
  {
    original_query: "kundtr",
    total_searches: 3,
  },
  {
    original_query: "wohnzimmert",
    total_searches: 3,
  },
  {
    original_query: "klickfliesenw",
    total_searches: 3,
  },
  {
    original_query: "hygienebereiche",
    total_searches: 3,
  },
  {
    original_query: "gummistufe",
    total_searches: 3,
  },
  {
    original_query: "zauns",
    total_searches: 3,
  },
  {
    original_query: "caru",
    total_searches: 3,
  },
  {
    original_query: "anhen",
    total_searches: 3,
  },
  {
    original_query: "aussenb",
    total_searches: 3,
  },
  {
    original_query: "stufenläufer",
    total_searches: 3,
  },
  {
    original_query: "unterbau",
    total_searches: 3,
  },
  {
    original_query: "abfe",
    total_searches: 3,
  },
  {
    original_query: "Tarn",
    total_searches: 3,
  },
  {
    original_query: "Teppichkante",
    total_searches: 3,
  },
  {
    original_query: "nasszonenbelag",
    total_searches: 3,
  },
  {
    original_query: "bodenschutzmaz",
    total_searches: 3,
  },
  {
    original_query: "rücknahme",
    total_searches: 3,
  },
  {
    original_query: "maschend",
    total_searches: 3,
  },
  {
    original_query: "Gummipl",
    total_searches: 3,
  },
  {
    original_query: "wolldecke",
    total_searches: 3,
  },
  {
    original_query: "floir",
    total_searches: 3,
  },
  {
    original_query: "Handtüch",
    total_searches: 3,
  },
  {
    original_query: "vogelab",
    total_searches: 3,
  },
  {
    original_query: "stativleinwand",
    total_searches: 3,
  },
  {
    original_query: "Teppichkleb",
    total_searches: 3,
  },
  {
    original_query: "Esszimmer",
    total_searches: 3,
  },
  {
    original_query: "duschrol",
    total_searches: 3,
  },
  {
    original_query: "vogelschu",
    total_searches: 3,
  },
  {
    original_query: "Leufer",
    total_searches: 3,
  },
  {
    original_query: "putdoo",
    total_searches: 3,
  },
  {
    original_query: "revolution",
    total_searches: 3,
  },
  {
    original_query: "gerä",
    total_searches: 3,
  },
  {
    original_query: "retrotex",
    total_searches: 3,
  },
  {
    original_query: "Schlingenflor",
    total_searches: 3,
  },
  {
    original_query: "lochgummi",
    total_searches: 3,
  },
  {
    original_query: "rundt",
    total_searches: 3,
  },
  {
    original_query: "antiermüdungsma",
    total_searches: 3,
  },
  {
    original_query: "flaschenkastens",
    total_searches: 3,
  },
  {
    original_query: "übergangsprogil",
    total_searches: 3,
  },
  {
    original_query: "Ausg",
    total_searches: 3,
  },
  {
    original_query: "sisalläufee",
    total_searches: 3,
  },
  {
    original_query: "buxus",
    total_searches: 3,
  },
  {
    original_query: "Läufee",
    total_searches: 3,
  },
  {
    original_query: "grasfliese",
    total_searches: 3,
  },
  {
    original_query: "Stuffe",
    total_searches: 3,
  },
  {
    original_query: "schmutzau",
    total_searches: 3,
  },
  {
    original_query: "Getränke",
    total_searches: 3,
  },
  {
    original_query: "abdeckmatte",
    total_searches: 3,
  },
  {
    original_query: "Rasentrppi",
    total_searches: 3,
  },
  {
    original_query: "rasenteppivh",
    total_searches: 3,
  },
  {
    original_query: "wäsc",
    total_searches: 3,
  },
  {
    original_query: "trittschalldämm",
    total_searches: 3,
  },
  {
    original_query: "kaminholzrega",
    total_searches: 3,
  },
  {
    original_query: "schutzn",
    total_searches: 3,
  },
  {
    original_query: "diamno",
    total_searches: 3,
  },
  {
    original_query: "vorh",
    total_searches: 3,
  },
  {
    original_query: "Pflanzküb",
    total_searches: 3,
  },
  {
    original_query: "katzenschu",
    total_searches: 3,
  },
  {
    original_query: "dünner",
    total_searches: 3,
  },
  {
    original_query: "RASE",
    total_searches: 3,
  },
  {
    original_query: "Modena",
    total_searches: 3,
  },
  {
    original_query: "quadrat",
    total_searches: 3,
  },
  {
    original_query: "Terassenflie",
    total_searches: 3,
  },
  {
    original_query: "rost",
    total_searches: 3,
  },
  {
    original_query: "schlüsselkasten",
    total_searches: 3,
  },
  {
    original_query: "doppelrolo",
    total_searches: 3,
  },
  {
    original_query: "Maschendrahtzaun",
    total_searches: 3,
  },
  {
    original_query: "versandd",
    total_searches: 3,
  },
  {
    original_query: "leon",
    total_searches: 3,
  },
  {
    original_query: "polys",
    total_searches: 3,
  },
  {
    original_query: "Unterle",
    total_searches: 3,
  },
  {
    original_query: "Vorh",
    total_searches: 3,
  },
  {
    original_query: "intergral",
    total_searches: 3,
  },
  {
    original_query: "conn",
    total_searches: 3,
  },
  {
    original_query: "Antr",
    total_searches: 3,
  },
  {
    original_query: "kunststoffliesen",
    total_searches: 3,
  },
  {
    original_query: "baracuda",
    total_searches: 3,
  },
  {
    original_query: "Schiene",
    total_searches: 3,
  },
  {
    original_query: "parkettschutz",
    total_searches: 3,
  },
  {
    original_query: "Puzzle",
    total_searches: 3,
  },
  {
    original_query: "teppichläf",
    total_searches: 3,
  },
  {
    original_query: "honko",
    total_searches: 3,
  },
  {
    original_query: "kosmetikspie",
    total_searches: 3,
  },
  {
    original_query: "Zaunsichtsch",
    total_searches: 3,
  },
  {
    original_query: "aufbewahr",
    total_searches: 3,
  },
  {
    original_query: "dest",
    total_searches: 3,
  },
  {
    original_query: "teppische",
    total_searches: 3,
  },
  {
    original_query: "ringlochmatte",
    total_searches: 3,
  },
  {
    original_query: "Baumrindenmatte",
    total_searches: 3,
  },
  {
    original_query: "dachblech",
    total_searches: 3,
  },
  {
    original_query: "Handtüc",
    total_searches: 3,
  },
  {
    original_query: "Polyca",
    total_searches: 3,
  },
  {
    original_query: "fußmate",
    total_searches: 3,
  },
  {
    original_query: "Susa",
    total_searches: 3,
  },
  {
    original_query: "Badtep",
    total_searches: 3,
  },
  {
    original_query: "Granu",
    total_searches: 3,
  },
  {
    original_query: "fußball",
    total_searches: 3,
  },
  {
    original_query: "Lief",
    total_searches: 3,
  },
  {
    original_query: "abedeckplane",
    total_searches: 3,
  },
  {
    original_query: "volierendra",
    total_searches: 3,
  },
  {
    original_query: "balkonra",
    total_searches: 3,
  },
  {
    original_query: "Kauri",
    total_searches: 3,
  },
  {
    original_query: "spanndr",
    total_searches: 3,
  },
  {
    original_query: "snti",
    total_searches: 3,
  },
  {
    original_query: "küchenmatt",
    total_searches: 3,
  },
  {
    original_query: "unkrautflie",
    total_searches: 3,
  },
  {
    original_query: "Lichtsch",
    total_searches: 3,
  },
  {
    original_query: "schminkspiegel",
    total_searches: 3,
  },
  {
    original_query: "wandschu",
    total_searches: 3,
  },
  {
    original_query: "pinna",
    total_searches: 3,
  },
  {
    original_query: "makita",
    total_searches: 3,
  },
  {
    original_query: "sisalz",
    total_searches: 3,
  },
  {
    original_query: "schlingenware",
    total_searches: 3,
  },
  {
    original_query: "badevorleger",
    total_searches: 3,
  },
  {
    original_query: "schmutzfanm",
    total_searches: 3,
  },
  {
    original_query: "sandboden",
    total_searches: 3,
  },
  {
    original_query: "klapptisch",
    total_searches: 3,
  },
  {
    original_query: "Hochflorteppi",
    total_searches: 3,
  },
  {
    original_query: "bettv",
    total_searches: 3,
  },
  {
    original_query: "Vogelschutznetz",
    total_searches: 3,
  },
  {
    original_query: "pinnwa",
    total_searches: 3,
  },
  {
    original_query: "küchenöä",
    total_searches: 3,
  },
  {
    original_query: "Stuhlunter",
    total_searches: 3,
  },
  {
    original_query: "Ringgumm",
    total_searches: 3,
  },
  {
    original_query: "vilt",
    total_searches: 3,
  },
  {
    original_query: "Anthra",
    total_searches: 3,
  },
  {
    original_query: "anro",
    total_searches: 3,
  },
  {
    original_query: "gewebt",
    total_searches: 3,
  },
  {
    original_query: "Korkroll",
    total_searches: 3,
  },
  {
    original_query: "schmutzfäng",
    total_searches: 3,
  },
  {
    original_query: "Antivibrati",
    total_searches: 3,
  },
  {
    original_query: "Auslegewa",
    total_searches: 3,
  },
  {
    original_query: "Fußabt",
    total_searches: 3,
  },
  {
    original_query: "Schnutzfangmatte",
    total_searches: 3,
  },
  {
    original_query: "pattex",
    total_searches: 3,
  },
  {
    original_query: "gummierte",
    total_searches: 3,
  },
  {
    original_query: "nikos",
    total_searches: 3,
  },
  {
    original_query: "bodenschutzplatten",
    total_searches: 3,
  },
  {
    original_query: "stuffenteppich",
    total_searches: 3,
  },
  {
    original_query: "bademstte",
    total_searches: 3,
  },
  {
    original_query: "gittermatt",
    total_searches: 3,
  },
  {
    original_query: "hohlkammerpl",
    total_searches: 3,
  },
  {
    original_query: "vinl",
    total_searches: 3,
  },
  {
    original_query: "oran",
    total_searches: 3,
  },
  {
    original_query: "kunsto",
    total_searches: 3,
  },
  {
    original_query: "Lucc",
    total_searches: 3,
  },
  {
    original_query: "Sichtachu",
    total_searches: 3,
  },
  {
    original_query: "zierg",
    total_searches: 3,
  },
  {
    original_query: "alexa",
    total_searches: 3,
  },
  {
    original_query: "abdeckleist",
    total_searches: 3,
  },
  {
    original_query: "fußabtre",
    total_searches: 3,
  },
  {
    original_query: "hangbefestigung",
    total_searches: 3,
  },
  {
    original_query: "Mull",
    total_searches: 3,
  },
  {
    original_query: "Bauma",
    total_searches: 3,
  },
  {
    original_query: "boardma",
    total_searches: 3,
  },
  {
    original_query: "stufenmtte",
    total_searches: 3,
  },
];
